var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol0, _symbol1, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23, _symbol24, _symbol25, _symbol26, _symbol27, _symbol28, _symbol29, _symbol30, _symbol31, _symbol32, _symbol33, _symbol34, _symbol35, _symbol36, _symbol37, _symbol38, _symbol39, _symbol40, _symbol41, _symbol42, _symbol43, _symbol44, _symbol45, _symbol46, _symbol47, _symbol48, _symbol49, _symbol50, _symbol51, _symbol52, _symbol53, _symbol54, _symbol55, _symbol56, _symbol57, _symbol58, _symbol59, _symbol60, _symbol61, _symbol62, _symbol63, _symbol64, _symbol65, _symbol66, _symbol67, _symbol68, _symbol69, _symbol70, _symbol71, _symbol72, _symbol73, _symbol74, _symbol75, _symbol76, _symbol77, _symbol78, _symbol79, _symbol80, _symbol81, _symbol82, _symbol83, _symbol84, _symbol85, _symbol86, _symbol87, _symbol88, _symbol89, _symbol90, _symbol91, _symbol92, _symbol93, _symbol94, _symbol95, _symbol96, _symbol97, _symbol98, _symbol99, _symbol100, _symbol101, _symbol102, _symbol103, _symbol104, _symbol105, _symbol106, _symbol107, _symbol108, _symbol109, _symbol110, _symbol111, _symbol112, _symbol113, _symbol114, _symbol115, _symbol116, _symbol117, _symbol118, _symbol119, _symbol120, _symbol121, _symbol122, _symbol123, _symbol124, _symbol125, _symbol126, _symbol127, _symbol128, _symbol129, _symbol130, _symbol131, _symbol132, _symbol133, _symbol134, _symbol135, _symbol136, _symbol137, _symbol138, _symbol139, _symbol140, _symbol141, _symbol142, _symbol143, _symbol144, _symbol145, _symbol146, _symbol147, _symbol148, _symbol149, _symbol150, _symbol151, _symbol152, _symbol153, _symbol154, _symbol155, _symbol156, _symbol157, _symbol158, _symbol159, _symbol160, _symbol161, _symbol162, _symbol163, _symbol164, _symbol165, _symbol166, _symbol167, _symbol168, _symbol169, _symbol170, _symbol171, _symbol172, _symbol173, _symbol174, _symbol175, _symbol176, _symbol177, _symbol178, _symbol179, _symbol180, _symbol181, _symbol182, _symbol183, _symbol184, _symbol185, _symbol186, _symbol187, _symbol188, _symbol189, _symbol190, _symbol191, _symbol192, _symbol193, _symbol194, _symbol195, _symbol196, _symbol197, _symbol198, _symbol199, _symbol200, _symbol201, _symbol202, _symbol203, _symbol204, _symbol205, _symbol206, _symbol207, _symbol208, _symbol209, _symbol210, _symbol211, _symbol212, _symbol213, _symbol214, _symbol215, _symbol216, _symbol217, _symbol218, _symbol219, _symbol220, _symbol221, _symbol222, _symbol223, _symbol224, _symbol225, _symbol226, _symbol227, _symbol228, _symbol229, _symbol230, _symbol231, _symbol232, _symbol233, _symbol234, _symbol235, _symbol236, _symbol237, _symbol238, _symbol239, _symbol240, _symbol241, _symbol242, _symbol243, _symbol244, _symbol245, _symbol246, _symbol247, _symbol248, _symbol249, _symbol250, _symbol251, _symbol252, _symbol253, _symbol254, _symbol255, _symbol256, _symbol257, _symbol258, _symbol259, _symbol260, _symbol261, _symbol262, _symbol263, _symbol264, _symbol265, _symbol266, _symbol267, _symbol268, _symbol269, _symbol270, _symbol271, _symbol272, _symbol273, _symbol274, _symbol275, _symbol276, _symbol277, _symbol278, _symbol279, _symbol280, _symbol281, _symbol282, _symbol283, _symbol284, _symbol285, _symbol286, _symbol287, _symbol288, _symbol289, _symbol290, _symbol291, _symbol292, _symbol293, _symbol294, _symbol295, _symbol296, _symbol297, _symbol298, _symbol299, _symbol300, _symbol301, _symbol302, _symbol303, _symbol304, _symbol305, _symbol306, _symbol307, _symbol308, _symbol309, _symbol310, _symbol311, _symbol312, _symbol313, _symbol314, _symbol315, _symbol316, _symbol317, _symbol318, _symbol319, _symbol320, _symbol321, _symbol322, _symbol323, _symbol324, _symbol325, _symbol326, _symbol327, _symbol328, _symbol329, _symbol330, _symbol331, _symbol332, _symbol333, _symbol334, _symbol335, _symbol336, _symbol337, _symbol338, _symbol339, _symbol340, _symbol341, _symbol342, _symbol343, _symbol344, _symbol345, _symbol346, _symbol347, _symbol348, _symbol349, _symbol350, _symbol351, _symbol352, _symbol353, _symbol354, _symbol355, _symbol356, _symbol357, _symbol358, _symbol359, _symbol360, _symbol361, _symbol362, _symbol363, _symbol364, _symbol365, _symbol366, _symbol367, _symbol368, _symbol369, _symbol370, _symbol371, _symbol372, _symbol373, _symbol374, _symbol375, _symbol376, _symbol377, _symbol378, _symbol379, _symbol380, _symbol381, _symbol382, _symbol383, _symbol384, _symbol385, _symbol386, _symbol387, _symbol388, _symbol389, _symbol390, _symbol391, _symbol392, _symbol393, _symbol394, _symbol395, _symbol396, _symbol397, _symbol398, _symbol399, _symbol400, _symbol401, _symbol402, _symbol403, _symbol404, _symbol405, _symbol406, _symbol407, _symbol408;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "add-cell",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z M160,448H64v-96h96V448z M160,320H64V192h96V320z M160,160H64V64h96V160z M320,448H192v-96h128V448z M320,160H192V64h128V160z M448,448h-96v-96h96V448z M448,320h-96V192h96V320z M448,160h-96V64h96V160z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-column",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0H56.9C25.5,0,0,25.5,0,56.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0H56.9C25.5,0,0,25.5,0,56.9z M448,352v96h-96v-96H448z M160,352v96H64v-96H160z M448,192v128h-96V192H448z M160,192v128H64V192H160z M448,64v96h-96V64H448z M160,64v96H64V64H160z"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-role",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "add-role-key-hole lexicon-icon-outline",
    d: "M336,166c0-87.7-128-85.6-128,0c0,28.1,17.9,51.9,42.7,60.8v68.7c0,27,42.7,30.3,42.7,0v-68.7C318.1,217.9,336,194.1,336,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "add-role-border lexicon-icon-outline",
    d: "M445.6,29.9C273.8-9,262.8-10.6,98.4,28.9C78.7,35.2,64,50.7,64,71.3c0,0,0.1,194.3,0.2,195c13.3-6.3,27.6-10.8,42.7-12.9c0,0,0.7-164.9,0-182.1c157.3-38.7,172.4-37.7,330.3,1c0,13.8,0,193,0,193c-2.2,116.4-107.8,138.3-149.1,155.2c0.2,7.4-5.4,28.6-11,41.6c4,1.2,9.1,4.2,28-1.1c123.3-43,170.4-78.4,174.9-195.7v-193C480,51.7,463.3,35.8,445.6,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "add-role-plus lexicon-icon-outline",
    d: "M139,296c-59.1,0-107,48.4-107,108s47.9,108,107,108s107-48.4,107-108S198.1,296,139,296z M192.5,425.6h-32.1V458c0,28.4-42.8,28.4-42.8,0v-32.4H85.5c-28.8,0-28.1-43.2,0-43.2h32.1V350c0-29,42.8-29,42.8,0v32.4h32.1C220.6,382.4,221.9,425.6,192.5,425.6z"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "add-row",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z M160,448H64v-96h96V448z M160,160H64V64h96V160z M320,448H192v-96h128V448z M320,160H192V64h128V160z M448,448h-96v-96h96V448z M448,160h-96V64h96V160z"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "adjust",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M256,0C114.9,0,0,114.8,0,256s114.8,256,256,256c141.1,0,256-114.9,256-256S397.1,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.9,0,0,114.8,0,256s114.8,256,256,256c141.1,0,256-114.9,256-256S397.1,0,256,0z M56.9,256c0-109.8,89.3-199.1,199.1-199.1l0,0v398.2C146.2,455.1,56.9,365.8,56.9,256z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-center",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M419.986 96h-327.973c-17.664 0-32-14.336-32-32v0c0-17.664 14.299-32 32-32h328.009c17.664 0 32 14.336 32 32v0c-0.037 17.664-14.336 32-32.037 32h0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 224h-448c-17.664 0-32-14.299-32-32v0c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v0c0 17.701-14.336 32-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M419.986 352h-327.973c-17.664 0-32-14.336-32-32v0c0-17.664 14.336-32 32-32h328.009c17.664 0 32 14.336 32 32v0c-0.037 17.664-14.336 32-32.037 32h0.001z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 480h-448c-17.664 0-32-14.336-32-32v0c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v0c0 17.664-14.336 32-32 32z"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-image-center",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M479.9,96H32c-43.7-2-41.5-62.2,0-64h448C524.5,34.1,520.8,94.7,479.9,96z M479.9,480H32c-43.7-2-41.5-62.2,0-64h448C524.5,418.1,520.8,478.7,479.9,480z M352,160H160c-17.7,0-32,14.3-32,32V320c0,17.7,14.3,32,32,32h192c17.7,0,32-14.3,32-32V192C384,174.3,369.7,160,352,160z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-image-full-width",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480.1,32H32.3c-43,0-43.2,64,0,64h447.8C522.6,96,522.6,32,480.1,32z M480.1,416H32.3c-43,0-43.2,64,0,64h447.8C522.6,480,522.6,416,480.1,416z M480,160H32c-17.7,0-32,14.3-32,32v128c0,17.7,14.3,32,32,32h448c17.7,0,32-14.3,32-32V192C512,174.3,497.7,160,480,160z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-image-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M479.9,224H320c-44.8-3.4-40.4-62.3,0-64h160C525.4,163.3,519.9,221.9,479.9,224z M479.9,352H320c-44.8-3.4-40.4-62.3,0-64h160C525.4,291.3,519.9,349.9,479.9,352z M192,160H32c-17.7,0-32,14.3-32,32V320c0,17.7,14.3,32,32,32h160c17.7,0,32-14.3,32-32V192C224,174.3,209.7,160,192,160z M479.9,96H32c-43.7-2-41.5-62.2,0-64h448C524.5,34.1,520.8,94.7,479.9,96z M479.9,480H32c-43.7-2-41.5-62.2,0-64h448C524.5,418.1,520.8,478.7,479.9,480z"
  }))), _symbol0 || (_symbol0 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-image-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M32.1,224H192c44.8-3.4,40.4-62.3,0-64H32C-13.4,163.3-7.9,221.9,32.1,224z M32.1,352H192c44.8-3.4,40.4-62.3,0-64H32C-13.4,291.3-7.9,349.9,32.1,352z M320,160h160c17.7,0,32,14.3,32,32v128c0,17.7-14.3,32-32,32H320c-17.7,0-32-14.3-32-32V192C288,174.3,302.3,160,320,160z M32.1,96H480c43.7-2,41.5-62.2,0-64H32C-12.5,34.1-8.8,94.7,32.1,96z M32.1,480H480c43.7-2,41.5-62.2,0-64H32C-12.5,418.1-8.8,478.7,32.1,480z"
  }))), _symbol1 || (_symbol1 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-justify",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M32 96h448c17.664 0 32-14.336 32-32s-14.336-32-32-32h-448c-17.664 0-32 14.336-32 32s14.336 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 160h-448c-17.664 0-32 14.336-32 32s14.336 32 32 32h448c17.664 0 32-14.336 32-32s-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 288h-448c-17.664 0-32 14.299-32 32 0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32 0-17.701-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 416h-448c-17.664 0-32 14.336-32 32s14.336 32 32 32h448c17.664 0 32-14.336 32-32s-14.336-32-32-32z"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M32 96h320c17.664 0 32-14.336 32-32s-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32s14.336 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M32 224h448c17.664 0 32-14.336 32-32s-14.336-32-32-32h-448c-17.664 0-32 14.336-32 32 0 17.701 14.336 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M32 352h320c17.664 0 32-14.336 32-32s-14.336-32-32-32h-320c-17.664 0-32 14.299-32 32 0 17.664 14.336 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 416h-448c-17.664 0-32 14.336-32 32s14.336 32 32 32h448c17.664 0 32-14.336 32-32s-14.336-32-32-32z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "align-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512 64c0-17.664-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32s14.336 32 32 32h320c17.664 0 32-14.336 32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512 192c0-17.664-14.336-32-32-32h-448c-17.664 0-32 14.336-32 32s14.336 32 32 32h448c17.664 0 32-14.299 32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512 320c0-17.701-14.336-32-32-32h-320c-17.664 0-32 14.336-32 32s14.336 32 32 32h320c17.664 0 32-14.336 32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0 448c0 17.664 14.336 32 32 32h448c17.664 0 32-14.336 32-32s-14.336-32-32-32h-448c-17.664 0-32 14.336-32 32z"
  }))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "analytics",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "analytics-bar1 lexicon-icon-outline",
    d: "M96,415.8H32c-17.7,0-32,14.3-32,32v32c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32v-32C128,430.1,113.7,415.8,96,415.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "analytics-bar2 lexicon-icon-outline",
    d: "M288,319.8h-64c-17.7,0-32,14.3-32,32v128c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32v-128C320,334.1,305.7,319.8,288,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "analytics-bar3 lexicon-icon-outline",
    d: "M480,223.8h-64c-17.7,0-32,14.3-32,32v224c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32v-224C512,238.1,497.7,223.8,480,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "analytics-uptrend-arrow lexicon-icon-outline",
    d: "M415,110.2v23.6c3.1,44.2,64.6,41.3,64.8,0V32.6c0-17.9-13.2-32.4-32.4-32.4l-101.3,0c-42.8,2.3-43.2,61.9,0,64.8h23.6l-95.3,94.9l-114.2-0.2c0,0,0,0-0.1,0c-10.1,0-19.5,4.7-25.6,12.8L38.6,300.3c-24.2,35.4,25.4,70.9,51.2,38.4l86.5-115.1l111.4,0.2c0,0,0,0,0.1,0c8.5,0,16.6-3.4,22.6-9.3L415,110.2z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-down-small",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M268,339.9l142.6-142.2c16.4-16.4-8.5-41.7-25.1-25.1L256,301.7L126.5,172.5c-16.8-16.7-41.6,8.7-25.1,25.1L244,339.9C251.2,347,261.4,346.4,268,339.9z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-down",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M272.8,375.2L475,173.3c23-23.6-11.9-59.9-35.1-36L256,320.3L72.2,137.4c-23.5-24-58.2,12.5-35.2,36.1l202.1,201.7C249.2,385.4,263.5,384.5,272.8,375.2z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-left-small",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M172.1,268l142.2,142.6c16.4,16.4,41.7-8.5,25.1-25.1L210.3,256l129.2-129.5c16.7-16.8-8.7-41.6-25.1-25.1L172.1,244C165,251.2,165.6,261.4,172.1,268z"
  }))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M136.8,272.8l201.7,202.1c23.5,23.1,60-11.6,36.1-35.2L191.7,256l183-183.9c23.9-23.2-12.5-58.1-36-35.1L136.8,239.2C127.5,248.5,126.6,262.8,136.8,272.8z"
  }))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-right-small",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M339.9,244L197.6,101.4c-16.4-16.5-41.8,8.3-25.1,25.1L301.7,256L172.6,385.5c-16.6,16.6,8.7,41.5,25.1,25.1L339.9,268C346.4,261.4,347,251.2,339.9,244z"
  }))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M375.2,239.2L173.3,37c-23.6-23-59.9,11.9-36,35.1l183,183.9L137.4,439.8c-24,23.5,12.5,58.2,36.1,35.2l201.7-202.1C385.4,262.8,384.5,248.5,375.2,239.2z"
  }))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-up-small",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M244,172.1L101.4,314.4c-16.5,16.4,8.3,41.8,25.1,25.1L256,210.3l129.5,129.2c16.6,16.6,41.5-8.7,25.1-25.1L268,172.1C261.4,165.6,251.2,165,244,172.1z"
  }))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-up",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M239.2,136.8L37.1,338.5c-23.1,23.5,11.6,60,35.2,36.1L256,191.7l183.9,183c23.2,23.9,58.1-12.5,35.1-36L272.8,136.8C263.5,127.5,249.2,126.6,239.2,136.8z"
  }))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "announcement",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M95.9,240.2c0.2-28.7,10.4-34.2,24.2-37.4l71.7-6.8v88.3c0,0-54-3-71.9-5.4C108.3,277.2,95.7,270.1,95.9,240.2z M192,400.1c-0.7,20.9-31,21.6-32,0v-86l32,2.4L192,400.1z M384.1,336.5c-0.3,14.6-17.3,21.3-27.4,11.1c-21.4-21.4-86.1-61.2-132.8-61.2v-92.8c46.1,0,111.2-39.1,132.6-60.5c10.8-10.8,27.4-2.6,27.4,11.1L384.1,336.5z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "anonymize",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480,220.3l-64-32L363.1,56.1c-6.3-15.6-23.6-23.8-39.6-18.6l-70.2,22.8l-64.5-22.1c-16.1-5.5-33.8,2.6-40.1,18.4L96,188.3l-64,32h64v86.3c0,6.9,2.1,13.1,5,18.8c52.4,200.3,256.4,202.3,310,0c2.9-5.7,5-11.9,5-18.8v-86.3H480z M141.8,348.3c84.9,0,94.2-64,114.2-64s27.3,64,114.2,64C316,476.3,196.7,476.9,141.8,348.3z M384,252.3H128v-32h256V252.3z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "api-lock",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-lock-a",
    d: "M112.1,467.3H54.7L43.2,512H0l58.8-191.5h51L168.5,512h-44.9L112.1,467.3z M103.4,434.1c0,0-17.1-68.1-19.6-77.9h-1.2c-2.3,10-19.3,77.9-19.3,77.9H103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-lock-p",
    d: "M192,320.5h65.5c10.2,0,73.4,0,73.4,64c0,64.2-63.5,63.8-73.4,63.8h-26.2V512H192V320.5z M254.9,410c23,0,34.6-10.7,34.6-25.4c0-25.3-23.2-27.3-34.6-27.3h-22.3V410H254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-lock-i",
    d: "M369.3,320.5H416V512h-46.7V320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-lock-lock",
    d: "M460.8,192.3H288V96.1c0-35.3,28.7-64.1,64-64.1s64,28.8,64,64.1v31.5h32V96.1C448,43,405,0,352,0s-96,43-96,96.1v96.1h-19.2c-28.2,0-44.8,23-44.8,51.3v12.8h256v160.2h32c32,0,32-30.7,32-51.3V243.6C512,215.3,489,192.3,460.8,192.3z"
  }))), _symbol24 || (_symbol24 = /*#__PURE__*/React.createElement("symbol", {
    id: "api-web",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-web-a",
    d: "M112.1,467.3H54.7L43.2,512H0l58.8-191.5h51L168.5,512h-44.9L112.1,467.3z M103.4,434.1c0,0-17.1-68.1-19.6-77.9h-1.2c-2.3,10-19.3,77.9-19.3,77.9H103.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-web-p",
    d: "M192,320.5h65.5c10.2,0,73.4,0,73.4,64c0,64.2-63.5,63.8-73.4,63.8h-26.2V512H192V320.5z M254.9,410c23,0,34.6-10.7,34.6-25.4c0-25.3-23.2-27.3-34.6-27.3h-22.3V410H254.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-web-i",
    d: "M369.3,320.5H416V512h-46.7V320.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline api-web-web",
    d: "M160,241.7c28.1-8.2,64.1-13.1,96-13.1v27.8h32v-25.9c49.8,2.8,96,26.2,96,26.2v31.4l31.9,0.5l0.3-16.3c0,0,43.7,24.1,64,48.3v31.7c0,0,31.9-38,31.9-111.8C512,106.8,403.3,0,272,0S32,107.5,32,240.4c0,11.2,0,48.1,0,48.1s-8.3-0.5,32,0c28-22.6,63.5-32.3,63.5-32.3l32.4,0.3L160,241.7z M463.3,165.2c-17.9-14.5-38.2-27.1-60.5-37.4c-6.3-22.8-14.9-44.1-25.2-63.9C416.2,87.2,446.6,122.7,463.3,165.2z M256,96.1c-23.4,0-46.1,2.4-67.8,6.5c9.6-23.2,21.6-44.5,36.1-62.5c10.3-2.5,20.9-4.2,31.8-5L256,96.1L256,96.1z M288,35.2c10.9,0.8,21.5,2.6,31.8,5c16.2,20.3,29.5,44.6,39.6,71.4c-22.6-6.8-46.4-11.5-71.4-13.7V35.2z M166.4,63.9c-8.2,15.6-15.2,32.2-20.9,49.8c-17.5,5.7-34.1,12.8-49.7,21C113.2,105.6,137.4,81.3,166.4,63.9z M72.1,192.5c18-14.4,39.2-26.5,62.4-36.1c-3.6,19.1-5.7,38.9-6.1,59.2c-22.4,8.7-43,19.7-61.7,32.4C66.6,245.5,62.8,221,72.1,192.5z M165.4,203.8c1.3-21.1,4.4-41.5,9.4-60.8c25.6-6.6,52.7-10.5,81.2-10.5v59.8C224.3,192.3,193.9,196.5,165.4,203.8z M288,134.2c30.1,2.9,58.5,9.7,84.3,19.8c4.2,19.2,6.3,39.6,6.9,60.4C351,203.9,320.4,196.8,288,194V134.2z M475,271.9c-17.2-15.8-37.2-29.7-59.4-41.3c1.5-21.3-1.1-40.6-3.5-57.1c26.5,15.8,48.8,35.4,65.1,57.8C477.4,234.3,478.9,255.3,475,271.9z"
  }))), _symbol25 || (_symbol25 = /*#__PURE__*/React.createElement("symbol", {
    id: "archive",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M0,128v295.1C0,454.5,25.5,480,56.9,480h398.2c31.4,0,56.9-25.5,56.9-56.9V128H0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,128v295.1C0,454.5,25.5,480,56.9,480h398.2c31.4,0,56.9-25.5,56.9-56.9V128H0z M64,416V192h384l0,224H64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480,96H32C14.4,96,0,81.6,0,64l0,0c0-17.6,14.4-32,32-32h448c17.6,0,32,14.4,32,32l0,0C512,81.6,497.6,96,480,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M320,320H192c-17.6,0-32-14.4-32-32l0,0c0-17.6,14.4-32,32-32h128c17.6,0,32,14.4,32,32l0,0C352,305.6,337.6,320,320,320z"
  }))), _symbol26 || (_symbol26 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-end",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M316,265.9l-100.4,82c-10,8.3-23.6,2.6-23.6-9.9v-50H96v-64h96v-50c0-12.5,14.9-18.7,23.6-9.9l100.4,82C321.3,251.6,321.3,260.4,316,265.9z M416,352h-64V160h64V352z"
  }))), _symbol27 || (_symbol27 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-join",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M493.5,210.8L301.3,18.7c-18-18-57.2-30.8-90.6-0.1l-192,192.3c-31,33.3-17.9,74.4,0,90.5c50.4,45.5,143.9,144.3,192.2,192.2c31.5,31.2,74.3,17,90.5,0l192.3-192C509.9,284.2,525.2,245,493.5,210.8z M347.9,343.7l-82,100.4c-5.4,5.4-14.3,5.4-19.7,0l-82-100.4c-8.8-8.7-2.6-23.6,9.9-23.6h50c0.2-64.1,1.1-67.8-18.7-92.1L141,163.7l22.6-22.6l60.3,60.3V96h64v224h50C350.5,320.1,356.7,335,347.9,343.7z"
  }))), _symbol28 || (_symbol28 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-right-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M255.4,0C124,0,15.9,97.8,0,224h261.2l-0.1-0.1l-27.4-27.2c-29.8-30.3,15.6-75.5,45.5-45.3l82.2,81.9c12.6,12.5,12.6,32.8,0,45.3l-82.5,81.9c-29.3,28.7-76.2-12-45.5-45.3l27.2-27.1l0.2-0.2H0c15.9,126.2,124,224,255.4,224C596.5,511.1,598.5,0,255.4,0z"
  }))), _symbol29 || (_symbol29 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-split",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M493.29,210.83L301.17,18.71c-24.95-24.95-65.39-24.95-90.34,0L18.71,210.83c-24.95,24.95-24.95,65.39,0,90.34l192.12,192.12c24.95,24.95,65.39,24.95,90.34,0l192.12-192.12C518.24,276.22,518.24,235.78,493.29,210.83z M376.81,351.82l-64.37-6.48c-6.18,0.03-9.24-7.41-4.84-11.81l17.65-17.64L256,246.64l-69.25,69.24l17.65,17.64c4.4,4.4,1.34,11.84-4.84,11.81l-64.37,6.48c-3.81-0.02-6.94-3.14-6.95-6.96l6.48-64.37c-0.03-6.18,7.41-9.24,11.81-4.84l17.64,17.64c48.25-49.75,59.03-52.6,59.89-73.12v-91.95h63.88v91.92c-0.72,19.87,16.02,27.16,59.89,73.14l17.64-17.64c4.4-4.4,11.84-1.35,11.81,4.84l6.48,64.37C383.74,348.68,380.62,351.8,376.81,351.82z"
  }))), _symbol30 || (_symbol30 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-start",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.62,0,0,114.62,0,256s114.62,256,256,256s256-114.62,256-256S397.38,0,256,0z M343.59,347.88c-8.72,8.8-23.59,2.59-23.59-9.88V288H183.12C136.62,353.63,64,307.14,64,256c0-50.21,71.1-98.22,119.12-32H320v-49.99c0-12.48,14.87-18.68,23.59-9.88l100.38,82.02c5.37,5.42,5.37,14.28,0,19.71L343.59,347.88z"
  }))), _symbol31 || (_symbol31 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-up-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,256.6C0,388,97.8,496.1,224,512V250.8l-0.1,0.1l-27.2,27.4c-30.3,29.8-75.5-15.6-45.3-45.5l81.9-82.2c12.5-12.6,32.8-12.6,45.3,0l81.9,82.5c28.7,29.3-12,76.2-45.3,45.5l-27.1-27.2l-0.2-0.2V512c126.2-15.9,224-124,224-255.4C511-84.5,0-86.5,0,256.6z"
  }))), _symbol32 || (_symbol32 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-xor",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M493.5,210.8L301.3,18.6c-18-18.1-57.2-30.8-90.6-0.1l-192,192.3c-31,33.3-17.9,74.4,0,90.5l192.2,192.2c31.5,31.2,74.3,17,90.5,0l192.3-192.1C509.9,284.2,525.2,245,493.5,210.8z M352,187.1V224c0,17.7-14.3,32-32,32h-48v106.7h38.7c8.3,0,12.5,9.9,6.6,15.7l-54.7,66.9c-3.6,3.6-9.5,3.6-13.1,0l-54.7-66.9c-5.9-5.8-1.7-15.7,6.6-15.7H240V256h-48c-17.7,0-32-14.3-32-32v-36.9c-25.6-12.6-19.1-59.1,16-59.1c33.9,0,43.3,44.2,16,59.1V224h128v-36.9c-26.1-14.9-19-59.1,16-59.1C370.2,128,379.1,172,352,187.1z"
  }))), _symbol33 || (_symbol33 = /*#__PURE__*/React.createElement("symbol", {
    id: "asterisk",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M323.6,190l146.7-48.8L512,263.9l-149.2,47.6l93.6,125.2l-104.9,76.3l-96.1-126.4l-93.6,126.4L56.9,435.3l92.3-123.9L0,263.8l40.4-122.6L188.4,190v-159h135.3L323.6,190L323.6,190z"
  }))), _symbol34 || (_symbol34 = /*#__PURE__*/React.createElement("symbol", {
    id: "audio",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M384,32H192c-35.2,0-64,28.8-64,64v225.6c-5.2-1-10.5-1.6-16-1.6c-44.2,0-80,35.8-80,80s35.8,80,80,80s80-35.8,80-80c0-2.7,0-208,0-208h192v97.6c-5.2-1-10.5-1.6-16-1.6c-44.2,0-80,35.8-80,80s35.8,80,80,80s80-35.8,80-80c0-2.7,0-272,0-272C448,60.8,419.2,32,384,32z"
  }))), _symbol35 || (_symbol35 = /*#__PURE__*/React.createElement("symbol", {
    id: "automatic-translate",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M159.7,0c13.2,0,24,10.7,24,24v40.1l112,0.5c13.2,0.1,23.9,10.9,23.9,24.1c-0.1,13.3-10.8,24-24.1,23.9l-26-0.1c-4.5,41.9-15.5,72.4-31.9,96.7c-11.4,16.8-24.8,29.8-38.6,41.3c14.2,11.1,41.1,30.4,58.9,43.2c10,7.1,13.2,20.5,7.6,31.3c-6.7,12.9-23,17.2-34.7,8.9c-25.2-17.6-48.9-36.1-67.8-50.8l-2.9-2.3L157,283c-24.5,19.1-55.3,43.1-88.5,64.7c-11.1,7.2-25.9,4-33.1-7.1c-7.2-11.1-4-26,7.1-33.1c29-18.9,55.5-39.1,78.4-57c-10.9-9.1-21.6-19.1-31.1-31c-9.7-12.2-18-26-24.6-42.5c-5.9-14.8,6-29.7,22-29.7c10.9,0,20.3,7.3,24.8,17.3c4.4,9.9,9.6,18.1,15.3,25.2c9,11.3,19.8,20.7,32.7,30.8c15.8-12.3,28.2-23.5,38.1-38c10.7-15.8,19.3-36.9,23.4-70l-61.5-0.3H24c-13.2,0-24-10.8-24-24c0-13.3,10.7-24,24-24h111.9V24C135.8,10.8,146.5,0,159.7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M378.7,208.5c9.6,0,18.3,5.7,22,14.6l109.4,255.6c5.2,12.2-0.4,26.2-12.6,31.4c-12.2,5.2-26.2-0.4-31.4-12.6l-21-49H312.2l-21,49c-5.2,12.2-19.3,17.8-31.4,12.6c-12.2-5.2-17.8-19.3-12.6-31.4l25.9-60.4c0.6-2.1,1.5-4.2,2.6-6l81-189.2C360.5,214.1,369.1,208.5,378.7,208.5z M424.6,400.5l-45.9-107.3l-45.9,107.3H424.6z"
  }))), _symbol36 || (_symbol36 = /*#__PURE__*/React.createElement("symbol", {
    id: "autosize",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline autosize-border",
    d: "M460.8,51.2v409.6H51.2V51.2H460.8 M460.8,0H51.2C23,0,0,23,0,51.2v409.6C0,489,23,512,51.2,512h409.6c28.2,0,51.2-23,51.2-51.2V51.2C512,23,489,0,460.8,0L460.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline autosize-arrow-bottom-left",
    d: "M128,409.6h69.1c23,0,33.3-28.2,17.9-43.5l-15.4-15.4l46.1-46.1c22-21.8-8.7-60.4-35.8-35.8l-46.1,46.1l-15.4-15.4c-15.4-15.4-43.5-5.1-43.5,17.9v69.1C102.4,399.4,112.6,409.6,128,409.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline autosize-arrow-top-right",
    d: "M384,102.4h-69.1c-23,0-33.3,28.2-17.9,43.5l15.4,15.4l-46.1,46.1c-23.5,24.8,12,58.9,35.8,35.8l46.1-46.1l15.4,15.4c15.4,15.4,43.5,5.1,43.5-17.9v-69.1C409.6,112.6,399.4,99.8,384,102.4z"
  }))), _symbol37 || (_symbol37 = /*#__PURE__*/React.createElement("symbol", {
    id: "background-color",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-background-color-line",
    d: "M399.7,512H111.9c-63.2,0-64.5-96,0-96h287.8C462.1,416,466,512,399.7,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-background-color-bucket-drop",
    d: "M447.6,335.9c0,64.4-95.9,63.8-95.9,0c0-26.5,47.9-80.1,47.9-80.1S447.6,309.4,447.6,335.9z M377.5,173.9L213.9,10c-30.1-30.1-75.8,14.6-45.2,45.3l27,27.1l-113,113.2c-25,25-25,65.6,0,90.6l80,80.1c23.7,23.8,64.6,25.9,90.4,0l124.4-125.1C396,222.6,396,192.5,377.5,173.9z M128,240.9L128,240.9v-0.2V240.9z M304.9,223.8h-160l95.9-96.2c0,0,0,0,0.1,0l80,80.2L304.9,223.8z"
  }))), _symbol38 || (_symbol38 = /*#__PURE__*/React.createElement("symbol", {
    id: "bars",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bars-line-top",
    d: "M480 64h-448c-17.664 0-32-14.336-32-32v0c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v0c0 17.664-14.336 32-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bars-line-middle",
    d: "M480 288h-448c-17.664 0-32-14.336-32-32v0c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v0c0 17.664-14.336 32-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bars-line-bottom",
    d: "M480 512h-448c-17.664 0-32-14.336-32-32v0c0-17.664 14.336-32 32-32h448c17.664 0 32 14.336 32 32v0c0 17.664-14.336 32-32 32z"
  }))), _symbol39 || (_symbol39 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M287.9,399.7c15.1-6.9,33.4-17.8,52.5-34C365.8,407.8,306.1,435,287.9,399.7z M223.5,383.5c-37.1-26.1-4.1-45.4-50.9-90.5c-16.9-16.2-70.6-60.6-30.6-127.6c-21.1-19.9,1.4-45.8,23.6-23.6c66.5-38.9,111.1,13.9,127.5,30.5c48.8,49.6,65.3,13.1,91.5,49.9C376,303.9,290.2,377.6,223.5,383.5z"
  }))), _symbol40 || (_symbol40 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-off",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bell-off-clapper",
    d: "M163.5,440.3c30.5,96.7,154.5,95.7,185,0C288,448,224,448,163.5,440.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bell-off-bowl-bottom",
    d: "M461.7,408.3L101.6,48.4c-26-24.4-66,11.1-39.4,39.4l38.5,38.5C79.4,168.8,64,230.5,64,320c-32,32-32,32-32,32c0,60,218.1,79.1,349.9,55.3l40.4,40.4C446.2,472.7,488.7,436.7,461.7,408.3z M128,341.6c0,0,0-89.2,28-160l165.7,165.6C256.7,351.4,201.8,349.6,128,341.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bell-off-bowl-top",
    d: "M373.1,240.8l74.9,74.8C446.4,32,288,32,288,32c0-41-64-42-64,0c0,0-20.4,0-46.7,13.1l54.2,54.1C317,78,358.7,162.3,373.1,240.8z"
  }))), _symbol41 || (_symbol41 = /*#__PURE__*/React.createElement("symbol", {
    id: "bell-on",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bell-on-bowl",
    d: "M384,341.6c-96,10.4-160,10.4-256,0c0,0,0-245.6,128-245.6S384,341.6,384,341.6z M224,32c0,0-160,0-160,288c-32,32-32,32-32,32c0,86,448,88,448,0c0,0,0,0-32-32C448,32,288,32,288,32C288-9,224-10,224,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline bell-on-clapper",
    d: "M163.5,440.3c30.5,96.7,154.5,95.7,185,0C288,448,224,448,163.5,440.3z"
  }))), _symbol42 || (_symbol42 = /*#__PURE__*/React.createElement("symbol", {
    id: "block",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M437,75C388.7,26.6,324.4,0,256,0S123.3,26.6,75,75C26.6,123.3,0,187.6,0,256s26.6,132.7,75,181 c48.4,48.4,112.6,75,181,75s132.7-26.6,181-75c48.4-48.4,75-112.6,75-181S485.4,123.3,437,75z M448,256c0,41.4-13.2,79.8-35.5,111.2 L144.8,99.5C176.2,77.2,214.6,64,256,64C361.9,64,448,150.1,448,256z M64,256c0-41.4,13.2-79.8,35.5-111.2l267.7,267.7 C335.8,434.8,297.4,448,256,448C150.1,448,64,361.9,64,256z"
  }))), _symbol43 || (_symbol43 = /*#__PURE__*/React.createElement("symbol", {
    id: "blogs",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline blogs-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,448H64V64h384V448C448,448,448,448,448,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline blogs-line-middle",
    d: "M384,256H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h256c17.7,0,32-14.3,32-32S401.7,256,384,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline blogs-line-bottom",
    d: "M288,352H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S305.7,352,288,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline blogs-line-top",
    d: "M384,96H128c-17.6,0-32,14.4-32,32v64c0,17.6,14.4,32,32,32h256c17.6,0,32-14.4,32-32v-64C416,110.4,401.6,96,384,96z"
  }))), _symbol44 || (_symbol44 = /*#__PURE__*/React.createElement("symbol", {
    id: "bold",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M247.9,224.1c76.5,0,76.5-96,0-96h-54.3v96H247.9L247.9,224.1z M247.9,64.1c173.3-5.8,143.8,172.9,70.3,182.3c85.2,21.3,124.5,176.3-38.6,201.5H120V64.1H247.9z M254.2,384c83.8,0,81.7-96,0-96h-60.7v96H254.2z"
  }))), _symbol45 || (_symbol45 = /*#__PURE__*/React.createElement("symbol", {
    id: "bolt",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M413.7,256.9l-120.5-69.8L354,41c13.4-33.1-25-52.6-45.2-33.3L95.7,209.5C82.3,225,83.3,242,101,254.8l120.7,70.1l-61.6,147.7c-11.4,30.1,23.6,50.4,45.9,31.8l213.2-201.8C432.3,287.7,430.3,268.3,413.7,256.9z"
  }))), _symbol46 || (_symbol46 = /*#__PURE__*/React.createElement("symbol", {
    id: "bookmarks",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,448H64V64h160v224l96-81.5l96,81.5V64h32V448C448,448,448,448,448,448z"
  }))), _symbol47 || (_symbol47 = /*#__PURE__*/React.createElement("symbol", {
    id: "books",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline books-1-spine-top",
    d: "M96.1,32h-64c-17.7,0-32,14.3-32,32v32h128V64C128.1,46.3,113.8,32,96.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline books-1-spine-bottom",
    d: "M0.1,448c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32v-32H0.1V448z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline books-1-spine",
    x: 0.1,
    y: 128,
    width: 128,
    height: 256
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline books-2-spine-top",
    d: "M256.1,32h-64c-17.7,0-32,14.3-32,32v32h128V64C288.1,46.3,273.8,32,256.1,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline books-2-spine-bottom",
    d: "M160.1,448c0,17.7,14.3,32,32,32h64c17.7,0,32-14.3,32-32v-32h-128V448z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline books-2-spine",
    x: 160.1,
    y: 128,
    width: 128,
    height: 256
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline books-3-spine-top",
    d: "M359.2,35.2l-31,8.1c-17.1,4.5-27.4,21.9-22.9,39l8.1,31l92.9-24.2l-8.1-31C393.7,41,376.3,30.7,359.2,35.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline books-3-spine",
    x: 352.1,
    y: 128,
    transform: "matrix(0.9678 -0.2518 0.2518 0.9678 -51.571 108.9927)",
    width: 96,
    height: 256
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline books-3-spine-bottom",
    d: "M402,453.9c4.5,17.1,21.9,27.4,39,22.9l31-8.1c17.1-4.5,27.4-21.9,22.9-39l-8.1-31l-92.9,24.2L402,453.9z"
  }))), _symbol48 || (_symbol48 = /*#__PURE__*/React.createElement("symbol", {
    id: "box-container",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline box-container-border",
    d: "M448,64v384H64V64H448 M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0L448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline box-container-square1",
    d: "M384,256h-64c-17.7,0-32-14.3-32-32v-64c0-17.7,14.3-32,32-32h64c17.7,0,32,14.3,32,32v64C416,241.7,401.7,256,384,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline box-container-square2",
    d: "M384,416h-64c-17.7,0-32-14.3-32-32v-64c0-17.7,14.3-32,32-32h64c17.7,0,32,14.3,32,32v64C416,401.7,401.7,416,384,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline box-container-square3",
    d: "M224,416h-64c-17.7,0-32-14.3-32-32v-64c0-17.7,14.3-32,32-32h64c17.7,0,32,14.3,32,32v64C256,401.7,241.7,416,224,416z"
  }))), _symbol49 || (_symbol49 = /*#__PURE__*/React.createElement("symbol", {
    id: "breadcrumb",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline breadcrumb-arrow-outline",
    d: "M111.8,128L111.8,128l102.2,127.8L111.8,383.6H32V128H111.8 M111.8,96H32c-19.2,0-32,12.8-32,32v255.6c0,19.2,12.8,32,32,32h79.9c9.6,0,19.2-3.2,25.6-12.8l102.2-127.8c9.6-12.8,9.6-28.8,0-38.3L137.4,108.8C131,99.2,121.4,96,111.8,96L111.8,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline breadcrumb-arrow-solid",
    d: "M377,415.5H258.8c-25.6,0-41.5-32-25.6-51.1l86.3-108.6l-86.3-108.6c-16-19.2,0-51.1,25.6-51.1H377c9.6,0,19.2,3.2,25.6,12.8l102.2,127.8c9.6,12.8,9.6,28.8,0,38.3L402.6,402.7C396.2,412.3,386.6,415.5,377,415.5z"
  }))), _symbol50 || (_symbol50 = /*#__PURE__*/React.createElement("symbol", {
    id: "briefcase",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-briefcase-bottom",
    d: "M504.42,337.42L288,378v22c0,8.84-7.16,16-16,16h-32c-8.84,0-16-7.16-16-16v-22L7.58,337.42C3.64,336.68,0,339.7,0,343.71V448c0,17.67,14.33,32,32,32h448c17.67,0,32-14.33,32-32V343.71C512,339.7,508.36,336.68,504.42,337.42z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-briefcase-top",
    d: "M480,128h-96V96c0-35.35-28.65-64-64-64H192c-35.35,0-64,28.65-64,64v32H32c-17.67,0-32,14.33-32,32v117.44c0,15.4,10.97,28.62,26.1,31.45L224,346v-10c0-8.84,7.16-16,16-16h32c8.84,0,16,7.16,16,16v10l197.9-37.11c15.14-2.84,26.1-16.05,26.1-31.45V160C512,142.33,497.67,128,480,128z M320,128H192V96h128V128z"
  }))), _symbol51 || (_symbol51 = /*#__PURE__*/React.createElement("symbol", {
    id: "button",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,416H64c-32,0-64-31.93-64-64V160c0.02-31.85,32.02-64,64-64h384c32,0.02,64,31.93,64,64v192C512,384.03,480.02,416,448,416z M64,160V352h384V160H64z"
  }))), _symbol52 || (_symbol52 = /*#__PURE__*/React.createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar-border lexicon-icon-outline",
    d: "M512,160c0-35-28.7-64-63.7-64l-0.3,0v-64c0-44-64-41-64,0v64h-96v-64c0-40-64-44-64,0v64h-96v-64c0-45-64-40-64,0v64l-0.3,0c-35,0-63.7,29-63.7,64V448c0,35,29,64,64,64h352l96-96V160z M384,448.1v-64h64L384,448.1z M448,320H320v128H64V160h384V320z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 96,
    y: 192,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 160,
    y: 192,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 224,
    y: 192,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 288,
    y: 192,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 352,
    y: 192,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 96,
    y: 256,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 160,
    y: 256,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 224,
    y: 256,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 288,
    y: 256,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 352,
    y: 256,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 96,
    y: 320,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 96,
    y: 384,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 160,
    y: 384,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 160,
    y: 320,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "calendar-date lexicon-icon-outline",
    x: 224,
    y: 320,
    width: 32,
    height: 32
  }))), _symbol53 || (_symbol53 = /*#__PURE__*/React.createElement("symbol", {
    id: "camera",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline camera-shutter-button",
    d: "M180.7,79.8c0-15.6-12.8-28.4-28.4-28.4H75.9c-15.6,0-28.4,12.8-28.4,28.4v22.6h133.2L180.7,79.8L180.7,79.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline camera-body",
    d: "M454.6,123.3h-33V78c0-26.8-22-48.8-48.8-48.8H242c-26.8,0-48.8,22-48.8,48.8v45.3H57.4C25.7,123.3,0,149,0,180.6v244.8c0,31.6,25.7,57.4,57.4,57.4h397.3c31.6,0,57.4-25.7,57.4-57.4V180.6C512,149,486.3,123.3,454.6,123.3L454.6,123.3z M90.4,241.9c-16.6,0-30.1-13.5-30.1-30.1s13.5-30.1,30.1-30.1s30.1,13.5,30.1,30.1S107,241.9,90.4,241.9z M316.2,452.7c-74.8,0-135.5-60.7-135.5-135.5s60.7-135.5,135.5-135.5s135.5,60.7,135.5,135.5S391.1,452.7,316.2,452.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline camera-lens",
    d: "M391.5,317.2c0,41.6-33.7,75.3-75.3,75.3s-75.3-33.7-75.3-75.3s33.7-75.3,75.3-75.3S391.5,275.6,391.5,317.2L391.5,317.2z"
  }))), _symbol54 || (_symbol54 = /*#__PURE__*/React.createElement("symbol", {
    id: "cards-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cards-full-top lexicon-icon-outline",
    width: 512,
    height: 224,
    rx: 32,
    ry: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cards-full-bottom lexicon-icon-outline",
    y: 288,
    width: 512,
    height: 224,
    rx: 32,
    ry: 32
  }))), _symbol55 || (_symbol55 = /*#__PURE__*/React.createElement("symbol", {
    id: "cards",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body cards-bg-top",
    fill: "none",
    d: "M465.1,0H46.9C21.1,0,0,21.1,0,46.9v130.8c0,25.8,21.1,46.9,46.9,46.9h418.1c25.8,0,46.9-21.1,46.9-46.9V46.9C512,21.1,490.9,0,465.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body cards-bg-bottom",
    fill: "none",
    d: "M465.1,287.3H46.9C21.1,287.3,0,308.4,0,334.3v130.8C0,490.9,21.1,512,46.9,512h418.1c25.8,0,46.9-21.1,46.9-46.9V334.3C512,308.4,490.9,287.3,465.1,287.3L465.1,287.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline cards-border-top",
    d: "M465.1,0H46.9C21.1,0,0,21.1,0,46.9v130.8c0,25.8,21.1,46.9,46.9,46.9h418.1c25.8,0,46.9-21.1,46.9-46.9V46.9C512,21.1,490.9,0,465.1,0z M448,160.7H64v-96h384V160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline cards-border-bottom",
    d: "M465.1,287.3H46.9C21.1,287.3,0,308.4,0,334.3v130.8C0,490.9,21.1,512,46.9,512h418.1c25.8,0,46.9-21.1,46.9-46.9V334.3C512,308.4,490.9,287.3,465.1,287.3L465.1,287.3z M448,448H64v-96h384V448z"
  }))), _symbol56 || (_symbol56 = /*#__PURE__*/React.createElement("symbol", {
    id: "cards2",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline cards2-box-top-left",
    d: "M192 0h-160c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline cards2-box-bottom-left",
    d: "M192 288h-160c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline cards2-box-top-right",
    d: "M480 0h-160c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline cards2-box-bottom-right",
    d: "M480 288h-160c-17.664 0-32 14.336-32 32v160c0 17.664 14.336 32 32 32h160c17.664 0 32-14.336 32-32v-160c0-17.664-14.336-32-32-32z"
  }))), _symbol57 || (_symbol57 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-bottom-l",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M165.2,223.7l81.5,85c5.4,5.6,14.2,5.6,19.6,0l81.5-85c8.7-9.1,2.5-24.7-9.8-24.7H175C162.7,199.1,156.5,214.6,165.2,223.7L165.2,223.7z"
  }))), _symbol58 || (_symbol58 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-bottom",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M103.5,204.3l136.1,136.1c9,9,23.7,9,32.7,0l136.1-136.1c14.6-14.6,4.3-39.5-16.4-39.5H119.9C99.2,164.8,88.9,189.7,103.5,204.3L103.5,204.3z"
  }))), _symbol59 || (_symbol59 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-double-l",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline caret-double-l-top",
    d: "M347.913 199.336l-81.538-85c-5.413-5.642-14.188-5.642-19.6 0l-81.538 85c-8.731 9.101-2.548 24.664 9.8 24.664h163.077c12.348 0 18.531-15.563 9.8-24.664z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline caret-double-l-bottom",
    d: "M165.236 312.664l81.538 85c5.412 5.642 14.188 5.642 19.6 0l81.538-85c8.731-9.101 2.548-24.664-9.8-24.664h-163.077c-12.347 0-18.531 15.563-9.8 24.664z"
  }))), _symbol60 || (_symbol60 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-double",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline caret-double-top",
    d: "M407.139 151.999l-136.136-136.136c-9.036-9.037-23.688-9.037-32.725 0l-136.136 136.136c-14.577 14.577-4.253 39.501 16.362 39.501h272.272c20.615 0 30.94-24.924 16.362-39.501z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline caret-double-bottom",
    d: "M103.18 359.002l136.136 136.136c9.036 9.036 23.688 9.036 32.724 0l136.136-136.136c14.577-14.577 4.253-39.502-16.362-39.502h-272.272c-20.615 0-30.939 24.925-16.362 39.502z"
  }))), _symbol61 || (_symbol61 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-left-l",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M288.8,164.7l-85,81.5c-5.6,5.4-5.6,14.2,0,19.6l85,81.5c9.1,8.7,24.7,2.5,24.7-9.8v-163C313.3,162.2,297.8,156,288.8,164.7L288.8,164.7z"
  }))), _symbol62 || (_symbol62 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M307.6,103.5L171.5,239.6c-9,9-9,23.7,0,32.7l136.1,136.1c14.6,14.6,39.5,4.3,39.5-16.4V119.9C347.1,99.2,322.2,88.9,307.6,103.5L307.6,103.5z"
  }))), _symbol63 || (_symbol63 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-right-l",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M224.2,347.2l85-81.5c5.6-5.4,5.6-14.2,0-19.6l-85-81.5c-9.1-8.7-24.7-2.5-24.7,9.8v163C199.6,349.8,215.1,356,224.2,347.2L224.2,347.2z"
  }))), _symbol64 || (_symbol64 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M204.3,408.4l136.1-136.1c9-9,9-23.7,0-32.7L204.3,103.5c-14.6-14.6-39.5-4.3-39.5,16.4V392C164.8,412.7,189.7,423,204.3,408.4L204.3,408.4z"
  }))), _symbol65 || (_symbol65 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-top-l",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M347.8,288.2l-81.5-85c-5.4-5.6-14.2-5.6-19.6,0l-81.5,85c-8.7,9.1-2.5,24.7,9.8,24.7h163C350.3,312.8,356.5,297.3,347.8,288.2L347.8,288.2z"
  }))), _symbol66 || (_symbol66 = /*#__PURE__*/React.createElement("symbol", {
    id: "caret-top",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M408.5,307.7L272.4,171.6c-9-9-23.7-9-32.7,0L103.5,307.7c-14.6,14.6-4.3,39.5,16.4,39.5h272.3C412.8,347.2,423.1,322.3,408.5,307.7L408.5,307.7z"
  }))), _symbol67 || (_symbol67 = /*#__PURE__*/React.createElement("symbol", {
    id: "catalog",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-catalog-border",
    d: "M444.8,32H70.4C32,32,0,64,0,102.4v310.4C0,448,32,480,70.4,480h374.4c38.4,0,67.2-32,67.2-67.2V102.4C512,64,480,32,444.8,32z M64,96h64v320H64V96z M448,416H192V96h256V416z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-catalog-line-top",
    x: 256,
    y: 160,
    width: 128,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-catalog-line-middle",
    x: 256,
    y: 224,
    width: 128,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-catalog-line-bottom",
    x: 256,
    y: 288,
    width: 128,
    height: 32
  }))), _symbol68 || (_symbol68 = /*#__PURE__*/React.createElement("symbol", {
    id: "categories",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M491.7,262.6l-1-1.2l-5.2-5.2c32.9-35,35.5-86.1,6.2-121.6l-1-1.2l-96.6-96.6C364.9,7.7,333.2,1.3,316.9,0.1L315.8,0H85.6C63,0,41.5,9.1,25.2,25.6C8.9,42,0,63.5,0,86v340.3c0,22.7,9,44.2,25.3,60.5C41.5,503,63,512,85.6,512h0l223.1-0.1h1.2l1.2-0.1c19.4-1.5,56.4-8.5,86.2-39.5l87.4-87.4l0.7-0.7C518.3,349.3,521,298.1,491.7,262.6z M340.5,212.5C335,218,327.7,221,320,221c-15.5,0-29-13.5-29-29c0-16,13-29,29-29c7.8,0,15,3,20.5,8.5c5.5,5.5,8.5,12.8,8.5,20.5C349,199.8,346,207,340.5,212.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline categories-tag-hole-border",
    d: "M320,256c17.1,0,33.2-6.6,45.3-18.7c12.1-12.1,18.7-28.2,18.7-45.3c0-34.1-29.8-64-64-64c-35.3,0-64,28.7-64,64c0,17.1,6.7,33.2,18.7,45.3C286.8,249.4,302.9,256,320,256z M320,163c7.8,0,15,3,20.5,8.5c5.5,5.5,8.5,12.8,8.5,20.5c0,7.8-3,15-8.5,20.5C335,218,327.7,221,320,221c-15.5,0-29-13.5-29-29C290.9,176,304,163,320,163z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline categories-tag-border",
    d: "M0,426.3c0,22.7,9,44.2,25.3,60.5C41.5,503,63,512,85.6,512h0l223.1-0.1h1.2l1.2-0.1c19.4-1.5,56.4-8.5,86.2-39.5l87.4-87.4l0.7-0.7c33-35,35.6-86.2,6.3-121.7l-1-1.2l-5.2-5.2c32.9-35,35.5-86.1,6.2-121.6l-1-1.2l-96.6-96.6C364.9,7.7,333.2,1.3,316.9,0.1L315.8,0H85.6C63,0,41.5,9.1,25.2,25.6C8.9,42,0,63.5,0,86 M85.6,320c-5.6,0-10.8-2.2-15.1-6.5c-4.3-4.3-6.5-9.5-6.5-15.2V256V86.1C64,74.5,74.3,64,85.6,64h227.6c7.7,0.8,21.7,4.2,35.6,18.1l94.3,94.3c7.7,10.3,6.1,24.8-4,35.8l-87.2,87.2l-0.5,0.5c-14.5,15.2-33.3,19.2-43.9,20.1L85.6,320 M85.6,448c-5.6,0-10.8-2.2-15.1-6.5c-4.3-4.3-6.5-9.5-6.5-15.2v-45.1c7,1.8,14.2,2.8,21.6,2.8h0l223.1-0.1h1.2l1.2-0.1c19.4-1.5,56.4-8.5,86.2-39.5l42.9-42.9l2.9,2.9c7.7,10.3,6.1,24.8-4,35.8l-87.2,87.2l-0.5,0.5c-14.5,15.2-33.3,19.2-43.9,20.1L85.6,448"
  }))), _symbol69 || (_symbol69 = /*#__PURE__*/React.createElement("symbol", {
    id: "chain-broken",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M338.7,37.9L226.8,149.8c-23.1,23.1,11.9,58,35,34.9L373.6,72.8c43.6-43.6,109.2,21.9,65.6,65.6L327.3,250.3c-23.1,23.1,11.9,58,35,34.9l111.9-111.9C564.5,83,429.2-52.7,338.7,37.9z M173.3,474.1l111.9-111.9c23.1-23.1-11.9-58-35-34.9L138.4,439.2c-43.6,43.6-109.2-21.9-65.6-65.6l111.9-111.9c23.1-23.1-11.9-58-35-34.9L37.8,338.7C-52.5,429,82.8,564.7,173.3,474.1z"
  }))), _symbol70 || (_symbol70 = /*#__PURE__*/React.createElement("symbol", {
    id: "change-list-disabled",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-disabled-arrow-right",
    d: "M264.56,379.24L160.59,483.22c3.84,22.48,31.97,40.83,54.91,18.96l63-63.2C303.82,409.06,273.41,389.44,264.56,379.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-disabled-box",
    d: "M480,224h-60.38L320,323.62V480c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32V256C512,238.3,497.7,224,480,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-disabled-arrow-left",
    d: "M440.64,22.31L398.95,64h-64.3c44.07-35.02-5.4-84.7-37.6-54l-63,63.2c-13.5,14.9-12.8,32.6,0,45.8L289,173.95L78.96,384H32.3c-37.26,0-41.38,49.55-13.14,61.38c-23.04,40.16,24.93,63.68,48.38,40.55c0,0,419.89-420.49,419.79-420.51C511.25,37.44,475.11-6.96,440.64,22.31z M334.8,128.15l-0.15-0.15h0.3L334.8,128.15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-disabled-box-outline",
    d: "M32,0h128c17.7,0,32,14.3,32,32v224c0,17.7-14.3,32-32,32H32c-17.7,0-32-14.3-32-32V32C0,14.3,14.3,0,32,0z M128,224V64H64v160H128z"
  }))), _symbol71 || (_symbol71 = /*#__PURE__*/React.createElement("symbol", {
    id: "change-list",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-box-outline",
    d: "M128,64v160H64V64H128 M160,0H32C14.3,0,0,14.3,0,32v224c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32V32C192,14.3,177.7,0,160,0L160,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-box",
    d: "M480,512H352c-17.7,0-32-14.3-32-32V256c0-17.7,14.3-32,32-32h128c17.7,0,32,14.3,32,32v224C512,497.7,497.7,512,480,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-arrow-left",
    d: "M234.1,73.2c-13.5,14.9-12.8,32.6,0,45.8l62.5,62.5c26.6,28.8,77.1-10.8,45.8-45.8l-7.7-7.7h145.6c42.3,0,42-64,0-64H334.7l8.2-8.2c29.1-28-13.6-76.5-45.8-45.8L234.1,73.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-list-arrow-right",
    d: "M278.5,438.8c13.5-14.9,12.8-32.6,0-45.8l-62.5-62.5c-26.6-28.8-77.1,10.8-45.8,45.8l7.7,7.7H32.3c-42.3,0-42,64,0,64h145.6l-8.2,8.2c-29.1,28,13.6,76.5,45.8,45.8L278.5,438.8z"
  }))), _symbol72 || (_symbol72 = /*#__PURE__*/React.createElement("symbol", {
    id: "change",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-top",
    d: "M32,256L32,256c17.6,0,32-14.4,32-32v-96h342.6l-17.1,17.1c-12.4,12.4-12.4,32.8,0,45.3l0,0c12.4,12.4,32.8,12.4,45.3,0l67.9-67.9l0,0c12.4-12.4,12.4-32.8,0-45.3l0,0L434.8,9.3c-12.4-12.4-32.8-12.4-45.3,0l0,0c-12.4,12.4-12.4,32.8,0,45.3l9.4,9.4H32h0C14.4,64,0,78.4,0,96v0v128C0,241.6,14.4,256,32,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline change-bottom",
    d: "M480,256L480,256c-17.6,0-32,14.4-32,32v96H105.4l17.1-17.1c12.4-12.4,12.4-32.8,0-45.3l0,0c-12.4-12.4-32.8-12.4-45.3,0L9.3,389.5l0,0c-12.4,12.4-12.4,32.8,0,45.3l0,0l67.9,67.9c12.4,12.4,32.8,12.4,45.3,0l0,0c12.4-12.4,12.4-32.8,0-45.3l-9.4-9.4H480h0c17.6,0,32-14.4,32-32v0V288C512,270.4,497.6,256,480,256z"
  }))), _symbol73 || (_symbol73 = /*#__PURE__*/React.createElement("symbol", {
    id: "chatbot",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-chatbot-border",
    d: "M480,32H32C12.8,32,0,44.8,0,64v319.7c0,19.2,12.8,32,32,32h64v32c0,25.6,32,44.8,54.4,22.5l54.4-54.4H480c19.2,0,32-12.8,32-32V64C512,44.8,499.2,32,480,32z M448,351.8H64V96h384V351.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-chatbot-eye-1",
    x: 128,
    y: 160,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-chatbot-eye-2",
    x: 320,
    y: 160,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-chatbot-mouth",
    d: "M256,320c64,0,96-28.7,96-64H160C160,291.3,192,320,256,320z"
  }))), _symbol74 || (_symbol74 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M471.2,117.7L280.3,340.8c-5.9,6.8-14.6,11.2-24.3,11.2c-8.8,0-16.8-3.6-22.6-9.4l-96-96.1 c-29.1-28.9,16.1-74.2,45.2-45.3l71.6,71.7L423.7,74.8c2.2-2.5,4.7-3.9,7.1-5.5C385,26.5,323.7,0,256,0C114.6,0,0,114.6,0,256 s114.6,256,256,256s256-114.6,256-256C512,205,496.9,157.6,471.2,117.7z"
  }))), _symbol75 || (_symbol75 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline check-circle-arc",
    d: "M256,512C114.8,512,0,397.2,0,256S114.8,0,256,0c27.3,0,54.2,4.3,79.9,12.7 c40.7,13.3,20,73.9-19.9,60.8c-19.3-6.3-39.5-9.5-60-9.5C150.1,64,64,150.1,64,256s86.1,192,192,192s192-86.1,192-192 c0-7.3-0.4-14.4-1.2-21.4c-2.5-43.4,58.4-47.8,63.6-7c1,9.3,1.6,18.8,1.6,28.5C512,397.2,397.2,512,256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline check-circle-check",
    d: "M423.7,74.8L254.2,272.9l-71.6-71.7c-29.1-28.9-74.3,16.4-45.2,45.3l96,96.1c5.8,5.8,13.8,9.4,22.6,9.4 c9.7,0,18.4-4.4,24.3-11.2l192-224.4C498.9,85.4,450.3,44.1,423.7,74.8z"
  }))), _symbol76 || (_symbol76 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-small",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M220.9,377.2c-8,0-15.8-3.2-21.5-8.9l-91-91c-28.1-28.1,14.8-71,42.9-42.9l68.2,68.2l139.8-157.2c26.4-30,72,10.1,45.6,40.1 L243.7,366.9c-5.5,6.3-13.4,10-21.8,10.3C221.5,377.2,221.2,377.2,220.9,377.2z"
  }))), _symbol77 || (_symbol77 = /*#__PURE__*/React.createElement("symbol", {
    id: "check-square",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline check-square-border",
    d: "M448,512H64c-35.3,0-64-28.7-64-64V64C0,28.7,28.7,0,64,0h224c42.7,0,42.7,64,0,64H64v384h384V288 c0-42.7,64-42.7,64,0v160C512,483.3,483.3,512,448,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline check-square-check",
    d: "M423.7,74.8L254.2,272.9l-71.6-71.7c-29.1-28.9-74.3,16.4-45.2,45.3l96,96.1c5.8,5.8,13.8,9.4,22.6,9.4 c9.7,0,18.4-4.4,24.3-11.2l192-224.4C498.9,85.4,450.3,44.1,423.7,74.8z"
  }))), _symbol78 || (_symbol78 = /*#__PURE__*/React.createElement("symbol", {
    id: "check",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M192.9,429.5c-8.3,0-16.4-3.3-22.3-9.2L44.5,294.1C15,263.2,62.7,222,89.1,249.5L191.5,352l230-258.9 c27.2-30.5,74.3,11.5,47.1,41.9L216.4,418.9c-5.8,6.5-14,10.3-22.6,10.6C193.5,429.5,193.2,429.5,192.9,429.5z"
  }))), _symbol79 || (_symbol79 = /*#__PURE__*/React.createElement("symbol", {
    id: "chip",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline chip-cpu",
    d: "M304,352h-96c-26.5,0-48-21.5-48-48v-96c0-26.5,21.5-48,48-48h96c26.5,0,48,21.5,48,48v96C352,330.5,330.5,352,304,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline chip-circuit",
    d: "M489.4,192c29.6,0,29.6-64,0-64H448c0-35.3-28.7-64-64-64V22.6c0-29.6-64-29.6-64,0V64h-32V22.6c0-29.6-64-29.6-64,0V64h-32V22.6c0-29.6-64-29.6-64,0V64c-35.3,0-64,28.7-64,64H22.6c-29.6,0-29.6,64,0,64H64v32H22.6c-29.6,0-29.6,64,0,64H64v32H22.6c-29.6,0-29.6,64,0,64H64c0,35.3,28.7,64,64,64v41.4c0,29.6,64,29.6,64,0V448h32v41.4c0,29.6,64,29.6,64,0V448h32v41.4c0,29.6,64,29.6,64,0V448c35.3,0,64-28.7,64-64h41.4c29.6,0,29.6-64,0-64H448v-32h41.4c29.6,0,29.6-64,0-64H448v-32H489.4z M384,384H128V128h256V384z"
  }))), _symbol80 || (_symbol80 = /*#__PURE__*/React.createElement("symbol", {
    id: "circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline",
    cx: 256,
    cy: 256,
    r: 256
  }))), _symbol81 || (_symbol81 = /*#__PURE__*/React.createElement("symbol", {
    id: "closed-book",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-closed-book-cover",
    fill: "none",
    x: 160,
    y: 64,
    width: 224,
    height: 224
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-closed-book-case",
    d: "M416,0H160c-53,0-96,46.3-96,96v320c0,0,0,64,80.2,63.7c0.1,0,4.7,0.3,15.8,0.3v-32h-16 c-64.1-0.1-63.9-96.1,0.2-96H416c17.7-0.1,32-15.4,32-32V32C448,15.4,433.7,0,416,0z M384,288H160V64h224V288z M192,512l48-32l48,32 v-96h112c23.1-1.6,19.4-31.7,0-32H143.8c-20.1,0.3-22.2,31,0,32H192V512z M432,480c0,0-52,0-112,0v-32l112,0.1 C452.9,449.3,453.6,478.7,432,480z"
  }))), _symbol82 || (_symbol82 = /*#__PURE__*/React.createElement("symbol", {
    id: "cloud",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M413.3,197.4C385.4,45.7,184.4,12,113.6,152.9c-150,21-157.6,283.7,13.9,295.6h278.2C548.8,440.7,543.5,209.5,413.3,197.4z M380.6,384.3H140.2c-99.6,0-116.1-177.4,16.6-177.4c30.4-121.8,201.4-103,201.4,33.4C476.8,241.2,469.4,381.4,380.6,384.3z"
  }))), _symbol83 || (_symbol83 = /*#__PURE__*/React.createElement("symbol", {
    id: "code",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M183.23,185.38c31.09-31.09-16.11-78.3-47.21-47.21l-94.41,94.41c-13.56,13.56-12.04,35.17,0,47.21l94.41,94.41c30.03,30.03,78.71-15.7,47.21-47.21l-70.72-70.58L183.23,185.38z M328.77,326.62c-31.09,31.09,16.11,78.3,47.21,47.21l94.41-94.41c13.56-13.56,12.04-35.17,0-47.21l-94.41-94.41c-30.03-30.03-78.71,15.7-47.21,47.21l70.72,70.58L328.77,326.62z"
  }))), _symbol84 || (_symbol84 = /*#__PURE__*/React.createElement("symbol", {
    id: "cog",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M451.1,280.9c2.3-15.5-0.5-39.3-1.9-50.1l48.5-32.2c13.4-9.3,17.6-27.1,9.9-41.4l-35.7-63c-7.9-14.7-25.7-20.8-41-14.2l-51.2,23.5c-12.9-10.4-34.3-21.9-49.9-28l-6.7-47.9C320.9,11.8,307.3,0,291.3,0l-70,0c-16.1,0-29.6,11.9-31.8,27.7l-6.5,46.9c-18.5,7.7-36.9,19.1-50.3,29.1L82.7,79.5c-14.7-5.8-30.4-4.5-38.4,9.2l-39.8,61c-7.9,13.4-4.9,30.5,7,40.6l50.3,40.2c-1.6,11.7-3,35.2-0.6,50.9l-47.4,32.6c-13.5,9.5-17.6,27.7-9.5,42l38.9,64.5c8.2,14.3,26,20.1,41.1,13.4l48.4-25.7c13.2,10.2,34.5,23.2,50.2,29.3l5.7,46.2c1.9,16.1,15.5,28.2,31.8,28.3l72.1,0.2c16.3,0,30-12.1,31.9-28.2l5.3-46.9c18.7-7.5,37.2-17.4,50.4-27.8l52.7,21.7c15.4,7.2,33.8,1.2,41.9-13.7l33.6-60.1c7.6-14.1,3.7-31.6-9.3-41L451.1,280.9z M256.4,343.4c-103.7,0-110.4-160,0-160C365.1,183.4,360.1,343.4,256.4,343.4z M504.1,318.2 M83.7,75.1"
  }))), _symbol85 || (_symbol85 = /*#__PURE__*/React.createElement("symbol", {
    id: "color-picker",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline color-picker-bucket",
    d: "M430.1,217.1L225,10.8c-29.8-30-75.9,15.3-45.6,45.8l22.8,22.9L19.9,262.9c-25.2,25.3-25.2,66.4,0,91.7l136.7,137.5c25.2,25.3,66,25.3,91.2,0l182.3-183.3C455.2,283.4,455.2,242.4,430.1,217.1z M247.8,125.4l130.1,130.8H117.7L247.8,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline color-picker-drop",
    d: "M511,446.6c0,85.6-128.9,86.1-128.9,0c0-35.8,64.5-97.2,64.5-97.2S511,410.8,511,446.6z"
  }))), _symbol86 || (_symbol86 = /*#__PURE__*/React.createElement("symbol", {
    id: "columns",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body columns-bg-left",
    fill: "none",
    d: "M0,46.9v418.1C0,490.9,21.1,512,46.9,512h130.8c25.8,0,46.9-21.1,46.9-46.9V46.9c0-25.8-21.1-46.9-46.9-46.9H46.9C21.1,0,0,21.1,0,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body columns-bg-right",
    fill: "none",
    d: "M287.3,46.9v418.1c0,25.8,21.1,46.9,46.9,46.9h130.8c25.8,0,46.9-21.1,46.9-46.9V46.9C512,21.1,490.9,0,465.1,0H334.3C308.4,0,287.3,21.1,287.3,46.9L287.3,46.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline columns-border-left",
    d: "M0,46.9v418.1C0,490.9,21.1,512,46.9,512h130.8c25.8,0,46.9-21.1,46.9-46.9V46.9c0-25.8-21.1-46.9-46.9-46.9H46.9C21.1,0,0,21.1,0,46.9z M160.7,64v384h-96V64H160.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline columns-border-right",
    d: "M287.3,46.9v418.1c0,25.8,21.1,46.9,46.9,46.9h130.8c25.8,0,46.9-21.1,46.9-46.9V46.9C512,21.1,490.9,0,465.1,0H334.3C308.4,0,287.3,21.1,287.3,46.9L287.3,46.9z M448,64v384h-96V64H448z"
  }))), _symbol87 || (_symbol87 = /*#__PURE__*/React.createElement("symbol", {
    id: "comments",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v288c0,35.3,28.7,64,64,64h50.7l-41,41c-12.5,12.5-12.5,32.8,0,45.3c6.2,6.2,14.4,9.4,22.6,9.4s16.4-3.1,22.6-9.4l86.3-86.3H448c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline comments-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v288c0,35.3,28.7,64,64,64h50.7l-41,41c-12.5,12.5-12.5,32.8,0,45.3c6.2,6.2,14.4,9.4,22.6,9.4s16.4-3.1,22.6-9.4l86.3-86.3H448c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,352H64V64h384V352L448,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline comments-line-top",
    d: "M384,128H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h256c17.7,0,32-14.3,32-32S401.7,128,384,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline comments-line-bottom",
    d: "M288,224H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S305.7,224,288,224z"
  }))), _symbol88 || (_symbol88 = /*#__PURE__*/React.createElement("symbol", {
    id: "community",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,256.6c0,337.1,512,344.1,512,0C512-85.5,0-85.5,0,256.6z M60.6,363.1c7.3-61.8,67.3-106.5,109.3-106.9C296.2,255.1,307,403.8,305,474.8C199.3,505.3,90,429.4,60.6,363.1z M128,176c0-63.7,95.8-63.9,95.8,0C223.8,241.3,128,239.3,128,176z M404,261.4c32.7-50.7-8.3-101.4-52.4-101c-57,0.6-82.8,66.9-47.1,102.2c-10.9,1.9-18.7,7.7-19,7.4c-22.4-25-54.7-35.6-54.5-35.8c52.6-46.2,19.2-137.8-55.1-138.3c-66.4-0.5-110.6,81.1-54,139.4c-63,26.3-81.3,83.5-81.8,81C4.7,149.3,134.3,31.9,256,31.9c123.5,0,258.3,112.6,211.3,299.2C445.9,284.8,417.3,267.4,404,261.4z"
  }))), _symbol89 || (_symbol89 = /*#__PURE__*/React.createElement("symbol", {
    id: "compress",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline compress-top-left",
    d: "M192 64v0c-17.6 0-32 14.4-32 32v25.373l-88.005-88.005c-10.623-10.623-28.005-10.623-38.627 0v0c-10.623 10.623-10.623 28.005 0 38.627l88.005 88.005h-25.373c-17.6 0-32 14.4-32 32v0c0 17.6 14.4 32 32 32h96c0.815 0 1.619-0.041 2.419-0.101 7.746 0.646 15.72-1.971 21.614-7.865v0c5.893-5.893 8.512-13.868 7.865-21.614 0.060-0.799 0.101-1.605 0.101-2.419v-96c0-17.6-14.4-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline compress-bottom-left",
    d: "M64 320v0c0 17.6 14.4 32 32 32h25.373l-88.005 88.005c-10.623 10.623-10.623 28.005 0 38.627v0c10.623 10.623 28.005 10.623 38.627 0l88.005-88.005v25.373c0 17.6 14.4 32 32 32v0c17.6 0 32-14.4 32-32v-96c0-0.815-0.041-1.62-0.101-2.419 0.646-7.747-1.971-15.721-7.865-21.614v0c-5.893-5.894-13.868-8.512-21.614-7.865-0.799-0.060-1.605-0.101-2.419-0.101h-96c-17.6 0-32 14.4-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline compress-bottom-right",
    d: "M320 448v0c17.6 0 32-14.4 32-32v-25.373l88.005 88.005c10.623 10.623 28.005 10.623 38.627 0v0c10.623-10.623 10.623-28.005 0-38.627l-88.005-88.005h25.373c17.6 0 32-14.4 32-32v0c0-17.6-14.4-32-32-32h-96c-0.815 0-1.62 0.041-2.419 0.101-7.747-0.646-15.721 1.971-21.614 7.865v0c-5.894 5.894-8.512 13.868-7.865 21.614-0.060 0.8-0.101 1.604-0.101 2.419v96c0 17.6 14.4 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline compress-top-right",
    d: "M448 192v0c0-17.6-14.4-32-32-32h-25.373l88.005-88.005c10.623-10.623 10.623-28.005 0-38.627v0c-10.623-10.623-28.005-10.623-38.627 0l-88.005 88.005v-25.373c0-17.6-14.4-32-32-32v0c-17.6 0-32 14.4-32 32v96c0 0.815 0.041 1.619 0.101 2.419-0.646 7.746 1.971 15.72 7.865 21.614v0c5.894 5.893 13.868 8.512 21.614 7.865 0.8 0.060 1.604 0.101 2.419 0.101h96c17.6 0 32-14.4 32-32z"
  }))), _symbol90 || (_symbol90 = /*#__PURE__*/React.createElement("symbol", {
    id: "container",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon",
    clipRule: "evenodd",
    d: "M448,64H64v384h384V64z M64,0C31.75,0,0,32.25,0,65c0,127.89,0,383,0,383c0,32.19,32.19,64,64,64h384c32,0,64-31.87,64-64V64c0-32-31.75-64-64-64H64z",
    fillRule: "evenodd"
  }))), _symbol91 || (_symbol91 = /*#__PURE__*/React.createElement("symbol", {
    id: "control-panel",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline control-panel-top",
    d: "M32,128h296.6c11.1,19.1,31.7,32,55.4,32s44.3-12.9,55.4-32H480c17.7,0,32-14.3,32-32s-14.3-32-32-32h-40.6c-11.1-19.1-31.7-32-55.4-32s-44.3,12.9-55.4,32H32C14.3,64,0,78.3,0,96S14.3,128,32,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline control-panel-bottom",
    d: "M480,384h-40.6c-11.1-19.1-31.7-32-55.4-32s-44.3,12.9-55.4,32H32c-17.7,0-32,14.3-32,32s14.3,32,32,32h296.6c11.1,19.1,31.7,32,55.4,32s44.3-12.9,55.4-32H480c17.7,0,32-14.3,32-32S497.7,384,480,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline control-panel-middle",
    d: "M480,224H183.4c-11.1-19.1-31.7-32-55.4-32s-44.3,12.9-55.4,32H32c-17.7,0-32,14.3-32,32s14.3,32,32,32h40.5c11.1,19.1,31.7,32,55.4,32s44.3-12.9,55.4-32H480c17.7,0,32-14.3,32-32S497.7,224,480,224z"
  }))), _symbol92 || (_symbol92 = /*#__PURE__*/React.createElement("symbol", {
    id: "copy",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    d: "M412,128h-60V68c0-37.4-30.6-68-68-68H100C62.6,0,32,30.6,32,68v248c0,37.4,30.6,68,68,68h60v60c0,37.4,30.6,68,68,68h184c37.4,0,68-30.6,68-68V196C480,158.6,449.4,128,412,128z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M412,128h-60V68c0-37.4-30.6-68-68-68H100C62.6,0,32,30.6,32,68v248c0,37.4,30.6,68,68,68h60v60c0,37.4,30.6,68,68,68h184c37.4,0,68-30.6,68-68V196C480,158.6,449.4,128,412,128z M160,196v124H96V64h192v64h-60C190.6,128,160,158.6,160,196z M416,448H224V192h192V448z"
  }))), _symbol93 || (_symbol93 = /*#__PURE__*/React.createElement("symbol", {
    id: "credit-card",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-credit-card-border",
    d: "M448,32.1L64,32C32,32,0,64.1,0,96v320.1c0,32,32,64,64,64h384c32,0,64-32,64-64V96C512,64.1,480,32.1,448,32.1z M448,416.1H64v-224h384V416.1z M448,128.1H64V96h384V128.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-credit-card-text",
    d: "M304,288.1h64c62.7,0,63.3,96,0,96h-64C240.7,384.1,239.7,288.1,304,288.1z"
  }))), _symbol94 || (_symbol94 = /*#__PURE__*/React.createElement("symbol", {
    id: "cursor",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M468.3,273.8L110.6,5.9C90.4-9.2,61.9,6.7,64.1,31.8l40.4,453.6c2.4,27,37.2,36.4,52.8,14.2l106.5-151c5.1-7.2,13.2-11.8,22-12.3l166.7-10C479.7,324.6,490,290.1,468.3,273.8z"
  }))), _symbol95 || (_symbol95 = /*#__PURE__*/React.createElement("symbol", {
    id: "custom-field",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline custom-field-cursor",
    points: "416,32 416,0 288,0 288,32 320,32 320,480 288,480 288,512 416,512 416,480 384,480 384,32 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-field-placeholder",
    d: "M224,224h-96c-41.6,0-41.6,60.8,0,64h96C265.6,288,265.6,224,224,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-field-border1",
    d: "M288,352H64V160h224V96H32c-19.2,0-32,12.8-32,32v256c0,19.2,12.8,32,32,32h256V352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-field-border2",
    d: "M480,96h-64v64h32v192h-32v64h64c19.2,0,32-12.8,32-32V128C512,108.8,499.2,96,480,96z"
  }))), _symbol96 || (_symbol96 = /*#__PURE__*/React.createElement("symbol", {
    id: "custom-size",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-size-border",
    d: "M332.8,230.4H384v-51.2c0-28.2-23-51.2-51.2-51.2h-51.2v51.2h51.2V230.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-size-border",
    d: "M332.8,409.6v51.2H51.2V179.2h51.2V128H51.2C23,128,0,151,0,179.2v281.6C0,489,23,512,51.2,512h281.6c28.2,0,51.2-23,51.2-51.2v-51.2H332.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-size-arrow-right",
    d: "M504.3,302.1l-51.2-48.6c-15.4-15.4-43.5-5.1-43.5,17.9v23H307.2c-33.6,0-34.1,51.2,0,51.2h102.4v23c0,23,28.2,33.3,43.5,17.9l51.2-48.6C514.6,327.7,514.6,312.3,504.3,302.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline custom-size-arrow-up",
    d: "M174.1,7.7l-48.6,51.2c-15.4,15.4-5.1,43.5,17.9,43.5h23v102.4c0,34.1,51.2,34.5,51.2,0V102.4h23c23,0,33.3-28.2,17.9-43.5L209.9,7.7C199.7-2.6,184.3-2.6,174.1,7.7z"
  }))), _symbol97 || (_symbol97 = /*#__PURE__*/React.createElement("symbol", {
    id: "cut",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M335.4,208.2c-16.7-16.6-32.8-32.8-48-47.9c35.1-35.1,68.9-69,96.2-96.3H480 C455.9,88.1,397.6,146.2,335.4,208.2z M287.4,256.1c78,77.9,161.9,161.6,192.1,191.9h-95.6c-39.6-39.6-93.2-93.1-144.3-144.1c-10.4,10.4-20.4,20.3-29.8,29.8c9,14.6,14.3,31.9,14.3,50.3c0,53-43,96-96,96s-96-43-96-96s43-96,96-96c9.7,0,19,1.4,27.9,4.1c11.2-11.3,23.3-23.3,35.9-35.9c-12.7-12.7-24.9-24.9-36.2-36.2c-8.7,2.6-18,4-27.5,4c-53,0-96-43-96-96s43-96,96-96s96,43,96,96c0,18.5-5.3,35.8-14.4,50.5c9.5,9.5,19.5,19.4,29.9,29.8c0.1-0.1,0.1-0.1,0.2-0.2c15.1,15.1,31.3,31.2,47.9,47.8C287.5,256,287.4,256.1,287.4,256.1z M128,160c17.7,0,32-14.3,32-32s-14.3-32-32-32c-17.7,0-32,14.3-32,32S110.3,160,128,160z M160,384c0-17.7-14.3-32-32-32c-17.7,0-32,14.3-32,32s14.3,32,32,32C145.7,416,160,401.7,160,384z"
  }))), _symbol98 || (_symbol98 = /*#__PURE__*/React.createElement("symbol", {
    id: "date",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "date-border lexicon-icon-outline",
    d: "M512,160.1c0-35-28.7-64-63.7-64l-0.3,0V32c0-44-64-41-64,0v64h-96V32c0-40-64-44-64,0v64h-96V32c0-45-64-40-64,0v64l-0.3,0C28.7,96,0,125,0,160v288.1c0,35,29,64,64,64h352l96-96V160.1z M384,448.2v-64h64L384,448.2z M448,320.1H320v128H64V160.1h384V320.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "date-1 lexicon-icon-outline",
    points: "256,416 288,416 288,256 288,224 288,192 256,192 256,224 224,224 224,256 256,256 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "date-3 lexicon-icon-outline",
    x: 96,
    y: 192,
    width: 64,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "date-3 lexicon-icon-outline",
    x: 160,
    y: 224,
    width: 32,
    height: 63
  }), /*#__PURE__*/React.createElement("rect", {
    className: "date-3 lexicon-icon-outline",
    x: 98.3,
    y: 288,
    width: 61.7,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "date-3 lexicon-icon-outline",
    points: "160,416 160,384 96,384 96,416 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "date-3 lexicon-icon-outline",
    x: 160,
    y: 320,
    width: 32,
    height: 63
  }))), _symbol99 || (_symbol99 = /*#__PURE__*/React.createElement("symbol", {
    id: "decimal",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline decimal-hundreths",
    d: "M397.1,129.3c-74,0-82.9,84.1-82.9,125.6s10.4,127.9,82.9,127.9c73.5,0,82.9-86.4,82.9-127.9C480,213.6,470.6,129.3,397.1,129.3z M397.1,163.8c19.4-0.4,29.3,15.8,34.7,34.9l-75,75C355.2,231.2,355.6,163,397.1,163.8z M397.1,348.2c-18.9-0.8-28.8-16.7-34.2-35.3l74.6-74.6C437,280.5,438.3,348.2,397.1,348.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline decimal-tenths",
    d: "M199.2,129.3c-74,0-82.9,84.1-82.9,125.6s10.4,127.9,82.9,127.9c73.5,0,82.9-86.4,82.9-127.9C282.1,213.6,272.7,129.3,199.2,129.3z M199.2,163.8c19.4-0.4,29.3,15.8,34.7,34.9l-75,75C157.4,231.2,157.7,163,199.2,163.8z M199.2,348.2c-18.9-0.8-28.8-16.7-34.2-35.3l74.6-74.6C239.1,280.5,240.5,348.2,199.2,348.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline decimal-decimal-point",
    cx: 64,
    cy: 348.8,
    r: 32
  }))), _symbol100 || (_symbol100 = /*#__PURE__*/React.createElement("symbol", {
    id: "desktop",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline desktop-monitor",
    d: "M448,0H64C28.8,0,0,28.8,0,64v289.2c0,35.2,28.8,64,64,64h384c35.2,0,64-28.8,64-64V64C512,28.8,483.2,0,448,0z M448,320H64V64h384V320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline desktop-stand",
    d: "M320,448H192c-42.3,0-43,64,0,64h128C362.3,512,363.3,448,320,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline desktop-content-circle",
    d: "M160,256L160,256c-35.3,0-64-28.7-64-64l0,0c0-35.3,28.7-64,64-64l0,0c35.3,0,64,28.7,64,64l0,0C224,227.3,195.3,256,160,256z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline desktop-content-rectangle1",
    x: 288,
    y: 128,
    width: 128,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline desktop-content-rectangle2",
    x: 288,
    y: 224,
    width: 96,
    height: 32
  }))), _symbol101 || (_symbol101 = /*#__PURE__*/React.createElement("symbol", {
    id: "device-check",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-device-check-check",
    d: "M329.6,131.2l-99.2,112l-48-44.8c-32-28.8-76.8,16-41.6,48l70.4,64c12.8,12.8,32,9.6,44.8-3.2l118.4-134.4C403.2,144,355.2,102.4,329.6,131.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-device-check-device",
    d: "M416,0H96C60.8,0,32,28.8,32,64v384c0,35.2,28.8,64,64,64h320c35.2,0,64-28.8,64-64V64C480,28.8,451.2,0,416,0z M224,448c0-41.6,64-41.6,64,0C288,492.8,224,489.6,224,448z M416,384H96V64h320V384z"
  }))), _symbol102 || (_symbol102 = /*#__PURE__*/React.createElement("symbol", {
    id: "devices",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline devices1",
    d: "M224,128H32c-17.7,0-32,14.3-32,32v320c0,17.7,14.3,32,32,32h192c17.7,0,32-14.3,32-32V160C256,142.3,241.7,128,224,128L224,128z M64,416V192h128v224H64L64,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline devices2",
    d: "M448,0H192c-35.3,0-64,28.7-64,64v32h64V64h256v384H288v64h160c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }))), _symbol103 || (_symbol103 = /*#__PURE__*/React.createElement("symbol", {
    id: "diagram",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-connector",
    d: "M256,368v-32c0-22.4,32-22.4,32,0v32C288,390.4,256,390.4,256,368z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-connector",
    d: "M304,448h-32c-22.4,0-22.4-32,0-32h32C326.4,416,326.4,448,304,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-connector",
    d: "M256,272v-64c0-22.4,32-22.4,32,0v64C288,294.4,256,294.4,256,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-connector",
    d: "M256,144v-32c0-22.4,32-22.4,32,0v32C288,166.4,256,166.4,256,144z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-connector",
    d: "M272,32h32c22.4,0,22.4,32,0,32h-32C249.6,64,249.6,32,272,32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-partbox1",
    d: "M208,224h-16v-64c0-19.2-12.8-32-32-32H32c-19.2,0-32,12.8-32,32v192c0,19.2,12.8,32,32,32h128c19.2,0,32-12.8,32-32v-96h16C227.2,256,230.4,224,208,224z M128,320H64V192h64V320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-partbox2",
    d: "M480,384h-64c-19.2,0-32,12.8-32,32h-16c-22.4,0-22.4,32,0,32h16v32c0,19.2,12.8,32,32,32h64c19.2,0,32-12.8,32-32v-64C512,396.8,499.2,384,480,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-partbox3",
    d: "M480,0h-64c-19.2,0-32,12.8-32,32h-16c-22.4,0-22.4,32,0,32h16v32c0,19.2,12.8,32,32,32h64c19.2,0,32-12.8,32-32V32C512,12.8,499.2,0,480,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diagram-partbox4",
    d: "M480,192h-64c-19.2,0-32,12.8-32,32h-16c-22.4,0-22.4,32,0,32h16v32c0,19.2,12.8,32,32,32h64c19.2,0,32-12.8,32-32v-64C512,204.8,499.2,192,480,192z"
  }))), _symbol104 || (_symbol104 = /*#__PURE__*/React.createElement("symbol", {
    id: "diamond",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M210.81,493.53C162.6,445.66,69.12,346.88,18.7,301.35c-17.9-16.16-30.95-57.26,0-90.54L210.7,18.53c33.39-30.68,72.58-17.94,90.62,0.11l192.11,192.17c31.74,34.16,16.43,73.37,0.11,90.65L301.32,493.53C285.1,510.54,242.27,524.77,210.81,493.53z"
  }))), _symbol105 || (_symbol105 = /*#__PURE__*/React.createElement("symbol", {
    id: "diary",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diary-inner-content1",
    d: "M305.7,128h-99.4c-19.3,0-19.3,32,0,32h99.4C325,160,325,128,305.7,128L305.7,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diary-inner-content2",
    d: "M305.7,192h-99.4c-19.3,0-19.3,32,0,32h99.4C325,224,325,192,305.7,192L305.7,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline diary-border",
    d: "M384,0H57.2C25.6,0,0,25.6,0,57.2v397.5C0,486.4,25.6,512,57.2,512H384c35.3,0,64-28.7,64-64v-96h32c42,0,42-64,0-64h-32v-32h32c42,0,42-64,0-64h-32v-32h32c42,0,42-64,0-64h-32V64C448,28.7,419.3,0,384,0L384,0z M128,448V64h256v384H128L128,448z"
  }))), _symbol106 || (_symbol106 = /*#__PURE__*/React.createElement("symbol", {
    id: "disk",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M416,0H64C28.8,0,0,28.8,0,64v384c0,35.2,28.8,64,64,64h384c35.2,0,64-28.8,64-64V96L416,0z M128,32h128v128h96V32h32v128c0,19.2-12.8,32-32,32H160c-19.2,0-32-12.8-32-32V32z M416,480H96V320c0-19.2,12.8-32,32-32h256c19.2,0,32,12.8,32,32V480z"
  }))), _symbol107 || (_symbol107 = /*#__PURE__*/React.createElement("symbol", {
    id: "display-content",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-display-content-monitor",
    d: "M64,0h384c35.2,0,64,28.8,64,64v289.2c0,35.2-28.8,64-64,64H64c-35.2,0-64-28.8-64-64V64C0,28.8,28.8,0,64,0z M64,320h384V64H64V320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-display-content-content-circle",
    d: "M160,256c-35.3,0-64-28.7-64-64s28.7-64,64-64s64,28.7,64,64S195.3,256,160,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-display-content-content-rectangle1",
    d: "M288,128h128v32H288V128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-display-content-content-rectangle2",
    d: "M288,224h96v32h-96V224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-display-content-stand",
    d: "M320,448H192c-44.8,0-41.6,64,0,64h128C361.6,512,361.6,448,320,448z"
  }))), _symbol108 || (_symbol108 = /*#__PURE__*/React.createElement("symbol", {
    id: "display",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M64,0h384c35.2,0,64,28.8,64,64v288c0,35.2-28.8,64-64,64H64c-35.2,0-64-28.8-64-64V64C0,28.8,28.8,0,64,0z M64,320h384V64H64V320z M192,448h128c41.6,0,41.6,64,0,64H192C150.4,512,147.2,448,192,448z M432,384c8.8,0,16-7.2,16-16s-7.2-16-16-16s-16,7.2-16,16S423.2,384,432,384z"
  }))), _symbol109 || (_symbol109 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-code",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M148.3,366.8l72.4-72.4L148.3,222l18.1-18.1l90.5,90.5l-90.5,90.5L148.3,366.8z M358.4,384H256v-25.6h102.4V384z"
  }))), _symbol110 || (_symbol110 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-compressed",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline document-compressed-document",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M332.8,409.6H179.2v51.2h-25.6v-51.2h25.6v-51.2h-25.6v-51.2h25.6V256h-25.6v-51.2h25.6v-51.2h-25.6v-51.2h25.6V51.2h25.6v51.2h-25.6v51.2h25.6v51.2h-25.6V256h25.6v51.2h128V409.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline document-compressed-zipper-hole",
    x: 256,
    y: 332.8,
    width: 51.2,
    height: 51.2
  }))), _symbol111 || (_symbol111 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-default",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z"
  }))), _symbol112 || (_symbol112 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-image",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M179.2,204.8c14.1,0,25.6,11.5,25.6,25.6c0,14.1-11.5,25.6-25.6,25.6c-14.1,0-25.6-11.5-25.6-25.6C153.6,216.3,165.1,204.8,179.2,204.8z M128,384l76.8-102.4l51.2,51.2l51.2-76.8L384,384H128z"
  }))), _symbol113 || (_symbol113 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-multimedia",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M192,395.5V193.3l152.3,101.1L192,395.5z"
  }))), _symbol114 || (_symbol114 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-pdf",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M131.2,267.6h-19.4v44.3h19.3c15.3,0,24.2-7.8,24.2-22C155.3,275.3,146.6,267.6,131.2,267.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M252.7,268.4h-19.2v81.8h19.2c23.5,0,36.8-14.5,36.8-41.4C289.5,283.1,275.8,268.4,252.7,268.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M136.9,333.5h-25.1V373H85.2V245.7h53.1c26.2,0,44.1,17.6,44.1,44C182.4,315.9,163.7,333.5,136.9,333.5z M257,373h-50.1V245.6H257c37.8,0,59.7,22.9,59.7,62.8C316.7,349.8,295.1,373,257,373z M425.2,268.5h-56.7v33.2h51.8v21.8h-51.8V373h-26.6V245.7h83.3V268.5z"
  }))), _symbol115 || (_symbol115 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-pending",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-document-pending-border",
    d: "M416,287.9V416c0,17.7-14.3,32-32,32H128c-17.7,0-32-14.3-32-32V159.8c0-17.7,14.3-32,32-32h249.2l-13,13c-27.5,29.3,13.7,69.5,42.2,42.2l65.9-65.9c9.9-11,10.3-30.3,0-42.2l-65.9-66c-30.9-27.4-68.9,14.6-42.2,42.2l12.7,12.7H128c-53,0-96,43-96,96V416c0,53,43,96,96,96h256c53,0,96-43,96-96V287.9C480,245.2,416,245.9,416,287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-document-pending-line-bottom",
    d: "M273.3,384.2H175c-20.7,0-21.3-32,0-32h98.3C294.7,352.2,293.3,384.2,273.3,384.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-document-pending-line-middle",
    d: "M339,319.9H175c-20.7,0-21.3-32,0-32h164C360.3,287.9,359,319.9,339,319.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-document-pending-line-top",
    d: "M339,255.9H175c-20.7,0-21.3-32,0-32h164C360.3,223.9,359,255.9,339,255.9z"
  }))), _symbol116 || (_symbol116 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-presentation",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M307.2,384H204.8v-25.6h102.4V384z M384,332.8H128v-128h256V332.8z"
  }))), _symbol117 || (_symbol117 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-table",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline document-table-box-1",
    x: 153.6,
    y: 256,
    width: 76.8,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline document-table-box-3",
    x: 256,
    y: 332.8,
    width: 102.4,
    height: 51.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline document-table-box-2",
    x: 256,
    y: 256,
    width: 102.4,
    height: 51.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline document-table-document",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M384,409.6H128V204.8h256V409.6z"
  }))), _symbol118 || (_symbol118 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-text",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M256,384H128v-25.6h128V384z M384,307.2H128v-25.6h256V307.2z M384,230.4H128v-25.6h256V230.4z"
  }))), _symbol119 || (_symbol119 = /*#__PURE__*/React.createElement("symbol", {
    id: "document-vector",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,0H102.4C74.1,0,51.2,22.9,51.2,51.2v409.6c0,28.3,22.9,51.2,51.2,51.2h307.2c28.3,0,51.2-22.9,51.2-51.2V128L332.8,0z M307.2,409.6H204.8V384h102.4V409.6z M307.2,358.4H204.8l-51.2-76.8l89.6-160v138.3c-25.6,18.5-7.5,46.7,12.8,47.3c19.2-1.1,38.9-26.1,12.8-47.3V121.6l89.6,160L307.2,358.4z"
  }))), _symbol120 || (_symbol120 = /*#__PURE__*/React.createElement("symbol", {
    id: "document",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline document-border",
    d: "M320,64v64c0,17.7,14.3,32,32,32h64v288H96V64H320z M325.5,0H96C60.7,0,32,28.7,32,64v384c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V154.5c0-33.5-18-44.5-63.5-90S360,0,325.5,0L325.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline document-text-1",
    d: "M336,256H176c-22,0-21-32,0-32h160C356,224,358,256,336,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline document-text-2",
    d: "M336,320H176c-22,0-21-32,0-32h160C356,288,358,320,336,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline document-text-3",
    d: "M272,384h-96c-22,0-21-32,0-32h96C292,352,294,384,272,384z"
  }))), _symbol121 || (_symbol121 = /*#__PURE__*/React.createElement("symbol", {
    id: "documents-and-media",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,96h-64V64c0-35.3-28.7-64-64-64H64C28.7,0,0,28.7,0,64v256c0,35.3,28.7,64,64,64h32v64c0,35.3,28.7,64,64,64h288c35.3,0,64-28.7,64-64V160C512,124.7,483.3,96,448,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline documents-and-media-border",
    d: "M448,96h-64V64c0-35.3-28.7-64-64-64H64C28.7,0,0,28.7,0,64v256c0,35.3,28.7,64,64,64h32v64c0,35.3,28.7,64,64,64h288c35.3,0,64-28.7,64-64V160C512,124.7,483.3,96,448,96z M64,320V64h256l0,32h0v64h0l0,160c0,0,0,0,0,0H160v0H96v0H64z M448,448H160v-64h160c35.3,0,64-28.7,64-64V160h64V448C448,448,448,448,448,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline documents-and-media-line-top",
    d: "M148,188.8c2.5,2.2,5.5,3.2,8.7,3.2c3.9,0,6.9-1.2,8.9-3.5c1.5-1.8,3.2-4.9,5.1-9.6l3.7-8.9h34.4l3.7,8.7l0,0.1c0.6,1.4,1.4,2.9,2.2,4.7c1,2,1.9,3.6,2.9,4.6c1.1,1.2,2.4,2.2,3.9,2.9c1.5,0.7,3.3,1,5.4,1c3.5,0,6.5-1.1,9-3.4c2.6-2.3,3.9-5.1,3.9-8.1c0-2.5-1-5.9-3.3-10.7l-25.1-55.5c-1.2-2.8-2.2-5-2.9-6.7c-0.9-1.9-2-3.7-3.2-5.3c-1.4-1.9-3.3-3.4-5.6-4.5c-2.3-1.2-5.1-1.8-8.4-1.8c-3.2,0-6,0.6-8.3,1.8c-2.3,1.2-4.2,2.7-5.6,4.6c-1.3,1.7-2.5,3.8-3.5,6.3l-2.5,5.8l-24.5,55.9c-1.1,2.3-1.8,4.1-2.3,5.5c-0.6,1.6-0.8,3.2-0.8,4.8C144,182.8,144.7,185.9,148,188.8z M191.5,127.2l9.3,22.8h-18.4L191.5,127.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline documents-and-media-line-bottom",
    d: "M128,288h128c17.7,0,32-14.3,32-32s-14.3-32-32-32H128c-17.7,0-32,14.3-32,32S110.3,288,128,288z"
  }))), _symbol122 || (_symbol122 = /*#__PURE__*/React.createElement("symbol", {
    id: "download",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "download-arrow-down lexicon-icon-outline",
    d: "M233.2,374.5c13.1,13.2,33.5,12.2,45.6,0l71.3-71.6c29.8-29.9-14.3-77.2-45.6-45.8l-16.6,16.7V32.1c0-42.5-63.7-43-63.7,0v241.7l-16.6-16.7c-30.8-30.9-75.5,15.8-45.6,45.8L233.2,374.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "download-border lexicon-icon-outline",
    d: "M384,384.5v63.8H128v-63.8c0-43.8-64-41.8-64,0V512h384V384.5C448,340.7,384,341.7,384,384.5z"
  }))), _symbol123 || (_symbol123 = /*#__PURE__*/React.createElement("symbol", {
    id: "drag",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline drag-dot-1",
    cx: 192,
    cy: 128,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline drag-dot-2",
    cx: 192,
    cy: 256,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline drag-dot-3",
    cx: 192,
    cy: 384,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline drag-dot-4",
    cx: 320,
    cy: 128,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline drag-dot-5",
    cx: 320,
    cy: 256,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline drag-dot-6",
    cx: 320,
    cy: 384,
    r: 32
  }))), _symbol124 || (_symbol124 = /*#__PURE__*/React.createElement("symbol", {
    id: "drop",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,312.4c0-73.6-115.2-227.2-166.4-291.2c-16-16-32-16-48,0C220.8,34,64,216.4,64,312.4C73.6,562,435.2,571.6,448,312.4z M256,91.6c67.2,86.4,105.6,150.4,121.6,192C227.2,274,262.4,357.2,128,312.4l0,0C128,280.4,166.4,203.6,256,91.6z"
  }))), _symbol125 || (_symbol125 = /*#__PURE__*/React.createElement("symbol", {
    id: "dropdown",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-dropdown-border",
    d: "M448,416H64c-32,0-64-31.9-64-64V160c0-31.9,32-64,64-64h384c32,0,64,31.9,64,64v192C512,384,480,416,448,416z M64,160v192h384V160H64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-dropdown-chevron-down",
    d: "M255,223c9.4-9.4,24.6-9.4,33.9,0l31,31l31-31c9.4-9.4,24.6-9.4,33.9,0c9.4,9.4,9.4,24.6,0,33.9l-48,48c-9.4,9.4-24.6,9.4-33.9,0l-48-48C245.7,247.6,245.7,232.4,255,223z"
  }))), _symbol126 || (_symbol126 = /*#__PURE__*/React.createElement("symbol", {
    id: "dynamic-data-list",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dynamic-data-list-bolt lexicon-icon-outline",
    d: "M474.6,416.2L429.4,390l22.8-54.7c4.7-11.4-8.3-19.9-16.9-12.5l-80,75.6c-5.4,6.1-3.9,13.1,2,17l45.3,26.3L379.5,497c-4.1,10.7,8.1,20.2,17.2,11.9l80-75.6C481.4,429,481.4,419.8,474.6,416.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dynamic-data-list-border lexicon-icon-outline",
    d: "M415.7,0H95.9C60.6,0,32,28.6,32,63.9V384c0,35.3,28.7,64,63.9,64h192.2l-0.1-64l0,0h-64v-64h128V192h64v64v0.2h64V64.3C480,28.8,451.2,0,415.7,0z M160,384H96v-64h64V384z M160,256H96v-64h64V256z M160,128H96V64h64V128z M288,256h-64v-64h64V256z M288,128h-64V64h64V128z M416,128h-64V64h64V128z"
  }))), _symbol127 || (_symbol127 = /*#__PURE__*/React.createElement("symbol", {
    id: "dynamic-data-mapping",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ddm-border1",
    d: "M64,87.6h128v32h32v-64c0-19.2-12.8-32-32-32H32c-19.2,0-32,12.8-32,32v288c0,19.2,12.8,32,32,32h83.2c3.2-22.4,9.6-44.8,22.4-64H64V87.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ddm-border2",
    d: "M480,23.6H320c-19.2,0-32,12.8-32,32v64h32v-32h128v224h-73.6c12.8,19.2,19.2,41.6,22.4,64H480c19.2,0,32-12.8,32-32v-288C512,36.4,499.2,23.6,480,23.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ddm-lightning",
    d: "M313.6,391.6L268.8,366l22.4-54.4c6.4-12.8-9.6-19.2-16-12.8l-80,76.8c-6.4,6.4-6.4,12.8,3.2,16l44.8,25.6l-22.4,54.4c-3.2,12.8,9.6,19.2,16,12.8l80-76.8C320,404.4,320,394.8,313.6,391.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ddm-barbell",
    d: "M368,151.6c-22.4,0-38.4,12.8-44.8,32H188.8c-6.4-19.2-22.4-32-44.8-32c-64,0-64,96,0,96c22.4,0,38.4-12.8,44.8-32h134.4c6.4,19.2,25.6,32,44.8,32C432,247.6,432,151.6,368,151.6z"
  }))), _symbol128 || (_symbol128 = /*#__PURE__*/React.createElement("symbol", {
    id: "edit-layout",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z M160,462.2H60.5V64H160V462.2z M224,448L224,448V288h224l0,160H224L224,448z M448,224H224V64h224V224z"
  }))), _symbol129 || (_symbol129 = /*#__PURE__*/React.createElement("symbol", {
    id: "effects",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline effects-dot-1",
    d: "M352 128c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline effects-dot-2",
    d: "M480 384c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline effects-dot-3",
    d: "M224 384c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
  }))), _symbol130 || (_symbol130 = /*#__PURE__*/React.createElement("symbol", {
    id: "ellipsis-h",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ellipsis-h-dot-2",
    d: "M320 256c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ellipsis-h-dot-1",
    d: "M128 256c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ellipsis-h-dot-3",
    d: "M512 256c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
  }))), _symbol131 || (_symbol131 = /*#__PURE__*/React.createElement("symbol", {
    id: "ellipsis-v",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ellipsis-v-dot-2",
    d: "M319 255.5c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ellipsis-v-dot-3",
    d: "M319 448c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline ellipsis-v-dot-1",
    d: "M319 64c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
  }))), _symbol132 || (_symbol132 = /*#__PURE__*/React.createElement("symbol", {
    id: "embed",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline embed-lt",
    d: "M148.1,102.3c-14.2-10.5-34.2-7.6-44.8,6.6l-95,128c-8.4,11.3-8.4,26.8,0,38.1l95,128c6.3,8.5,15.9,12.9,25.7,12.9c6.6,0,13.3-2.1,19-6.3c14.2-10.5,17.2-30.6,6.6-44.8L73.9,256l80.8-108.9C165.2,132.9,162.3,112.8,148.1,102.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline embed-gt",
    d: "M505.7,238.9l-95-128c-10.5-14.2-30.6-17.2-44.8-6.6c-14.2,10.5-17.2,30.6-6.6,44.8L440.1,258l-80.8,108.9c-10.5,14.2-7.6,34.2,6.6,44.8c5.7,4.3,12.4,6.3,19,6.3c9.8,0,19.4-4.5,25.7-12.9l95-128C514.1,265.8,514.1,250.3,505.7,238.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline embed-slash",
    d: "M296.8,97c-17.1-4.3-34.5,6.1-38.8,23.3l-64,256c-4.3,17.1,6.1,34.5,23.3,38.8c2.6,0.7,5.2,1,7.8,1c14.3,0,27.4-9.7,31-24.2l64-256C324.3,118.6,313.9,101.2,296.8,97z"
  }))), _symbol133 || (_symbol133 = /*#__PURE__*/React.createElement("symbol", {
    id: "emoji",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,255.2c0,256.8-384,255.4-384,0C64-0.5,448-1.9,448,255.2z M0,255.2c0,340.3,512,344.6,512,0C512-85.6,0-84.5,0,255.2z M333.7,299.1c25.4-7,48.8,19.8,37.2,43.5c-20.8,42.6-64.5,71.9-115.1,71.9s-94.3-29.3-115.1-71.9c-11.6-23.7,14.2-52.2,37.2-43.5C232.7,322.3,276.5,325.3,333.7,299.1z M176,159c26.5,0,48,21.5,48,48s-21.5,48-48,48s-48-21.5-48-48S149.5,159,176,159z M336,159c26.5,0,48,21.5,48,48s-21.5,48-48,48s-48-21.5-48-48S309.5,159,336,159z"
  }))), _symbol134 || (_symbol134 = /*#__PURE__*/React.createElement("symbol", {
    id: "envelope-closed",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,64H64C28.7,64,0,92.7,0,128v256c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V128C512,92.7,483.3,64,448,64z M416,128L275.2,233.6c-11.3,8.5-27.1,8.5-38.4,0L96,128H416z M64,384V184l134.4,100.8c33.1,25.2,77.1,26.2,115.2,0L448,184v200H64z"
  }))), _symbol135 || (_symbol135 = /*#__PURE__*/React.createElement("symbol", {
    id: "envelope-open",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M313.6,19.1C278-8,232.7-4.7,198.4,19.1c0,0-174.5,121.2-183.7,132.2C5.7,159.3,0,176.6,0,192.1v256c0,35.3,28.6,64,64,64h384c35.3,0,64-28.6,64-64V192c0-15.2-5.7-31.7-14.2-40.1C488.6,140.5,313.6,19.1,313.6,19.1z M236.8,70.3c11.3-8.5,27.1-8.5,38.4,0L426.8,184L275.2,297.6c-11.3,8.5-27.1,8.5-38.4,0L85.2,183.9L236.8,70.3z M64,448V248l134.4,100.8c33.6,25.9,80.3,25.9,115.2,0L448,248v200H64z"
  }))), _symbol136 || (_symbol136 = /*#__PURE__*/React.createElement("symbol", {
    id: "environment-connected",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "environment-connected-server-bottom-right lexicon-icon-outline",
    d: "M480,288h-96c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32V320C512,302.3,497.7,288,480,288z M464,384h-64c-21.3,0-22-32,0-32h64C485.3,352,484.9,384,464,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "environment-connected-server-bottom-left lexicon-icon-outline",
    d: "M128,288H32c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32V320C160,302.3,145.7,288,128,288z M112,384H48c-21.3,0-22-32,0-32h64C133.3,352,132.9,384,112,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "environment-connected-server-top lexicon-icon-outline",
    d: "M320,0H192c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32V32C352,14.3,337.7,0,320,0z M304,96h-96c-21.3,0-22-32,0-32h96C325.3,64,324.9,96,304,96z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "environment-connected-border-bottom lexicon-icon-outline",
    x: 192,
    y: 384,
    width: 128,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "environment-connected-border-left lexicon-icon-outline",
    d: "M128,95.2C80.7,133,50.3,190.9,50.3,256h27.4c0-48.1,19.2-91.7,50.3-123.8V95.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "environment-connected-border-right lexicon-icon-outline",
    d: "M384,95.2v37c31.1,32.1,50.3,75.7,50.3,123.8h27.4C461.7,190.9,431.3,133,384,95.2z"
  }))), _symbol137 || (_symbol137 = /*#__PURE__*/React.createElement("symbol", {
    id: "environment-disconnected",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "environment-disconnected-server-bottom-right lexicon-icon-outline",
    d: "M480,288h-96c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32V320C512,302.3,497.7,288,480,288z M464,384h-64c-21.3,0-22-32,0-32h64C485.3,352,484.9,384,464,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "environment-disconnected-server-bottom-left lexicon-icon-outline",
    d: "M128,288H32c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h96c17.7,0,32-14.3,32-32V320C160,302.3,145.7,288,128,288z M112,384H48c-21.3,0-22-32,0-32h64C133.3,352,132.9,384,112,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "environment-disconnected-server-top lexicon-icon-outline",
    d: "M320,0H192c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32V32C352,14.3,337.7,0,320,0z M304,96h-96c-21.3,0-22-32,0-32h96C325.3,64,324.9,96,304,96z"
  }))), _symbol138 || (_symbol138 = /*#__PURE__*/React.createElement("symbol", {
    id: "environment",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M352,32H160c-35.3,0-64,28.7-64,64v320c0,35.3,28.7,64,64,64h192c35.3,0,64-28.7,64-64V96C416,60.7,387.3,32,352,32z M336,256H176c-21.3,0-22-32,0-32h160C357.3,224,356.9,256,336,256z M336,160H176c-21.3,0-22-32,0-32h160C357.3,128,356.9,160,336,160z M336,96c-21.3,0-22-32,0-32C357.3,64,356.9,96,336,96z"
  }))), _symbol139 || (_symbol139 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M491.9,156.3C479,125.8,460.5,98.5,437,75S386.2,33,355.7,20.1C324.1,6.8,290.5,0,256,0s-68.1,6.8-99.7,20.1C125.8,33,98.5,51.5,75,75S33,125.8,20.1,156.3C6.8,187.9,0,221.5,0,256s6.8,68.1,20.1,99.7C33,386.2,51.5,413.5,75,437s50.9,41.9,81.4,54.8c31.6,13.4,65.1,20.1,99.7,20.1s68.1-6.8,99.7-20.1c30.5-12.9,57.9-31.3,81.4-54.8s41.9-50.9,54.8-81.4c13.4-31.6,20.1-65.1,20.1-99.7S505.2,187.9,491.9,156.3L491.9,156.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline exclamation-circle-stem",
    d: "M240,288h32l16-160h-64L240,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline exclamation-circle-dot",
    d: "M288,352c0,17.7-14.3,32-32,32s-32-14.3-32-32s14.3-32,32-32S288,334.3,288,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline exclamation-circle-border",
    d: "M491.9,156.3C479,125.8,460.5,98.5,437,75S386.2,33,355.7,20.1C324.1,6.8,290.5,0,256,0s-68.1,6.8-99.7,20.1C125.8,33,98.5,51.5,75,75S33,125.8,20.1,156.3C6.8,187.9,0,221.5,0,256s6.8,68.1,20.1,99.7C33,386.2,51.5,413.5,75,437s50.9,41.9,81.4,54.8c31.6,13.4,65.1,20.1,99.7,20.1s68.1-6.8,99.7-20.1c30.5-12.9,57.9-31.3,81.4-54.8s41.9-50.9,54.8-81.4c13.4-31.6,20.1-65.1,20.1-99.7S505.2,187.9,491.9,156.3L491.9,156.3z M256,448c-106,0-192-86-192-192S150,64,256,64s192,86,192,192S362,448,256,448z"
  }))), _symbol140 || (_symbol140 = /*#__PURE__*/React.createElement("symbol", {
    id: "exclamation-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M256,384c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,384,256,384z M272,288h-32l-16-160h64L272,288z"
  }))), _symbol141 || (_symbol141 = /*#__PURE__*/React.createElement("symbol", {
    id: "expand",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M64,128v-25.4l88,88c25.5,25.5,64.5-12.8,38.6-38.6l-88-88H128c42.6,0,42.6-64,0-64H32C16.4,0,0,14.4,0,32v96C0,170.7,64,170.6,64,128z M448,128v-25.4l-88,88c-25.5,25.5-64.5-12.8-38.6-38.6l88-88H384c-42.6,0-42.6-64,0-64h96c15.6,0,32,14.4,32,32v96C512,170.7,448,170.6,448,128z M64,384v25.4l88-88c25.5-25.5,64.5,12.8,38.6,38.6l-88,88H128c42.6,0,42.6,64,0,64H32c-15.6,0-32-14.4-32-32v-96C0,341.3,64,341.4,64,384z M448,384v25.4l-88-88c-25.5-25.5-64.5,12.8-38.6,38.6l88,88H384c-42.6,0-42.6,64,0,64h96c15.6,0,32-14.4,32-32v-96C512,341.3,448,341.4,448,384z"
  }))), _symbol142 || (_symbol142 = /*#__PURE__*/React.createElement("symbol", {
    id: "fieldset",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-fieldset-bracket-start",
    d: "M128,64c0-17.7-14.3-32-32-32H64C28.7,32,0,60.7,0,96v320c0,35.3,28.7,64,64,64h32c17.7,0,32-14.3,32-32s-14.3-32-32-32H64V96h32C113.7,96,128,81.7,128,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-fieldset-bracket-end",
    d: "M512,416c0,35.3-28.7,64-64,64h-32c-17.7,0-32-14.3-32-32s14.3-32,32-32h32V96h-32c-17.7,0-32-14.3-32-32s14.3-32,32-32h32c35.3,0,64,28.7,64,64V416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-fieldset-line-1-dot",
    d: "M128,224c17.7,0,32-14.3,32-32s-14.3-32-32-32s-32,14.3-32,32S110.3,224,128,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-fieldset-line-1-line",
    d: "M224,160h160c17.7,0,32,14.3,32,32s-14.3,32-32,32H224c-17.7,0-32-14.3-32-32S206.3,160,224,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-fieldset-line-2-dot",
    d: "M384,288H224c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S401.7,288,384,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-fieldset-line-2-line",
    d: "M128,352c17.7,0,32-14.3,32-32s-14.3-32-32-32s-32,14.3-32,32S110.3,352,128,352z"
  }))), _symbol143 || (_symbol143 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-script",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-script-border",
    d: "M320,64v64c0,17.7,14.3,32,32,32h64v288H96V64H320z M325.5,0H96C60.7,0,32,28.7,32,64v384c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V154.5c0-33.5-18-44.5-63.5-90S360,0,325.5,0L325.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-script-forward-slash",
    d: "M212.2,409.2l69.1-187.5c7.7-20.7,37.7-7.7,30.1,10.9l-69.1,187.5C234,440,205,428,212.2,409.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-script-angle-bracket-open",
    d: "M160,320l35.9-35.9l-22.6-22.6l-35.9,35.9c-12.5,12.5-12.5,32.8,0,45.3l35.9,35.9l22.6-22.6L160,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-script-angle-bracket-close",
    d: "M355.9,320L320,284.1l22.6-22.6l35.9,35.9c12.5,12.5,12.5,32.8,0,45.3l-35.9,35.9L320,355.9L355.9,320z"
  }))), _symbol144 || (_symbol144 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-template",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-template-border",
    d: "M320,64v64c0,17.7,14.3,32,32,32h64v288H96V64H320z M325.5,0H96C60.7,0,32,28.7,32,64v384c0,35.3,28.7,64,64,64h320c35.3,0,64-28.7,64-64V154.5c0-33.5-18-44.5-63.5-90S360,0,325.5,0L325.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-template-content1",
    d: "M352,320v64H160v-64H352 M352,288H160c-17.7,0-32,14.3-32,32v64c0,17.7,14.3,32,32,32h192c17.7,0,32-14.3,32-32v-64C384,302.3,369.7,288,352,288L352,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-template-content2",
    d: "M352,256H160c-42,0-43-64,0-64h192C394,192,394,256,352,256z"
  }))), _symbol145 || (_symbol145 = /*#__PURE__*/React.createElement("symbol", {
    id: "file-xsl",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-xsl-border1",
    d: "M96,192V64h224v64c0,19.2,12.8,32,32,32h64v32h64v-38.4c0-32-19.2-44.8-64-89.6S358.4,0,326.4,0H96C60.8,0,32,28.8,32,64v128H96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-xsl-border2",
    d: "M32,448c0,35.2,28.8,64,64,64h320c35.2,0,64-28.8,64-64H32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-xsl-x",
    d: "M80,326.4l-44.8-83.2H80l26.2,52.1l24.9-52.1h41.6L128,326.4l48,89.6h-44.8l-28.8-64l0,0l-28.8,64H32L80,326.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-xsl-s",
    d: "M198.4,393.6l22.4-25.6c12.8,12.8,64,28.8,67.2,0c3.2-22.4-83.2-19.2-83.2-76.8c0-48,73.6-73.6,115.2-28.8L304,288c-25.6-19.2-60.8-16-60.8,3.2c0,25.6,86.4,16,86.4,76.8C329.6,425.6,259.2,441.6,198.4,393.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline file-xsl-l",
    d: "M374.4,243.2h38.4V384H480v32H374.4V243.2z"
  }))), _symbol146 || (_symbol146 = /*#__PURE__*/React.createElement("symbol", {
    id: "filter",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline filter-border",
    d: "M448.1,89.9V156L256,316.1l0,0L63.9,156V89.9H448.1 M480.2,25.9H31.8c-17.7,0-32,14.3-32,32V186L192,346.1v108.3c0,18.6,18.5,40.8,46.3,28.6l64-32c10.8-5.4,17.7-16.5,17.7-28.6v-76.3L512.2,186V57.9C512.2,40.2,497.9,25.9,480.2,25.9L480.2,25.9z"
  }))), _symbol147 || (_symbol147 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag-empty",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M384,32H128c0-42.4-64-42.9-64,0v448c0,42.6,64,42.7,64,0V288h256c18.2,0,32-13.8,32-32V64C416,45.8,402.2,32,384,32z M352,224H128V96h224V224z"
  }))), _symbol148 || (_symbol148 = /*#__PURE__*/React.createElement("symbol", {
    id: "flag-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M64,480c0,42.6,64,42.7,64,0V288h256c18.2,0,32-13.8,32-32V64c0-18.2-13.8-32-32-32H128c0-42.4-64-42.9-64,0V480z"
  }))), _symbol149 || (_symbol149 = /*#__PURE__*/React.createElement("symbol", {
    id: "ar-sa",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#75BD4A",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M200.6,108.3c-0.4,0-1.1,0.2-2,0.8c-2,1.4-6.1,5.6-6.2,10.4c-0.1,2.7-0.6,2.7,1.2,4.5c1.3,1.9,2.6,1.7,5.2,0.3c1.5-1.1,2-1.8,2.5-3.6c0.6-3.1-3.3,1.5-3.8-2c-0.9-3.2,1.6-4.5,4-7.6C201.5,109.5,201.6,108.3,200.6,108.3L200.6,108.3z M238.6,108.5c-0.7,0.1-1.6,1-2.8,3.3c-0.9,2.4-4.7,5.9-2,13.2c2.3,4.6,3.2,12.2,2.2,20.6c-1.6,2.4-1.9,3.2-4,5.6c-2.9,3.1-6,2.3-8.4,1.2c-2.2-1.5-4-2.3-5-7.1c0.2-7.6,0.6-20.1-0.8-22.8c-2.1-4.1-5.4-2.6-6.9-1.4c-7,6.4-10.4,17.1-12.5,25.7c-1.9,6.2-4,4.4-5.4,1.9c-3.5-3.3-3.8-29.1-8-24.8c-6.8,19.4,3.9,40.7,11.3,38.6c5.3,2.2,8.7-8,10.9-19.1c1.5-3.1,2.6-3.5,3.4-1.9c-0.2,14.8,1.1,18.1,4.9,22.6c8.5,6.6,15.5,0.8,16.1,0.3c0.5-0.5,6.6-6.6,6.6-6.6c1.5-1.6,3.4-1.6,5.5-0.3c2,1.8,1.8,5,6.1,7.2c3.6,1.5,11.4,0.4,13.2-2.8c2.4-4.2,3-5.6,4.1-7.2c1.7-2.3,4.7-1.3,4.7-0.6c-0.3,1.3-2,2.6-0.8,4.9c2.1,1.6,2.5,0.6,3.8,0.2c4.3-2.1,7.6-11.4,7.6-11.4c0.2-3.5-1.8-3.2-3.1-2.5c-1.6,1-1.8,1.4-3.4,2.4c-2.1,0.3-6.2,1.7-8.2-1.4c-2.1-3.8-2.1-9-3.6-12.8c0-0.3-2.8-6-0.2-6.3c1.3,0.2,4,1,4.5-1.4c1.3-2.3-2.9-8.6-5.8-11.9c-2.5-2.8-6-3.1-9.4-0.3c-2.4,2.2-2,4.6-2.5,6.9c-0.6,2.6-0.5,5.9,2.2,9.4c2.4,4.6,6.6,10.6,5.2,19c0,0-2.5,4-6.9,3.5c-1.8-0.4-4.8-1.2-6.4-12.8c-1.2-8.8,0.3-21.2-3.4-27C240.5,110.4,239.8,108.3,238.6,108.5L238.6,108.5z M226.6,109.4c-1.1,0.1-2.4,1.4-3.4,4c-0.9,1.9-2,12.1-1.8,12.1c-0.7,3,3.2,4.3,4.9,0.4c2.6-7.1,2.6-10.1,2.8-13.2C228.7,110.4,227.7,109.3,226.6,109.4L226.6,109.4z M270.9,110.2c-1.2,0.1-2.1,0.8-2.4,2.5c-0.5,4-0.2,6.2,0.4,9.6c0.5,2.2,3.8,6,5.4,8.2c7.7,10.3,15.1,20.7,22.2,31.4c1.1,8,2,15.8,2.5,23.5c1.2,17,1.5,38.2,0.4,56.2c3.2,0.1,8.3-5.2,10.1-12.9c1.2-10.7-0.4-32.5-0.5-38.8c0-2.6-0.2-5.8-0.4-9c8.3,13.6,16.4,28,24.3,43.7c2.9-1.4,2.2-17.6,0.6-19.9c-6.3-13.6-15.1-27.1-17.9-32.2c-1-1.9-4.4-7.1-8.5-13.1c-0.8-8.6-1.6-15.8-2.1-18c-1.3-9.1,3.7,1,3-4.2c-1.6-9.1-6.6-15.2-12.5-23.5c-1.9-2.7-1.9-3.2-4.8,0.7c-1.8,4-1.7,7.3-1.2,10.4c-0.8-1.1-1.7-2.4-3.1-4.1c-5.1-4.4-5.4-4.6-9.6-8.2C275.4,111.5,272.8,110,270.9,110.2L270.9,110.2z M402.4,111.6c-0.6-0.1-1.2,0.2-1.9,1.2c-1.3,1.2-2.8,3.3-2.7,6c0.3,4.8,1.2,9.7,1.5,14.4c0.1,0.6,0.2,1.3,0.4,1.9c-0.5-0.7-1-1.2-1.2-1.4c-9.3-9.8,4.3-1.6-1.8-9.2c-5.1-5.6-6.6-7.4-11-10.8c-2.2-1.4-3.5-4.1-4.2,0.5c-0.3,4.1-0.6,8.8-0.3,12.2c0,1.9,2,5.5,3.6,7.6c6.2,7.6,12.6,15.8,18.9,24.2c1.3,17.3,1.7,33.1,3.1,50.4c-0.2,7.4-2.5,17.2-4.6,18.2c0,0-3.3,1.9-5.5-0.2c-1.6-0.6-8-10.7-8-10.7c-3.3-3-5.5-2.1-7.8,0c-6.4,6.2-9.3,17.9-13.7,25.9c-1.1,1.8-4.3,3.3-7.8-0.1c-9-12.3-3.7-29.7-4.8-25.2c-8,9-4.4,23.9-2.6,27.1c2.6,5.3,4.8,8.6,9.9,11.2c4.7,3.4,8.3,1.3,10.3-1.1c4.7-4.9,4.8-17.3,7-19.8c1.6-4.5,5.4-3.7,7.3-1.7c1.8,2.6,4,4.4,6.7,5.8c4.4,3.9,9.6,4.6,14.8,1c3.5-2,5.8-4.5,7.9-9.6c2.2-5.9,1.1-36.9,0.6-54.2c3.3,4.7,6.6,9.4,9.8,14.2c1.4,15.1,2.1,30,1.6,44.4c-0.3,2.8,9.9-8.5,9.9-13.9c0-4.7,0-9,0-12.9c5,8,9.8,16,14.4,24.2c2.8-1.5,1.9-17.5,0.1-19.7c-4.8-8-10.9-16.6-15.6-23.3c-0.9-8.4-2.2-18.4-2.8-21.4c-0.9-4.8-1.8-11.9-3.2-17.6c-0.4-2.2-1.5-9.2-1.2-9.9c0.6-1.6,2.7,0,3.7-1.8c1.6-1.7-5.4-19.6-8.9-24.7c-1.3-2.3-3.6-1.5-6.4,2.2c-2.6,2.4-1.7,8-0.7,13.4c2.6,13.6,4.9,27.4,6.8,41.2c-3.4-5.1-7.6-11.2-11.6-17.1c-0.1-0.6-0.5-2.7-0.5-2.7c0-0.2-0.6-11.1-1-13.7c-0.1-1.1-0.3-1.4,0.8-1.2c1.2,1,1.3,1,2,1.4c1.2,0.2,2.2-1.8,1.5-3.6c-3.6-6.7-7.3-13.5-10.9-20.2C403.4,112.1,402.9,111.7,402.4,111.6L402.4,111.6z M63.1,111.9c-2-0.1-4.3,1.2-3.4,3.6c-0.5,1.3,4,5.8,4.7,8.3c0.7,1.7-0.7,7.4,0.8,7.9c1.3,0.6,3.2-3.9,3.9-8c0.4-2.3,0.1-10-5.2-11.6C63.7,112,63.4,111.9,63.1,111.9L63.1,111.9z M449.6,112c-0.5,0-1,0.8-1.9,2.6c-2.1,3.4-2.8,9.4-2,14.8c5,33.6,8.7,66.2,9.4,96.1c-0.4,2.8-0.6,4.3-1.9,7.9c-2.9,3.8-6.2,8.5-9.2,10.8s-9.5,4.4-11.7,6.1c-6.7,3.9-6.8,8.4-1.3,8.5c9.4-1.1,20.5-1.9,28.1-13.4c2-3.2,4.4-12,4.6-17.4c0.7-31.5-0.4-62.2-5.1-85c-0.3-2.2-1.3-7.3-0.9-8c0.6-1.6,3.7,0.2,4.8-1.6c1.6-1.6-7.9-13.9-11.3-19.1C450.6,113,450.2,111.9,449.6,112L449.6,112z M351.2,112.5c-0.4,0.1-1,0.7-2,2c-2.6,8.6-3.5,15.6-2.5,20.9c6.7,35.1,13.6,67.1,12.5,100.6c3.2,0,6.9-7.3,8.5-14.6c0.9-10-0.6-16.1-0.8-21.9c-0.3-5.9-6.6-53.5-7.9-57.9c-1.6-8.4,6.2-1.1,5.4-6c-2.7-6.2-9.4-15.1-11.5-20.5C352,113.7,351.9,112.4,351.2,112.5L351.2,112.5z M111.6,113.2c-0.8,0.1-1.6,0.8-1.9,2c-0.2,0.7,0.3,2-0.3,2.3c-0.4,0.4-1.8,0.1-1.8-1.9c0-0.7-0.5-1.3-0.8-1.7c-0.3-0.2-0.5-0.2-1-0.2c-0.6,0-0.6,0.2-1,0.7c-0.2,0.5-0.4,1.1-0.4,1.7c-0.1,0.7-0.4,1-0.9,1.1c-0.6,0-0.4,0.1-0.9-0.2c-0.3-0.3-0.6-0.4-0.6-1s-0.1-1.4-0.3-1.8c-0.3-0.3-0.7-0.5-1.1-0.6c-2.5,0-2.7,2.9-2.5,4c-0.2,0.2-0.3,5.3,3.1,6.7c4.6,2.2,13.2,1.3,12.8-6.1c0-0.7-0.1-2.8-0.2-3.4C113.3,113.4,112.4,113,111.6,113.2L111.6,113.2z M173.1,113.2c-1.6,0.1-3,0.5-4.2,1.2c-3,2.9-3.7,7.6-1.4,10.5c2.3,1.1,4.7,3.4,3.1,4.7c-6.6,7-23.7,18.8-24.6,20.9c0,0,0,0,0,0.1c0,0,0,0,0,0.1l0,0v0.1l0,0l0,0l0,0l0,0l0,0c0.9,0.6,11.6,0.6,12.8,0l0,0l0,0l0,0c3.7-1.4,21.2-21.3,21.2-21.3c-0.9-0.8-1.7-1.3-2.6-2.1c-1-0.8-0.9-1.7,0-2.5c4.3-2.5,3-8.1,0.7-10.6C176.5,113.4,174.7,113.2,173.1,113.2L173.1,113.2z M333.8,113.3c-0.5,0-1,0.8-1.9,2.6c-2.1,3.4-3.5,9.3-3.3,14.8c4.5,31,5.9,58.1,8.8,89.1c0.2,3-0.2,7.3-2.2,9.1c-7.4,7.7-18,17.2-29.6,21.6c-1.2,1.4,3.1,7.3,8.7,7.3c9.4-1.1,17.6-6.4,25.3-20.2c2-3.2,5.6-10.2,5.7-15.5c0.7-31.5-1.6-55.9-6.3-78.7c-0.3-2.2-0.1-4.8,0.3-5.5c0.6-0.7,2.7,0,3.8-1.8c1.6-1.6-4.3-15.2-7.6-20.4C334.8,114.3,334.4,113.2,333.8,113.3L333.8,113.3z M84.9,114.2c-1.3,0.2-2.5,1.2-3.1,2.6c-0.2,5-0.2,9.9,0.3,14.5c2.3,8,3,15.1,4.1,23.3c0.3,11-6.4,4.8-6.1-0.7c1.5-7.1,1.1-18.3-0.2-21.1c-1.1-2.8-2.4-3.5-5-3.1c-2.1-0.1-7.5,5.8-9,15.5c0,0-1.3,5-1.8,9.5c-0.7,5-4.1,8.6-6.4-0.7c-2-6.8-3.3-23.4-6.6-19.5c-1,13-2.1,35.9,8.9,38.3c13.4,1.3,6-22.6,10.8-26.9c0.9-2.1,2.6-2.2,2.8,0.5v20.3c-0.1,6.6,4.2,8.5,7.6,9.9c3.5-0.3,5.8-0.2,7.2,3.2c0.5,11.7,1.1,23.4,1.7,35.1c0,0,8.1,2.3,8.5-19.7c0.4-13-2.6-23.8-0.8-26.4c0.1-2.5,3.2-2.6,5.4-1.4c3.5,2.5,5.1,5.5,10.5,4.3c8.3-2.3,13.2-6.3,13.4-12.6c-0.5-6-1.2-12.1-3.8-18.1c0.4-1.1-1.6-4-1.2-5c1.5,2.3,3.7,2.1,4.2,0c-1.4-4.6-3.6-9.1-7.1-11c-2.9-2.6-7.2-2-8.8,3.3c-0.7,6.2,2.3,13.5,6.8,19.5c1,2.3,2.3,6.2,1.7,9.7c-2.4,1.4-4.8,0.8-6.8-1.3c0,0-6.6-4.9-6.6-6c1.7-11.2,0.4-12.5-0.6-15.6c-0.7-4.3-2.7-5.6-4.4-8.6c-1.6-1.7-3.9-1.7-4.9,0c-2.9,5-1.6,15.9,0.5,20.7c1.5,4.5,3.8,7.2,2.8,7.2c-0.9,2.5-2.8,1.9-4.1-1c-1.9-6-2.3-15-2.3-19c-0.6-5-1.2-15.7-4.5-18.4C86.9,114.5,85.9,114.1,84.9,114.2L84.9,114.2z M131.8,114.3c-0.7,0.1-1.4,0.5-2.3,0.7c-2.8,0.9-5.5,3.4-4.7,8.1c3.4,20.4,5.6,36,8.9,56.4c0.5,2.4-1.5,5.6-4.1,5.2c-4.4-3-5.5-9-13-8.7c-5.4,0.1-11.6,6-12.4,11.7c-0.9,4.5-1.2,9.4,0,13.4c3.8,4.6,8.4,4.1,12.4,3.1c3.3-1.4,6-4.6,7.2-3.8l0,0l0,0c0.7,1.2-0.1,11.9-15.5,20.1c-9.5,4.3-17.1,5.3-21.1-2.5c-2.5-4.8,0.2-23.3-6-19c-18.4,47.3,43,53.9,49.9,2c0.4-1.5,1.8-2.9,2.8-2.6c0.4,0.2,0.8,0.8,0.9,1.8c-1.4,47.1-47.5,50.3-55.3,35.5c-1.9-3.5-2.5-11.3-2.7-15.9c-0.4-2.8-1.1-4.4-1.9-5.1c-1.9-1.4-4.4,2.3-4.9,8.6c-0.8,5.1-0.6,6.5-0.6,11.4c2.5,37.2,61.7,21.2,71.3-9.5c4.8-15.9-0.1-27.8,1.5-29.3c0,0,0,0,0.1,0c0,0,0,0,0.1,0c0,0,0,0,0.1,0s0.1,0,0.2,0c5.9,6.3,14.1,0.8,16-1.4c0.8-1.1,2.7-1.8,4.1-0.4c4.6,3.3,12.6,1.7,14.3-4.1c1-5.7,1.8-11.5,2-17.6c-3,0.9-5.4,1.6-6.4,2.6c-0.2,0.3-0.4,0.5-0.4,0.8c-0.3,1.7-0.5,3.4-0.8,5.1c0,0.1-0.1,0.3-0.1,0.4c-0.1,0.2-0.3,0.4-0.6,0.5c-1.1,0.6-2.9,0.2-3-1.3c-1.4-6.5-7.3-7.3-10.8,2.7c-2.4,1.9-6.8,2.3-7.2-0.6c0.6-6.7-2.1-7.6-7.6-4.5c-1.8-13.3-3.5-26-5.2-39.3c2.3-0.1,4.3,1.6,6.4-1c-2.2-7-7-21.1-9.6-22.5c0,0,0,0-0.1,0c-0.1-0.1-0.3-0.3-0.4-0.4c0,0-0.1-0.1-0.2-0.1c0,0-0.1-0.1-0.2-0.1c-0.1-0.1-0.2-0.1-0.4-0.1C132.3,114.3,132.1,114.3,131.8,114.3L131.8,114.3z M314.9,114.4c-2.4-0.1-4.9,1.4-3.9,4.4c-0.6,1.6,5,7.1,6,10c1.6,4.6-1.2,8.9,0.4,9.6c1.6,0.7,3.7-4.7,4.6-9.7c0.9-4.1-2-12.4-6-14.1C315.6,114.4,315.3,114.4,314.9,114.4L314.9,114.4z M172.3,119.4c1.1-0.1,2.4,0.9,3,2.3c0.7,1.5,0.3,2.9-0.8,3.2s-2.5-0.7-3.2-2.2s-0.3-2.9,0.8-3.2C172.1,119.5,172.2,119.4,172.3,119.4z M436.9,126.3c-2.1-0.1-4.5,1.6-3.6,4.7c-0.5,1.7,4.6,7.6,5.4,10.9c0.8,2.3-1.1,9.7,0.4,10.4c1.4,0.8,3.4-5.1,4.2-10.5c0.4-3-1.8-13.4-5.5-15.3C437.5,126.4,437.2,126.3,436.9,126.3L436.9,126.3z M290.6,129.9c0.2,0.9,0.4,1.7,0.5,2.6c0.4,1.9,0.8,3.8,1.2,5.7c-1.7-2.3-3.1-4.2-3.7-4.9C284.8,128.9,288.7,130.4,290.6,129.9L290.6,129.9z M324.3,146.5c-0.8,0.1-1.6,0.9-1.9,2c-0.2,0.7,0.4,1.9-0.3,2.3c-0.4,0.4-1.9,0.2-1.8-1.9c0-0.7-0.5-1.4-0.8-1.8c-0.3-0.2-0.5-0.2-1-0.2c-0.6,0-0.6,0.2-1,0.7c-0.1,0.5-0.4,1.1-0.4,1.7c-0.1,0.7-0.3,1-0.9,1.1c-0.6,0-0.5,0.1-1-0.2c-0.3-0.3-0.6-0.4-0.6-1s-0.1-1.4-0.3-1.8c-0.3-0.3-0.7-0.5-1.1-0.6c-2.5,0-2.7,2.8-2.5,3.9c-0.2,0.2-0.3,5.3,3.1,6.8c4.6,2.2,13.2,1.2,12.8-6.2c0-0.7-0.2-2.8-0.2-3.4C326,146.8,325.1,146.4,324.3,146.5L324.3,146.5z M170.4,148c-0.6-0.1-1.3,0.1-2.2,0.7c-4,2.2-5.6,8.7-3.1,12.5c2.4,3.3,6.1,2.1,6.6,2.1c4,0.5,6.3-7.5,6.3-7.5s0.1-2.2-4.6,2c-2,0.4-2.3-0.4-2.8-1.5c-0.4-2.1-0.3-4.2,0.6-6.2C171.8,148.9,171.4,148.1,170.4,148L170.4,148z M388,149c-2.3-0.1-4.6,1.3-5.3,4.4c0,1.8,0.8,2.8,0.7,4.5c-0.2,0.9-1.2,1.6-3.5,0.4c0.4-0.3-1.5-3-1.5-3c-1.8-1.1-4.2,0.1-5.8,1.1c-0.9,1.6-1.5,4.3-0.5,7c2.6,4.8,11.5,12.9,15.7,13c0.1-4.3,0.5-10,0.7-13.6c0.1-1.3,0.4-2.8,1.7-3.2c1.3-0.3,3.5,1.3,3.6-0.1c-0.2-2.7-0.8-6.8-2.3-8.7C390.6,149.7,389.3,149.1,388,149L388,149z M207.9,164c-0.1,0-0.1,0.1-0.2,0.1c0,0-0.1,0-0.1,0.1c-0.4,0.3-1,1.1-2.2,2c-2,2.3-2.4,3.8-2.2,8.4c0.1,0.5,3.8,10.7,6.9,17.9c2.1,7.5,4,16,2.6,24.1c-4.9,10.7-14.8,20.2-24.3,25.4c-4.8,1.6-9,1-10.2,0l0,0c-2.8-1.9-2.8-5.2-2.7-5.8l0,0l0,0c8-5.6,17.2-10.1,24.4-25.2c2.1-5.8,2.8-9.2,0.7-18.2c-0.8-3.3-1.8-6.1-4.1-8.4l0,0c1.4-0.7,4.9,2,5.5,0.3c-0.8-4.3-3.7-10-7-12.9c-2.9-2.6-6-2.9-8.6-0.5c-3,1.6-3.6,7.6-2.2,12.7c1.6,3.9,5.8,4.6,8.9,12.4l0,0c0.1,0.5,1,5.8-0.5,8c-1.2,3.9-17.2,16.4-18.3,17.2l-0.1,0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0v-0.1c0-0.3,0-1.1,0-2.4c-0.1-2.4,0.9-7.7,0.8-8.6l0,0l0,0l0,0l0,0c-5.3,3.4-7,13.8-8,16.9c-13.3,9.2-28.5,16.1-37.2,25.4c-4.5,7.1,31.3-8.1,35.5-10l0.1,0.1c0.8,0.9,0.9,3.9,3.2,6.7c3.7,5.1,11.6,8.2,19.4,6.2c12.9-4.7,20.4-13.5,28-23.3c1.1-1.6,2.8-2.8,4.4-1.6c5.2,11.7,20.2,20,39.6,20.8c4.5-5.5,2.4-8.2,0.5-9.3c-0.6-0.4-9.7-3.9-11.1-7.5c-0.9-3.3,1.3-6.2,5.6-8.4c12.5-1.5,24.7-3.2,36.6-7c0.1-4,2.5-10,4-12.5c1.1-1.8,1.8-2,2-2.2l0,0l0,0l0,0v-0.1c0-0.1,0-0.2,0-0.4l-2-1.2l-39.8-0.2c-0.5-0.2-0.9-0.4-1.1-0.6c0,0,0,0-0.1-0.1l0,0l0,0v-0.1l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0l0,0c0,0,0,0,0-0.1c0.2-0.3,0.7-0.5,1.2-0.7c9.5-1.3,26.4-4.1,27.5-20.3c-0.2-8.5-3.6-14-14-15.5c-7.6,0.6-13.1,8-12.2,16.1c-0.4,2.2,0.7,6.5-1.5,7c-14.6,1.3-30.6,10.5-31.1,17.1l0,0l0,0c0,0,0,0-0.1,0h-0.1h-0.1l0,0h-0.1l0,0H224h-0.1c-0.9-0.3-2.2-1.8-2-4c-0.6-11.3-4.2-24.2-10-34c-2.1-2.1-3-2.9-3.6-3c0,0,0,0-0.1,0C208.1,164,208,164,207.9,164L207.9,164L207.9,164L207.9,164L207.9,164z M246,170c-0.8,0.1-1.6,0.8-1.9,2c-0.2,0.7,0.4,2-0.3,2.3c-0.4,0.4-1.9,0.2-1.8-1.9c0-0.7-0.5-1.4-0.8-1.8c-0.3-0.2-0.4-0.2-1-0.2s-0.7,0.2-1,0.7c-0.1,0.5-0.4,1.1-0.4,1.7c-0.1,0.7-0.3,1-0.9,1.1c-0.6,0-0.4,0.1-0.9-0.2c-0.3-0.3-0.7-0.4-0.7-1s-0.1-1.4-0.3-1.8c-0.3-0.3-0.7-0.5-1.2-0.6c-2.5,0-2.7,2.8-2.5,3.9c-0.2,0.2-0.3,5.3,3.1,6.8c4.6,2.2,15.5,0.9,12.8-6.2c0-0.7-0.2-2.8-0.2-3.4C247.7,170.3,246.8,169.9,246,170L246,170z M399.7,176.3c-0.1,0-0.2,0-0.4,0c0,0-21.2,15.1-21.8,15.6c-2.1,1.9-1.1,8.4,0,7.7c1.5,0.6,22.9-13.9,22.5-15.6C401,184.1,401.4,176.6,399.7,176.3L399.7,176.3z M266,178.6c0.9-0.1,2,0.2,3.1,0.8c1.6,0.9,2.6,2.3,2.4,3.3v0.1l-0.1,0.1v0.1c0,0,0,0,0,0.1c0,0,0,0,0,0.1s-0.1,0.2-0.2,0.2c-0.8,0.7-2.5,0.6-4.2-0.4c-1.6-0.9-2.5-2.3-2.4-3.3v-0.1c0-0.1,0.1-0.2,0.1-0.4c0,0,0-0.1,0.1-0.1l0,0c0,0,0.1-0.1,0.2-0.2C265.3,178.8,265.6,178.6,266,178.6L266,178.6z M80.1,182.4c-11,0.2-27.1,14.4-27.6,22.3c11.6-5.6,23-10.9,34.8-16.7C85.4,185.2,87.2,182.6,80.1,182.4L80.1,182.4z M115.7,187.3c1.1,0,2.2,0.5,2.8,2c0.5,1.4,0,2.8-0.6,3.6l0,0v0.1c-0.5,0.6-2.1,0.4-3.2,0.4c-1.4-0.1-2.1-0.3-2.9-1.4c-0.4-1.3,0.8-2.5,1.4-3.5l0,0c0.1-0.1,0.2-0.2,0.2-0.3c0.4-0.4,1.1-0.7,1.9-0.8C115.4,187.4,115.6,187.3,115.7,187.3L115.7,187.3z M395.6,191.7c-2,0.2-3.8,2.1-3,5.1c-0.5,1.7,2.7,7.8,3.5,11c0.8,2.3-1,8.8,0.6,9.5c1.4,0.8,5.2-3.9,5.1-9.6c0.4-3-1.1-14-4.8-15.8C396.5,191.7,396,191.7,395.6,191.7L395.6,191.7z M157.9,202.4c-1.7,0.1-3.3,1-2.6,3.5c-0.1,1.8,4.9,3.9,5.2,8c0.7,1.7-1.1,7.1,0.4,7.6c1.4,0.6,3.2-3.7,4-7.7c0.4-2.2-1.7-9.8-5.3-11.2C159.1,202.5,158.5,202.4,157.9,202.4L157.9,202.4z M229,212.2c0.1,0,0.2,0,0.4,0c0,0,0,0,0.1,0c4.4,1.2,11,1.3,16.6,1.9c4.6,0.3,6.9,3.9,2.6,5.4c-4.3,1.5-8.4,2.6-8.4,8.8c0.6,3.1,0.4,4.7,0,5.4c0,0-0.1,0.1-0.1,0.2l0,0l0,0l0,0l0,0h-0.1c-0.1,0-0.1,0.1-0.2,0.1c-0.1,0-0.1,0-0.2,0c-1,0.1-2.5-0.8-3.6-1.4c-2.6-1.9-10-6.5-11.1-16.3C224.7,214.3,226.4,212.3,229,212.2L229,212.2z M55.3,219.7c-0.3,0-0.8,0.8-1.6,1.8c-6.5,10.4-7.1,26-3.5,30.6c1.9,2.2,5.1,3.2,7.4,2.5c4.1-1.8,5.9-10.1,4.9-13.2c-1.4-2.1-2.5-2.5-3.8-0.7c-2.9,5.9-4.1,1.9-4.4-1.4c-0.4-6.2,0.2-12,0.8-16.5C55.6,220.5,55.6,219.7,55.3,219.7L55.3,219.7z M278.3,233.4c-0.5,0-1,0-1.5,0.3c-0.1,0-4.7,3.1-6.2,5.3c-0.9,0.7-0.8,1.3-0.5,2.5c0.7,1.6,1.9,1.1,3.3,0.4c1.9-0.3,2.8,1,2.6,3.2c-0.9,2.8,0.4,3.8,0.4,4s1.8,1.7,3.9,0.5c4.4-1.7,7.2-3.3,13.4-4.7c1.6,0,1.5-4.4-1-4.6c-3.4,0.2-6.5,0.3-9.9,3c-2.1,0.5-2.4-0.8-2.9-1.9c-0.5-2.8,1.2-4.8,0.8-6.9C280.9,234.5,279.8,233.5,278.3,233.4L278.3,233.4z M421.1,238.7c-0.8,0-1.7,0.1-3,0.2c-1.4,0.3-1.8,0.9-2.1,2.5c0.1,2.5,1.6,2.4,3.2,3.4c0.9,1.2,1.5,2.2-0.1,4.1c-1.5,1.4-2.5,2.1-4,3.5c-0.7,1.2-1.1,3,1,3.6c4,1.1,13.2-4.8,13.2-5c1.5-1.1,1-3.2,0.9-3.2c-0.9-1-2.8-0.4-4.1-0.6c-0.6,0-2.7-0.3-1.7-2.1c0.8-1.1,1.1-1.8,1.7-3.2s0.1-2.3-2.2-3C422.7,238.8,421.9,238.7,421.1,238.7L421.1,238.7z M361.4,359.5L361.4,359.5c-6.6,1.7-6.4,8.6-2.2,11.6c-69.7,0-176.8-1.2-199.7-1.2c-12.8,0-53.5-1.5-54.2-1.5c8.7,12.7,21.3,15.3,37.8,15.6c31,0,174.5-0.4,215.3-0.4c-2.9,5.2,0.3,13.5,2.5,15c0,0,0.1,0.1,0.2,0.1s0.2,0.1,0.3,0.1h0.1c2.7,0.6,3.9-1.3,4.8-2.8c4.4,0.4,29.1,0.8,31.3,0l0,0c1.5,2.3,3,4.4,6,4c5.1-1.1,9.1-1.6,9.2-12c0,0-0.5-17.6-12.1-16.5c-2.7,0.4-10.4,1.2-10.4,1.2c-8.9-1.1-15.4-1.2-25.4-1.5c0.9-1.2,2.5-5.9,0.6-7.6c-0.5-0.4-1.3-0.7-2.4-0.6l0,0c0,0,0,0-0.1,0l0,0h-0.1c0,0-0.1-0.1-0.2-0.2c0,0-0.1,0-0.1-0.1c-0.5-0.7-0.8-2.5-1.1-3l0,0l0,0C361.6,359.5,361.5,359.5,361.4,359.5C361.5,359.5,361.5,359.5,361.4,359.5C361.5,359.5,361.4,359.5,361.4,359.5L361.4,359.5z M366.2,384.7L366.2,384.7c10.2,0.5,19.8,0.1,29.9,0.6c1.6,1.4,0.8,4.5-0.2,5.1c0,0-0.1,0.1-0.2,0.1h-0.1h-0.1c-3.3-0.1-5.2-0.2-8.5-0.2c0-0.2,0-0.3-0.1-0.5c-0.8-2.3-6.5-2.2-7.8-0.4c0,0,0,0.1-0.1,0.1s0,0.1-0.1,0.1s0,0.1-0.1,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.2,0,0.3c-4.5,0.5-8.5-0.1-12.9-0.3C364.5,388.3,364.6,385.4,366.2,384.7L366.2,384.7z"
  }))), _symbol150 || (_symbol150 = /*#__PURE__*/React.createElement("symbol", {
    id: "bg-bg",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#FFFFFF",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#75BD4A",
    width: 480,
    height: 128
  }))), _symbol151 || (_symbol151 = /*#__PURE__*/React.createElement("symbol", {
    id: "ca-ad",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    fill: "#E03232",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    fill: "#FCD638",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 206.5,
    fill: "#A97451",
    width: 96,
    height: 96
  }))), _symbol152 || (_symbol152 = /*#__PURE__*/React.createElement("symbol", {
    id: "ca-es",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#FCD638",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 119.1,
    fill: "#E03232",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 158.2,
    fill: "#FCD638",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 197.3,
    fill: "#E03232",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 236.4,
    fill: "#FCD638",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 275.6,
    fill: "#E03232",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 314.7,
    fill: "#FCD638",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 353.8,
    fill: "#E03232",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 392.9,
    fill: "#FCD638",
    width: 480,
    height: 39.1
  }))), _symbol153 || (_symbol153 = /*#__PURE__*/React.createElement("symbol", {
    id: "cs-cz",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.6,
    fill: "#FFFFFF",
    width: 480,
    height: 176
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 256,
    fill: "#E03232",
    width: 480,
    height: 176
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0035A0",
    points: "16,80 208,256 16,432 "
  }))), _symbol154 || (_symbol154 = /*#__PURE__*/React.createElement("symbol", {
    id: "da-dk",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 80,
    fill: "#FFFFFF",
    width: 64,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 224,
    fill: "#FFFFFF",
    width: 480.1,
    height: 64
  }))), _symbol155 || (_symbol155 = /*#__PURE__*/React.createElement("symbol", {
    id: "de-de",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#4C4C4E",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#FCD638",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#E03232",
    width: 480,
    height: 128
  }))), _symbol156 || (_symbol156 = /*#__PURE__*/React.createElement("symbol", {
    id: "el-gr",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 119.1,
    fill: "#FFFFFF",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 197.3,
    fill: "#FFFFFF",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 236.4,
    fill: "#0035A0",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 275.6,
    fill: "#FFFFFF",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 314.7,
    fill: "#0035A0",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 353.8,
    fill: "#FFFFFF",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 392.9,
    fill: "#0035A0",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.1,
    y: 80,
    fill: "#0035A0",
    width: 207.9,
    height: 195.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 158.2,
    fill: "#0035A0",
    width: 480,
    height: 39.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.2,
    y: 80,
    fill: "#FFFFFF",
    width: 39.1,
    height: 195.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 158.2,
    fill: "#FFFFFF",
    width: 207.8,
    height: 39.1
  }))), _symbol157 || (_symbol157 = /*#__PURE__*/React.createElement("symbol", {
    id: "en-au",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 80,
    fill: "#FFFFFF",
    width: 48,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 152,
    fill: "#FFFFFF",
    width: 192,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 152,
    fill: "#FFFFFF",
    width: 192,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 80,
    fill: "#E03232",
    width: 32,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 160,
    fill: "#E03232",
    width: 192,
    height: 32
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E03232",
    points: "27.3,80 16,80 16,91.3 196.7,272 208,272 208,260.7 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E03232",
    points: "208,91.3 208,80 196.7,80 16,260.7 16,272 27.3,272 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 272,
    fill: "#FFFFFF",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96,
    y: 336,
    fill: "#FFFFFF",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 112,
    fill: "#FFFFFF",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272,
    y: 240,
    fill: "#FFFFFF",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400,
    y: 176,
    fill: "#FFFFFF",
    width: 32,
    height: 32
  }))), _symbol158 || (_symbol158 = /*#__PURE__*/React.createElement("symbol", {
    id: "en-gb",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 80,
    fill: "#FFFFFF",
    width: 96,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 208,
    fill: "#FFFFFF",
    width: 480,
    height: 96
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "256,315.5 414.8,432 496,432 496,372.5 337.2,256 496,139.5 496,80 414.8,80 256,196.5 97.2,80 16,80 16,139.5 174.8,256 16,372.5 16,432 97.2,432 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E03232",
    points: "256,295.7 441.9,432 496,432 496,392.3 310.1,256 496,119.7 496,80 441.9,80 256,216.3 70.1,80 16,80 16,119.7 201.9,256 16,392.3 16,432 70.1,432 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E03232",
    points: "496,224 288,224 288,80 224,80 224,224 16,224 16,288 224,288 224,432 288,432 288,288 496,288 "
  }))), _symbol159 || (_symbol159 = /*#__PURE__*/React.createElement("symbol", {
    id: "en-us",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 112,
    fill: "#FFFFFF",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 144,
    fill: "#E03232",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 176,
    fill: "#FFFFFF",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 208,
    fill: "#E03232",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 240,
    fill: "#FFFFFF",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 272,
    fill: "#E03232",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 304,
    fill: "#FFFFFF",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 336,
    fill: "#E03232",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 368,
    fill: "#FFFFFF",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 400,
    fill: "#E03232",
    width: 480,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#66A1CC",
    width: 256,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 256,
    height: 192
  }))), _symbol160 || (_symbol160 = /*#__PURE__*/React.createElement("symbol", {
    id: "es-es",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#FCD638",
    width: 480,
    height: 128
  }))), _symbol161 || (_symbol161 = /*#__PURE__*/React.createElement("symbol", {
    id: "et-ee",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C0CFD8",
    y: 64,
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#448FDC",
    x: 16,
    y: 80.3,
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 16,
    y: 320,
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    width: 480,
    height: 128
  }))), _symbol162 || (_symbol162 = /*#__PURE__*/React.createElement("symbol", {
    id: "eu-es",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#0094CE",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#FFFFFF",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#4C4C4E",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#75BD4A",
    points: "256,295.7 441.9,432 496,432 496,392.3 310.1,256 496,119.7 496,80 441.9,80 256,216.3 70.1,80 16,80 16,119.7 201.9,256 16,392.3 16,432 70.1,432 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "496,224 288,224 288,80 224,80 224,224 16,224 16,288 224,288 224,432 288,432 288,288 496,288 "
  }))), _symbol163 || (_symbol163 = /*#__PURE__*/React.createElement("symbol", {
    id: "fa-ir",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#75BD4A",
    width: 480,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 336,
    fill: "#E03232",
    width: 480,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 176,
    fill: "#FFFFFF",
    width: 480,
    height: 160
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.6,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.9,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.1,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.3,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.9,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.2,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 143.4,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65.2,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.4,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.6,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.7,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.9,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 231.1,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.3,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.5,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.7,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.9,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.2,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 463.4,
    y: 352,
    opacity: 0.5,
    fill: "#FFFFFF",
    width: 16.6,
    height: 16.6
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E03232",
    cx: 254,
    cy: 252,
    r: 40
  }))), _symbol164 || (_symbol164 = /*#__PURE__*/React.createElement("symbol", {
    id: "fi-fi",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#FFFFFF",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 80,
    fill: "#0035A0",
    width: 64,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 224,
    fill: "#0035A0",
    width: 480.1,
    height: 64
  }))), _symbol165 || (_symbol165 = /*#__PURE__*/React.createElement("symbol", {
    id: "fr-ca",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 112,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384,
    y: 80,
    fill: "#E03232",
    width: 112,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 80,
    fill: "#FFFFFF",
    width: 256,
    height: 352
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E03232",
    d: "M301.9,300.3c0,3.6,4.1,13.4,4.1,13.4s-34.2-5.7-37.1-6.2s-5.5-0.5-5.4,5.5l2.4,18.2h-8.4l1.9-18.2c0-6-2.6-6-5.5-5.5s-37.1,6.4-37.1,6.4s4-9.7,4-13.4c0-4.7-10.1-11.4-21.1-21c-11-9.7-18.6-14.6-18.6-15.7c0-1,7.8-0.8,7.8-6.6c0-5.7-7.4-27.3-7.4-27.3s15.4,6,19.6,5.9c4.2,0,10.7-8.4,10.7-14.4c0,0,20.1,25.4,24.3,23.5c4.2-1.8-7.7-51.8-7.7-51.8s12,10.9,16.1,9.6c4.2-1.3,15.9-31.3,15.9-31.3s0.1-0.4,0.4-0.4c0.2,0,0.4,0.4,0.4,0.4s11.8,29.9,16,31.1c4.2,1.3,16.1-9.7,16.1-9.7s-11.6,50-7.4,51.9c4.2,1.8,24.2-23.8,24.2-23.8c0,6,6.6,14.4,10.7,14.4c4.2-0.1,19.5-6.1,19.5-6.1s-7.3,21.6-7.2,27.4c0,5.8,7.8,5.5,7.8,6.5s-7.6,6-18.5,15.8C311.9,288.9,301.9,295.5,301.9,300.3L301.9,300.3z"
  }))), _symbol166 || (_symbol166 = /*#__PURE__*/React.createElement("symbol", {
    id: "fr-fr",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    fill: "#E03232",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    fill: "#FFFFFF",
    width: 160,
    height: 352
  }))), _symbol167 || (_symbol167 = /*#__PURE__*/React.createElement("symbol", {
    id: "gl-es",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#FFFFFF",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0094CE",
    points: "256,295.7 441.9,432 496,432 496,392.3 310.1,256 256,216.3 70.1,80 16,80 16,119.7 201.9,256 "
  }))), _symbol168 || (_symbol168 = /*#__PURE__*/React.createElement("symbol", {
    id: "hi-in",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#F5984C",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#75BD4A",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#FFFFFF",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0035A0",
    cx: 256,
    cy: 256,
    r: 40
  }))), _symbol169 || (_symbol169 = /*#__PURE__*/React.createElement("symbol", {
    id: "hr-hr",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#0035A0",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#FFFFFF",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#E03232",
    stroke: "#FFFFFF",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    points: "342.4,174.4 262.4,334.4 182.4,174.4"
  }))), _symbol170 || (_symbol170 = /*#__PURE__*/React.createElement("symbol", {
    id: "hu-hu",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#75BD4A",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#FFFFFF",
    width: 480,
    height: 128
  }))), _symbol171 || (_symbol171 = /*#__PURE__*/React.createElement("symbol", {
    id: "in-id",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.6,
    fill: "#E03232",
    width: 480,
    height: 176
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 256,
    fill: "#FFFFFF",
    width: 480,
    height: 176
  }))), _symbol172 || (_symbol172 = /*#__PURE__*/React.createElement("symbol", {
    id: "it-it",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#75BD4A",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    fill: "#E03232",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    fill: "#FFFFFF",
    width: 160,
    height: 352
  }))), _symbol173 || (_symbol173 = /*#__PURE__*/React.createElement("symbol", {
    id: "iw-il",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#FFFFFF",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 96,
    fill: "#0094CE",
    width: 480,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 352,
    fill: "#0094CE",
    width: 480,
    height: 64
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0094CE",
    points: "256,192 288,239.7 320,287.5 256,287.5 192,287.5 224,239.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0094CE",
    points: "256,320 224,272.3 192,224.5 256,224.5 320,224.5 288,272.3"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 256,
    cy: 256,
    r: 16
  }))), _symbol174 || (_symbol174 = /*#__PURE__*/React.createElement("symbol", {
    id: "ja-jp",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#FFFFFF",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#E03232",
    cx: 256,
    cy: 256,
    r: 80
  }))), _symbol175 || (_symbol175 = /*#__PURE__*/React.createElement("symbol", {
    id: "kk-kz",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 64h512v384H0V64z",
    fill: "#00AFCA"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 282.8,
    cy: 209.3,
    r: 55.2,
    fill: "#FEC50C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.8 150.6c3.9 0 6.2-2.5 6.2-6.3 0-3.3-4-17.2-4.4-18.8l-1.8-6.3-1.8 6.3c-.5 1.6-4.4 15.4-4.4 18.8-.1 3.8 2.4 6.3 6.2 6.3zM347.7 203c-3.8 0-6.3 2.4-6.3 6.2 0 3.8 2.5 6.2 6.3 6.2 3.3 0 17.2-4 18.8-4.4l6.3-1.8-6.3-1.8c-1.6-.4-15.5-4.4-18.8-4.4zM282.8 267.9c-3.9 0-6.2 2.5-6.2 6.3 0 3.3 4 17.2 4.4 18.8l1.8 6.3 1.8-6.3c.5-1.6 4.4-15.4 4.4-18.8 0-3.8-2.4-6.3-6.2-6.3zM217.8 215.5c3.8 0 6.3-2.4 6.3-6.2 0-3.8-2.5-6.2-6.3-6.2-3.3 0-17.2 4-18.8 4.4l-6.3 1.8 6.3 1.8c1.6.4 15.5 4.4 18.8 4.4zM301.5 151.4c.4 1.1 1.3 2.7 3.7 3.6 1 .4 1.9.6 2.7.6 2.4 0 4.3-1.4 5.4-4 1.3-3.1 2.9-17.4 3.1-19l.7-6.5-4.1 5.1c-1 1.3-10 12.6-11.3 15.6-.5 1.7-.6 3.2-.2 4.6zM345.1 228.3c-3.5-1.5-6.7-.1-8.2 3.4-1.4 3.6-.1 6.7 3.4 8.1 3.1 1.3 17.4 2.9 19 3.1l6.5.7-5.1-4.1c-1.2-.9-12.5-9.9-15.6-11.2zM260.3 263.4c-3.6-1.4-6.7-.1-8.2 3.4-1.3 3.1-2.9 17.4-3.1 19l-.7 6.5 4.1-5.1c1-1.3 10-12.6 11.3-15.7 1.4-3.4.1-6.6-3.4-8.1zM220.4 190.2c1 .4 1.9.6 2.8.6.6 0 1.2-.1 1.8-.3 1.1-.4 2.7-1.3 3.6-3.7 1.4-3.6.1-6.7-3.4-8.1-3.1-1.3-17.4-2.9-19-3.1l-6.5-.7 5.1 4.1c1.2.9 12.5 9.9 15.6 11.2zM322.2 163c-.1 1.2.2 3 2 4.8 1.4 1.3 2.9 2 4.4 2 1.5 0 3.1-.7 4.4-2 2.4-2.4 9.4-15 10.1-16.4l3.2-5.7-5.7 3.2c-1.4.8-14 7.8-16.4 10.1-1.2 1.2-1.9 2.6-2 4zM333.1 250.7c-2.7-2.7-6.2-2.7-8.9 0s-2.7 6.1 0 8.8c2.4 2.4 15 9.4 16.4 10.1l5.7 3.2-3.2-5.7c-.7-1.4-7.7-14-10-16.4zM243.3 255.5c.1-1.2-.2-3-2-4.8-2.7-2.7-6.1-2.7-8.8 0-2.4 2.4-9.4 15-10.1 16.4l-3.2 5.7 5.7-3.2c1.4-.8 14-7.8 16.4-10.1 1.2-1.1 1.9-2.6 2-4zM232.4 167.8c1.2 1.2 2.6 1.9 4.1 2h.4c1.2 0 2.8-.4 4.4-2 2.7-2.7 2.7-6.1 0-8.8-2.4-2.4-15-9.4-16.4-10.1l-5.7-3.2 3.2 5.7c.7 1.4 7.7 14 10 16.4zM336.9 181.6c-.5 1.1-1 2.8 0 5.2 1.1 2.6 3.1 3.9 5.4 3.9.9 0 1.8-.2 2.8-.6 3.1-1.3 14.4-10.3 15.7-11.3l5.1-4.1-6.5.7c-1.6.2-16 1.8-19 3.1-1.6.8-2.8 1.8-3.5 3.1zM313.4 266.8c-.7-1.6-1.7-2.8-3-3.4-1.1-.5-2.8-1-5.2 0-3.5 1.5-4.8 4.6-3.3 8.2 1.3 3.1 10.3 14.4 11.3 15.7l4.1 5.1-.7-6.5c-.3-1.6-1.9-16-3.2-19.1zM228.6 231.7c-1.5-3.5-4.7-4.8-8.2-3.4-3.1 1.3-14.4 10.3-15.7 11.3l-5.1 4.1 6.5-.7c1.6-.2 16-1.8 19-3.1 3.6-1.5 4.9-4.7 3.5-8.2zM252.2 151.7c1.1 2.6 3.1 4 5.4 4 .9 0 1.8-.2 2.7-.6 3.5-1.5 4.8-4.6 3.3-8.2-1.3-3.1-10.3-14.4-11.3-15.7l-4.1-5.1.7 6.5c.3 1.6 2 16 3.3 19.1zM294.2 151.7c.5.1 1 .1 1.5.1 3 0 5.2-1.9 5.8-5.1.7-3.3-.5-17.6-.7-19.3l-.6-6.5-3 5.8c-.8 1.5-7.4 14.3-8 17.5-.3 1.7-.1 3.3.6 4.5.7 1.2 1.9 2.5 4.4 3z",
    fill: "#FEC50C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.7 215.8c-1.7-.3-3.3-.1-4.5.6-1 .6-2.4 1.8-2.9 4.3-.7 3.8 1.2 6.6 4.9 7.3.7.1 1.9.2 3.3.2 5.4 0 14.6-.8 15.9-.9l6.5-.6-5.8-3c-1.3-.6-14.2-7.3-17.4-7.9zM271.3 266.8c-3.8-.7-6.6 1.2-7.3 4.9-.7 3.3.5 17.6.7 19.3l.6 6.5 3-5.8c.8-1.5 7.4-14.3 8-17.5.3-1.7.1-3.3-.6-4.5-.6-1.1-1.9-2.4-4.4-2.9zM217.9 202.7c.5.1 1.1.2 1.6.2 1.1 0 2.1-.2 3-.7 1-.6 2.4-1.8 2.9-4.3.7-3.8-1.2-6.6-4.9-7.3-3.3-.7-17.6.5-19.3.7l-6.5.6 5.8 3c1.3.6 14.1 7.2 17.4 7.8zM313.6 151.8c-1 1.4-1.4 3-1.2 4.4.1 1.2.8 2.9 2.9 4.3 1.2.8 2.5 1.2 3.7 1.2 1.9 0 3.7-1 5-3 1.9-2.8 6.3-16.5 6.7-18.1l2-6.2-5 4.2c-1.2 1.1-12.2 10.4-14.1 13.2zM340.2 240.1c-1.4-1-3-1.4-4.4-1.2-1.2.1-2.9.8-4.3 2.9-2.1 3.2-1.4 6.5 1.8 8.7 2.8 1.9 16.5 6.3 18.1 6.7l6.2 2-4.2-5c-1.1-1.2-10.4-12.2-13.2-14.1zM251.9 266.7c1-1.4 1.4-3 1.2-4.4-.1-1.2-.8-2.9-2.9-4.3-3.2-2.1-6.5-1.4-8.7 1.8-1.9 2.8-6.3 16.5-6.7 18.1l-2 6.2 5-4.2c1.2-1.1 12.2-10.4 14.1-13.2zM225.3 178.4c1.2.8 2.5 1.2 3.7 1.2 1.9 0 3.7-1 5-2.9 2.1-3.2 1.4-6.5-1.8-8.7-2.8-1.9-16.5-6.3-18.1-6.7l-6.2-2 4.2 5c1.1 1.2 10.4 12.2 13.2 14.1zM330.5 171.6c-.3 1.1-.4 2.9 1 5.1 1.3 1.9 3.1 2.9 5 2.9 1.2 0 2.5-.4 3.7-1.2 2.8-1.9 12.1-12.9 13.1-14.1l4.2-5-6.2 2c-1.6.5-15.3 4.9-18.1 6.7-1.4 1-2.3 2.2-2.7 3.6zM324 259.8c-1-1.4-2.2-2.4-3.6-2.8-1.1-.3-2.9-.4-5.1 1-3.2 2.2-3.8 5.5-1.7 8.7 1.9 2.8 12.9 12.1 14.1 13.1l5 4.2-2-6.2c-.4-1.5-4.8-15.3-6.7-18zM235 246.9c.3-1.1.4-2.9-1-5.1-2.2-3.2-5.5-3.8-8.7-1.7-2.8 1.9-12.1 12.9-13.1 14.1l-4.2 5 6.2-2c1.6-.5 15.3-4.9 18.1-6.7 1.4-1 2.4-2.2 2.7-3.6zM241.5 158.7c1 1.4 2.2 2.4 3.6 2.8.4.1.9.2 1.4.2 1 0 2.3-.3 3.7-1.2 3.2-2.2 3.8-5.5 1.7-8.7-1.9-2.8-12.9-12.1-14.1-13.1l-5-4.2 2 6.2c.5 1.5 4.8 15.3 6.7 18zM345.2 190.5c-1.7.3-3.1 1.1-4 2.3-.7.9-1.5 2.6-1 5.1.7 3.2 2.8 5 5.8 5 .5 0 1-.1 1.6-.2 3.3-.7 16.1-7.3 17.5-8l5.8-3-6.5-.6c-1.5-.1-15.9-1.3-19.2-.6zM299.3 267.8c-.9-.7-2.6-1.5-5.1-1-3.8.8-5.6 3.6-4.9 7.4.7 3.3 7.3 16.1 8 17.5l3 5.8.6-6.5c.1-1.6 1.3-16 .7-19.3-.4-1.7-1.2-3.1-2.3-3.9zM217 228.2c1.5 0 2.7-.1 3.3-.2 3.7-.7 5.7-3.6 4.9-7.3-.8-3.8-3.6-5.6-7.4-4.9-3.3.7-16.1 7.3-17.5 8l-5.8 3 6.5.6c1.3.1 10.5.8 16 .8zM269.8 151.9c.5 0 1-.1 1.5-.2 3.8-.8 5.6-3.6 4.9-7.4-.7-3.3-7.3-16.1-8-17.5l-3-5.8-.6 6.5c-.1 1.6-1.3 16-.7 19.3.7 3.2 2.9 5.1 5.9 5.1z",
    fill: "#FEC50C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9 268.3c1.4-2.3 4-6.8 1.3-11.6l-.5-.9-.8-.6c-2.2-1.8-5-2.5-7.8-2-.1 0-.3.1-.4.1.2-1.4.3-2.9.3-4.4v-.1c0-3.9-1.1-6.9-3.3-8.7-1.8-1.5-4.1-2.2-6.6-1.9h-.2c-5.4 1-6.3 6.1-6.7 8 0 .1 0 .2-.1.3-1.5-.7-3.2-.8-4.9-.5-3.8.8-6.4 4.1-6.3 7.8-4.9 23.4-20.8 44.9-42.6 57.5-9.5 5.4-20.7 9.1-32.1 10.8l-.4.1c-1 .2-2.1.3-3.4.4-2.1.1-4.6.3-7.1 1.2l-.8.3-.7.5c-.9.7-1.8 1.5-2.6 2.2l.2-3.6c-.6 0-1.2-.1-1.7-.1-.9 0-1.9-.1-2.8-.2h-.2c-16.4-1-32.3-6.4-45.9-15.8-16.8-11.6-29-28.4-34.6-47.3l-.1-.3c-.4-1-.6-2.3-.9-3.7-.4-1.9-.8-3.9-1.6-5.9l-.5-1.3-1.1-.9c-2.3-1.9-5.5-2.4-8.2-1.3-.1 0-.1 0-.2.1v-.2l-.2-.6-.1-.3c0-.1-.1-.3-.1-.4-1.5-6.6-6-7.1-8-6.9-3.1 0-8 1.6-8.4 10.5v.4c0 1.4.1 2.9.3 4.3-2-.5-4-.3-6 .6-1.9.8-3.4 2.2-4.2 4.1-1.5 3.6.3 7.2 1.1 8.7.3.6.6 1.1.9 1.6-3.4 1.3-5.4 4.5-5 8.1l.2 1.2.7 1c2.9 4.6 6.3 8.7 9.9 12.4-.5.5-.9 1.1-1.1 1.8-1.5 3.5.7 6.8 1.9 8.6l.4.6.3.4c2.4 2.5 5 4.6 7.8 6.3-.9 1.8-.8 3.9.2 5.8l.3.6.4.5c1.6 1.8 3.5 3 5.4 3.8l-.5 3.1 2.9 2c.7.5 1.4.8 2.1 1.2l-1 1.7 4.3 2.7-4.1 2.1 12 4.4c3.9 1.4 8.1 3.1 13.5 5.5 10.6 4.7 20.3 7.3 29.7 7.8l1.4-11.2c-3.1-.6-6.2-1.5-9-2.5-5.3-1.8-10-3.4-14.4-5.3l2.9-2.4 3.2-1.4-1.3-.3 4.3-3.6-14.7-.5c-.6 0-1.2-.1-1.8-.2l-.3-1.5c-.6-2.9-2.6-4.3-4.5-5l.7-.6-.8-.3c-.2-1.3-.7-2.2-1.4-3l2.2-.9-4-1.8c-.1-.5-.3-1-.6-1.6l3.7-.6-11-8-.1-.1-.3-3.9 6.2 5.2v.1c3.3 4.4 6.8 8.9 11.4 12.7 4.4 3.7 9.5 5.5 14.4 6.9 2.3 1.5 4.5 3.6 6.8 5.9 1.6 1.6 3.3 3.3 5.2 4.8 6 5.5 14.1 5.9 19.5 6.2.6 0 1.3.1 2 .1 4 .2 7.8.3 10.9 1.4-1.7 1.4-3.5 2.5-5.5 3.2l-.4.1-.4.2c-1 .5-2.3.9-3.7 1.4-3.5 1.2-7.9 2.6-11 6.6l-.3.4-.2.4c-.2.4-.4.8-.5 1.3-1.1.8-2.2 1.8-3.1 3.2-1.1 1.7-1.4 3.3-1.5 4.4v.4c-.1 1.8.2 3.7 1.1 5.5l2.1 3.6 3.6-.3c.5 0 1.4-.2 2.2-.7 1.2.2 2.6 0 3.8-.8 1.7-.6 3.9-.8 6.2-1H262.5c-1.1 1.5-1.9 3.3-2.4 5.1l-1.4 5.5 5.4 1.4c3.4.9 6.4.2 9-1 .3.3.6.7 1 1l1.8 1.4 2.3-.2c1.5-.1 2.8-.5 4-1.1l.8.9 2.2.2c2.5.2 4.6-.5 6.2-1.5l.8.4c2.5 1.1 5.3 1 7.8-.1.6-.3 1.2-.6 1.8-1 .9.5 2 .7 3.1.7 2.2 0 4.2-.8 5.8-2.1l.2.1 1.5.2c3.6.6 6.2-.9 8.1-2.6 2.8 1 5.9.3 8.1-2 .6-.6 1.1-1.2 1.5-1.8 2.2.9 5.1 1.4 8.3-.5l.4-.3c1.3-1 2.2-2.2 2.8-3.4 3.6.7 7.5-.3 10.4-2.8 3.1-2.6 4.6-6.5 4-10.5l-.7-4.6-4.6-.2c3.6-1.2 7-2.8 10.1-4.8l.7-.5.2-.2.8-.4c2-1 5.6-2.8 5.5-6.9 1.7-.2 3.5-.5 5.2-1.1l3.5-1.2.3-3.7v-.2c1.7-.6 3.4-1.5 5.1-2.7l7.4-5.7-1.8-.8c.2-.1.4-.3.6-.4l.5-.3.4-.4c2.9-3.3 1.8-6.4 1.4-7.4 3.7-2.3 7.6-5.1 10.4-9.4 1.5-2.2 3.5-7.2.5-10.7 3.9-4.1 7.2-8.2 9.9-12.5l.7-1.1.1-1.3c0-3.1-2-6.3-5.3-7.6zm-78.1 78c-2.6-.2-5.3-.2-7.9-.1h-.3c-.3 0-.5 0-.8.1-1.7.1-4.6.3-6.7 2.7-.4.5-.8 1.1-1.1 1.9-1.3.5-3.1 1.6-3.9 3.9-.2.5-.3 1-.3 1.6-.2.1-.3.2-.5.3-2.3.8-4.6 1.2-7.1 1.4l-4.2-2.4c-1.7-1-3.4-1.2-4.5-1.3l-8.4-.1c-.4 0-.7-.1-1.1-.1-.7-.1-1.4-.1-2.1-.2l1.3-1.5 10.4-7.8-7.1.4c2.2-2 4.1-3.7 6.2-4.1l.5-.1c4.5-1.4 9.2-1.9 14.2-2.6 4.9-.6 9.9-1.2 15-2.6l1.9-.5 1.2-1.6c4.6-6.2 11.8-9.7 19.5-13.3 2.7-1.3 5.6-2.7 8.3-4.1 4.3-1.6 6-5.3 6.8-7.4.2-.2.3-.5.5-.7l6.1-2.9 3.2-.1-4.7 5.1 1.3.3-1.5 1.2-8.9 7.8 2.4.4c0 .1-.1.2-.1.3l-.4.2c-.5.2-1.1.4-1.6.7l-1.1.5.2.1c-1.2.8-2.2 1.9-2.8 3.5l-7.1-.6 2.5 7.9c-5.6 4.1-11.7 6.5-17.5 7.1l.2 6.7zM70.1 326.5c1.6-6.2 2.2-10.3 2.2-16.7 0-11-3.9-19.3-11-19.9 7.1-.6 11-8.9 11-19.9 0-6.5-.6-10.5-2.2-16.7 0 0-12.6-50.1-17.5-69.4-.6-2.4-.8-5.2-.8-9.2 0-6.2 3.2-11.3 6.5-11.5 3-.1 6.3 5.4 6.3 11.7 0 7.6-2.1 11.1-4.2 11.1-2.6 0-3.7-2.1-3.7-5.6 0-2.5.6-3.5 1.5-3.5 2.3 0 1.6 5.8 1.6 5.8 1.1-.5 2-2.6 1.5-5.4.8-.3 1.6-1.2 2.2-2.5-.6-1.1-1.3-2-2.2-2.3.5-3.3-.2-4.9-1.7-5.6.3 1.3.3 2.5.2 3.6-2.4-1.3-6.1.8-6.1 8.7 0 7.9 2.9 14.5 8.2 12.8-1.3 1.2-1.9 3.5-2.1 6.2 1-.7 2.1-.8 2.1-.8-.6 2.1-1.5 3.9-1.5 8.1 1-.9 1.9-2.5 3.2-1.4-2 7.5.5 17.8 6.7 20.3-2.3-5.1-3.4-10.6-3.4-16.1 0-17.8 2.6-20.8 2.6-33.2 0-5.1-1.4-10.6-4.1-14.4 1.8-.9 2.9-2.6 3.6-4.9-1.3-3.2-2.1-4.2-4.2-4.4 2.4-2.3 4.8-7.4 4.8-15.4 0-12.2-2.6-17.3-2.6-31 0-7.6 3.3-17.4 3.3-17.4-5.8 1.1-8.7 11.4-7 19.6-.9.3-1.8-.1-2.5-1.4-.4 2.3.2 4.9 1.1 7.2-.7.7-1.3.3-2.4-.2.1 2.3.8 4.8 2.6 7.2-5.2-2.6-8.4 4.4-8.4 11.6 0 5.5 2 9.4 4 9.4.6 0 1.6-.5 2.1-1.3.4 1.5.2 3.5-.2 5 1.4-.7 2.4-2.4 1.7-5.8 1.1-.2 2-.9 2.6-2.3-.6-1.5-1.5-2.3-2.6-2.3.8-3.2-.1-5-1.4-6.4 0 0 .8 6.4-1.3 6.4-1 0-1.8-.6-1.8-3.3 0-2.3 1.1-5.6 3.6-5.4 2.5.2 4.5 3.3 4.5 10.8 0 7-3 10.5-6.8 10.7-3.5.2-6.2-3.4-6.2-10.3 0-9.2 7-30.1 7-38.3 0-6.1-2.9-9.6-5.7-9.6-1.8 0-3.4 1.6-4.6 3.3-1.2-1.7-2.8-3.3-4.6-3.3-2.8 0-5.7 3.4-5.7 9.6 0 8.2 7 29.1 7 38.3 0 6.9-2.6 10.5-6.2 10.3-3.9-.2-6.8-3.7-6.8-10.7 0-7.6 2-10.6 4.5-10.8 2.5-.2 3.6 3 3.6 5.4 0 2.7-.9 3.3-1.8 3.3-2.1 0-1.3-6.4-1.3-6.4-1.3 1.4-2.2 3.2-1.4 6.4-1.1-.1-2 .8-2.6 2.3.6 1.4 1.5 2.1 2.6 2.3-.7 3.4.3 5 1.7 5.8-.4-1.5-.6-3.5-.2-5 .5.8 1.5 1.3 2.1 1.3 2 0 4-3.9 4-9.4 0-7.3-3.2-14.2-8.4-11.6 1.8-2.3 2.5-4.8 2.6-7.2-1.2.5-1.7.9-2.4.2.9-2.3 1.6-4.9 1.1-7.2-.7 1.3-1.6 1.7-2.5 1.4 1.6-8.2-1.2-18.5-7-19.6 0 0 3.3 9.7 3.3 17.4 0 13.8-2.6 18.8-2.6 31 0 7.9 2.4 13 4.8 15.4-2.1.3-2.9 1.2-4.2 4.4.7 2.3 1.8 4 3.6 4.9-2.7 3.8-4.1 9.3-4.1 14.4 0 12.4 2.6 15.4 2.6 33.2 0 5.5-1.1 11-3.4 16.1 6.2-2.4 8.7-12.8 6.7-20.3 1.3-1 2.2.6 3.2 1.4 0-4.1-.8-6-1.5-8.1 0 0 1.1.1 2.1.8-.1-2.7-.8-5-2.1-6.2 5.4 1.7 8.2-5 8.2-12.8 0-7.9-3.7-10-6.1-8.7-.1-1.1-.1-2.3.2-3.6-1.5.7-2.2 2.3-1.7 5.6-.9.3-1.6 1.2-2.2 2.3.6 1.3 1.4 2.1 2.2 2.5-.5 2.7.4 4.9 1.5 5.4 0 0-.6-5.8 1.6-5.8.9 0 1.5 1.1 1.5 3.5 0 3.5-1 5.6-3.7 5.6-2.1 0-4.2-3.4-4.2-11.1 0-6.3 3.3-11.8 6.3-11.7 3.3.2 6.5 5.2 6.5 11.5 0 4-.2 6.8-.8 9.2-4.9 19.4-17.5 69.4-17.5 69.4-1.6 6.2-2.2 10.3-2.2 16.7 0 11 3.9 19.3 11 19.9-7.1.6-11 8.9-11 19.9 0 6.5.6 10.5 2.2 16.7 0 0 12.6 50.1 17.5 69.4.6 2.4.8 5.2.8 9.2 0 6.2-3.2 11.3-6.5 11.5-3 .1-6.3-5.4-6.3-11.7 0-7.6 2.1-11.1 4.2-11.1 2.6 0 3.7 2.1 3.7 5.6 0 2.5-.6 3.5-1.5 3.5-2.3 0-1.6-5.8-1.6-5.8-1.1.5-2 2.6-1.5 5.4-.8.3-1.6 1.2-2.2 2.5.6 1.1 1.3 2 2.2 2.3-.5 3.3.2 4.9 1.7 5.6-.3-1.3-.3-2.5-.2-3.6 2.4 1.3 6.1-.8 6.1-8.7 0-7.9-2.9-14.5-8.2-12.8 1.3-1.2 1.9-3.5 2.1-6.2-1 .7-2.1.8-2.1.8.6-2.1 1.5-3.9 1.5-8.1-1 .9-1.9 2.5-3.2 1.4 2-7.5-.5-17.8-6.7-20.3 2.3 5.1 3.4 10.6 3.4 16.1 0 17.8-2.6 20.8-2.6 33.2 0 5.1 1.4 10.6 4.1 14.4-1.8.9-2.9 2.6-3.6 4.9 4.2 2.3 10.2 2.2 13.5-.2 3.7-.8 6.4-6.3 7.1-9.1.8 2.8 3.4 8.3 7.1 9.1 3.3 2.4 9.3 2.5 13.5.2-.7-2.3-1.8-4-3.6-4.9 2.7-3.8 4.1-9.3 4.1-14.4 0-12.4-2.6-15.4-2.6-33.2 0-5.5 1.1-11 3.4-16.1-6.2 2.4-8.7 12.8-6.7 20.3-1.3 1-2.2-.6-3.2-1.4 0 4.1.8 6 1.5 8.1 0 0-1.1-.1-2.1-.8.1 2.7.8 5 2.1 6.2-5.4-1.7-8.2 5-8.2 12.8 0 7.9 3.7 10 6.1 8.7.1 1.1.1 2.3-.2 3.6 1.5-.7 2.2-2.3 1.7-5.6.9-.3 1.6-1.2 2.2-2.3-.6-1.3-1.4-2.1-2.2-2.5.5-2.7-.4-4.9-1.5-5.4 0 0 .6 5.8-1.6 5.8-.9 0-1.5-1.1-1.5-3.5 0-3.5 1-5.6 3.7-5.6 2.1 0 4.2 3.4 4.2 11.1 0 6.3-3.3 11.8-6.3 11.7-3.3-.2-6.5-5.2-6.5-11.5 0-4 .2-6.8.8-9.2 4.5-19.4 17.1-69.4 17.1-69.4zm-21.6-20.3c-1.7-10.3-6.8-15.9-11.4-16.4 4.6-.5 9.7-6.1 11.4-16.4 1.7 10.3 6.8 15.9 11.4 16.4-4.6.4-9.7 6.1-11.4 16.4zM43.4 97.6c1.3-3.1 5.1 3 5.1 3s3.8-6.1 5.1-3c1.6 3.7-2.8 18.4-5.1 29.2-2.3-10.7-6.7-25.5-5.1-29.2zm-2.1 58c-.2-.2-.6-.2-.8-.4 3.5-1.5 6.4-4 7.9-9.2 1.6 5.2 4.5 7.7 7.9 9.2-.3.1-.6.2-.8.4-3.7.8-6.4 6.3-7.1 9.1-.7-2.8-3.3-8.3-7.1-9.1zM29.4 268.8c0-3.6.5-7 1.2-10.1 3.6-14.9 15.3-62.2 17.8-72.1 2.5 9.9 14.2 57.2 17.8 72.1.8 3.2 1.2 6.5 1.2 10.1 0 9.1-4.4 12.3-6.9 12.3-3 0-6-4.3-6-9.7 0-3.4 1-5.5 2.4-5.5 3.4 0 3.2 5.5 2.5 8.9 2.1-1.8 3.3-5 3-8.4 1.2-.3 2.3-1.4 3.3-3.6-.8-2-1.8-3.5-3.3-3.5.7-5.2-1.2-7.5-3-8.7.6 3.8.9 8.3-2.5 8.3-2.5 0-4.5.8-5.6 3.9-.1-4.1-.3-20.5-.3-20.5-.1-6.1 4.3-6 7.1-4.1-1.1-7.1-3.3-10.9-8.3-9.9 1.2-1 2.5-3.2 2.5-7.4 0-5.8-2.4-12.1-4.1-14-1.6 1.9-4.1 8.3-4.1 14 0 4.3 1.3 6.5 2.5 7.4-5.1-1-7.3 2.9-8.3 9.9 2.8-1.8 7.3-2 7.1 4.1 0 0-.2 16.3-.3 20.5-1.1-3.1-3.1-3.9-5.6-3.9-3.4 0-3.1-4.4-2.5-8.3-1.8 1.2-3.6 3.4-3 8.7-1.5.1-2.5 1.5-3.3 3.5 1 2.2 2.2 3.3 3.3 3.6-.3 3.4.9 6.6 3 8.4-.7-3.4-.9-8.9 2.5-8.9 1.4 0 2.4 2.1 2.4 5.5 0 5.4-3 9.7-6 9.7-2.1 0-6.5-3.2-6.5-12.3zM48.5 393c-2.5-9.9-14.2-57.2-17.8-72.1-.8-3.2-1.2-6.5-1.2-10.1 0-9.1 4.4-12.3 6.9-12.3 3 0 6 4.3 6 9.7 0 3.4-1 5.5-2.4 5.5-3.4 0-3.2-5.5-2.5-8.9-2.1 1.8-3.3 5-3 8.4-1.2.3-2.3 1.4-3.3 3.6.8 2 1.8 3.5 3.3 3.5-.7 5.2 1.2 7.5 3 8.7-.6-3.8-.9-8.3 2.5-8.3 2.5 0 4.5-.8 5.6-3.9.1 4.1.3 20.5.3 20.5.1 6.1-4.3 6-7.1 4.1 1.1 7.1 3.3 10.9 8.3 9.9-1.2 1-2.5 3.2-2.5 7.4 0 5.8 2.4 12.1 4.1 14 1.6-1.9 4.1-8.3 4.1-14 0-4.3-1.3-6.5-2.5-7.4 5.1 1 7.3-2.9 8.3-9.9-2.8 1.8-7.3 2-7.1-4.1 0 0 .2-16.3.3-20.5 1.1 3.1 3.1 3.9 5.6 3.9 3.4 0 3.1 4.4 2.5 8.3 1.8-1.2 3.6-3.4 3-8.7 1.5-.1 2.5-1.5 3.3-3.5-1-2.2-2.2-3.3-3.3-3.6.3-3.4-.9-6.6-3-8.4.7 3.4.9 8.9-2.5 8.9-1.4 0-2.4-2.1-2.4-5.5 0-5.4 3-9.7 6-9.7 2.5 0 6.9 3.2 6.9 12.3 0 3.6-.5 7-1.2 10.1-4 14.9-15.7 62.2-18.2 72.1z",
    fill: "#FEC50C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496 80v352H16V80h480m16-16H0v384h512V64z",
    fill: "#AFBDC6"
  }))), _symbol176 || (_symbol176 = /*#__PURE__*/React.createElement("symbol", {
    id: "ko-kr",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 81.3,
    fill: "#FFFFFF",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E03232",
    d: "M256,176c-44.2,0-80,35.8-80,80h160C336,211.8,300.2,176,256,176z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0035A0",
    d: "M256,336c44.2,0,80-35.8,80-80H176C176,300.2,211.8,336,256,336z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    x1: 384,
    y1: 128,
    x2: 448,
    y2: 192
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    x1: 64,
    y1: 192,
    x2: 128,
    y2: 128
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    x1: 128,
    y1: 384,
    x2: 64,
    y2: 320
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    x1: 448,
    y1: 320,
    x2: 384,
    y2: 384
  }))), _symbol177 || (_symbol177 = /*#__PURE__*/React.createElement("symbol", {
    id: "lo-la",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 81.3,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#0035A0",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 256,
    cy: 256,
    r: 48
  }))), _symbol178 || (_symbol178 = /*#__PURE__*/React.createElement("symbol", {
    id: "lt-lt",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#FCD638",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#75BD4A",
    width: 480,
    height: 128
  }))), _symbol179 || (_symbol179 = /*#__PURE__*/React.createElement("symbol", {
    id: "ms-my",
    viewBox: "0 0 32 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h32v24H0V0z",
    fill: "#B0BEC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1h30v22H1V1z",
    fill: "#E03232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,3h30v2H1V3z M1,7h30v2H1V7z M1,11h30v2H1V11z M1,15h30v2H1V15z M1,19h30v2H1V19z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,1h16v12H1V1z",
    fill: "#00206A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,7c0-1.9,1.4-3.5,3.2-3.9C8.6,3.1,8.3,3,8,3C5.8,3,4,4.8,4,7s1.8,4,4,4c0.3,0,0.5,0,0.8-0.1C7,10.6,5.6,9,5.6,7z",
    fill: "#FCD638"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5,4.5c3.1,0,3.3,5,0,5C8.4,9.5,8.3,4.5,11.5,4.5z",
    fill: "#FCD638"
  }))), _symbol180 || (_symbol180 = /*#__PURE__*/React.createElement("symbol", {
    id: "nb-no",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 80,
    fill: "#FFFFFF",
    width: 96,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 208,
    fill: "#FFFFFF",
    width: 480.1,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 240,
    fill: "#0035A0",
    width: 480.1,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160,
    y: 80,
    fill: "#0035A0",
    width: 32,
    height: 352
  }))), _symbol181 || (_symbol181 = /*#__PURE__*/React.createElement("symbol", {
    id: "nl-be",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#4C4C4E",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    fill: "#E03232",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    fill: "#FCD638",
    width: 160,
    height: 352
  }))), _symbol182 || (_symbol182 = /*#__PURE__*/React.createElement("symbol", {
    id: "nl-nl",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#0035A0",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#FFFFFF",
    width: 480,
    height: 128
  }))), _symbol183 || (_symbol183 = /*#__PURE__*/React.createElement("symbol", {
    id: "pl-pl",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.6,
    fill: "#FFFFFF",
    width: 480,
    height: 176
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 256,
    fill: "#E03232",
    width: 480,
    height: 176
  }))), _symbol184 || (_symbol184 = /*#__PURE__*/React.createElement("symbol", {
    id: "pt-br",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#75BD4A",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD638",
    points: "256,416 32,256 256,96 480,256 "
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0035A0",
    cx: 256,
    cy: 256,
    r: 80
  }))), _symbol185 || (_symbol185 = /*#__PURE__*/React.createElement("symbol", {
    id: "pt-pt",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#75BD4A",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.6,
    y: 80,
    fill: "#E03232",
    width: 320,
    height: 352
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EDC645",
    cx: 176,
    cy: 224,
    r: 64
  }))), _symbol186 || (_symbol186 = /*#__PURE__*/React.createElement("symbol", {
    id: "ro-ro",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336,
    y: 80,
    fill: "#E03232",
    width: 160,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176,
    y: 80,
    fill: "#FCD638",
    width: 160,
    height: 352
  }))), _symbol187 || (_symbol187 = /*#__PURE__*/React.createElement("symbol", {
    id: "ru-ru",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#FFFFFF",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#0035A0",
    width: 480,
    height: 128
  }))), _symbol188 || (_symbol188 = /*#__PURE__*/React.createElement("symbol", {
    id: "sk-sk",
    viewBox: "0 0 32 24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    fill: "#B0BEC9",
    d: "M0,0h32v24H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    fill: "#E03232",
    d: "M1,16h30v7H1V16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#0035A0",
    d: "M1,8h30v8H1V8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    fill: "#FFFFFF",
    d: "M31,1H1v7h4v4.9c0,3.9,5,5.1,5,5.1s5-1.2,5-5.1V8h16V1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    fill: "#0035A0",
    d: "M6.1,13c0.5,3.1,3.9,4,3.9,4s3.4-0.9,3.9-4H6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    fill: "#D80027",
    d: "M14,6H6c0,0.4-0.1,6.9,0.1,7h3.4v-2h-2v-1h2V9h-1V8h1V7h1v1h1v1h-1v1h2v1h-2v2h3.4C14.1,12.9,14,6.4,14,6z"
  }))), _symbol189 || (_symbol189 = /*#__PURE__*/React.createElement("symbol", {
    id: "sl-si",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#FFFFFF",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#0035A0",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#0035A0",
    stroke: "#FFFFFF",
    strokeWidth: 16,
    strokeMiterlimit: 10,
    points: "256,160 176,320 96,160 "
  }))), _symbol190 || (_symbol190 = /*#__PURE__*/React.createElement("symbol", {
    id: "sr-rs-latin",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#FFFFFF",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#0035A0",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD638",
    points: "240,176 160,336 80,176 "
  }))), _symbol191 || (_symbol191 = /*#__PURE__*/React.createElement("symbol", {
    id: "sr-rs",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#B0BEC9",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#E03232",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#FFFFFF",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#0035A0",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD638",
    points: "240,176 160,336 80,176 "
  }))), _symbol192 || (_symbol192 = /*#__PURE__*/React.createElement("symbol", {
    id: "sv-se",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 80,
    fill: "#FCD638",
    width: 64,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 224,
    fill: "#FCD638",
    width: 480.1,
    height: 64
  }))), _symbol193 || (_symbol193 = /*#__PURE__*/React.createElement("symbol", {
    id: "ta-in",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.3,
    fill: "#F5984C",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 320,
    fill: "#75BD4A",
    width: 480,
    height: 112
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 192,
    fill: "#FFFFFF",
    width: 480,
    height: 128
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#0035A0",
    cx: 256,
    cy: 256,
    r: 40
  }))), _symbol194 || (_symbol194 = /*#__PURE__*/React.createElement("symbol", {
    id: "th-th",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#C0CFD8",
    y: 64,
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F01616",
    x: 16,
    y: 372.5,
    width: 480,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 16,
    y: 313.9,
    width: 480,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#241B50",
    x: 16,
    y: 198,
    width: 480,
    height: 116
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 16,
    y: 139.9,
    width: 480,
    height: 58
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F01616",
    x: 16,
    y: 82,
    width: 480,
    height: 58
  }))), _symbol195 || (_symbol195 = /*#__PURE__*/React.createElement("symbol", {
    id: "tr-tr",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M240,336c-44.2,0-80-35.8-80-80s35.8-80,80-80c2,0,4,0.4,6,0.6c-15.4-10.5-34-16.6-54-16.6c-53,0-96,43-96,96s43,96,96,96c20,0,38.6-6.1,54-16.6C244,335.6,242,336,240,336z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFFFFF",
    points: "253.2,202 273.8,227.7 304.5,216.1 286.5,243.5 307,269.2 275.3,260.5 257.2,288 255.7,255.2 224,246.5 254.8,234.9"
  }))), _symbol196 || (_symbol196 = /*#__PURE__*/React.createElement("symbol", {
    id: "uk-ua",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80.6,
    fill: "#0094CE",
    width: 480,
    height: 176
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 256,
    fill: "#FCD638",
    width: 480,
    height: 176
  }))), _symbol197 || (_symbol197 = /*#__PURE__*/React.createElement("symbol", {
    id: "vi-vn",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD638",
    points: "296.7,318.7 256.7,289.3 217.6,320 232,271.1 192,241.7 240.9,240.9 255.3,192 271.1,240.4 320,239.6 280.9,270.3"
  }))), _symbol198 || (_symbol198 = /*#__PURE__*/React.createElement("symbol", {
    id: "zh-cn",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FCD638",
    points: "152.7,238.7 112.7,209.3 73.6,240 88,191.1 48,161.7 96.9,160.9 111.3,112 127.1,160.4 176,159.6  136.9,190.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDD00",
    points: "236.6,154.2 226.6,140.1 210.3,145.9 220.5,131.4 210.5,117.3 226.7,122.4 236.9,107.9 236.7,125.6 252.9,130.7 236.7,136.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDD00",
    points: "275.6,203.8 276.2,186.5 259.7,181.4 276.5,175.9 277,158.6 286.9,172.4 303.7,166.9 293,181 302.9,194.8 286.4,189.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDD00",
    points: "267,276.9 272.2,260.4 257.7,251 275.4,250.2 280.5,233.8 286.3,249.7 304,249 289.9,259.6 295.6,275.6 281.1,266.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFDD00",
    points: "207.9,319.2 219.8,306.8 211.1,291.9 227.2,299.1 239.2,286.7 237.2,303.6 253.4,310.8 236,314 234.1,330.9 225.3,316"
  }))), _symbol199 || (_symbol199 = /*#__PURE__*/React.createElement("symbol", {
    id: "zh-tw",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 64,
    fill: "#C0CFD8",
    width: 512,
    height: 384
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#E03232",
    width: 480,
    height: 352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 80,
    fill: "#0035A0",
    width: 192,
    height: 160
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFFFFF",
    cx: 112,
    cy: 160,
    r: 32
  }))), _symbol200 || (_symbol200 = /*#__PURE__*/React.createElement("symbol", {
    id: "folder",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,128h-96L241.1,44.8C230,36.5,216.5,32,202.7,32H64C28.7,32,0,60.7,0,96v320c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V192C512,156.7,483.3,128,448,128z"
  }))), _symbol201 || (_symbol201 = /*#__PURE__*/React.createElement("symbol", {
    id: "form-extensions",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-form-extensions-border-1",
    x: 256,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "lexicon-icon-outline lx-form-extensions-circle-1",
    transform: "matrix(0.9782 -0.2075 0.2075 0.9782 -30.4077 30.0357)",
    cx: 128,
    cy: 160,
    rx: 32,
    ry: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-form-extensions-rectangle-1",
    d: "M224,192h160c17.7,0,32-14.3,32-32s-14.3-32-32-32H224c-17.7,0-32,14.3-32,32S206.3,192,224,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-form-extensions-rectangle-2",
    d: "M384,224H224c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S401.7,224,384,224z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "lexicon-icon-outline lx-form-extensions-circle-2",
    transform: "matrix(0.4711 -0.8821 0.8821 0.4711 -158.1109 248.3094)",
    cx: 128,
    cy: 256,
    rx: 32,
    ry: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-form-extensions-rectangle-3",
    d: "M416,354c0-17.7-14.3-32-32-32H224c-17.7,0-32,14.3-32,32s14.3,32,32,32h160C401.7,386,416,371.7,416,354z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lx-form-extensions-circle-3",
    cx: 128,
    cy: 354,
    r: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-form-extensions-border-2",
    x: 448,
    y: 192,
    width: 64,
    height: 128
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-form-extensions-border-3",
    x: 256,
    y: 448,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-form-extensions-border-4",
    d: "M64,64h128V0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h128v-64H64V64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-form-extensions-border-5",
    d: "M448,448h-64v64h64c35.3,0,64-28.7,64-64v-64h-64V448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-form-extensions-border-6",
    d: "M448,0h-64v64h64v64h64V64C512,28.7,483.3,0,448,0z"
  }))), _symbol202 || (_symbol202 = /*#__PURE__*/React.createElement("symbol", {
    id: "format",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "format-roller lexicon-icon-outline",
    d: "M416,192H192c-35.3,0-64-28.7-64-64V64c0-35.3,28.7-64,64-64h224c35.3,0,64,28.7,64,64v64C480,163.3,451.3,192,416,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "format-handle lexicon-icon-outline",
    d: "M320,320v-64c0-17.7-14.3-32-32-32H96V96c0-43-64-43-64,0v160c0,17.7,14.3,32,32,32h192v32h0c-17.7,0-32,14.3-32,32v160h128V352C352,334.3,337.7,320,320,320L320,320z"
  }))), _symbol203 || (_symbol203 = /*#__PURE__*/React.createElement("symbol", {
    id: "forms",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline forms-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,448H64V64h384V448C448,448,448,448,448,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline forms-li-item-1",
    d: "M384,128H224c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S401.7,128,384,128z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline forms-li-bullet-1",
    cx: 128,
    cy: 160,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline forms-li-item-2",
    d: "M384,224H224c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S401.7,224,384,224z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline forms-li-bullet-2",
    cx: 128,
    cy: 256,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline forms-li-item-3",
    d: "M384,320H224c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S401.7,320,384,320z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline forms-li-bullet-3",
    cx: 128,
    cy: 352,
    r: 32
  }))), _symbol204 || (_symbol204 = /*#__PURE__*/React.createElement("symbol", {
    id: "full-size",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline full-size-bottom-right",
    d: "M384,382.8041H224V448h160c35.2,0,64-28.8,64-64V224h-64V382.8041z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline full-size-top-left",
    d: "M128,126.8041h160v-64H128c-35.2,0-64,28.8-64,64V288h64V126.8041z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline full-size-top-right",
    d: "M502.5245,9.4752C496.4434,3.3941,488.241,0,479.6143,0H378.3566c-17.9605-0.0001-32.4562,14.4956-32.3855,32.3854c0,8.9095,3.6063,17.0413,9.4753,22.9103c5.869,5.869,14.0007,9.4752,22.9102,9.4752h23.6174l-80.4688,80.4688l45.2548,45.2548l80.4688-80.4688v23.6174c0,17.9605,14.4957,32.4562,32.3855,32.3854c17.9605,0,32.4562-14.4957,32.3855-32.3854V32.3855C511.9998,23.7587,508.6057,15.5564,502.5245,9.4752z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline fullsize-bottom-left",
    d: "M145.24,321.5054l-80.4688,80.4688v-23.6174c0-17.9606-14.4957-32.4562-32.3855-32.3855c-17.9605,0-32.4562,14.4957-32.3855,32.3855v101.2576c0,8.6268,3.3941,16.8292,9.4753,22.9103c6.0811,6.0811,14.2835,9.4753,22.9102,9.4752L133.6434,512c17.9605,0,32.4562-14.4957,32.3855-32.3855c0-8.9095-3.6063-17.0413-9.4753-22.9103c-5.869-5.869-14.0007-9.4752-22.9102-9.4752h-23.6174l80.4688-80.4688L145.24,321.5054z"
  }))), _symbol205 || (_symbol205 = /*#__PURE__*/React.createElement("symbol", {
    id: "geolocation",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0c-79.4,0-144,61.7-144,137.5c0,43.3,102.1,307.3,122.5,359.8c3.5,8.9,12,14.8,21.5,14.8l0,0c9.5,0,18-5.9,21.5-14.8c28.7-73.8,122.5-318,122.5-359.7C400,61.7,335.4,0,256,0z M256,224c-44.2,0-80-35.8-80-80s35.8-80,80-80s80,35.8,80,80S300.2,224,256,224z"
  }))), _symbol206 || (_symbol206 = /*#__PURE__*/React.createElement("symbol", {
    id: "globe",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C115.2,0,0,115.2,0,256s115.2,256,256,256s256-115.2,256-256S396.8,0,256,0z M320,384c12.8,9.6,25.6,76.8,25.6,76.8c-28.8,12.8-73.6,25.2-121.6,16c0,0-32-16-32-60.8s16-67.2-32-96s-86.4-22.4-96-32s-16-38.4,0-64c12.8,0,19.2,0,32,0c0-22.4,0-48,0-64c25.6,0,35.2,0,64,0c19.2-12.8,64-124.8,64-124.8c19.2-6.4,52.8-6.9,64,0C183.3,161.3,348.7,46.7,320,96c-19.2,35.2-96,83.2-96,96s22.4,32,32,32s51.2-64,64-64s41.6,54.4,32,64s-115.2,16-128,32s-16,80,0,96S307.2,374.4,320,384z M425.6,403.2c0,0,25.6-86.4,22.4-115.2s-22.4-60.8-32-64s-25.6,6.4-32,0c0-6.4,0-19.2,0-32c6.4-6.4,67.2-6.4,86.4,0C476.8,195.2,506.5,308.9,425.6,403.2z"
  }))), _symbol207 || (_symbol207 = /*#__PURE__*/React.createElement("symbol", {
    id: "google-drive",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M500.1,315.3L336.6,30.8H175.4L339,315.3H500.1z M201.5,339l-80.6,142.2h310.5L512,339H201.5z M154.1,66.4L0,339l80.6,142.2L237,208.6L154.1,66.4z"
  }))), _symbol208 || (_symbol208 = /*#__PURE__*/React.createElement("symbol", {
    id: "google",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M261.21,219.43v87.77h147.83c-5.96,37.67-44.68,110.44-147.83,110.44c-88.99,0-161.61-72.41-161.61-161.64S172.22,94.35,261.21,94.35c50.64,0,84.53,21.21,103.89,39.5l70.75-66.93C390.42,25.23,331.59,0,261.21,0C117.11,0,0.56,114.47,0.56,256s116.55,256,260.65,256c150.44,0,250.23-103.86,250.23-250.15c0-16.82-1.86-29.62-4.09-42.42H261.21z"
  }))), _symbol209 || (_symbol209 = /*#__PURE__*/React.createElement("symbol", {
    id: "grid",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-3",
    d: "M495.965 0.018h-95.993c-8.813 0-15.981 7.168-15.981 16.017v95.993c0 8.85 7.168 16.017 16.017 16.017h95.993c8.849 0 16.017-7.168 16.017-16.017v-95.993c-0.037-8.85-7.204-16.017-16.054-16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-4",
    d: "M112.028 192.005h-95.993c-8.85 0-16.017 7.167-16.017 16.017v95.993c0 8.849 7.168 16.017 16.017 16.017h95.993c8.85 0 15.981-7.168 15.981-16.017v-95.993c0-8.85-7.168-16.017-15.981-16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-5",
    d: "M303.978 192.005h-95.993c-8.85 0-16.017 7.167-16.017 16.017v95.993c0 8.849 7.167 16.017 16.017 16.017h95.993c8.849 0 16.017-7.168 16.017-16.017v-95.993c0-8.85-7.168-16.017-16.017-16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-6",
    d: "M495.965 192.005h-95.993c-8.849 0-16.017 7.167-16.017 16.017v95.993c0 8.849 7.168 16.017 16.017 16.017h95.993c8.849 0 16.017-7.168 16.017-16.017v-95.993c0-8.85-7.168-16.017-16.017-16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-7",
    d: "M112.028 383.991h-95.993c-8.85 0-16.017 7.168-16.017 16.017v95.993c0 8.813 7.168 15.981 16.017 15.981h95.993c8.85 0 15.981-7.168 15.981-16.017v-95.993c0-8.813-7.168-15.981-15.981-15.981z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-8",
    d: "M303.978 383.991h-95.993c-8.85 0-16.017 7.168-16.017 16.017v95.993c0 8.849 7.167 16.017 16.017 16.017h95.993c8.849 0 16.017-7.168 16.017-16.017v-95.993c0-8.849-7.168-16.017-16.017-16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-9",
    d: "M495.965 383.991h-95.993c-8.849 0-16.017 7.168-16.017 16.017v95.993c0 8.849 7.168 16.017 16.017 16.017h95.993c8.849-0.037 16.017-7.204 16.017-16.054v-95.993c0-8.813-7.168-15.981-16.017-15.981z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-1",
    d: "M112.028 0.018h-95.993c-8.85 0-16.017 7.168-16.017 16.017v95.993c0 8.814 7.168 15.981 16.017 15.981h95.993c8.85 0 15.981-7.168 15.981-16.017v-95.956c0-8.85-7.168-16.017-15.981-16.017z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline grid-square-2",
    d: "M303.978 0.018h-95.993c-8.85 0-16.017 7.168-16.017 16.017v95.993c0 8.85 7.167 16.017 16.017 16.017h95.993c8.849 0 16.017-7.168 16.017-16.017v-95.993c0-8.85-7.168-16.017-16.017-16.017z"
  }))), _symbol210 || (_symbol210 = /*#__PURE__*/React.createElement("symbol", {
    id: "h1",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline heading-h1-h",
    d: "M266.812 199.731c-7.13-8.47-16.182-15.246-27.105-20.303-10.947-5.056-23.893-7.585-38.786-7.585-11.1 0-22.528 2.048-34.26 6.119s-21.416 10.846-29 20.303l-0-134.264h-73.662v352h73.662l0-138.521c0.607-13.375 4.753-24.525 12.339-33.501 7.636-8.951 18.078-13.451 31.403-13.451 15.221 0 26.244 4.576 33.071 13.678 6.827 9.127 10.215 20.556 10.215 34.235l-0 137.56h63.31l0-148.812c0-13.021-1.744-25.435-5.233-37.142-3.514-11.732-8.824-21.846-15.954-30.315l0-0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline heading-h1-1",
    d: "M396.014 128c-2.925 15.277-11.122 28.141-24.68 38.611-13.536 10.471-30.694 15.857-51.334 16.16v41.229h64v192h64v-288h-51.986z"
  }))), _symbol211 || (_symbol211 = /*#__PURE__*/React.createElement("symbol", {
    id: "h2",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline heading-h2-h",
    d: "M234.812 231.731c-7.13-8.47-16.182-15.246-27.105-20.303-10.947-5.056-23.893-7.585-38.786-7.585-11.1 0-22.528 2.048-34.26 6.119s-21.416 10.846-29 20.303l-0.001-134.264h-73.662v352h73.662l0.001-138.521c0.607-13.375 4.753-24.525 12.338-33.501 7.636-8.95 18.079-13.451 31.402-13.451 15.221 0 26.244 4.576 33.071 13.678 6.827 9.127 10.215 20.556 10.215 34.235l-0 137.56h63.31l0-148.812c0-13.021-1.744-25.435-5.233-37.142-3.514-11.732-8.824-21.846-15.954-30.315l0-0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline heading-h2-2",
    d: "M358.197 382.474c4.146-4.012 8.916-7.757 14.353-11.211l53.513-32.74c17.139-10.632 30.378-23.202 39.829-37.712 9.406-14.51 14.108-30.824 14.108-48.9 0-12.058-2.273-23.559-6.82-34.48-4.569-10.921-11.211-20.483-19.925-28.662s-19.257-14.732-31.671-19.613c-12.392-4.881-26.344-7.31-41.745-7.31-16.27 0-30.69 2.585-43.239 7.756-12.57 5.171-23.135 12.058-31.671 20.683-8.58 8.603-15.156 18.522-19.725 29.732s-6.82 23.001-6.82 35.349c0 0.375 0.012 0.761 0.017 1.14h56.188c0.743-11.25 4.341-20.839 10.793-28.732 7.288-8.916 18.32-13.373 33.164-13.373 13.974 0 24.45 3.877 31.448 11.634 6.998 7.778 10.498 16.671 10.498 26.723 0 9.762-2.519 18.477-7.489 26.077s-13.485 15.022-25.475 22.199l-45.825 27.57c-12.548 7.489-22.957 15.601-31.248 24.361-8.247 8.76-14.911 18.165-19.903 28.238-0.463 0.928-0.909 1.861-1.349 2.798-4.32 9.21-7.507 18.839-9.55 28.874-0.214 1.034-0.409 2.080-0.603 3.126v32h200.95v-64h-123.274c0.478-0.519 0.965-1.029 1.47-1.526z"
  }))), _symbol212 || (_symbol212 = /*#__PURE__*/React.createElement("symbol", {
    id: "hashtag",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480,128h-64l22.4-89.4C447-2,390-16,378.1,23.5L352,128H224l22.4-89.4C255-2,198-16,186.1,23.5L160,128H64c-42,0-43,64,0,64h80l-32,128H32c-42,0-43,64,0,64h64l-22.4,89.4C65,517,126,525,133.9,488.5L160,384h128l-22.4,89.4C257,517,318,525,325.9,488.5L352,384h96c43,0,42-64,0-64h-80l32-128h80C523,192,522,128,480,128z M304,320H176l32-128h128L304,320z"
  }))), _symbol213 || (_symbol213 = /*#__PURE__*/React.createElement("symbol", {
    id: "hdd",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-hdd-bottom",
    d: "M480,352c17.7,0,32-14.3,32-32v-96c0-17.7-14.3-32-32-32H32c-17.7,0-32,14.3-32,32v96c0,17.7,14.3,32,32,32h192v96H32c-42,0-42.3,64,0,64h448c42,0,42.7-64,0-64H288v-96H480z M448,272c0,20.8-32,21.5-32,0C416,251.5,448,250.2,448,272z M384,272c0,21-32,21.5-32,0S384,250.8,384,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-hdd-top",
    d: "M480,0H32C14.3,0,0,14.3,0,32v96c0,17.7,14.3,32,32,32h448c17.7,0,32-14.3,32-32V32C512,14.3,497.7,0,480,0z M352,80c0-21.5,32-20.8,32,0C384,102,352,100.5,352,80z M416,80c0-21.2,32-21.3,32,0C448,101.7,416,101.8,416,80z"
  }))), _symbol214 || (_symbol214 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,113.4C148.7-6-30,105.3,31.3,253.4C58.4,311.2,222,457.7,240.6,474.1c8.7,6.9,21.7,7.9,30.8,0.1c18.6-16.5,182.2-162.9,209.3-220.7C546,104.7,353.3-6,256,113.4z"
  }))), _symbol215 || (_symbol215 = /*#__PURE__*/React.createElement("symbol", {
    id: "heart",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M417,75.7c-17.9-8.5-37-12.8-56.7-12.8c-41,0-79.4,19.1-104.3,50.5C231,82,192.6,62.9,151.7,62.9c-19.7,0-38.8,4.3-56.7,12.8C28.6,107.1,0,186.8,31.3,253.4C58.4,311.2,222,457.7,240.6,474.1c4.3,3.8,9.8,5.9,15.4,5.9l0,0l0,0c0.4,0,0.8,0,1.2,0c5.2-0.3,10.2-2.2,14.2-5.8c18.6-16.5,182.2-162.9,209.3-220.7C512,186.8,483.4,107.1,417,75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M417,75.7c-17.9-8.5-37-12.8-56.7-12.8c-41,0-79.4,19.1-104.3,50.5C231,82,192.6,62.9,151.7,62.9c-19.7,0-38.8,4.3-56.7,12.8C28.6,107.1,0,186.8,31.3,253.4C58.4,311.2,222,457.7,240.6,474.1c4.3,3.8,9.8,5.9,15.4,5.9l0,0l0,0c0.4,0,0.8,0,1.2,0c5.2-0.3,10.2-2.2,14.2-5.8c18.6-16.5,182.2-162.9,209.3-220.7C512,186.8,483.4,107.1,417,75.7z M438.8,233.8c-16.3,34.7-113,128.9-182.8,192c-69.8-63.1-166.5-157.3-182.8-192c-20.4-43.5-1.8-95.6,41.5-116.1c11.7-5.5,24.1-8.3,36.9-8.3l0,0l0,0l0,0l0,0c33.5,0,64.4,19.6,78.6,50c0.7,1.6,1.9,4.6,3.2,9.9c2.5,10.4,11.8,17.7,22.5,17.7l0,0c10.7,0,20-7.3,22.5-17.7c1.3-5.3,2.5-8.3,3.2-9.9c14.3-30.4,45.1-50,78.6-50c12.8,0,25.2,2.8,36.9,8.3C440.6,138.1,459.2,190.2,438.8,233.8z"
  }))), _symbol216 || (_symbol216 = /*#__PURE__*/React.createElement("symbol", {
    id: "hidden",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M478.4,278.7c7.1-8.3,20.8-24.4,29-38.1c20.4-36.2-32.2-69-54.9-32.9c-78.7,135.8-339,139.8-390.7,4.6C42.4,172-11.9,198.5,2.4,236c7,17.4,22.6,41.6,28.1,47.9c-19,8.6-39.8,25.6-25.7,52.8c25,33.7,52.7,4.7,74.4-7.4c8.7,6.8,29.3,17.1,38.3,21.1c-15,22.5-32.3,50.3-2,69.6c36.8,15.3,47.7-20.2,64.3-50c7.2,1.5,31.7,5.1,44.2,5.3c0,40.8-6.1,69.4,32,72.8c37.5-2.6,32-32,32-74.6c13.2-1,38.2-7.1,44.3-8.6c20.3,31.9,27.8,70,67.7,53.2c30.3-21.3,13-41.4-6.7-75.6c7.3-3.5,28.7-15.7,33.9-19.4c27.2,15.1,57.1,43.9,80.3,9.5C518.7,311.7,508.8,292.4,478.4,278.7z"
  }))), _symbol217 || (_symbol217 = /*#__PURE__*/React.createElement("symbol", {
    id: "home-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M233.6,22.4c12.5-12.5,32.3-12.5,44.8,0l182.9,182.8c12,12,18.7,28.3,18.7,45.3V512H320V384c0-35.3-28.7-64-64-64s-64,28.7-64,64v128H32V250.5c0-17,6.7-33.3,18.7-45.3L233.6,22.4z"
  }))), _symbol218 || (_symbol218 = /*#__PURE__*/React.createElement("symbol", {
    id: "home",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M461.3,205.2L278.4,22.4c-12.5-12.5-32.3-12.5-44.8,0L50.7,205.3c-12,12-18.7,28.3-18.7,45.3V512h192V352c0-42.7,64-42.7,64,0v160h192V250.5C480,233.5,473.3,217.2,461.3,205.2z M416,448h-64v-96c0-128-192-128-192,0c0,21.3,0,74.7,0,96H96V256L256,96l160,160V448z"
  }))), _symbol219 || (_symbol219 = /*#__PURE__*/React.createElement("symbol", {
    id: "horizontal-scroll",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512,223.8c0-8.6-3.4-16.4-8.9-22.1c-0.7-0.9-1.5-1.7-2.3-2.5L423.7,122c-13.6-13.6-35.7-13.6-49.3,0c-6.8,6.8-10.2,15.7-10.2,24.7c0,8.9,3.4,17.9,10.2,24.7l20.4,20.4H115.3l20.4-20.4c13.6-13.6,13.6-35.7,0-49.3c-13.6-13.6-35.7-13.6-49.3,0L9.2,199.1C2.7,205.7-1,214.6-1,223.8c0,9.3,3.7,18.1,10.2,24.7l77.1,77.1c13.6,13.6,35.7,13.6,49.3,0c6.8-6.8,10.2-15.7,10.2-24.7c0-8.9-3.4-17.9-10.2-24.7l-20.4-20.4h279.5l-20.4,20.4c-13.6,13.6-13.6,35.7,0,49.3c13.6,13.6,35.7,13.6,49.3,0l77.1-77.1c0.8-0.8,1.6-1.7,2.3-2.5C508.6,240.2,512,232.4,512,223.8z"
  }))), _symbol220 || (_symbol220 = /*#__PURE__*/React.createElement("symbol", {
    id: "hr",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M384,288H128c-42.7,0-42.7-64,0-64h256C426.7,224,426.7,288,384,288z"
  }))), _symbol221 || (_symbol221 = /*#__PURE__*/React.createElement("symbol", {
    id: "import-export",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline import-export-arrow-up",
    d: "M254.5,81.1L182.9,9.5C176.8,3.4,168.6,0,160,0c-8.6,0-16.8,3.4-22.9,9.5L65.5,81.1c-12.7,12.7-12.7,33.2,0,45.8c6.3,6.3,14.6,9.5,22.9,9.5s16.6-3.2,22.9-9.5l16.7-16.7V481c0,17.7,14.3,32,32,32s32-14.3,32-32V110.2l16.7,16.7c12.7,12.7,33.2,12.7,45.8,0C267.2,114.2,267.2,93.7,254.5,81.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline import-export-arrow-down",
    d: "M446.5,385.1c-6.3-6.3-14.6-9.5-22.9-9.5s-16.6,3.2-22.9,9.5L384,401.8V31c0-17.7-14.3-32-32-32s-32,14.3-32,32v370.8l-16.7-16.7c-12.7-12.7-33.2-12.7-45.8,0c-12.7,12.7-12.7,33.2,0,45.8l71.6,71.6c6.1,6.1,14.3,9.5,22.9,9.5s16.8-3.4,22.9-9.5l71.6-71.6C459.2,418.2,459.2,397.7,446.5,385.1z"
  }))), _symbol222 || (_symbol222 = /*#__PURE__*/React.createElement("symbol", {
    id: "import-list",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-import-list-border-bottom",
    d: "M448,160v288H64V160c0-42.4-64-41.4-64,0v288c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V160C512,117.3,448,117.8,448,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-import-list-bar",
    d: "M352,64H160c-43.5,0-43-64,0-64l192,0C395,0,395.5,64,352,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-import-list-arrow-down",
    d: "M352,96H160c-42,0-43,64,0,64h64.2l0.1,121.4l-16.6-16.6c-27.3-23.8-65.2,18-38.6,44.8l64.3,65.2c6.1,6.1,25.5,17.2,45.5,0l64.3-65.2c27.1-29.4-14.1-67.2-38.6-44.8l-16.6,16.6L287.8,160H352C394.5,160,394.5,96,352,96z"
  }))), _symbol223 || (_symbol223 = /*#__PURE__*/React.createElement("symbol", {
    id: "import",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-import-border-bottom",
    d: "M448,160v288H64V160c0-42.4-64-41.4-64,0v288c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V160C512,117.3,448,117.8,448,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-import-arrow-down",
    d: "M278.9,342.8l64.3-65.2c27.1-29.4-14.1-67.2-38.6-44.8l-16.6,16.6l-0.1-217.8c0-42.7-63.6-41.7-63.6,0l0.1,217.8l-16.6-16.6c-27.3-23.8-65.2,18-38.6,44.8l64.3,65.2C239.4,348.9,258.8,360,278.9,342.8z"
  }))), _symbol224 || (_symbol224 = /*#__PURE__*/React.createElement("symbol", {
    id: "indent-less",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-more-line-1",
    d: "M64,96h384c17.7,0,32-14.3,32-32s-14.3-32-32-32H64c-17.7,0-32,14.3-32,32S46.3,96,64,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-more-line-4",
    d: "M448,416H64c-17.7,0-32,14.3-32,32s14.3,32,32,32h384c17.7,0,32-14.3,32-32S465.7,416,448,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-more-line-3",
    d: "M448,288H320c-17.7,0-32,14.3-32,32s14.3,32,32,32h128c17.7,0,32-14.3,32-32S465.7,288,448,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-more-line-2",
    d: "M448,160H320c-17.7,0-32,14.3-32,32s14.3,32,32,32h128c17.7,0,32-14.3,32-32S465.7,160,448,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-more-arrow",
    d: "M113.1,350.5c12.7,12.7,33.2,12.7,45.8,0c6.3-6.3,9.5-14.6,9.5-22.9s-3.2-16.6-9.5-22.9L142.2,288H224c17.7,0,32-14.3,32-32s-14.3-32-32-32h-81.8l16.7-16.7c12.7-12.7,12.7-33.2,0-45.8c-12.7-12.7-33.2-12.7-45.8,0l-71.6,71.6c-6.1,6.1-9.5,14.3-9.5,22.9s3.4,16.8,9.5,22.9L113.1,350.5z"
  }))), _symbol225 || (_symbol225 = /*#__PURE__*/React.createElement("symbol", {
    id: "indent-more",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-less-line-1",
    d: "M64,96h384c17.7,0,32-14.3,32-32s-14.3-32-32-32H64c-17.7,0-32,14.3-32,32S46.3,96,64,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-less-line-4",
    d: "M448,416H64c-17.7,0-32,14.3-32,32s14.3,32,32,32h384c17.7,0,32-14.3,32-32S465.7,416,448,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-less-line-3",
    d: "M448,288H320c-17.7,0-32,14.3-32,32s14.3,32,32,32h128c17.7,0,32-14.3,32-32S465.7,288,448,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-less-line-2",
    d: "M448,160H320c-17.7,0-32,14.3-32,32s14.3,32,32,32h128c17.7,0,32-14.3,32-32S465.7,160,448,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline indent-less-arrow",
    d: "M64,288h81.8l-16.7,16.7c-12.7,12.7-12.7,33.2,0,45.8c12.7,12.7,33.2,12.7,45.8,0l71.6-71.6c6.1-6.1,9.5-14.3,9.5-22.9c0-8.6-3.4-16.8-9.5-22.9l-71.6-71.6c-12.7-12.7-33.2-12.7-45.8,0c-6.3,6.3-9.5,14.6-9.5,22.9s3.2,16.6,9.5,22.9l16.7,16.7H64c-17.7,0-32,14.3-32,32S46.3,288,64,288z"
  }))), _symbol226 || (_symbol226 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-book",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-book-i-dot",
    d: "M272.3,95.4c-8.8,0-16,7.2-16,16s7.2,16,16,16s16-7.2,16-16S281.1,95.4,272.3,95.4L272.3,95.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-book-i-stem",
    d: "M288.1,160h-48c-21,0.6-22,30.6,0,32h16v80c0.9,20.2,29.9,23,32,0V160L288.1,160z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-book-pages",
    d: "M400,448H143.8c-22.2-1.1-20.1-31.7,0-32H400C419.4,416.3,423.1,446.3,400,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-book-border",
    d: "M448,352V32c0-17.7-14.3-32-32-32H160c-53,0-96,43-96,96v336.1c0,0-0.9,73.8,78.3,79.7c0.6,0.1,289.7,0.3,289.7,0.3c21.6-1.4,20.9-30.7,0-32c0,0-286.8-0.2-288-0.2c-65.2-2.3-61-93.4-1.7-95.8H416C433.7,384,448,369.7,448,352z M160.1,320V64h224v256H160.1z"
  }))), _symbol227 || (_symbol227 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-circle-open",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-circle-open-border",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z M256,448c-105.9,0-192-86.1-192-192S150.1,64,256,64s192,86.1,192,192S361.9,448,256,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-circle-open-i-stem",
    d: "M256,192c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32c17.7,0,32-14.3,32-32V224C288,206.3,273.7,192,256,192z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline info-circle-open-i-dot",
    cx: 256,
    cy: 128,
    r: 32
  }))), _symbol228 || (_symbol228 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z M288,384c0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32V224c0-17.7,14.3-32,32-32c17.7,0,32,14.3,32,32V384z M256,160c-17.7,0-32-14.3-32-32c0-17.7,14.3-32,32-32s32,14.3,32,32C288,145.7,273.7,160,256,160z"
  }))), _symbol229 || (_symbol229 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-panel-closed",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-panel-closed-border",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z M256,480C132.5,480,32,379.5,32,256S132.5,32,256,32s224,100.5,224,224S379.5,480,256,480z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline info-panel-closed-i-stem",
    d: "M288,384V224c0-17.7-14.3-32-32-32c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32C273.7,416,288,401.7,288,384z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline info-panel-closed-i-dot",
    cx: 256,
    cy: 128,
    r: 32
  }))), _symbol230 || (_symbol230 = /*#__PURE__*/React.createElement("symbol", {
    id: "info-panel-open",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M437.0195,74.9805C388.667,26.6289,324.3799,0,256,0C187.6196,0,123.3325,26.6289,74.9805,74.9805C26.6289,123.3325,0,187.6196,0,256c0,68.3799,26.6289,132.667,74.9805,181.0195C123.3325,485.3711,187.6196,512,256,512c68.3799,0,132.667-26.6289,181.0195-74.9805C485.3711,388.667,512,324.3799,512,256C512,187.6196,485.3711,123.3325,437.0195,74.9805z M288,384c0,17.6729-14.3267,32-32,32c-17.6729,0-32-14.3271-32-32V224c0-17.6733,14.3271-32,32-32c17.6733,0,32,14.3267,32,32V384z M256,160c-17.6731,0-32-14.3269-32-32c0-17.6732,14.3269-32,32-32s32,14.3268,32,32C288,145.6731,273.6731,160,256,160z"
  }))), _symbol231 || (_symbol231 = /*#__PURE__*/React.createElement("symbol", {
    id: "information-live",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline information-live-i-stem",
    d: "M273.542 160h-58.313c-12.814 0-23.229 10.386-23.229 23.229 0 12.814 10.386 23.229 23.229 23.229h58.313v272.748c0 12.813 10.386 23.229 23.229 23.229 12.813 0 23.229-10.386 23.229-23.229v-319.207h-46.458z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline information-live-i-dot",
    d: "M320 49.369c0 27.257-22.096 49.354-49.354 49.354s-49.354-22.097-49.354-49.354 22.096-49.354 49.354-49.354 49.354 22.096 49.354 49.354z"
  }))), _symbol232 || (_symbol232 = /*#__PURE__*/React.createElement("symbol", {
    id: "integer",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline integer-ones",
    d: "M361.4,129.3c-74,0-82.9,84.1-82.9,125.6s10.4,127.9,82.9,127.9c73.5,0,82.9-86.4,82.9-127.9C444.4,213.6,434.9,129.3,361.4,129.3z M361.4,163.8c19.4-0.4,29.3,15.8,34.7,34.9l-75,75C319.6,231.2,319.9,163,361.4,163.8z M361.4,348.2c-18.9-0.8-28.8-16.7-34.2-35.3l74.6-74.6C401.3,280.5,402.7,348.2,361.4,348.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline integer-tens",
    d: "M99.4,342h54.5V181.5H109v-27.6c12.3-2.3,32.2-3.3,56.5-20h33V342h48v36.1H99.4V342z"
  }))), _symbol233 || (_symbol233 = /*#__PURE__*/React.createElement("symbol", {
    id: "italic",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M320,448H128v-32h64l64-320h-64V64h192v32h-64l-64,320h64V448z"
  }))), _symbol234 || (_symbol234 = /*#__PURE__*/React.createElement("symbol", {
    id: "liferay-ac",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-liferay-ac-bar-1",
    d: "M128,512H32c-17.7,0-32-14.3-32-32V288c0-17.7,14.3-32,32-32h96V512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-liferay-ac-bar-2",
    d: "M320,512H192c-17.7,0-32-14.3-32-32V32c0-17.7,14.3-32,32-32h128c17.7,0,32,14.3,32,32v448C352,497.7,337.7,512,320,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-liferay-ac-bar-3",
    d: "M480,512h-96V160h96c17.7,0,32,14.3,32,32v288C512,497.7,497.7,512,480,512z"
  }))), _symbol235 || (_symbol235 = /*#__PURE__*/React.createElement("symbol", {
    id: "link",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M216.2,295.8c-23.4-23.4,11.6-58.3,35-35c18.1,18.1,47.5,18.1,65.6,0l122.5-122.5c43.4-43.4-22.2-109.1-65.6-65.6L273.1,173.3c-23.4,23.4-58.3-11.6-35-35L338.7,37.8C429-52.5,564.5,83,474.2,173.3L351.7,295.7C310.4,337.1,249.7,329.4,216.2,295.8z M295.8,216.2c23.4,23.4-11.6,58.3-35,35c-18.1-18.1-47.5-18.1-65.6,0L72.8,373.6c-43.4,43.4,22.2,109.1,65.6,65.6l100.5-100.5c23.4-23.4,58.3,11.6,35,35L173.3,474.2C83,564.5-52.5,429,37.8,338.7l122.5-122.5C201.6,174.9,262.3,182.6,295.8,216.2z"
  }))), _symbol236 || (_symbol236 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ol-rtl",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M499.2,106.9h-16.4V9.5c0-3.4-0.6-5.8-1.7-7.3C480,0.7,478.1,0,475.3,0c-0.9,0-2,0.1-3.3,0.4c-1.4,0.3-3.1,0.7-5.2,1.2l-25.1,6.7c-3.5,0.8-6.1,2-7.8,3.7s-2.5,3.5-2.5,5.8c0,3.2,0.8,5.6,2.3,7.3c1.5,1.7,3.7,2.6,6.4,2.6c0.5,0,1.4-0.1,2.5-0.3c1.1-0.2,2.6-0.5,4.3-0.9l11.3-2.9v83.3h-18.8c-4.6,0-7.8,0.8-9.8,2.5c-2,1.7-3,4.3-3,8.1c0,3.7,1,6.3,2.9,8s5.3,2.5,9.9,2.5h59.6c4.6,0,7.9-0.8,9.9-2.5c2-1.7,2.9-4.3,2.9-8c0-3.8-1-6.4-3-8.1C507,107.8,503.7,106.9,499.2,106.9L499.2,106.9L499.2,106.9z M503,288.4c-3.5,0-6.2,0.8-8,2.4c-1.8,1.6-2.7,4-2.7,7.2v0.6h-34.6l29.9-24.9c8-6.6,13.8-13.3,17.6-20c3.8-6.6,5.7-13.6,5.7-21c0-10.9-3.6-19.6-10.9-26.1c-7.3-6.4-17.1-9.7-29.5-9.7c-6.6,0-12.8,0.8-18.5,2.4c-5.7,1.6-11.1,4-16.2,7.3c-3.2,2.1-5.3,4.2-6.3,6.3c-1,2.1-1.6,5.3-1.6,9.5c0,4.1,0.8,7.2,2.5,9.3c1.7,2.1,4.1,3.1,7.5,3.1c3.8,0,7.3-2.5,10.5-7.4c1.1-1.8,2.1-3.2,2.9-4.1c1.4-1.8,3.5-3.2,6.2-4.1c2.7-1,5.7-1.5,9.1-1.5c5.8,0,10.2,1.4,13.1,4.2c2.9,2.8,4.3,7.1,4.3,12.7c0,4-1.1,8.1-3.2,12.2s-5.4,8.1-9.7,12.2l-40.1,37.4c-2.8,2.6-4.9,5.1-6.2,7.4c-1.3,2.4-2,4.8-2,7.2c0,2.9,1,5.2,3.1,6.7s5,2.4,8.8,2.4h70.9c2.1,0,3.6-0.4,4.4-1.1c0.8-0.8,1.3-2.6,1.4-5.5l0.8-14.7v-1.2c0-2.9-0.8-5.1-2.4-6.6C508.1,289.2,505.8,288.4,503,288.4L503,288.4L503,288.4z M490,442.5c6.5-3,11.4-6.6,14.4-10.9c3.1-4.3,4.6-9.7,4.6-15.9c0-9.6-3.4-17.3-10.1-23c-6.7-5.8-15.7-8.7-27-8.7c-11.2,0-20.7,2-28.3,5.8c-7.7,3.9-11.5,8.6-11.5,14c0,2.5,0.8,4.6,2.3,6.2c1.5,1.6,3.6,2.4,6.1,2.4c2.3,0,6.4-1.5,12.3-4.5s11.4-4.5,16.1-4.5c4.5,0,8,1.3,10.5,3.8c2.5,2.5,3.8,6.1,3.8,10.6c0,5.3-1,9.1-3.1,11.4s-6.6,4-13.6,5c-0.4,0-1,0.1-1.8,0.2c-5.6,0.8-8.4,3.7-8.4,8.9c0,3.7,0.7,6.3,2.1,7.8c1.4,1.5,4.1,2.2,8.2,2.3c7.8,0.3,13.1,1.9,15.8,4.6c2.8,2.8,4.1,7.4,4.1,13.8c0,6-1.7,10.7-4.9,13.9c-3.3,3.3-7.9,4.9-14,4.9c-5.1,0-10.9-1.5-17.5-4.3c-6.6-2.9-10.7-4.3-12.3-4.3c-3.4,0-6.1,1-8.1,2.9c-2,2.1-3,4.7-3,7.8c0,5.3,3.7,9.8,11.2,13.6c7.5,3.7,16.9,5.6,28.3,5.6c14.1,0,25.3-3.5,33.5-10.5c8.2-7,12.3-16.5,12.3-28.6c0-7.9-1.8-14.4-5.5-19.4C503,448.5,497.4,444.9,490,442.5L490,442.5L490,442.5z M29.2,31.6h293.5c39.1,0,39.1,64,0,64H29.2C-9.7,95.6-9.7,31.6,29.2,31.6z M29.2,224h293.5c39.1,0,39.1,64,0,64H29.2C-9.7,288-9.7,224,29.2,224z M29.2,416h293.5c39.1,0,39.1,64,0,64H29.2C-9.7,480-9.7,416,29.2,416z"
  }))), _symbol237 || (_symbol237 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ol",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M72.5,106.9H56.1V9.5c0-3.4-0.6-5.8-1.7-7.3S51.3,0,48.6,0c-0.9,0-2,0.1-3.3,0.4c-1.4,0.3-3.1,0.7-5.2,1.2L15.1,8.3c-3.5,0.8-6.1,2-7.8,3.7s-2.5,3.5-2.5,5.8c0,3.2,0.8,5.6,2.3,7.3s3.7,2.6,6.4,2.6c0.5,0,1.4-0.1,2.5-0.3c1.1-0.2,2.6-0.5,4.3-0.9l11.3-2.9v83.3H12.8c-4.6,0-7.8,0.8-9.8,2.5c-2,1.7-3,4.3-3,8.1c0,3.7,1,6.3,2.9,8s5.3,2.5,9.9,2.5h59.6c4.6,0,7.9-0.8,9.9-2.5c2-1.7,2.9-4.3,2.9-8c0-3.8-1-6.4-3-8.1C80.2,107.8,77,106.9,72.5,106.9L72.5,106.9L72.5,106.9z M80.4,288.4c-3.5,0-6.2,0.8-8,2.4c-1.8,1.6-2.7,4-2.7,7.2v0.6H35.1L65,273.6c8-6.6,13.8-13.3,17.6-20c3.8-6.6,5.7-13.6,5.7-21c0-10.9-3.6-19.6-10.9-26.1c-7.3-6.4-17.1-9.7-29.5-9.7c-6.6,0-12.8,0.8-18.5,2.4c-5.7,1.6-11.1,4-16.2,7.3c-3.2,2.1-5.3,4.2-6.3,6.3c-1,2.1-1.6,5.3-1.6,9.5c0,4.1,0.8,7.2,2.5,9.3c1.7,2.1,4.1,3.1,7.5,3.1c3.8,0,7.3-2.5,10.5-7.4c1.1-1.8,2.1-3.2,2.9-4.1c1.4-1.8,3.5-3.2,6.2-4.1c2.7-1,5.7-1.5,9.1-1.5c5.8,0,10.2,1.4,13.1,4.2s4.3,7.1,4.3,12.7c0,4-1.1,8.1-3.2,12.2c-2.1,4-5.4,8.1-9.7,12.2L8.2,296.3c-2.8,2.6-4.9,5.1-6.2,7.4c-1.3,2.4-2,4.8-2,7.2c0,2.9,1,5.2,3.1,6.7s5,2.4,8.8,2.4h70.9c2.1,0,3.6-0.4,4.4-1.1c0.8-0.8,1.3-2.6,1.4-5.5l0.8-14.7v-1.2c0-2.9-0.8-5.1-2.4-6.6C85.5,289.2,83.3,288.4,80.4,288.4L80.4,288.4L80.4,288.4z M63.2,442.5c6.5-3,11.4-6.6,14.4-10.9c3.1-4.3,4.6-9.7,4.6-15.9c0-9.6-3.4-17.3-10.1-23c-6.7-5.8-15.7-8.7-27-8.7c-11.2,0-20.7,2-28.3,5.8s-11.5,8.6-11.5,14c0,2.5,0.8,4.6,2.3,6.2c1.5,1.6,3.6,2.4,6.1,2.4c2.3,0,6.4-1.5,12.3-4.5s11.4-4.5,16.1-4.5c4.5,0,8,1.3,10.5,3.8c2.5,2.5,3.8,6.1,3.8,10.6c0,5.3-1,9.1-3.1,11.4s-6.6,4-13.6,5c-0.4,0-1,0.1-1.8,0.2c-5.6,0.8-8.4,3.7-8.4,8.9c0,3.7,0.7,6.3,2.1,7.8c1.4,1.5,4.1,2.2,8.2,2.3c7.8,0.3,13.1,1.9,15.8,4.6c2.8,2.8,4.1,7.4,4.1,13.8c0,6-1.7,10.7-4.9,13.9c-3.3,3.3-7.9,4.9-14,4.9c-5.1,0-10.9-1.5-17.5-4.3c-6.6-2.9-10.7-4.3-12.3-4.3c-3.4,0-6.1,1-8.1,2.9c-2,2.1-3,4.7-3,7.8c0,5.3,3.7,9.8,11.2,13.6c7.5,3.7,16.9,5.6,28.3,5.6c14.1,0,25.3-3.5,33.5-10.5s12.3-16.5,12.3-28.6c0-7.9-1.8-14.4-5.5-19.4C76.2,448.5,70.7,444.9,63.2,442.5L63.2,442.5L63.2,442.5z M189.2,31.6h293.5c39.1,0,39.1,64,0,64H189.2C150.3,95.6,150.3,31.6,189.2,31.6z M189.2,224h293.5c39.1,0,39.1,64,0,64H189.2C150.3,288,150.3,224,189.2,224z M189.2,416h293.5c39.1,0,39.1,64,0,64H189.2C150.3,480,150.3,416,189.2,416z"
  }))), _symbol238 || (_symbol238 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ul-rtl",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M31.8,416H352c42.7,0,42.7,64,0,64H31.8C-10.6,480-10.6,416,31.8,416z M31.8,288H352c42.7,0,42.7-64,0-64H31.8C-10.6,224-10.6,288,31.8,288z M31.8,95.6H352c42.7,0,42.7-64,0-64H31.8C-10.6,31.6-10.6,95.6,31.8,95.6z M448,63.7c0,42.6,64,42.6,64,0C512,21,448,21,448,63.7z M448,256c0,42.6,64,42.6,64,0C512,213.3,448,213.3,448,256z M448,448c0,42.6,64,42.6,64,0C512,405.3,448,405.3,448,448z"
  }))), _symbol239 || (_symbol239 = /*#__PURE__*/React.createElement("symbol", {
    id: "list-ul",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M159.8,416H480c42.7,0,42.7,64,0,64H159.8C117.4,480,117.4,416,159.8,416z M159.8,288H480c42.7,0,42.7-64,0-64H159.8C117.4,224,117.4,288,159.8,288z M159.8,95.6H480c42.7,0,42.7-64,0-64H159.8C117.4,31.6,117.4,95.6,159.8,95.6z M0,63.7c0,42.6,64,42.6,64,0C64,21,0,21,0,63.7z M0,256c0,42.6,64,42.6,64,0C64,213.3,0,213.3,0,256z M0,448c0,42.6,64,42.6,64,0C64,405.3,0,405.3,0,448z"
  }))), _symbol240 || (_symbol240 = /*#__PURE__*/React.createElement("symbol", {
    id: "list",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline list-li-bullet-1",
    d: "M96.037 0h-64c-17.664 0-32 14.336-32 32s14.336 32 32 32h64c17.664 0 32-14.336 32-32s-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline list-li-bullet-2",
    d: "M96.037 224h-64c-17.664 0-32 14.336-32 32s14.336 32 32 32h64c17.664 0 32-14.336 32-32s-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline list-li-bullet-3",
    d: "M96.037 448h-64c-17.664 0-32 14.336-32 32s14.336 32 32 32h64c17.664 0 32-14.336 32-32s-14.336-32-32-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline list-li-item-2",
    d: "M480 288h-256c-17.6 0-32-14.4-32-32v0c0-17.6 14.4-32 32-32h256c17.6 0 32 14.4 32 32v0c0 17.6-14.4 32-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline list-li-item-1",
    d: "M480 64h-256c-17.6 0-32-14.4-32-32v0c0-17.6 14.4-32 32-32h256c17.6 0 32 14.4 32 32v0c0 17.6-14.4 32-32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline list-li-item-3",
    d: "M480 512h-256c-17.6 0-32-14.4-32-32v0c0-17.6 14.4-32 32-32h256c17.6 0 32 14.4 32 32v0c0 17.6-14.4 32-32 32z"
  }))), _symbol241 || (_symbol241 = /*#__PURE__*/React.createElement("symbol", {
    id: "live",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z M256,384c-70.7,0-128-57.3-128-128s57.3-128,128-128s128,57.3,128,128S326.7,384,256,384z"
  }))), _symbol242 || (_symbol242 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock-dots",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lock-dots-dot1",
    cx: 464,
    cy: 48,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lock-dots-dot2",
    cx: 464,
    cy: 240,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lock-dots-dot3",
    cx: 464,
    cy: 432,
    r: 48
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline lock-dots-connector",
    points: "288,192 384,96 352,96 288,160 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lock-dots-lock",
    d: "M384,224H96v-96c0-84,128-84,128,0v31.5h32V128C256,1,64,0,64,128v96H44.8C16.6,224,0,247,0,275.2v153.6C0,457,16.6,480,44.8,480h224c28.2,0,51.2-23,51.2-51.2v-87.5l64,42.7v-32l-64-42.7l0.5-53.3H384V224z M192,416h-64v-96h64V416z"
  }))), _symbol243 || (_symbol243 = /*#__PURE__*/React.createElement("symbol", {
    id: "lock",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M364.8,223.9H352v-96.1c0-127.4-192-128.1-192,0v96.1h-19.2c-28.2,0-44.8,23-44.8,51.2v153.7c0,28.2,16.6,51.2,44.8,51.2h224c28.2,0,51.2-23,51.2-51.2V275.1C416,246.9,393,223.9,364.8,223.9z M192,127.8c0-84,128-84.7,128,0v96.1H192V127.8z M288,416h-64v-96.1h64V416z"
  }))), _symbol244 || (_symbol244 = /*#__PURE__*/React.createElement("symbol", {
    id: "logout",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-logout-1",
    d: "M256 256v0c17.6 0 32-14.4 32-32v-192c0-17.6-14.4-32-32-32v0c-17.6 0-32 14.4-32 32v192c0 17.6 14.4 32 32 32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-logout-2",
    d: "M459.834 164.518c-12.916-28.269-31.25-53.15-54.493-73.954-13.169-11.787-33.399-10.667-45.185 2.502s-10.666 33.399 2.502 45.186c16.628 14.883 29.738 32.668 38.965 52.864 9.54 20.879 14.377 43.215 14.377 66.389 0 42.738-16.643 82.917-46.863 113.137s-70.4 46.863-113.137 46.863c-42.738 0-82.917-16.643-113.137-46.863s-46.863-70.4-46.863-113.137c0-23.175 4.837-45.512 14.377-66.392 9.228-20.197 22.337-37.983 38.965-52.865 13.168-11.787 14.289-32.017 2.502-45.185s-32.017-14.289-45.185-2.502c-23.243 20.803-41.577 45.686-54.493 73.956-13.38 29.286-20.165 60.572-20.165 92.988 0 30.226 5.927 59.564 17.616 87.201 11.284 26.678 27.43 50.63 47.992 71.191s44.513 36.709 71.191 47.992c27.637 11.69 56.975 17.616 87.201 17.616s59.565-5.927 87.2-17.616c26.678-11.284 50.63-27.43 71.192-47.992s36.708-44.513 47.991-71.191c11.69-27.637 17.616-56.975 17.616-87.201 0-32.416-6.784-63.702-20.166-92.987z"
  }))), _symbol245 || (_symbol245 = /*#__PURE__*/React.createElement("symbol", {
    id: "low-vision",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M506.8,254c-32.7-49.2-73.2-85.3-117.3-108.9l-29.4,51c30.4,17.3,60.1,42.2,88.1,75.4c-58.9,68.7-124.7,102.7-190.8,102.7l-32.2,55.9c103.5,11.1,211.1-36.3,281.5-141.2C513.7,278.6,513.7,264.4,506.8,254z M297.9,64.3l-28.5,48.5c-98-4.2-197.4,43.1-264.1,141.4c-7,10.3-7.1,24.3-0.2,34.9c29.3,44.3,65.1,77.8,104.2,101.3l-14.1,25.5c-20,37.6,32.9,67.9,55.4,32.1L353.3,96.4C372.7,64.3,324.8,25.4,297.9,64.3z M261.1,367.4c97.2-10,100.7-104.1,80.2-139L261.1,367.4z"
  }))), _symbol246 || (_symbol246 = /*#__PURE__*/React.createElement("symbol", {
    id: "magic",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M335.1,114.2c-16.7,0-32.5,6.5-44.3,18.4L18.5,404.9C6.3,417.1-0.2,433.3,0.2,450.5c0.4,17.3,7.6,33.2,20.3,44.8c11.6,10.6,26.6,16.4,42.3,16.4c16.7,0,32.5-6.5,44.3-18.4l272.3-272.3c24.4-24.4,24.4-64.2,0-88.6C367.6,120.7,351.9,114.2,335.1,114.2L335.1,114.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline magic-wand",
    d: "M335.1,114.2c-16.7,0-32.5,6.5-44.3,18.4L18.5,404.9C6.3,417.1-0.2,433.3,0.2,450.5c0.4,17.3,7.6,33.2,20.3,44.8c11.6,10.6,26.6,16.4,42.3,16.4c16.7,0,32.5-6.5,44.3-18.4l272.3-272.3c24.4-24.4,24.4-64.2,0-88.6C367.6,120.7,351.9,114.2,335.1,114.2L335.1,114.2z M278.7,203.8l29.5,29.5L115.8,425.7l-29.5-29.5L278.7,203.8L278.7,203.8z M48.7,464.6c-4.2-3.9-6.7-9.2-6.8-14.9s2.1-11.1,6.1-15.2l8.7-8.7l29.5,29.5l-8.7,8.7C70,471.6,56.7,471.9,48.7,464.6L48.7,464.6z M349.9,191.6l-12.2,12.1l-29.5-29.5l12.1-12.1c3.9-3.9,9.2-6.1,14.8-6.1s10.8,2.2,14.8,6.1C358,170.2,358,183.5,349.9,191.6L349.9,191.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline magic-sparkle-2",
    d: "M446.6,95l6.1,6.1c4.1,4.1,9.4,6.1,14.8,6.1s10.7-2,14.8-6.1c8.2-8.2,8.2-21.4,0-29.5l-6.1-6.1l6.1-6.1c8.2-8.2,8.2-21.4,0-29.5c-8.2-8.2-21.4-8.2-29.5,0l-6.1,6.1l-6.1-6.1c-8.2-8.2-21.4-8.2-29.5,0c-8.2,8.2-8.2,21.4,0,29.5l6.1,6.1l-6.1,6.1c-8.2,8.2-8.2,21.4,0,29.5c4.1,4.1,9.4,6.1,14.8,6.1s10.7-2,14.8-6.1L446.6,95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline magic-sparkle-1",
    d: "M303,62.8c0,11.5,9.4,20.9,20.9,20.9s20.9-9.4,20.9-20.9c11.5,0,20.9-9.4,20.9-20.9s-9.4-20.9-20.9-20.9c0-11.5-9.4-20.9-20.9-20.9S303,9.5,303,21.1c-11.5,0-20.9,9.4-20.9,20.9S291.5,62.8,303,62.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline magic-sparkle-3",
    d: "M490.9,188.1c0-11.5-9.4-20.9-20.9-20.9s-20.9,9.4-20.9,20.9c-11.5,0-20.9,9.4-20.9,20.9s9.4,20.9,20.9,20.9c0,11.5,9.4,20.9,20.9,20.9s20.9-9.4,20.9-20.9c11.5,0,20.9-9.4,20.9-20.9S502.5,188.1,490.9,188.1z"
  }))), _symbol247 || (_symbol247 = /*#__PURE__*/React.createElement("symbol", {
    id: "mark-as-answer",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-answer-hook",
    d: "M105,109.4c0-47.6,73-48.6,73,0c0,53.2-73,53.2-73,145.9c0,50.9,73,46.9,73,0c0-49.9,73-56.9,73-145.9C251-35,32-38,32,109.4C32,158.6,105,157.6,105,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-answer-item-2",
    d: "M312.4,390h131.2c48.1,0,49.1-64,0-64H312.4C264.9,326,262.9,390,312.4,390z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-answer-item-1",
    d: "M312.4,262h131.2c48.1,0,49.1-64,0-64H312.4C264.9,198,262.9,262,312.4,262z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-answer-item-3",
    d: "M312.4,511h67.2c48.1,0,49.1-64,0-64h-67.2C264.9,447,262.9,511,312.4,511z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline mark-as-answer-dot",
    cx: 141.1,
    cy: 358,
    r: 36
  }))), _symbol248 || (_symbol248 = /*#__PURE__*/React.createElement("symbol", {
    id: "mark-as-question",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-question-hook",
    d: "M333,109.4c0-47.6,73-48.6,73,0c0,53.2-73,53.2-73,145.9c0,50.9,73,46.9,73,0c0-49.9,73-56.9,73-145.9c0-144.4-219-147.4-219,0C260,158.6,333,157.6,333,109.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-question-item-1",
    d: "M100.4,390h131.2c48.1,0,49.1-64,0-64H100.4C52.9,326,50.9,390,100.4,390z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mark-as-question-item-2",
    d: "M100.4,512h311.2c48.1,0,49.1-64,0-64H100.4C52.9,448,50.9,512,100.4,512z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline mark-as-question-dot",
    cx: 369.1,
    cy: 358,
    r: 36
  }))), _symbol249 || (_symbol249 = /*#__PURE__*/React.createElement("symbol", {
    id: "megaphone-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M95.9,240.2c0.2-28.7,10.4-34.2,24.2-37.4l71.7-6.8v88.3c0,0-54-3-71.9-5.4C108.3,277.2,95.7,270.1,95.9,240.2z M192,400.1c-0.7,20.9-31,21.6-32,0v-86l32,2.4L192,400.1z M384.1,336.5c-0.3,14.6-17.3,21.3-27.4,11.1c-21.4-21.4-86.1-61.2-132.8-61.2v-92.8c46.1,0,111.2-39.1,132.6-60.5c10.8-10.8,27.4-2.6,27.4,11.1L384.1,336.5z"
  }))), _symbol250 || (_symbol250 = /*#__PURE__*/React.createElement("symbol", {
    id: "merge",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M322.6,238.2l-115.5-59c89-52.6,45-179.2-47-179.2c-112,0-130.6,154.6-32,186.1v182.2c-44.7,27.6-53.3,140.9,48,143.6c96,1.3,108.6-134,16-158.3V243.4l97.1,49.6c-13.1,88.3,110.2,126.9,150.8,46.9C476.7,248.6,377.4,196.6,322.6,238.2z M160.1,48c66.6,0,62,96,0,96C95.5,143.9,97.5,48,160.1,48z M176.1,479.8c-66,0-62-96,0-96C237.4,383.9,241.4,479.2,176.1,479.8z M368,351.9c-60,0-64.6-96,0-96C430.7,255.9,431.3,351.9,368,351.9z"
  }))), _symbol251 || (_symbol251 = /*#__PURE__*/React.createElement("symbol", {
    id: "message-boards",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-boards-speech-balloon-content1",
    d: "M272.8,256.1h-160c-22.4,0-22.4,32,0,32h160C292,288.1,295.2,256.1,272.8,256.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-boards-speech-balloon-content2",
    d: "M208.8,320.1h-96c-22.4,0-22.4,32,0,32h96C228,352.1,231.2,320.1,208.8,320.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-boards-speech-balloon-outline",
    d: "M352,160.1H32c-17.7,0-32,14.3-32,32v224c0,17.7,14.3,32,32,32h32v32c0.4,30.2,36.2,41.7,54.6,22.6l54.4-54.6H352c17.7,0,32-14.3,32-32v-224C384,174.4,369.6,160.1,352,160.1z M352,416.1H32v-224H352V416.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-boards-speech-balloon-solid",
    d: "M480,64.1h-32v-32c0.3-25.1-31.5-44.5-54.6-22.6l-54.4,54.6H160c-17.7,0-32,14.3-32,32v32h225.2c34.7,0,62.8,28.1,62.8,62.8v161.2h64c17.7,0,32-14.3,32-32v-224C511.9,78.5,497.6,64.1,480,64.1z"
  }))), _symbol252 || (_symbol252 = /*#__PURE__*/React.createElement("symbol", {
    id: "message",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-speech-balloon-outline",
    d: "M480,31.9H32c-19.2,0-32,12.8-32,32v320c0,19.2,12.8,32,32,32h64v32c0,25.6,32,44.8,54.4,22.4l54.4-54.4l0,0H480c19.2,0,32-12.8,32-32v-320C512,44.7,499.2,31.9,480,31.9z M448,351.9H64v-256h384V351.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-speech-balloon-content1",
    d: "M336,159.9H144c-22.4,0-22.4,32,0,32h192C355.2,191.9,358.4,159.9,336,159.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline message-speech-balloon-content2",
    d: "M272,255.9H144c-22.4,0-22.4,32,0,32h128C291.2,287.9,294.4,255.9,272,255.9z"
  }))), _symbol253 || (_symbol253 = /*#__PURE__*/React.createElement("symbol", {
    id: "minus-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256.4,0c-340.8,0-342.8,512,0,512C595.2,512,599.2,0,256.4,0z M384.7,304H128.1c-64.2,0-63.2-96,0-96h256.6C448.8,208,450.8,304,384.7,304z"
  }))), _symbol254 || (_symbol254 = /*#__PURE__*/React.createElement("symbol", {
    id: "mobile-device-rules",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mobile-device-rules-phone",
    d: "M192,0H64C28.8,0,0,28.8,0,64v0.1588v255.5755v0.4245v64c0,35.2,28.8,64,64,64h128c35.2,0,64-28.8,64-64v-64v-256V64C256,28.8,227.2,0,192,0z M129,416.1588c-8.8365,0-16-7.1635-16-16s7.1635-16,16-16s16,7.1635,16,16S137.8365,416.1588,129,416.1588z M192,320.1588v30.8041H64v-30.8041v-256V64h128v0.1588V320.1588z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline mobile-device-rules-bullet-1",
    cx: 320,
    cy: 96,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline mobile-device-rules-bullet-3",
    cx: 320,
    cy: 352,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline mobile-device-rules-bullet-2",
    cx: 320,
    cy: 224,
    r: 32
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mobile-device-rules-item-1",
    d: "M416,128h64c17.6729,0,32-14.3271,32-32s-14.3271-32-32-32h-64c-17.6729,0-32,14.3271-32,32S398.3271,128,416,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mobile-device-rules-item-2",
    d: "M480,192h-64c-17.6729,0-32,14.3271-32,32s14.3271,32,32,32h64c17.6729,0,32-14.3271,32-32S497.6729,192,480,192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline mobile-device-rules-item-3",
    d: "M480,320h-64c-17.6729,0-32,14.3271-32,32s14.3271,32,32,32h64c17.6729,0,32-14.3271,32-32S497.6729,320,480,320z"
  }))), _symbol255 || (_symbol255 = /*#__PURE__*/React.createElement("symbol", {
    id: "mobile-landscape",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,128v256c0,35.2,28.8,64,64,64h384c35.2,0,64-28.8,64-64V128c0-35.2-28.8-64-64-64H64C28.8,64,0,92.8,0,128z M480,238v32c0,22-32,20-32,0v-32C448,216,480,217,480,238z M384,128.7c17.7,0,32,14.3,32,32V352c0,17.7-14.3,32-32,32H96c-17.7,0-32-14.3-32-32V160.7c0-17.7,14.3-32,32-32H384z"
  }))), _symbol256 || (_symbol256 = /*#__PURE__*/React.createElement("symbol", {
    id: "mobile-portrait",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M384,0H128C92.8,0,64,28.8,64,64v384c0,35.2,28.8,64,64,64h256c35.2,0,64-28.8,64-64V64C448,28.8,419.2,0,384,0z M274,480h-32c-22,0-20-32,0-32h32C296,448,295,480,274,480z M383.3,384c0,17.7-14.3,32-32,32H160c-17.7,0-32-14.3-32-32V96c0-17.7,14.3-32,32-32h191.3c17.7,0,32,14.3,32,32V384z"
  }))), _symbol257 || (_symbol257 = /*#__PURE__*/React.createElement("symbol", {
    id: "moon",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M186.5,81.4c0-25.4,3.8-49.8,10.7-72.9C84.3,34.3,0,135.2,0,256c0,140.3,113.7,254,254,254c114.9,0,212-76.3,243.3-181.1c-18.3,4.2-37.3,6.5-56.8,6.5C300.3,335.4,186.5,221.6,186.5,81.4L186.5,81.4z"
  }))), _symbol258 || (_symbol258 = /*#__PURE__*/React.createElement("symbol", {
    id: "move-folder",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,128h-96L241.1,44.8C230,36.5,216.5,32,202.7,32H64C28.7,32,0,60.7,0,96v320c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V192C512,156.7,483.3,128,448,128z M423.1,325l-65.9,65.9c-28.4,27.3-69.6-12.9-42.2-42.2l15.4-15.4H207.8c-39.1,0-39.1-58.9,0-58.9h122.6L315,259c-26.8-27.6,11.2-69.6,42.2-42.2l65.9,65.9C433.5,294.7,433.1,314,423.1,325z"
  }))), _symbol259 || (_symbol259 = /*#__PURE__*/React.createElement("symbol", {
    id: "move",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M502.5,233.1l-71.6-71.6c-12.7-12.7-33.2-12.7-45.8,0c-6.3,6.3-9.5,14.6-9.5,22.9s3.2,16.6,9.5,22.9l16.7,16.7H288V110.2l16.7,16.7c12.7,12.7,33.2,12.7,45.8,0c12.7-12.7,12.7-33.2,0-45.8L278.9,9.5C272.8,3.4,264.6,0,256,0c-8.6,0-16.8,3.4-22.9,9.5l-71.6,71.6c-12.7,12.7-12.7,33.2,0,45.8c6.3,6.3,14.6,9.5,22.9,9.5s16.6-3.2,22.9-9.5l16.7-16.7v113.8H110.2l16.7-16.7c12.7-12.7,12.7-33.2,0-45.8c-12.7-12.7-33.2-12.7-45.8,0l-71.6,71.6c-6.1,6.1-9.5,14.3-9.5,22.9c0,8.6,3.4,16.8,9.5,22.9l71.6,71.6c12.7,12.7,33.2,12.7,45.8,0c6.3-6.3,9.5-14.6,9.5-22.9s-3.2-16.6-9.5-22.9l-16.7-16.7H224v113.8l-16.7-16.7c-12.7-12.7-33.2-12.7-45.8,0c-12.7,12.7-12.7,33.2,0,45.8l71.6,71.6c6.1,6.1,14.3,9.5,22.9,9.5c8.6,0,16.8-3.4,22.9-9.5l71.6-71.6c12.7-12.7,12.7-33.2,0-45.8c-6.3-6.3-14.6-9.5-22.9-9.5s-16.6,3.2-22.9,9.5L288,401.8v-113.8h113.8l-16.7,16.7c-12.7,12.7-12.7,33.2,0,45.8c12.7,12.7,33.2,12.7,45.8,0l71.6-71.6c6.1-6.1,9.5-14.3,9.5-22.9C512,247.4,508.6,239.2,502.5,233.1z"
  }))), _symbol260 || (_symbol260 = /*#__PURE__*/React.createElement("symbol", {
    id: "myspace",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline myspace-user",
    d: "M488.728 231.264c-12.846 0-23.272 10.426-23.272 23.273 0 115.486-93.969 209.454-209.454 209.454s-209.454-93.969-209.454-209.454c0-12.846-10.426-23.273-23.273-23.273s-23.273 10.426-23.273 23.273c0 141.152 114.847 256 256 256s256-114.848 256-256c0-12.846-10.426-23.273-23.272-23.273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline myspace-border",
    d: "M115.513 298.183c6.49 0 12.953-2.712 17.581-8.006 30.986-35.588 75.776-56.014 122.933-56.014s91.947 20.427 122.933 56.014c8.431 9.682 23.139 10.719 32.848 2.261 9.682-8.431 10.692-23.139 2.261-32.848-21.916-25.188-49.338-44.205-79.579-56.44 23.139-21.278 37.901-51.519 37.901-85.377 0-64.153-52.211-116.364-116.363-116.364s-116.363 52.211-116.363 116.364c0 33.858 14.762 64.1 37.901 85.377-30.242 12.235-57.663 31.251-79.579 56.44-8.431 9.682-7.421 24.39 2.287 32.848 4.388 3.856 9.814 5.745 15.24 5.745zM186.182 117.826c0-38.513 31.305-69.818 69.818-69.818s69.818 31.305 69.818 69.818-31.305 69.818-69.818 69.818-69.818-31.332-69.818-69.818z"
  }))), _symbol261 || (_symbol261 = /*#__PURE__*/React.createElement("symbol", {
    id: "number",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline number-hundreds",
    d: "M7,334.5h50V187.4H15.8V162c15.9-3.5,35-7.8,51.7-18.3h30.3v190.8h44v33.1H7V334.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline number-tens",
    d: "M174.9,344c18.1-21,98.1-82,101.4-133.8c-0.3-59.2-66.3-39.7-80.6-13.7L173.2,174c91.3-89,188.8,8,118.1,95.2c-7.4,10.5-46.2,54.6-57.2,66.4c36.9-2.6,92.2-2.5,92.2-2.5v34.5H174.9V344z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline number-ones",
    d: "M369.9,314.1C382,326,416,354,452.8,329.8c29.7-27.3,6.7-68.8-54.4-62.8v-29.6c11,0,58.6,0.6,58.4-35.9c-2.3-43.5-54.8-34-78.1-8.8l-20.7-25c9.6-8.5,43-38.7,96.8-24.3c67.2,23.1,46.2,98.1,3.8,106.6c47.4,9,77.4,88-1.6,117.4c-44,11.6-86-2.4-106.5-27.3L369.9,314.1z"
  }))), _symbol262 || (_symbol262 = /*#__PURE__*/React.createElement("symbol", {
    id: "oauth",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline oauth-2-border",
    d: "M256.4,64c254.8,13,256.7,370.5,0,384C-0.5,436.4,0.2,76.4,256.4,64 M256.4,0c-342,15.6-341.7,497.6,0,512C596.9,499.9,597.5,14.2,256.4,0L256.4,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline oauth-2-a",
    d: "M350.6,310.3L303.9,164c-7.2-17.7-16-36-47.8-36c-32.1,0-40.5,18.2-48,36l-46.7,146.4c-10.9,40.4,45.8,59.7,61.2,19.3l9.2-29h48.3l9.2,29C304.7,370,361.6,351,350.6,310.3z"
  }))), _symbol263 || (_symbol263 = /*#__PURE__*/React.createElement("symbol", {
    id: "open-id",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline open-id-tail",
    d: "M224,64v382.2C128.3,436.4,64,383.8,64,336c0-42.3,50.3-88.3,128-105.2v-65C81.6,185.3,0,254,0,336c0,89.7,97.8,165.2,224,176l96-64V0L224,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline open-id-head",
    d: "M512,320l-32-128l-35.2,26.4c-25.6-19.5-56.7-35.5-92.8-45.5v66.9c7.2,2.6,26.3,7.5,41.8,16.8L352,288L512,320z"
  }))), _symbol264 || (_symbol264 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-arrow-down",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M161.5,367.9l71.6,71.6c11.9,10.8,32.9,11.2,45.8,0l71.6-71.6c29.8-33.6-15.8-74.9-45.8-45.8L288,338.8V96c0-42.5-64-42.5-64,0v242.8l-16.7-16.7C175.5,292.2,131.8,337,161.5,367.9z"
  }))), _symbol265 || (_symbol265 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-arrow-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M143.9,161.5l-71.6,71.6c-10.8,11.9-11.2,32.9,0,45.8l71.6,71.6c33.6,29.8,74.9-15.8,45.8-45.8L173,288h242.8c42.5,0,42.5-64,0-64H173l16.7-16.7C219.6,175.5,174.8,131.8,143.9,161.5z"
  }))), _symbol266 || (_symbol266 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-arrow-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M367.9,350.3l71.6-71.6c10.8-11.9,11.2-32.9,0-45.8l-71.6-71.6c-33.6-29.8-74.9,15.8-45.8,45.8l16.7,16.7H96c-42.5,0-42.5,64,0,64h242.8l-16.7,16.7C292.2,336.3,337,380,367.9,350.3z"
  }))), _symbol267 || (_symbol267 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-arrow-up",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M350.4,143.9l-71.6-71.6c-11.9-10.8-32.9-11.3-45.8,0l-71.6,71.6c-29.8,33.6,15.8,74.9,45.8,45.8l16.7-16.7v242.8c0,42.5,64,42.5,64,0V173l16.7,16.7C336.4,219.5,380.1,174.8,350.4,143.9z"
  }))), _symbol268 || (_symbol268 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-arrow",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-arrow-arrow-down",
    d: "M307.6,431.5l71.6,71.6c11.9,10.8,32.9,11.2,45.8,0l71.6-71.6c29.8-33.6-15.8-74.9-45.8-45.8l-16.7,16.7V31.6c0-42.5-64-42.5-64,0v370.8l-16.7-16.7C321.6,355.8,277.9,400.6,307.6,431.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-arrow-arrow-up",
    d: "M204.4,80.5L132.8,8.9C120.9-1.8,99.9-2.3,87,8.9L15.4,80.5c-29.8,33.6,15.7,74.9,45.8,45.8l16.7-16.7v370.8c0,42.5,64,42.5,64,0V109.6l16.7,16.7C190.4,156.2,234.1,111.4,204.4,80.5z"
  }))), _symbol269 || (_symbol269 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-list-down",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-down-arrow-down",
    d: "M183.3,375.9c-8.6,0-17.2,3.2-23.8,9.5L142.2,402V31.9C142.2,14.3,127.4,0,109,0S75.8,14.3,75.8,31.9V402l-17.3-16.7c-13.2-12.7-34.5-12.7-47.6,0c-13.2,12.7-13.2,33.2,0,45.8l74.3,71.5c6.3,6.1,14.8,9.5,23.8,9.5c8.9,0,17.4-3.4,23.8-9.5l74.3-71.5c13.2-12.7,13.2-33.1,0-45.7C200.6,379.1,191.9,375.9,183.3,375.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-down-line-3",
    d: "M352.9,352h-64c-17.6,0-31.9,14.3-31.9,32c0.1,17.7,14.4,32,32.1,32h64c17.6,0,31.9-14.3,31.9-32S370.6,352,352.9,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-down-line-2",
    d: "M417,224H289c-17.7,0-32,14.3-32,32s14.3,32,32,32h128c17.7,0,32-14.3,32-32S434.7,224,417,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-down-line-1",
    d: "M481,96H289c-17.7,0-32,14.3-32,32s14.3,32,32,32h192c17.7,0,32-14.3,32-32S498.7,96,481,96z"
  }))), _symbol270 || (_symbol270 = /*#__PURE__*/React.createElement("symbol", {
    id: "order-list-up",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-up-line-1",
    d: "M287.9,160.5h64c17.7,0,32.1-14.4,32.1-32c0-17.7-14.3-32-31.9-32h-64c-17.7,0-32,14.3-32.1,32C256,146.2,270.3,160.5,287.9,160.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-up-line-2",
    d: "M288,288.5h128c17.7,0,32-14.3,32-32s-14.3-32-32-32H288c-17.7,0-32,14.3-32,32S270.3,288.5,288,288.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-up-line-3",
    d: "M480,352.5H288c-17.7,0-32,14.3-32,32s14.3,32,32,32h192c17.7,0,32-14.3,32-32S497.7,352.5,480,352.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline order-list-up-arrow-up",
    d: "M131.8,9.5C125.4,3.4,116.9,0,108,0S90.6,3.4,84.2,9.5L9.9,80.9c-13.2,12.7-13.2,33.1,0,45.7c6.5,6.3,15.2,9.5,23.8,9.5c8.6,0,17.2-3.2,23.8-9.5L74.8,110v370.1c0,17.7,14.8,31.9,33.2,31.9c18.4,0,33.2-14.3,33.2-31.9V110l17.3,16.7c13.2,12.7,34.5,12.7,47.5,0c13.3-12.7,13.3-33.2,0.1-45.8L131.8,9.5z"
  }))), _symbol271 || (_symbol271 = /*#__PURE__*/React.createElement("symbol", {
    id: "organizations",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M468,320h-20v-64c0-17.6729-14.3271-32-32-32H288v-32h20c24.2617,0,44-19.7383,44-44V44c0-24.2617-19.7383-44-44-44H204c-24.2617,0-44,19.7383-44,44v104c0,24.2617,19.7383,44,44,44h20v32H96c-17.6729,0-32,14.3271-32,32v64H44c-24.2617,0-44,19.7383-44,44v104c0,24.2617,19.7383,44,44,44h104c24.2617,0,44-19.7383,44-44V364c0-24.2617-19.7383-44-44-44h-20v-32h256v32h-20c-24.2617,0-44,19.7383-44,44v104c0,24.2617,19.7383,44,44,44h104c24.2617,0,44-19.7383,44-44V364C512,339.7383,492.2617,320,468,320z M224,64h64v64h-64V64z M128,448H64v-64h64V448z M448,448h-64v-64h64V448z"
  }))), _symbol272 || (_symbol272 = /*#__PURE__*/React.createElement("symbol", {
    id: "page-template",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline page-template-border",
    d: "M416,0v0.0001L63.375,0C28.3739,0,0,28.3741,0,63.375v384.6252c0,35.0009,28.3739,63.375,63.375,63.375h380.25c35.0011,0,68.375-28.3741,68.375-63.375V128.0001V96.0002L416,0z M448,445.3696c-1.1612,0.9965-3.1295,2.0057-4.375,2.0057L64,447.3748L64.0004,64H288h32v96v32.0001h32h96V445.3696z M384,128.0001v-64l64,64H384z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline page-template-box-1",
    x: 96,
    y: 96.0001,
    width: 192,
    height: 96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline page-template-box-2",
    x: 96,
    y: 224.0001,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline page-template-box-3",
    x: 320,
    y: 224.0001,
    width: 96,
    height: 192
  }))), _symbol273 || (_symbol273 = /*#__PURE__*/React.createElement("symbol", {
    id: "page",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M416,0L416,0H63.4C28.4,0,0,28.4,0,63.4V448c0,35,28.4,63.4,63.4,63.4h380.2c35,0,68.4-28.4,68.4-63.4V128V96L416,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M416,0L416,0H63.4C28.4,0,0,28.4,0,63.4V448c0,35,28.4,63.4,63.4,63.4h380.2c35,0,68.4-28.4,68.4-63.4V128V96L416,0z M448,445.4c-1.2,1-3.1,2-4.4,2l-379.6,0L64,64h224h32v96v32h32h96V445.4z M384,128V64l64,64H384z"
  }))), _symbol274 || (_symbol274 = /*#__PURE__*/React.createElement("symbol", {
    id: "pages-tree",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline pages-tree-tree",
    d: "M161.5,288h126c0,17.6,14.4,32,32,32h64c17.8,0,32-14.4,32-32v-64c0-17.8-14.4-32-32-32h-64c-17.8,0-32,14.4-32,32v32h-126V128h32c17.8,0,32-14.4,32-32V32c0-17.8-14.4-32-32-32h-64c-17.8,0-32,14.4-32,32v64c0,17.6,14.4,32,32,32v352h158c0,17.6,14.4,32,32,32h64c17.8,0,32-14.4,32-32v-64c0-17.8-14.4-32-32-32h-64c-17.8,0-32,14.4-32,32v32h-126V288z"
  }))), _symbol275 || (_symbol275 = /*#__PURE__*/React.createElement("symbol", {
    id: "paperclip",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M473.449 48.992c-17.8-17.799-41.45-27.588-66.604-27.588s-48.805 9.788-66.604 27.588l-203.012 202.984c-12.604 12.604-19.249 28.517-18.784 44.868 0.465 15.339 7.136 30.185 18.756 41.832 11.566 11.565 26.986 17.963 43.364 17.963s31.798-6.398 43.363-17.963l108.902-108.902c9.351-9.351 9.351-24.498 0-33.822s-24.498-9.351-33.822 0l-108.93 108.902c-5.059 5.086-13.917 5.113-19.030 0-2.98-2.98-4.675-6.316-4.785-9.378-0.082-3.144 1.531-6.37 4.785-9.624l203.012-203.012c17.526-17.499 48.039-17.499 65.565 0 18.073 18.073 18.073 47.493 0 65.565l-237.899 237.899c-32.645 32.619-85.771 32.645-118.417 0s-32.645-85.771 0-118.417l169.162-169.162c9.351-9.35 9.351-24.498 0-33.822-9.351-9.35-24.498-9.35-33.822 0l-169.162 169.162c-51.293 51.293-51.293 134.794 0 186.087 25.647 25.647 59.359 38.469 93.044 38.469 33.713 0 67.397-12.823 93.044-38.469l237.899-237.899c36.719-36.775 36.719-96.516-0.027-133.263z"
  }))), _symbol276 || (_symbol276 = /*#__PURE__*/React.createElement("symbol", {
    id: "paragraph",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480,448L480,448c0,17.7-14.3,32-32,32H128c-17.7,0-32-14.3-32-32l0,0c0-17.7,14.3-32,32-32h320C465.7,416,480,430.3,480,448z M448,288H224c-17.7,0-32,14.3-32,32l0,0c0,17.7,14.3,32,32,32h224c17.7,0,32-14.3,32-32l0,0C480,302.3,465.7,288,448,288z M448,160H320c-17.7,0-32,14.3-32,32l0,0c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32l0,0C480,174.3,465.7,160,448,160z M448,32H320c-17.7,0-32,14.3-32,32l0,0c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32l0,0C480,46.3,465.7,32,448,32z M96,320c0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32h32h32c53,0,96,43,96,96s-43,96-96,96H96V320z M96,160h32c17.7,0,32-14.3,32-32c0-17.7-14.3-32-32-32H96V160z"
  }))), _symbol277 || (_symbol277 = /*#__PURE__*/React.createElement("symbol", {
    id: "password-policies",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline password-policies-head",
    cx: 192,
    cy: 96,
    r: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon password-policies-body",
    d: "M288,245.9C30,132-174,475.5,224,446.8V352c0-35.5,28.7-64.2,64-64.2V245.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon password-policies-unlock",
    d: "M480,320H352v-64c0-43.5,64-43.5,64,0v32h32v-32c0-84-128-86.5-128,0v64h-32c-17.7,0-32,14.3-32,32v128c0,17.7,14.3,32,32,32h192c17.7,0,32-14.3,32-32V352C512,334.3,497.7,320,480,320z M416,448h-64v-64h64V448z"
  }))), _symbol278 || (_symbol278 = /*#__PURE__*/React.createElement("symbol", {
    id: "paste-plaintext",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M388.1,32H123.9C90.8,32,64,58.8,64,91.9v328.3c0,33.1,26.8,59.9,59.9,59.9h264.3c33.1,0,59.9-26.8,59.9-59.9V91.9C448,58.8,421.2,32,388.1,32L388.1,32z M192,128h128c17.7,0,32-14.3,32-32h32v320H128V96h32C160,113.7,174.3,128,192,128L192,128z M304,192h-96c-21,0-21,32,0,32h96C325,224,325,192,304,192L304,192z M304,256h-96c-21,0-21,32,0,32h96C325,288,325,256,304,256L304,256z M240,320h-32c-21,0-21,32,0,32h32C261,352,261,320,240,320L240,320z"
  }))), _symbol279 || (_symbol279 = /*#__PURE__*/React.createElement("symbol", {
    id: "paste-word",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M416,192h-64V91.87C352,58.8,325.2,32,292.13,32H91.87C58.8,32,32,58.8,32,91.87v264.27C32,389.2,58.8,416,91.87,416H160v32c0,35.35,28.65,64,64,64h192c35.35,0,64-28.65,64-64V256C480,220.65,451.35,192,416,192z M160,256v96H96V96h32c0,17.67,14.33,32,32,32h64c17.67,0,32-14.33,32-32h32v96h-64C188.65,192,160,220.65,160,256z M386.03,416h-36.64l-27.36-83.24L293.85,416h-35.82l-32-128h32l19.35,85.66L304.79,288h33.7l26.84,85.66l20.7-85.66h32L386.03,416z"
  }))), _symbol280 || (_symbol280 = /*#__PURE__*/React.createElement("symbol", {
    id: "paste",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M388.1,32H123.9C90.8,32,64,58.8,64,91.9v328.3c0,33.1,26.8,59.9,59.9,59.9h264.3c33.1,0,59.9-26.8,59.9-59.9V91.9C448,58.8,421.2,32,388.1,32L388.1,32z M192,128h128c17.7,0,32-14.3,32-32h32v320H128V96h32C160,113.7,174.3,128,192,128L192,128z"
  }))), _symbol281 || (_symbol281 = /*#__PURE__*/React.createElement("symbol", {
    id: "pause",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline pause-line-1",
    d: "M160,0c-17.7,0-32,14.3-32,32v448c0,17.7,14.3,32,32,32s32-14.3,32-32V32C192,14.3,177.7,0,160,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline pause-line-2",
    d: "M352,0c-17.7,0-32,14.3-32,32v448c0,17.7,14.3,32,32,32s32-14.3,32-32V32C384,14.3,369.7,0,352,0z"
  }))), _symbol282 || (_symbol282 = /*#__PURE__*/React.createElement("symbol", {
    id: "pencil",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M483,31C466.9,14.9,445.5,6,422.8,6s-44.1,8.9-60.2,24.9L4.1,389.4l4.4,115.3l119.9,1.2L483,151.4C516.2,118.2,516.2,64.2,483,31L483,31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M483,31C466.9,14.9,445.5,6,422.8,6s-44.1,8.9-60.2,24.9L4.1,389.4l4.4,115.3l119.9,1.2L483,151.4C516.2,118.2,516.2,64.2,483,31L483,31z M105.1,449l-42-0.4l-1.4-36.5l274.4-274.4l40.1,40.1L105.1,449L105.1,449z M442.9,111.2l-26.4,26.4l-40.1-40.1l26.4-26.4c10.7-10.7,29.4-10.7,40.1,0C453.9,82.2,453.9,100.2,442.9,111.2z"
  }))), _symbol283 || (_symbol283 = /*#__PURE__*/React.createElement("symbol", {
    id: "phone",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M490.9,363.4l-2.8-5.1C468.3,322.4,359.9,304,358.9,304l-2.4-0.1l-10.8,1.5c-16.9,3.9-31,15.7-50.5,33.8c-25.2-14.7-52.4-37.6-68.7-54.3c-16.7-17.1-39.9-47.7-52.4-71.6c22-21.6,37.4-38.7,38.4-61.7c0-1-13.8-110.1-48.9-131.7l0,0l-5.1-3.1c-9.6-5.7-27.5-16.4-49.3-16.4c-5.4,0-10.8,0.7-17,2.3c-6.9,2-13.3,4.8-20,9.1C55.9,23,26.2,46.7,11.7,78c-13.5,30.8-4.4,187.9,113.4,311c111.6,116.8,241.2,122.7,266.1,122.7c6.4,0,15.1-0.3,22.4-1.6l2.8-0.1l6.7-2.5c32.2-13.2,56.9-41.7,68.4-57.2C518.4,415.5,497.8,376.6,490.9,363.4L490.9,363.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M490.9,363.4l-2.8-5.1C468.3,322.4,359.9,304,358.9,304l-2.4-0.1l-10.8,1.5c-16.9,3.9-31,15.7-50.5,33.8c-25.2-14.7-52.4-37.6-68.7-54.3c-16.7-17.1-39.9-47.7-52.4-71.6c22-21.6,37.4-38.7,38.4-61.7c0-1-13.8-110.1-48.9-131.7l0,0l-5.1-3.1c-9.6-5.7-27.5-16.4-49.3-16.4c-5.4,0-10.8,0.7-17,2.3c-6.9,2-13.3,4.8-20,9.1C55.9,23,26.2,46.7,11.7,78c-13.5,30.8-4.4,187.9,113.4,311c111.6,116.8,241.2,122.7,266.1,122.7c6.4,0,15.1-0.3,22.4-1.6l2.8-0.1l6.7-2.5c32.2-13.2,56.9-41.7,68.4-57.2C518.4,415.5,497.8,376.6,490.9,363.4L490.9,363.4z M445.4,415.1c-10.5,14-27.3,31.3-42.6,38c-1.5,0.2-5.4,0.6-11.6,0.6c-20.7,0-128.8-5.1-224.1-104.8C67,244.3,62.6,119,65.5,100c6.6-12.7,21.2-27.7,38.7-39.8c0.5-0.3,1.9-1.1,3.4-1.6c5.5-1.4,15.6,4.6,21,7.8l2.4,1.5c8.1,13.5,20.6,63.6,23.3,81.2c-3.8,6.4-19.2,21.4-27.7,29.8l-1,1.1c-11.9,12.8-15.5,31.2-8.9,47.3c14.2,32.9,45.9,75.3,68.4,98.3c22.1,22.8,59.4,53.4,93.2,70.6c16.3,8.1,36.3,4.8,49.1-7.5c10.1-9.4,25-23.4,30.6-26.3c17.6,3.4,67.7,18.2,80.8,26.7l1.1,2C446.9,404.3,448.5,411,445.4,415.1L445.4,415.1z"
  }))), _symbol284 || (_symbol284 = /*#__PURE__*/React.createElement("symbol", {
    id: "picture",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M509.6,486.8L336.6,200c-5.5-9.1-18-10.7-25.5-3.2L199.4,308.2l-41-40.9c-7.5-7.5-20-6-25.5,3.2L2.4,486.8c-6.7,11,1.2,25.2,14,25.2h479.1C508.4,512,516.2,497.8,509.6,486.8L509.6,486.8z M160,79.8c0,106.9-160,106.9-160,0C0-26.7,160-26.5,160,79.8z"
  }))), _symbol285 || (_symbol285 = /*#__PURE__*/React.createElement("symbol", {
    id: "pin-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M401.4,246.4c-27.2,27.2-45.4,10.5-51.2,5.9l-25.7,25.7c13.1,67.7-42.2,110.1-42.2,110.1c-12.5,12.5-32.8,12.5-45.3,0L195.7,347l-66.5,54L111.4,383l53-67.3l-40.6-40.6c-12.5-12.5-12.5-32.8,0-45.3c0,0,41.8-55.1,110.1-42.2l25.7-25.7c-2.1-2.1-23.6-21.7,6.4-51.8c20.7-20.7,39.6-15.1,50-4.7l90.5,90.5C412,202.6,427.7,220.1,401.4,246.4z"
  }))), _symbol286 || (_symbol286 = /*#__PURE__*/React.createElement("symbol", {
    id: "pin",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline pin-tack",
    points: "0,512 140,295.5 217.6,372.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline pin-body",
    d: "M501.9,140.7l-129.2-129c-35.4-32-76.7,8.8-58.1,41.9l-175.4,85.8c-34.8-34.8-84.3,14.6-50.9,52.9L321,424.5c29.6,29.4,87.9-11.4,51.7-51.6l85.9-175.1C494.5,216.7,529.9,173.3,501.9,140.7z"
  }))), _symbol287 || (_symbol287 = /*#__PURE__*/React.createElement("symbol", {
    id: "play",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M127.499 453.745v-395.49c0-46.992 26.018-58.255 57.841-25.017l189.245 197.744c13.165 13.751 13.165 36.28 0 50.067l-189.245 197.745c-31.788 33.205-57.841 21.941-57.841-25.050z"
  }))), _symbol288 || (_symbol288 = /*#__PURE__*/React.createElement("symbol", {
    id: "plug",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M457.8,326.4L413,281.6l89.6-89.6c28.8-32-16-73.6-44.8-44.8l-89.6,89.6L275.4,144L365,54.4c28.8-32-12.8-73.6-44.8-44.8l-89.6,89.6l-44.8-44.8C157,28.8,112.2,67.2,141,99.2l-38.4,38.4c-64,64-67.2,166.4-6.4,233.6l-96,96L45,512l92.8-92.8c28.8,32,128,92.8,224,3.2l48-48C445,400,486.6,355.2,457.8,326.4z"
  }))), _symbol289 || (_symbol289 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus-squares",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline plus-squares-square1",
    d: "M481,1H321c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h160c17.7,0,32-14.3,32-32V33C513,15.3,498.7,1,481,1z M449,161h-96V65h96V161z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline plus-squares-square2",
    d: "M481,289H321c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h160c17.7,0,32-14.3,32-32V321C513,303.3,498.7,289,481,289z M449,449h-96v-96h96V449z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline plus-squares-square3",
    d: "M193,289H33c-17.7,0-32,14.3-32,32v160c0,17.7,14.3,32,32,32h160c17.7,0,32-14.3,32-32V321C225,303.3,210.7,289,193,289z M161,449H65v-96h96V449z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline plus-squares-plus",
    points: "129,33 97,33 97,97 33,97 33,129 97,129 97,193.1 129,193.1 129,129 193,129 193,97 129,97"
  }))), _symbol290 || (_symbol290 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M479.82 224.002h-192.41v-191.91c0-17.6-14.4-32-32-32v0c-17.6 0-32 14.4-32 32v191.91h-191.41c-17.6 0-32 14.4-32 32v0c0 17.6 14.4 32 32 32h191.41v191.91c0 17.6 14.4 32 32 32v0c17.6 0 32-14.4 32-32v-191.909h192.41c17.6 0 32-14.4 32-32v0c0-17.6-14.4-32-32-32z"
  }))), _symbol291 || (_symbol291 = /*#__PURE__*/React.createElement("symbol", {
    id: "polls",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-polls-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,448H64V64h384V448C448,448,448,448,448,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-polls-bar-1",
    d: "M160,128c-17.7,0-32,14.3-32,32v192c0,17.7,14.3,32,32,32s32-14.3,32-32V160C192,142.3,177.7,128,160,128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-polls-bar-2",
    d: "M256,224c-17.7,0-32,14.3-32,32v96c0,17.7,14.3,32,32,32s32-14.3,32-32v-96C288,238.3,273.7,224,256,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-polls-bar-3",
    d: "M352,192c-17.7,0-32,14.3-32,32v128c0,17.7,14.3,32,32,32s32-14.3,32-32V224C384,206.3,369.7,192,352,192z"
  }))), _symbol292 || (_symbol292 = /*#__PURE__*/React.createElement("symbol", {
    id: "print",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,96h-63.5V33c0-18.2-14.8-33-33-33H161.4c-18.2,0-33,14.8-33,33v63H64c-35.3,0-64,27.7-64,63v193.3c0,35.3,28.7,64,64,64h32.6v64.3c0,18.2,14.8,33,33,33h254.9c18.2,0,32-14.8,32-33v-64.3H448c35.3,0,64-28.7,64-64V159C512,123.7,483.3,96,448,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline print-printer",
    d: "M448,96h-63.5V33c0-18.2-14.8-33-33-33H161.4c-18.2,0-33,14.8-33,33v63H64c-35.3,0-64,27.7-64,63v193.3c0,35.3,28.7,64,64,64h32.6v64.3c0,18.2,14.8,33,33,33h254.9c18.2,0,32-14.8,32-33v-64.3H448c35.3,0,64-28.7,64-64V159C512,123.7,483.3,96,448,96z M192.4,64h128.1v32.4H192.4V64z M351.6,447.6h-191v-95.3h190.9L351.6,447.6z M448,352.3h-31.4v-31.1c0-18.2-14.8-33-33-33h-254c-18.2,0-33,14.8-33,33v31.1H64V160h384V352.3L448,352.3z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline print-indicator-1",
    cx: 112,
    cy: 208.3,
    r: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline print-indicator-2",
    cx: 176.3,
    cy: 208,
    r: 15.7
  }))), _symbol293 || (_symbol293 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-menu-closed",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-closed-left",
    d: "M0,31C0,13.9,13.9,0,31,0c17.2,0,31.1,13.9,31,31v450c0,17.1-13.9,31-31,31S0,498.1,0,481V31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-closed-right",
    d: "M464,512H144c-26.5,0-48-21.5-48-48V48c0-26.4,21.5-48,48-48h320c26.5,0,48,21.5,48,48v416C512,490.4,490.4,512,464,512z M160,448h288V64H160V448z"
  }))), _symbol294 || (_symbol294 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-menu-open",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M46.5,0.8h419c25.6,0,46.5,21.3,46.4,47.5v415.3c0,26.1-20.8,47.4-46.5,47.4H46.5C20.9,511.1,0,489.9,0,463.7V48.2C0,22.1,20.9,0.8,46.5,0.8z M256,451.8h192V60.2H256V451.8z"
  }))), _symbol295 || (_symbol295 = /*#__PURE__*/React.createElement("symbol", {
    id: "product-menu",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-left-bg",
    fill: "none",
    d: "M176,512H48c-26.5,0-48-21.5-48-48V48C0,21.5,21.5,0,48,0h128c26.5,0,48,21.5,48,48v416C224,490.5,202.5,512,176,512L176,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-left-border",
    d: "M176,512H48c-26.5,0-48-21.5-48-48V48C0,21.5,21.5,0,48,0h128c26.5,0,48,21.5,48,48v416C224,490.5,202.5,512,176,512L176,512z M64,448h96V64H64C64,64,64,448,64,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-line-1",
    d: "M480,64H320c-17.7,0-32-14.3-32-32l0,0c0-17.7,14.3-32,32-32h160c17.7,0,32,14.3,32,32l0,0C512,49.7,497.7,64,480,64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-line-2",
    d: "M480,288H320c-17.7,0-32-14.3-32-32l0,0c0-17.7,14.3-32,32-32h160c17.7,0,32,14.3,32,32l0,0C512,273.7,497.7,288,480,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-product-menu-line-3",
    d: "M480,512H320c-17.7,0-32-14.3-32-32l0,0c0-17.7,14.3-32,32-32h160c17.7,0,32,14.3,32,32l0,0C512,497.7,497.7,512,480,512z"
  }))), _symbol296 || (_symbol296 = /*#__PURE__*/React.createElement("symbol", {
    id: "propagation",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline propagation-arrow-bottom-right",
    d: "M379.4,229.1L480,329.6v-12c0-21.1,31.5-21.2,32,0V368c0,8.8-7.2,16-16,16h-50.4c-21.7-0.8-20.7-31.8,0-32h11.5L356.8,251.7C342,234.6,364.9,214.8,379.4,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline propagation-arrow-bottom-left",
    d: "M132.6,229.1L32,329.6v-12c0-21.1-31.5-21.2-32,0V368c0,8.8,7.2,16,16,16h50.4c21.7-0.8,20.7-31.8,0-32H54.9l100.3-100.3C170,234.6,147.1,214.8,132.6,229.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline propagation-arrow-bottom",
    d: "M240.2,304.2v153.4l-8.5-8.5c-14.9-14.9-37.3,7.3-22.6,22.6l35.6,35.6c6.2,6.2,16.4,6.2,22.6,0l35.6-35.6c14.8-15.9-7.8-37.1-22.6-22.6l-8.1,8.1l0-153C270.5,281.7,240.3,283.8,240.2,304.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline propagation-circle",
    cx: 256,
    cy: 112,
    r: 112
  }))), _symbol297 || (_symbol297 = /*#__PURE__*/React.createElement("symbol", {
    id: "question-circle-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256 0c-141.37 0-256 114.6-256 256 0 141.37 114.629 256 256 256s256-114.63 256-256c0-141.4-114.63-256-256-256zM269.605 360.769c-4.974 4.827-10.913 7.226-17.876 7.226s-12.873-2.428-17.73-7.226c-4.857-4.827-7.285-10.708-7.285-17.613 0-6.933 2.428-12.844 7.285-17.788 4.857-4.915 10.767-7.402 17.73-7.402s12.932 2.457 17.876 7.402c4.945 4.945 7.431 10.854 7.431 17.788 0 6.905-2.457 12.786-7.431 17.613zM321.038 232.506c-5.705 8.923-13.283 16.735-22.791 23.464l-12.99 9.128c-5.5 3.979-9.714 8.455-12.668 13.37-2.955 4.945-4.447 10.649-4.447 17.145v1.901h-34.202c-0.439-2.106-0.731-4.184-0.936-6.291s-0.321-4.301-0.321-6.612c0-8.397 1.901-16.413 5.705-24.079s10.24-14.834 19.309-21.563l15.185-11.322c9.070-6.7 13.605-15.009 13.605-24.869 0-3.57-0.644-7.080-1.901-10.533s-3.219-6.495-5.851-9.128c-2.633-2.633-5.969-4.71-9.977-6.291s-8.66-2.369-13.927-2.369c-5.705 0-10.561 1.054-14.571 3.16s-7.343 4.769-9.977 8.017c-2.633 3.247-4.594 7.022-5.851 11.322s-1.901 8.66-1.901 13.049c0 4.213 0.41 7.548 1.258 10.065l-39.877-1.58c-0.644-2.311-1.054-4.652-1.258-7.080-0.205-2.399-0.321-4.769-0.321-7.080 0-8.397 1.58-16.619 4.74-24.693s7.812-15.214 13.927-21.416c6.114-6.173 13.663-11.176 22.645-14.951s19.368-5.676 31.188-5.676c12.229 0 22.996 1.785 32.3 5.355 9.274 3.57 17.087 8.25 23.435 14.014 6.319 5.764 11.089 12.434 14.248 19.982s4.74 15.331 4.74 23.289c0.058 12.581-2.809 23.347-8.514 32.27z"
  }))), _symbol298 || (_symbol298 = /*#__PURE__*/React.createElement("symbol", {
    id: "question-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M491.4,155.8C478.5,125.3,460,98,436.5,74.5s-50.9-41.9-81.4-54.8C323.6,6.3,290-0.5,255.5-0.5s-68.1,6.8-99.7,20.1C125.3,32.5,98,51,74.5,74.5s-41.9,50.9-54.8,81.4C6.3,187.4-0.5,221-0.5,255.5s6.8,68.1,20.1,99.7C32.5,385.7,51,413,74.5,436.5s50.9,41.9,81.4,54.8c31.6,13.4,65.1,20.1,99.7,20.1s68.1-6.8,99.7-20.1c30.5-12.9,57.9-31.3,81.4-54.8s41.9-50.9,54.8-81.4c13.4-31.6,20.1-65.1,20.1-99.7S504.7,187.4,491.4,155.8L491.4,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline question-circle-border",
    d: "M491.4,155.8C478.5,125.3,460,98,436.5,74.5s-50.9-41.9-81.4-54.8C323.6,6.3,290-0.5,255.5-0.5s-68.1,6.8-99.7,20.1C125.3,32.5,98,51,74.5,74.5s-41.9,50.9-54.8,81.4C6.3,187.4-0.5,221-0.5,255.5s6.8,68.1,20.1,99.7C32.5,385.7,51,413,74.5,436.5s50.9,41.9,81.4,54.8c31.6,13.4,65.1,20.1,99.7,20.1s68.1-6.8,99.7-20.1c30.5-12.9,57.9-31.3,81.4-54.8s41.9-50.9,54.8-81.4c13.4-31.6,20.1-65.1,20.1-99.7S504.7,187.4,491.4,155.8L491.4,155.8z M255.5,447.5c-106,0-192-86-192-192s86-192,192-192s192,86,192,192S361.5,447.5,255.5,447.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline question-circle-hook",
    d: "M236,287.9c-0.4-1.9-0.7-3.8-0.9-5.7s-0.3-3.9-0.3-6c0-7.6,1.7-14.9,5.2-21.9s9.3-13.5,17.6-19.6l13.8-10.3c8.2-6.1,12.4-13.6,12.4-22.6c0-3.2-0.6-6.4-1.7-9.6s-2.9-5.9-5.3-8.3s-5.4-4.3-9.1-5.7s-7.9-2.2-12.7-2.2c-5.2,0-9.6,1-13.2,2.9s-6.7,4.3-9.1,7.3c-2.4,3-4.2,6.4-5.3,10.3s-1.7,7.9-1.7,11.9c0,3.8,0.4,6.9,1.1,9.1l-36.3-1.4c-0.6-2.1-1-4.2-1.1-6.4c-0.2-2.2-0.3-4.3-0.3-6.4c0-7.6,1.4-15.1,4.3-22.4s7.1-13.8,12.7-19.5c5.6-5.6,12.4-10.2,20.6-13.6s17.6-5.2,28.4-5.2c11.1,0,20.9,1.6,29.4,4.9c8.4,3.2,15.5,7.5,21.3,12.7c5.7,5.2,10.1,11.3,13,18.2s4.3,13.9,4.3,21.2c0,11.4-2.6,21.2-7.8,29.3s-12.1,15.2-20.7,21.3l-11.8,8.3c-5,3.6-8.8,7.7-11.5,12.2c-2.7,4.5-4,9.7-4,15.6v1.7L236,287.9L236,287.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline question-circle-dot",
    d: "M229.4,329.4c0-6.3,2.2-11.7,6.6-16.2c4.4-4.5,9.8-6.7,16.1-6.7s11.8,2.2,16.3,6.7s6.8,9.9,6.8,16.2s-2.3,11.6-6.8,16c-4.5,4.4-9.9,6.6-16.3,6.6s-11.7-2.2-16.1-6.6S229.4,335.7,229.4,329.4L229.4,329.4z"
  }))), _symbol299 || (_symbol299 = /*#__PURE__*/React.createElement("symbol", {
    id: "quote-left",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M233.385 350.832c0 27.183-10.151 51.067-30.398 71.653-20.303 20.613-46.95 30.906-79.943 30.906-37.73 0-67.676-13.113-89.813-39.337-22.164-26.224-33.246-58.061-33.246-95.536 0-46.81 7.303-86.4 21.91-118.716s32.738-58.512 54.451-78.674c21.684-20.133 45.258-35.135 70.722-44.949 25.492-9.841 49.517-15.678 72.16-17.567v85.695c-27.352 4.709-53.042 17.117-77.067 37.222-24.053 20.162-37.025 46.612-38.886 79.379 7.529-4.681 17.455-7.021 29.694-7.021 32.034 0 56.792 8.685 74.247 25.999 17.427 17.342 26.168 40.972 26.168 70.947zM511.986 350.832c0 27.183-10.151 51.067-30.398 71.653-20.303 20.613-46.923 30.906-79.914 30.906-37.73 0-67.676-13.113-89.813-39.337-22.164-26.224-33.246-58.061-33.246-95.536 0-46.81 7.303-86.4 21.91-118.716s32.738-58.512 54.451-78.674c21.685-20.133 45.258-35.135 70.722-44.949 25.464-9.841 49.517-15.678 72.16-17.567v85.695c-27.353 4.709-53.041 17.117-77.094 37.222-24.053 20.162-37.024 46.612-38.885 79.379 7.529-4.681 17.455-7.021 29.694-7.021 32.034 0 56.792 8.685 74.247 25.999 17.426 17.342 26.168 40.972 26.168 70.947z"
  }))), _symbol300 || (_symbol300 = /*#__PURE__*/React.createElement("symbol", {
    id: "quote-right",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M278.615 161.168c0-27.184 10.151-51.067 30.398-71.653 20.303-20.614 46.95-30.906 79.943-30.906 37.73 0 67.676 13.112 89.812 39.337 22.164 26.225 33.246 58.061 33.246 95.536 0 46.81-7.303 86.401-21.91 118.716s-32.738 58.512-54.451 78.673c-21.685 20.134-45.258 35.135-70.721 44.949-25.464 9.841-49.488 15.678-72.132 17.567v-85.695c27.353-4.709 53.041-17.116 77.067-37.222 24.053-20.163 37.024-46.613 38.885-79.379-7.529 4.681-17.455 7.021-29.693 7.021-32.034 0-56.792-8.685-74.247-25.999-17.455-17.342-26.197-40.972-26.197-70.948zM0.015 161.168c0-27.184 10.152-51.067 30.398-71.653 20.303-20.614 46.923-30.906 79.914-30.906 37.73 0 67.676 13.112 89.812 39.337 22.164 26.225 33.246 58.061 33.246 95.536 0 46.81-7.304 86.401-21.91 118.716s-32.738 58.512-54.451 78.673c-21.684 20.134-45.258 35.135-70.722 44.949-25.463 9.841-49.517 15.678-72.16 17.567v-85.695c27.352-4.709 53.041-17.116 77.094-37.222 24.053-20.163 37.024-46.613 38.886-79.379-7.529 4.681-17.455 7.021-29.693 7.021-32.033 0-56.792-8.685-74.247-25.999-17.427-17.342-26.168-40.972-26.168-70.948z"
  }))), _symbol301 || (_symbol301 = /*#__PURE__*/React.createElement("symbol", {
    id: "radio-button",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M384,256c0,70.7-57.3,128-128,128s-128-57.3-128-128s57.3-128,128-128S384,185.3,384,256z M512,256c0,141.4-114.6,256-256,256S0,397.4,0,256S114.6,0,256,0S512,114.6,512,256z M448,256c0-106-86-192-192-192S64,150,64,256s86,192,192,192S448,362,448,256z"
  }))), _symbol302 || (_symbol302 = /*#__PURE__*/React.createElement("symbol", {
    id: "react",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512,259.8c0-33.9-42.5-66-107.6-85.9c15-66.3,8.3-119.1-21.1-136c-6.8-4-14.6-5.8-23.3-5.8V32c-28.7,0-66.3,20.4-104.3,55.9c-38-35.2-75.6-55.5-104.3-55.5v0.1c-8.8,0-16.7,1.9-23.6,5.8C98.6,55.3,92,107.9,107.2,174C42.3,194,0,226.1,0,259.8c0,33.9,42.5,66,107.6,85.9c-15,66.3-8.3,119.1,21.1,136c6.8,4,14.7,5.8,23.5,5.8c28.7,0,66.3-20.4,104.3-55.9c38,35.2,75.6,55.5,104.3,55.5c8.8,0,16.7-1.9,23.6-5.8c29.3-16.9,35.9-69.6,20.8-135.7C469.7,325.7,512,293.6,512,259.8z M359.9,55.3c4.8,0.1,8.7,1,11.9,2.8c14.2,8.1,20.3,39.1,15.5,78.9c-1.1,9.8-3,20.1-5.3,30.7c-20.5-5-42.8-8.9-66.3-11.4c-14.1-19.3-28.7-36.8-43.4-52.1C306.3,72.6,338.2,55.4,359.9,55.3z M163.5,313.2c4.9,8.3,9.9,16.5,15,24.4c-14.8-2.2-29.1-4.9-42.8-8.2c3.9-13.5,8.7-27.3,14.1-41.2C154.1,296.5,158.6,304.9,163.5,313.2z M135.5,190.3c13.7-3.2,28.1-6,43-8.2c-5.1,8-10.2,16.3-15,24.7c-4.8,8.3-9.3,16.7-13.6,25C144.2,217.8,139.4,203.8,135.5,190.3z M162.1,260.2c6.5-14,13.8-27.9,21.6-41.6c8.1-14.1,16.5-27.4,25.2-39.8c15.6-1.4,31.3-2.1,47.2-2.1c15.8,0,31.5,0.7,47,2c8.7,12.4,17.1,25.7,25.3,39.6c7.9,13.7,15.1,27.5,21.7,41.5c-6.6,14-13.8,27.9-21.6,41.6c-8.1,14.1-16.5,27.4-25.2,39.8c-15.5,1.4-31.3,2.1-47.2,2.1c-15.8,0-31.5-0.7-47-2c-8.7-12.4-17.1-25.7-25.3-39.6C175.9,288,168.6,274.1,162.1,260.2z M348.5,312.9c4.8-8.3,9.3-16.8,13.6-25.1c5.6,14,10.4,27.9,14.4,41.5c-13.7,3.3-28.1,6.2-43,8.3C338.5,329.6,343.7,321.4,348.5,312.9z M348.4,206.5c-4.8-8.3-9.9-16.5-15-24.4c14.8,2.2,29.1,4.9,42.8,8.2c-3.9,13.5-8.7,27.3-14.1,41.2C357.8,223.1,353.3,214.8,348.4,206.5z M284.7,154c-9.4-0.4-19-0.7-28.7-0.7c-9.8,0-19.5,0.2-29,0.7c9.4-12.2,19.1-23.4,28.7-33.4C265.4,130.6,275.1,141.8,284.7,154z M139.5,58.5c3.1-1.9,7.2-2.7,12-2.7v-0.1c21.6,0,53.6,17.2,87.7,48.6c-14.6,15.3-29.2,32.7-43.1,52c-23.6,2.5-45.9,6.4-66.4,11.5c-2.4-10.4-4.2-20.5-5.4-30.2C119.4,97.7,125.4,66.7,139.5,58.5z M113.2,323.2c-10.3-3.2-20.1-6.8-29.2-10.6c-36.9-15.7-60.8-36.4-60.8-52.8s23.9-37.1,60.8-52.8c9-3.9,18.8-7.3,28.9-10.5c5.9,20.4,13.8,41.7,23.5,63.5C126.8,281.7,119.1,302.9,113.2,323.2z M152,464.4c-4.7-0.1-8.7-1-11.8-2.8c-14.2-8.1-20.4-39.1-15.6-78.9c1.1-9.8,3-20.1,5.3-30.7c20.5,5,42.8,8.9,66.3,11.4c14.1,19.3,28.7,36.8,43.4,52.1C205.6,447.1,173.7,464.4,152,464.4z M256.2,399c-9.7-10-19.4-21.2-29-33.4c9.4,0.4,19,0.7,28.7,0.7c9.8,0,19.5-0.2,29-0.7C275.5,377.9,265.8,389,256.2,399z M372.5,461.2c-3.1,1.9-7.2,2.7-12,2.7c-21.6,0-53.6-17.2-87.7-48.6c14.6-15.3,29.2-32.7,43.1-52c23.6-2.5,45.9-6.4,66.4-11.5c2.4,10.5,4.3,20.6,5.4,30.3C392.6,422,386.6,453,372.5,461.2z M427.9,312.6c-9,3.9-18.8,7.3-28.9,10.5c-5.9-20.4-13.8-41.7-23.5-63.5c9.6-21.7,17.3-42.9,23.2-63.2c10.3,3.2,20.1,6.8,29.3,10.6c36.9,15.7,60.8,36.4,60.8,52.8C488.7,276.2,464.8,297,427.9,312.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M255.9,307.5c26.3,0,47.7-21.3,47.7-47.7s-21.4-47.7-47.7-47.7c-26.3,0-47.7,21.3-47.7,47.7S229.6,307.5,255.9,307.5z"
  }))), _symbol303 || (_symbol303 = /*#__PURE__*/React.createElement("symbol", {
    id: "rectangle-split",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,32H64C28.7,32,0,60.7,0,96v320c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V96C512,60.7,483.3,32,448,32z M224,416H64V96h160V416z M448,416H288V96h160V416z"
  }))), _symbol304 || (_symbol304 = /*#__PURE__*/React.createElement("symbol", {
    id: "rectangle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,32H64C28.7,32,0,60.7,0,96v320c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V96C512,60.7,483.3,32,448,32z M448,416H64V96h384V416z"
  }))), _symbol305 || (_symbol305 = /*#__PURE__*/React.createElement("symbol", {
    id: "redo",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M438.6,137.6l-96-96c-12.5-12.5-32.8-12.5-45.3,0c-12.5,12.5-12.5,32.8,0,45.3l41.2,41.2H224c-88.2,0-160,71.8-160,160c0,88.2,71.8,160,160,160c17.7,0,32-14.3,32-32s-14.3-32-32-32c-52.9,0-96-43.1-96-96s43.1-96,96-96h115l-41.4,41.4c-12.5,12.5-12.5,32.8,0,45.3c6.2,6.2,14.4,9.4,22.6,9.4s16.4-3.1,22.6-9.4l95.8-95.8C451.1,170.3,451.1,150.1,438.6,137.6z"
  }))), _symbol306 || (_symbol306 = /*#__PURE__*/React.createElement("symbol", {
    id: "relationship",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M332.8,76.8c-27.5,0-53.5,6.2-76.8,17.2c-23.3-11.1-49.3-17.2-76.8-17.2C80.2,76.8,0,157,0,256c0,99,80.2,179.2,179.2,179.2c27.5,0,53.5-6.2,76.8-17.2c23.3,11.1,49.3,17.2,76.8,17.2c99,0,179.2-80.2,179.2-179.2S431.8,76.8,332.8,76.8z M204.8,381.4c-8.3,1.7-16.8,2.6-25.6,2.6c-70.7,0-128-57.3-128-128c0-70.7,57.3-128,128-128c8.8,0,17.3,0.9,25.6,2.6c-31.7,32.3-51.2,76.6-51.2,125.4S173.1,349.1,204.8,381.4z M332.8,384c-8.8,0-17.3-0.9-25.6-2.6c31.7-32.3,51.2-76.6,51.2-125.4s-19.5-93.1-51.2-125.4c8.3-1.7,16.8-2.6,25.6-2.6c70.7,0,128,57.3,128,128S403.5,384,332.8,384z"
  }))), _symbol307 || (_symbol307 = /*#__PURE__*/React.createElement("symbol", {
    id: "reload",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline reload-arrow-down",
    d: "M472.065 460.954l-80.854 2.365c67.538-47.63 108.976-125.482 108.976-208.888 0-97.148-53.904-184.701-140.685-228.505-11.483-5.768-25.463-1.169-31.231 10.286-5.795 11.483-1.197 25.463 10.286 31.257 71.020 35.856 115.142 107.487 115.142 186.987 0 68.947-34.659 133.269-90.981 172.129l-2.074-70.702c-0.372-12.838-11.19-23.23-23.921-22.566-12.838 0.372-22.938 11.084-22.566 23.921l3.854 131.462v0.027c0 0.027 0 0.027 0 0.027l0.027 0.478c0.372 12.599 10.685 22.566 23.23 22.566 0.239 0 0.478 0 0.691 0 0.904-0.027 1.647-0.452 2.525-0.585l128.964-3.774c12.838-0.372 22.938-11.084 22.566-23.921s-11.269-23.23-23.948-22.566z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline reload-arrow-up",
    d: "M194.017 23.27c0-0.027 0-0.027 0-0.053v-0.478c-0.372-12.838-11.111-22.938-23.922-22.566-0.904 0.027-1.648 0.452-2.525 0.585l-128.99 3.774c-12.838 0.372-22.938 11.084-22.566 23.922 0.372 12.599 10.685 22.566 23.23 22.566 0.239 0 0.452 0 0.691 0l80.855-2.365c-67.538 47.63-108.976 125.508-108.976 208.889 0 97.149 53.903 184.701 140.685 228.505 3.349 1.702 6.937 2.498 10.446 2.498 8.506 0 16.692-4.678 20.785-12.785 5.794-11.483 1.196-25.463-10.286-31.231-71.020-35.856-115.142-107.488-115.142-186.987 0-68.947 34.66-133.269 90.981-172.129l2.073 70.701c0.372 12.599 10.685 22.566 23.23 22.566 0.239 0 0.478 0 0.691 0 12.838-0.372 22.938-11.083 22.566-23.922l-3.854-131.462 0.027-0.027z"
  }))), _symbol308 || (_symbol308 = /*#__PURE__*/React.createElement("symbol", {
    id: "remove-role",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline remove-role-key-hole",
    d: "M336,166c0-87.7-128-85.6-128,0c0,28.1,17.9,51.9,42.7,60.8v68.7c0,27,42.7,30.3,42.7,0v-68.7C318.1,217.9,336,194.1,336,166z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline remove-role-border",
    d: "M445.6,29.9C273.8-9,262.8-10.6,98.4,28.9C78.7,35.2,64,50.7,64,71.3c0,0,0.1,194.3,0.2,195c13.3-6.3,27.6-10.8,42.7-12.9c0,0,0.7-164.9,0-182.1c157.3-38.7,172.4-37.7,330.3,1c0,13.8,0,193,0,193c-2.2,116.4-107.8,138.3-149.1,155.2c0.2,7.4-5.4,28.6-11,41.6c4,1.2,9.1,4.2,28-1.1c123.3-43,170.4-78.4,174.9-195.7v-193C480,51.7,463.3,35.8,445.6,29.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline remove-role-minus",
    d: "M139,296c-59.1,0-107,48.4-107,108s47.9,108,107,108s107-48.4,107-108S198.1,296,139,296z M192.5,425.6h-107c-28.8,0-28.1-43.2,0-43.2h107C220.6,382.4,221.9,425.6,192.5,425.6z"
  }))), _symbol309 || (_symbol309 = /*#__PURE__*/React.createElement("symbol", {
    id: "remove-style",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline remove-style-t",
    d: "M0 64.426h116.531l-61.846 287.847h70.601l57.645-287.847h110.736v-64.426h-293.667l-0.001 64.426z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline remove-style-t-underline",
    d: "M0 384h288v32h-288v-32z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline remove-style-x",
    d: "M481 512c-8.281 0-16.065-3.224-21.921-9.080l-45.962-45.962-45.962 45.962c-5.856 5.856-13.64 9.080-21.92 9.080s-16.065-3.224-21.921-9.080c-5.856-5.854-9.080-13.639-9.080-21.92s3.224-16.065 9.080-21.921l45.962-45.962-45.962-45.962c-12.087-12.087-12.087-31.753 0-43.841 5.854-5.856 13.639-9.080 21.92-9.080s16.065 3.224 21.921 9.080l45.962 45.962 45.962-45.962c5.854-5.856 13.639-9.080 21.92-9.080s16.065 3.224 21.921 9.080c12.086 12.087 12.086 31.754-0 43.841l-45.962 45.962 45.962 45.962c5.856 5.854 9.080 13.639 9.080 21.92s-3.224 16.065-9.080 21.921c-5.855 5.855-13.639 9.079-21.92 9.079z"
  }))), _symbol310 || (_symbol310 = /*#__PURE__*/React.createElement("symbol", {
    id: "reply",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M460.8,198.4H181l15-15c49.7-49.7-25.8-119.2-72.5-72.5L14.9,219.5c-19.8,20-19.8,52.6,0,72.5l108.6,108.6c48.9,48.9,119.9-25.1,72.5-72.5l-27.4-27.4h241v95.6c0,68.6,102.4,68.6,102.4,0V249.6C512,221.4,489,198.4,460.8,198.4z"
  }))), _symbol311 || (_symbol311 = /*#__PURE__*/React.createElement("symbol", {
    id: "repository",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,384c35.3,0,64-28.7,64-64V160c0-35.3-28.7-64-64-64h-96L241.1,12.8C230,4.5,216.5,0,202.7,0H64C28.7,0,0,28.7,0,64v256c0,35.3,28.7,64,64,64h160v64H32c-42,0-42,64,0,64h448c43,0,42-64,0-64H288v-64H448z"
  }))), _symbol312 || (_symbol312 = /*#__PURE__*/React.createElement("symbol", {
    id: "reset",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256,0C179.5,0,110.9,33.5,64,86.7V64c0-44.5-64-43-64,0v96l0,0c0,18.5,15,32,32,32l0,0h96c41.5,0,43.5-64,0-64h-15.1c35.2-39.3,86.2-64,143.1-64c251,0,253,384,0,384c-95.1,0-174.1-69.2-189.3-160H2c15.7,126.3,123.5,224,254,224C593,512,598,0,256,0z"
  }))), _symbol313 || (_symbol313 = /*#__PURE__*/React.createElement("symbol", {
    id: "restore",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline restore-hands",
    d: "M180.7,347.3c3.1,3.1,7.2,4.7,11.3,4.7s8.2-1.6,11.3-4.7l48-48c6.3,3,13.3,4.7,20.7,4.7c26.5,0,48-21.5,48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16,7.2-16,16v98.7c-18.6,6.6-32,24.4-32,45.3c0,7.4,1.7,14.4,4.7,20.7l-48,48C174.4,330.9,174.4,341.1,180.7,347.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline restore-border",
    d: "M256,0C179.5,0,110.9,33.5,64,86.7V64c0-17.6-14.4-32-32-32h0C14.4,32,0,46.4,0,64v96l0,0c0,9.9,4.6,18.8,11.7,24.7c5.5,4.6,12.6,7.3,20.3,7.3l0,0h96c17.6,0,32-14.4,32-32s-14.4-32-32-32h-15.1c35.2-39.3,86.2-64,143.1-64c106,0,192,86,192,192s-86,192-192,192c-95.1,0-174.1-69.2-189.3-160H2c15.7,126.3,123.5,224,254,224c141.4,0,256-114.6,256-256S397.4,0,256,0z"
  }))), _symbol314 || (_symbol314 = /*#__PURE__*/React.createElement("symbol", {
    id: "rotate",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline rotate-arrow ",
    d: "M285.8,0c-13.7-0.1-38.2,1.4-56.1,8c-39.1,14.8-20.2,73.7,21.3,60.4c17.1-5.2,34-4.4,34.8-4.4c186.4,2.2,232.1,265.8,36.3,316l5.1-5.1c31.2-35.4-17.9-72.2-45.2-45.4l-61.4,61.2c-14.1,14-14.1,36.9,0,51l61.3,61.2c33.1,28.2,73.7-16.9,45.2-45.4l-11.5-11.5C612.4,390.2,548,0,285.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline rotate-box",
    d: "M145.5,156.3l67.9,67.9l-67.9,67.9l-67.9-67.9L145.5,156.3 M122.9,88.3L9.7,201.6c-12.5,12.5-12.5,32.8,0,45.3l113.2,113.2c12.5,12.5,33.1,12.2,45.3,0l113.2-113.2c12.5-12.5,12.5-32.8,0-45.3L168.2,88.3C155.6,75.8,135.5,75.7,122.9,88.3z"
  }))), _symbol315 || (_symbol315 = /*#__PURE__*/React.createElement("symbol", {
    id: "rss-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M96,368c0-63.3,95.6-64.6,95.6-0.4C191.5,432.3,96,430.8,96,368z M249.4,389.1c0-84.1-40.1-124.8-125.9-127c-36.9-0.9-36.6-55.8-1.2-55.8c128.7,0,181.7,83.2,181.7,182.8C303.9,424.5,249.4,425.2,249.4,389.1z M360.3,387.8c0.4-121.1-81.9-236.9-237.2-236.9c-37,0-36-54.8-0.6-54.8c176.5,0,292.4,133.1,292.4,292.3C414.9,423.8,360.1,424.6,360.3,387.8z"
  }))), _symbol316 || (_symbol316 = /*#__PURE__*/React.createElement("symbol", {
    id: "rss",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline rss-dot",
    cx: 78.6,
    cy: 433.4,
    r: 76.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline rss-wave-1",
    d: "M41.9,152c-54.9,0-54.9,81.5,0,83.8c129.2,0,234.3,105.1,234.3,234.3c0,54.1,83.8,57.4,83.8,0C360,276.9,199,152,41.9,152z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline rss-wave-2",
    d: "M41.9,0C-14,0-12,83.8,41.9,83.8C256,83.8,428.2,256,428.2,470.1c0,55.8,83.8,52.8,83.8,0C512,212.9,305,0,41.9,0z"
  }))), _symbol317 || (_symbol317 = /*#__PURE__*/React.createElement("symbol", {
    id: "rules",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,192h-32V64c0-17.7-14.3-32-32-32h-96c0-17.7-14.3-32-32-32H64C46.3,0,32,14.3,32,32v64c0,17.7,14.3,32,32,32h64v64H96c-17.7,0-32,14.3-32,32v64c0,17.7,14.3,32,32,32h32v64H96c-17.7,0-32,14.3-32,32v64c0,17.7,14.3,32,32,32h128c17.7,0,32-14.3,32-32h128c17.7,0,32-14.3,32-32V320h32c17.7,0,32-14.3,32-32v-64C480,206.3,465.7,192,448,192z M64,96V32h192v64H64z M384,448H256v-32c0-17.7-14.3-32-32-32h-64v-64h64c17.7,0,32-14.3,32-32v-64c0-17.7-14.3-32-32-32h-64v-64h96c17.7,0,32-14.3,32-32V64h96v128c-17.7,0-32,14.3-32,32v64c0,17.7,14.3,32,32,32V448z"
  }))), _symbol318 || (_symbol318 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-experiences",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline search-experiences-line-1",
    d: "M24,48h368c13.3,0,24-10.7,24-24S405.3,0,392,0H24C10.7,0,0,10.7,0,24S10.7,48,24,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline search-experiences-line-2",
    d: "M24,164h80c13.3,0,24-10.7,24-24s-10.7-24-24-24H24c-13.3,0-24,10.7-24,24S10.7,164,24,164z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline search-experiences-line-3",
    d: "M24,280h48c13.3,0,24-10.7,24-24s-10.7-24-24-24H24c-13.3,0-24,10.7-24,24C0,269.3,10.7,280,24,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline search-experiences-line-4",
    d: "M24,396h80c13.3,0,24-10.7,24-24s-10.7-24-24-24H24c-13.3,0-24,10.7-24,24S10.7,396,24,396z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline search-experiences-line-5",
    d: "M360,464H24c-13.3,0-24,10.7-24,24s10.7,24,24,24h336c13.3,0,24-10.7,24-24S373.3,464,360,464z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline search-experiences-lens",
    d: "M502.6,425.4l-81.5-81.5c16.6-25.2,26.3-55.4,26.3-87.9c0-88.4-71.6-160-160-160s-160,71.6-160,160s71.6,160,160,160c32.8,0,63.2-9.9,88.6-26.8l81.4,81.4c12.5,12.5,32.8,12.5,45.3,0C515.1,458.1,515.1,437.9,502.6,425.4z M287.4,352c-53,0-96-43-96-96s43-96,96-96s96,43,96,96S340.4,352,287.4,352z"
  }))), _symbol319 || (_symbol319 = /*#__PURE__*/React.createElement("symbol", {
    id: "search-plus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-search-plus-zoom",
    d: "M272.6,193.1L272.6,193.1H225v-47.5l0,0c0-22.2-31.7-22.2-31.7,0l0,0v47.5h-47.5l0,0c-22.2,0-22.2,31.7,0,31.7l0,0h47.5v47.5l0,0c0,22.2,31.7,22.2,31.7,0l0,0v-47.5h47.5l0,0C294.7,224.7,294.7,193.1,272.6,193.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-search-plus-lens",
    d: "M499.2,455.6L378.1,333.8C521.5,48.7,202.8-85.8,59.4,58.3C-100,237.7,84.9,519.6,333.5,378.7l121.1,118.5C489.6,535.7,534.3,490.8,499.2,455.6z M209.2,64.7c191.2,0,188,288.3,0,288.3S27.5,64.7,209.2,64.7z"
  }))), _symbol320 || (_symbol320 = /*#__PURE__*/React.createElement("symbol", {
    id: "search",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M499.2,455.5L377.7,333.4c146-241.1-148.1-435.8-318.2-274c-165.1,185.9,41.6,460.6,273.4,319l121.5,118.8C489.5,535.8,534.4,490.8,499.2,455.5z M206.2,63.6c191.9,0,198.1,289,0,289C13.3,352.6,18.8,63.6,206.2,63.6z"
  }))), _symbol321 || (_symbol321 = /*#__PURE__*/React.createElement("symbol", {
    id: "select-all",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body lx-select-all-body",
    d: "M416,448H64c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32h352c17.7,0,32,14.3,32,32v352C448,433.7,433.7,448,416,448z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-select-all-outline",
    d: "M352.1,160H127.8c-43.4,0-41.4-64,0-64h224.3C393.8,96,395.5,160,352.1,160z M367.9,224H111.8c-21.2,0-20.8-32,0-32H368C389.1,192,389.6,224,367.9,224z M367.9,288H111.8c-21.2,0-20.8-32,0-32H368C389.1,256,389.6,288,367.9,288z M207.9,352h-96.1c-21.2,0-20.8-32,0-32h96.1C229.2,320,229.6,352,207.9,352z M320,320l32,160l32-32l64,64l64-64l-64-64l32-32L320,320z M160,32h64v32h-64V32z M256,32h64v32h-64V32z M160,416h64v32h-64V416z M256,416h32v32h-32V416z M32,160h32v64H32V160z M32,256h32v64H32V256z M416,160h32v64h-32V160z M416,256h32v32h-32V256z M128,32H64c-17.7,0-32,14.3-32,32v64h32V64h64V32z M32,352v64c0,17.7,14.3,32,32,32h64v-32H64v-64H32z M448,128V64c0-17.7-14.3-32-32-32h-64v32h64v64H448z"
  }))), _symbol322 || (_symbol322 = /*#__PURE__*/React.createElement("symbol", {
    id: "select-from-list",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M512,72v368c0,39.6-32.4,72-72,72H72c-39.6,0-72-32.4-72-72V72C0,32.4,32.4,0,72,0h368C479.6,0,512,32.4,512,72z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M134.4,211.2c-4-5.4-6.4-12-6.4-19.2c0-17.7,14.3-32,32-32c10.5,0,19.9,5.1,25.7,12.9c28.8,38.4,46.8,62.5,70.3,93.8c23.5-31.3,41.5-55.3,70.3-93.8c5.8-7.8,15.2-12.9,25.7-12.9c17.7,0,32,14.3,32,32c0,7.2-2.4,13.9-6.4,19.2c-38.4,51.2-57.6,76.8-95.9,127.9c-5.8,7.8-15.2,12.9-25.7,12.9s-19.9-5.1-25.7-12.9C192,288,172.8,262.4,134.4,211.2z M512,72v368c0,39.6-32.4,72-72,72H72c-39.6,0-72-32.4-72-72V72C0,32.4,32.4,0,72,0h368C479.6,0,512,32.4,512,72z M448,64H64v384h384V64z"
  }))), _symbol323 || (_symbol323 = /*#__PURE__*/React.createElement("symbol", {
    id: "select",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline select-border",
    d: "M448,64v384H64V64H448 M64,0C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64c0-35.3-28.7-64-64-64H64z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline select-caret-up",
    points: "414.5,224 278.8,224 346.7,156.1 "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline select-caret-down",
    points: "278.8,288 414.5,288 346.7,355.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline select-s",
    d: "M104.8,306.8c14.2,20.2,94.7,49.1,96.9-3.6C205,259,89.5,268.5,91.5,193.3c6-77.3,100-83.3,143.7-35.9C229,166,215,183.8,215,183.8c-43.2-35.8-84.9-17.7-83.6,7.5C129,237,238,215,242.2,300.1c2.8,92.4-135.7,76.4-160.7,34.9L104.8,306.8z"
  }))), _symbol324 || (_symbol324 = /*#__PURE__*/React.createElement("symbol", {
    id: "separator",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline separator-content-2",
    d: "M416,448H96c-17.7,0-32-14.3-32-32v-32c0-17.7,14.3-32,32-32h320c17.7,0,32,14.3,32,32v32C448,433.7,433.7,448,416,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline separator-divider",
    d: "M464,272H48c-21.2,0-20.5-32,0-32h416C484.8,240,485.8,272,464,272z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline separator-content-1",
    d: "M416,160H96c-17.7,0-32-14.3-32-32V96c0-17.7,14.3-32,32-32h320c17.7,0,32,14.3,32,32v32C448,145.7,433.7,160,416,160z"
  }))), _symbol325 || (_symbol325 = /*#__PURE__*/React.createElement("symbol", {
    id: "share-alt",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M397.255 402.745c-5.868-5.868-12.709-10.478-20.334-13.702-7.911-3.346-16.296-5.043-24.921-5.043s-17.010 1.697-24.921 5.043c-2.625 1.111-5.154 2.389-7.587 3.822l-104.357-104.357c1.434-2.432 2.712-4.962 3.822-7.587 3.346-7.911 5.042-16.296 5.042-24.922s-1.696-17.011-5.042-24.922c-1.111-2.625-2.388-5.155-3.822-7.587l104.357-104.357c2.432 1.433 4.961 2.712 7.587 3.822 7.911 3.346 16.296 5.043 24.921 5.043s17.010-1.697 24.921-5.043c7.625-3.225 14.466-7.835 20.334-13.703s10.478-12.709 13.702-20.334c3.346-7.911 5.043-16.296 5.043-24.922s-1.697-17.011-5.043-24.922c-3.225-7.625-7.835-14.466-13.702-20.334s-12.709-10.477-20.334-13.703c-7.911-3.346-16.296-5.043-24.921-5.043s-17.010 1.696-24.921 5.043c-7.625 3.225-14.466 7.835-20.334 13.703s-10.478 12.709-13.702 20.334c-3.346 7.911-5.043 16.296-5.043 24.922s1.697 17.011 5.043 24.922c1.111 2.625 2.389 5.155 3.822 7.587l-104.357 104.357c-2.431-1.434-4.962-2.712-7.587-3.822-7.911-3.346-16.296-5.042-24.922-5.042s-17.011 1.696-24.922 5.042c-7.625 3.225-14.466 7.835-20.334 13.702s-10.478 12.709-13.703 20.334c-3.346 7.911-5.043 16.296-5.043 24.922s1.697 17.011 5.043 24.922c3.225 7.625 7.835 14.466 13.703 20.334s12.709 10.478 20.334 13.702c7.911 3.346 16.296 5.043 24.922 5.043s17.011-1.697 24.922-5.043c2.625-1.111 5.155-2.389 7.587-3.822l104.357 104.357c-1.433 2.432-2.712 4.961-3.822 7.587-3.346 7.911-5.043 16.296-5.043 24.921s1.697 17.010 5.043 24.921c3.225 7.625 7.835 14.466 13.702 20.334s12.709 10.478 20.334 13.702c7.911 3.346 16.296 5.042 24.921 5.042s17.010-1.697 24.921-5.043c7.625-3.225 14.466-7.835 20.334-13.702s10.478-12.709 13.702-20.334c3.346-7.911 5.043-16.296 5.043-24.921s-1.697-17.010-5.043-24.921c-3.225-7.625-7.835-14.466-13.702-20.333zM352 32c17.673 0 32 14.327 32 32s-14.327 32-32 32-32-14.327-32-32 14.327-32 32-32zM160 288c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.327 32-32 32zM352 480c-17.673 0-32-14.327-32-32s14.327-32 32-32 32 14.327 32 32-14.327 32-32 32z"
  }))), _symbol326 || (_symbol326 = /*#__PURE__*/React.createElement("symbol", {
    id: "share",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M326.2,323.3l-107.6-53.8c2.7-5.9,2.4-19.9,0-27.1l107.6-53.8c77.2,69.3,185.8,13,185.8-78.9C512,49.2,462.8,0,402.3,0S287,51.3,293.4,123.3l-107.6,53.8C113.3,108,0,161.7,0,256c0,100.3,118.3,143.7,185.8,78.9l107.6,53.8C285,460.7,341.8,512,402.3,512S512,462.8,512,402.3C512,314.3,406.3,252,326.2,323.3z M438.9,109.7c0,49-73.1,47.6-73.1,0C365.7,60.3,438.9,62,438.9,109.7z M73.1,256c0-49,73.1-49,73.1,0C146.3,303.3,73.1,305,73.1,256z M365.7,402.3c0-48.6,73.1-49,73.1,0C438.9,451,365.7,449.7,365.7,402.3z"
  }))), _symbol327 || (_symbol327 = /*#__PURE__*/React.createElement("symbol", {
    id: "sheets",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sheets-page3",
    d: "M499.8,364.7l-61.1-25.6l-38.6,16l67.5,28.8l-212.1,92.8L46.7,383.9l67.5-28.8l-38.6-16l-61.1,25.6c-19.3,6.4-19.3,32,0,41.6l241,105.6l244.2-108.7C515.9,396.7,515.9,371.1,499.8,364.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sheets-page2",
    d: "M499.9,236.8l-60.7-25.6l-38.3,16l63.9,28.8l-207.6,92.8L49.6,256l67.1-28.8L75.2,208l-60.7,28.8c-19.2,6.4-19.2,32,0,41.6L257.2,384l242.7-108.7C515.9,268.8,515.9,243.2,499.9,236.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sheets-page1",
    d: "M256,0.1L14.3,108.9c-19.1,6.4-19.1,32,0,41.6L256,256l241.7-108.7c19.1-6.4,19.1-32,0-41.6L256,0.1z"
  }))), _symbol328 || (_symbol328 = /*#__PURE__*/React.createElement("symbol", {
    id: "shield-check",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M474.7,54.4c-3.5-5.5-8.6-10-14.6-12.7C395.8,13.6,326.2-0.6,256,0C185.8-0.6,116.2,13.6,51.9,41.6c-6,2.8-11.1,7.2-14.6,12.7c-3.5,5.5-5.4,12-5.3,18.6v170C31.9,298.1,48.6,352,79.9,397.5c31.3,45.6,75.7,80.6,127.4,100.7l23.9,9.2c15.9,6.1,33.6,6.1,49.5,0l23.9-9.2c51.7-20,96.2-55.1,127.4-100.7c31.3-45.6,48-99.5,47.9-154.6v-170C480,66.4,478.2,59.9,474.7,54.4z M419,170.3L251.7,353.7l0,0c-5.1,5.4-12.2,8.6-19.6,8.8l-0.8,0c-7.2,0-14.2-2.7-19.4-7.7l-96.5-92.5c-6.3-6.3-8.6-13.4-8-20.1c0.7-6.7,4.2-12.6,9.1-17c9.7-8.7,26-11.9,37.7-0.2l75.8,72.7l148-162.5l0,0c5.8-6.3,12.9-8.9,19.9-8.8c6.9,0.1,13.4,2.9,18.4,7.2c5,4.3,8.7,10.2,9.6,16.8C426.8,157,424.8,164,419,170.3z"
  }))), _symbol329 || (_symbol329 = /*#__PURE__*/React.createElement("symbol", {
    id: "shopping-cart",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline shopping-cart-wheel1",
    cx: 144,
    cy: 464,
    r: 48
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline shopping-cart-wheel2",
    cx: 432,
    cy: 464,
    r: 48
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline shopping-cart-basket",
    d: "M495.9,352.1H192.5c-17.7,0-32.4-14.2-32.4-31.8s14.9-31.9,32.6-31.9c2.5,0,305-34.8,305-34.8c8.1-0.9,14.2-7.7,14.2-15.9V80.1c0-8.8-7.1-15.9-15.9-15.9H129.2l-20.8-53.9C106,4.1,100.1,0,93.5,0H16C-5.5,0.7-5.1,31.7,16.1,32h66.5l88.2,228.5c-24.4,9-42.6,32.2-42.6,59.7c0,35.3,29.2,63.8,64.5,63.8H496C517.9,382.5,516.6,353,495.9,352.1z M288.1,160.1v-64h94.5L384,160L288.1,160.1z M480.1,160H416l0.1-64h64V160z M256,96.1l0.1,63.9h-89.9l-24.7-63.9H256z"
  }))), _symbol330 || (_symbol330 = /*#__PURE__*/React.createElement("symbol", {
    id: "shortcut",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-shortcut-border",
    d: "M480,320c-17.6729,0-32,14.3271-32,32v96H64V64h96c17.6729,0,32-14.3271,32-32S177.6729,0,160,0H64C28.7104,0,0,28.7104,0,64v384c0,35.29,28.7104,64,64,64h384c35.29,0,64-28.71,64-64v-96C512,334.3271,497.6729,320,480,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-shortcut-arrow",
    d: "M480,0H320c-17.6729,0-32,14.3267-32,32s14.3271,32,32,32h82.7456L265.373,201.3726c-12.4971,12.4971-12.4971,32.7578,0,45.2549C271.6211,252.876,279.8105,256,288,256s16.3789-3.124,22.627-9.3726L448,109.2544V192c0,17.6733,14.3271,32,32,32s32-14.3267,32-32V32C512,14.3267,497.6729,0,480,0z"
  }))), _symbol331 || (_symbol331 = /*#__PURE__*/React.createElement("symbol", {
    id: "sign-in",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-sign-in-border",
    d: "M416,0H96C60.7,0,32,28.6,32,64v64h64V64h320v384H96v-64H32v64c0,35.4,28.7,64,64,64h320c35.4,0,64-28.6,64-64V64C480,28.6,451.4,0,416,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-sign-in-arrow-right",
    d: "M310.4,233.1l-71.6-71.6c-27.2-27.4-76.2,9.4-45.8,45.8l16.7,16.7l-145.8,0.1c-43,0-42,64,0,64l145.8-0.1L193,304.7c-30.4,36.2,18.8,72.6,45.8,45.8l71.6-71.6C316.5,272.8,327.7,253.3,310.4,233.1z"
  }))), _symbol332 || (_symbol332 = /*#__PURE__*/React.createElement("symbol", {
    id: "signature",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M467.2 44.9c-62.5-62.5-161.7-64.8-252.3 25.7-78.6 78.5-61 60.9-85.8 85.7-60.5 60.4-70.4 150.8-63.6 211.2l178.4-178.2c6.3-6.2 16.4-6.2 22.7 0 6.3 6.2 6.2 16.4 0 22.6L7.1 471.1c-9.4 9.4-9.4 24.6 0 33.9 9.4 9.4 24.6 9.4 34 0l66.1-66c52.2 15.7 171.8 18.2 246.8-54.9h-98.2L403.4 335c50-49.9 36.4-36.2 46.3-46.9h-97.8l131.5-43.8c45.4-74.5 34.3-148.8-16.2-199.4z"
  }))), _symbol333 || (_symbol333 = /*#__PURE__*/React.createElement("symbol", {
    id: "simple-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M256 384c70.691 0 128-57.309 128-128 0-70.692-57.309-128-128-128-70.692 0-128 57.308-128 128 0 70.691 57.308 128 128 128z"
  }))), _symbol334 || (_symbol334 = /*#__PURE__*/React.createElement("symbol", {
    id: "simulation-menu-closed",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M480 224h-2.272c-14.033-98.102-91.627-175.696-189.728-189.728v-2.272c0-17.673-14.327-32-32-32v0c-17.673 0-32 14.327-32 32v2.272c-98.102 14.033-175.696 91.627-189.728 189.728h-2.272c-17.673 0-32 14.327-32 32v0c0 17.673 14.327 32 32 32h2.272c14.033 98.101 91.627 175.696 189.728 189.728v2.272c0 17.673 14.327 32 32 32v0c17.673 0 32-14.327 32-32v-2.272c98.101-14.033 175.696-91.627 189.728-189.728h2.272c17.673 0 32-14.327 32-32v0c0-17.673-14.327-32-32-32zM324.493 93.811c20.952 8.862 39.779 21.559 55.958 37.738s28.876 35.006 37.738 55.958c4.986 11.79 8.625 23.99 10.916 36.493h-32.673c-1.865-8.201-4.455-16.238-7.767-24.066-7.255-17.153-17.632-32.548-30.841-45.757s-28.604-23.585-45.757-30.84c-7.827-3.311-15.865-5.901-24.066-7.766v-32.674c12.502 2.29 24.702 5.928 36.493 10.915zM224 224h-58.53c9.642-27.275 31.255-48.888 58.53-58.53v58.53zM224 288v58.53c-27.274-9.642-48.888-31.255-58.53-58.53h58.53zM288 288h58.53c-9.642 27.274-31.255 48.889-58.53 58.53v-58.53zM288 224v-58.53c27.274 9.642 48.889 31.255 58.53 58.53h-58.53zM93.811 187.507c8.862-20.952 21.559-39.779 37.738-55.958s35.006-28.876 55.958-37.738c11.79-4.987 23.99-8.624 36.493-10.915v32.674c-8.201 1.865-16.238 4.456-24.066 7.766-17.153 7.255-32.548 17.632-45.757 30.841s-23.585 28.604-30.84 45.757c-3.311 7.827-5.901 15.865-7.766 24.066h-32.674c2.29-12.502 5.928-24.702 10.915-36.493zM187.507 418.189c-20.952-8.862-39.779-21.559-55.958-37.738s-28.876-35.006-37.738-55.958c-4.987-11.79-8.624-23.99-10.915-36.493h32.674c1.865 8.201 4.456 16.238 7.766 24.066 7.255 17.153 17.632 32.548 30.841 45.757s28.604 23.586 45.757 30.841c7.827 3.311 15.865 5.901 24.066 7.767v32.673c-12.502-2.291-24.702-5.928-36.493-10.916zM418.189 324.493c-8.862 20.952-21.559 39.779-37.738 55.958s-35.006 28.876-55.958 37.738c-11.79 4.986-23.99 8.625-36.493 10.916v-32.673c8.201-1.865 16.238-4.455 24.066-7.767 17.153-7.255 32.548-17.632 45.757-30.841s23.586-28.604 30.841-45.757c3.311-7.827 5.901-15.865 7.767-24.066h32.673c-2.291 12.502-5.928 24.702-10.916 36.493z"
  }))), _symbol335 || (_symbol335 = /*#__PURE__*/React.createElement("symbol", {
    id: "simulation-menu-open",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M458.233 412.978c33.697-43.35 53.767-97.819 53.767-156.978s-20.070-113.627-53.767-156.977l21.768-21.768c12.497-12.497 12.497-32.758 0-45.255v0c-12.497-12.496-32.758-12.496-45.255 0l-21.768 21.768c-43.35-33.698-97.819-53.768-156.977-53.768s-113.627 20.070-156.977 53.767l-21.768-21.768c-12.497-12.496-32.758-12.496-45.255 0v0c-12.496 12.496-12.496 32.758 0 45.255l21.768 21.768c-33.697 43.35-53.767 97.819-53.767 156.978s20.070 113.627 53.767 156.977l-21.768 21.768c-12.496 12.497-12.496 32.758 0 45.255v0c12.496 12.497 32.758 12.497 45.255 0l21.768-21.768c43.35 33.698 97.819 53.768 156.977 53.768s113.627-20.070 156.977-53.767l21.768 21.768c12.497 12.497 32.758 12.497 45.255 0v0c12.497-12.497 12.497-32.758 0-45.255l-21.768-21.768zM432.938 181.285c9.995 23.63 15.062 48.768 15.062 74.715s-5.067 51.086-15.062 74.716c-5.483 12.963-12.315 25.178-20.421 36.548l-46.247-46.246c11.26-19.056 17.729-41.279 17.729-65.016s-6.469-45.96-17.729-65.016l46.246-46.246c8.106 11.369 14.938 23.584 20.421 36.547zM181.285 79.062c23.63-9.995 48.768-15.062 74.715-15.062s51.086 5.067 74.716 15.062c12.963 5.483 25.178 12.315 36.548 20.421l-46.246 46.246c-19.056-11.26-41.279-17.729-65.016-17.729s-45.96 6.469-65.016 17.729l-46.246-46.246c11.369-8.106 23.584-14.938 36.547-20.421zM79.062 330.716c-9.995-23.63-15.062-48.767-15.062-74.716s5.067-51.086 15.062-74.716c5.483-12.963 12.315-25.178 20.421-36.547l46.246 46.246c-11.26 19.056-17.729 41.279-17.729 65.016s6.469 45.96 17.729 65.016l-46.246 46.247c-8.106-11.369-14.938-23.584-20.421-36.548zM330.716 432.938c-23.63 9.995-48.767 15.062-74.716 15.062s-51.086-5.067-74.716-15.062c-12.963-5.483-25.178-12.315-36.547-20.421l46.246-46.247c19.056 11.26 41.279 17.729 65.016 17.729s45.96-6.469 65.016-17.729l46.247 46.246c-11.369 8.106-23.584 14.938-36.548 20.421z"
  }))), _symbol336 || (_symbol336 = /*#__PURE__*/React.createElement("symbol", {
    id: "simulation-menu",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body lx-simulation-menu-bg",
    fill: "none",
    d: "M512,192h-41.3C449.2,119.8,392.2,62.8,320,41.3V0H192v41.3C119.8,62.8,62.8,119.8,41.3,192H0v128h41.3c21.5,72.2,78.5,129.2,150.7,150.7V512h128v-41.3c72.2-21.5,129.2-78.5,150.7-150.7H512V192z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-simulation-menu-border",
    d: "M512,192h-41.3C449.2,119.8,392.2,62.8,320,41.3V0H192v41.3C119.8,62.8,62.8,119.8,41.3,192H0v128h41.3c21.5,72.2,78.5,129.2,150.7,150.7V512h128v-41.3c72.2-21.5,129.2-78.5,150.7-150.7H512V192z M418.2,324.5c-8.9,21-21.6,39.8-37.7,56s-35,28.9-56,37.7c-1.5,0.6-3,1.2-4.5,1.8v-4H192v4c-1.5-0.6-3-1.2-4.5-1.8c-21-8.9-39.8-21.6-56-37.7s-28.9-35-37.7-56c-0.6-1.5-1.2-3-1.8-4.5h4V192h-4c0.6-1.5,1.2-3,1.8-4.5c8.9-21,21.6-39.8,37.7-56s35-28.9,56-37.7c1.5-0.6,3-1.2,4.5-1.8v4h128v-4c1.5,0.6,3,1.2,4.5,1.8c21,8.9,39.8,21.6,56,37.7s28.9,35,37.7,56c0.6,1.5,1.2,3,1.8,4.5h-4v128h4C419.4,321.5,418.8,323,418.2,324.5L418.2,324.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-simulation-menu-dot",
    d: "M320,256c0,35.3-28.7,64-64,64s-64-28.7-64-64s28.7-64,64-64S320,220.7,320,256z"
  }))), _symbol337 || (_symbol337 = /*#__PURE__*/React.createElement("symbol", {
    id: "site-template",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64C28.7104,0,0,28.7104,0,64v384c0,35.29,28.7104,64,64,64h384c35.29,0,64-28.71,64-64V64C512,28.7104,483.29,0,448,0z M448,140.4629c-9.3101-15.4089-20.5503-29.7977-33.6074-42.855C401.335,84.5506,386.9458,73.3102,371.5367,64H448V140.4629z M256,416c-40.2595,0-77.0888-14.952-105.2404-39.5875L320,320l56.4132-169.2397C401.0483,178.9118,416,215.7408,416,256C416,344.2246,344.2246,416,256,416z M256,96c40.2593,0,77.0883,14.9518,105.2397,39.5868L192,192l-56.4132,169.2397C110.9518,333.0883,96,296.2593,96,256C96,167.7759,167.7759,96,256,96z M286.894,255.999c0,17.673-14.327,32-32,32c-17.673,0-32-14.327-32-32c0-17.673,14.327-32,32-32C272.567,223.999,286.894,238.326,286.894,255.999z M140.4636,64c-15.4091,9.3102-29.7982,20.5506-42.8557,33.6079C84.5506,110.6654,73.3102,125.0544,64,140.4636V64H140.4636z M64,371.5367c9.3102,15.4091,20.5506,29.7983,33.6079,42.8559c13.0573,13.0571,27.4461,24.2974,42.855,33.6074H64V371.5367z M448,448h-76.4626c15.4089-9.3101,29.7978-20.5503,42.8552-33.6074c13.0571-13.0574,24.2974-27.4464,33.6074-42.8552v76.4607C448,447.998,448.0273,448,448,448z"
  }))), _symbol338 || (_symbol338 = /*#__PURE__*/React.createElement("symbol", {
    id: "sites",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body lx-sites-bg",
    fill: "none",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-sites-border",
    d: "M437,75C388.7,26.6,324.4,0,256,0C187.6,0,123.3,26.6,75,75C26.6,123.3,0,187.6,0,256c0,68.4,26.6,132.7,75,181c48.4,48.4,112.6,75,181,75c68.4,0,132.7-26.6,181-75c48.4-48.4,75-112.6,75-181C512,187.6,485.4,123.3,437,75z M256,448c-105.9,0-192-86.1-192-192S150.1,64,256,64s192,86.1,192,192S361.9,448,256,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-sites-hands",
    d: "M128,384l192-64l64-192l-192,64L128,384z M254.9,224c17.7,0,32,14.3,32,32s-14.3,32-32,32s-32-14.3-32-32C222.9,238.3,237.2,224,254.9,224z"
  }))), _symbol339 || (_symbol339 = /*#__PURE__*/React.createElement("symbol", {
    id: "slideshow",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-slideshow-border",
    d: "M64,480h384c32,0,64-32,64-64c0-79.93,0-320,0-320c0-32-32-64-64-64H64C32,32,0,64,0,96v320C0,448,32,480,64,480z M64,96h384v320H64"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lx-slideshow-dot-1",
    cx: 160,
    cy: 320,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lx-slideshow-dot-2",
    cx: 256,
    cy: 320,
    r: 32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline lx-slideshow-dot-3",
    cx: 352,
    cy: 320,
    r: 32
  }))), _symbol340 || (_symbol340 = /*#__PURE__*/React.createElement("symbol", {
    id: "social-facebook",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M483.7,0H28.3C12.6,0,0,12.6,0,28.3v455.5C0,499.4,12.6,512,28.3,512h245.2V313.7h-66.7v-77.3h66.7v-57c0-66.1,40.4-102.1,99.4-102.1c28.3,0,52.5,2.1,59.6,3v69.1h-40.9c-32.1,0-38.3,15.2-38.3,37.6v49.3h76.5l-10,77.3h-66.6V512h130.5c15.6,0,28.3-12.7,28.3-28.3V28.3C512,12.6,499.3,0,483.7,0z"
  }))), _symbol341 || (_symbol341 = /*#__PURE__*/React.createElement("symbol", {
    id: "social-instagram",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-social-instagram-body",
    d: "M352,64c52.9,0,96,43.1,96,96v192c0,52.9-43.1,96-96,96H160c-52.9,0-96-43.1-96-96V160c0-52.9,43.1-96,96-96H352 M352,0H160C72,0,0,72,0,160v192c0,88,72,160,160,160h192c88,0,160-72,160-160V160C512,72,440,0,352,0L352,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-social-instagram-viewfinder",
    d: "M384,96c-17.7,0-32,14.3-32,32s14.3,32,32,32s32-14.3,32-32S401.7,96,384,96L384,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-social-instagram-shutter",
    d: "M320,256c0,86.2-128,88.1-128,0C192,173.6,320,169.8,320,256z M128,256c4.4,167.7,252.5,168.6,256,0C377.7,83.5,134.3,88.3,128,256z"
  }))), _symbol342 || (_symbol342 = /*#__PURE__*/React.createElement("symbol", {
    id: "social-linkedin",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M474.1,0H37.8C16.9,0,0,16.5,0,36.9V475c0,20.4,16.9,37,37.8,37h436.4c20.9,0,37.9-16.6,37.9-36.9V36.9C512,16.5,495,0,474.1,0z M151.9,436.3h-76V191.9h76V436.3z M69.8,114.6c0-60.6,88.1-60.6,88.1,0C157.9,175,69.8,173,69.8,114.6z M436.3,436.3h-75.9V317.5c0-28.3-0.5-64.8-39.5-64.8c-39.5,0-45.5,30.9-45.5,62.8v120.8h-75.8V191.9h72.8v33.4h1c10.1-19.2,34.9-39.5,71.8-39.5c76.9,0,91.1,50.6,91.1,116.4L436.3,436.3L436.3,436.3z"
  }))), _symbol343 || (_symbol343 = /*#__PURE__*/React.createElement("symbol", {
    id: "social-twitter",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512.015 97.213c-18.842 8.368-39.089 14.015-60.332 16.531 21.68-12.991 38.358-33.589 46.2-58.108-20.306 12.026-42.776 20.774-66.71 25.485-19.164-20.423-46.462-33.179-76.688-33.179-58.020 0-105.039 47.048-105.039 105.039 0 8.222 0.936 16.238 2.721 23.934-87.308-4.389-164.698-46.2-216.516-109.749-9.041 15.508-14.22 33.559-14.22 52.812 0 36.457 18.55 68.612 46.727 87.425-17.234-0.556-33.414-5.267-47.575-13.137 0 0.439 0 0.877 0 1.317 0 50.91 36.222 93.336 84.266 102.99-8.807 2.399-18.082 3.687-27.679 3.687-6.759 0-13.343-0.673-19.779-1.901 13.371 41.723 52.169 72.123 98.135 72.942-35.959 28.176-81.252 44.971-130.465 44.971-8.486 0-16.853-0.498-25.046-1.464 46.493 29.815 101.704 47.195 161.041 47.195 193.226 0 298.879-160.075 298.879-298.879 0-4.565-0.117-9.070-0.293-13.576 20.481-14.776 38.3-33.267 52.374-54.334v0z"
  }))), _symbol344 || (_symbol344 = /*#__PURE__*/React.createElement("symbol", {
    id: "social-vimeo",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M292.9,156.6C327.8,6.9,525.6-14.2,511.3,138c0,91.6-180.5,340.2-280.8,340.2c-106-4.7-99.3-313.5-166.2-315.8c-9.3-0.1-40.2,23.3-40.2,23.3L0,154.6C74.7,88,126.5,33.6,168.5,41.9c84.2,19.2,61.9,277.3,114,277.3C322,319.2,439.6,97.7,292.9,156.6z"
  }))), _symbol345 || (_symbol345 = /*#__PURE__*/React.createElement("symbol", {
    id: "spacer",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline spacer-border",
    d: "M448,64v384H64V64H448 M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0L448,0z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline spacer-indicator-start",
    x: 96,
    y: 224,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline spacer-indicator-end",
    x: 352,
    y: 224,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline spacer-indicator-top",
    x: 224,
    y: 96,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline spacer-indicator-bottom",
    x: 224,
    y: 352,
    width: 64,
    height: 64
  }))), _symbol346 || (_symbol346 = /*#__PURE__*/React.createElement("symbol", {
    id: "special-character",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M255.87,32C35.55,43.31,12.72,299.8,151.6,384H96.29c-43.54,0-42.58,64,0,64h127.99v-78.07c0-12.64-7.49-24.01-19.08-29.07C90.01,293.65,105.82,101.28,256.58,96c144.34,3.53,171.57,193.26,50.77,244.86c-11.58,5.06-19.08,16.43-19.08,29.07V448h127.99c41.84,0,42.8-64,0-64h-55.31C501.05,301.56,474.7,38.92,255.87,32z"
  }))), _symbol347 || (_symbol347 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-hole-multi",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-square-hole-multi-square-1",
    d: "M460,0H148c-28.6,0-52,23.4-52,52v12h320c17.7,0,32,14.3,32,32v320h12c28.6,0,52-23.4,52-52V52C512,23.4,488.6,0,460,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-square-hole-multi-square-2",
    d: "M364,96H52c-28.6,0-52,23.4-52,52v312c0,28.6,23.4,52,52,52h312c28.6,0,52-23.4,52-52V148C416,119.4,392.6,96,364,96z M286,382H130V226h156V382z"
  }))), _symbol348 || (_symbol348 = /*#__PURE__*/React.createElement("symbol", {
    id: "square-hole",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64A64,64,0,0,0,0,64V448a64,64,0,0,0,64,64H448a64,64,0,0,0,64-64V64A64,64,0,0,0,448,0ZM352,352H160V160H352Z"
  }))), _symbol349 || (_symbol349 = /*#__PURE__*/React.createElement("symbol", {
    id: "square",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M416,512H96c-44.3,0-96-34.58-96-96c0-97.04,0-245.73,0-320C0,40.09,44.62,0,96,0c71.53,0,320,0,320,0c57.71,0,96,46.53,96,96v320C512,470.05,465.76,512,416,512z"
  }))), _symbol350 || (_symbol350 = /*#__PURE__*/React.createElement("symbol", {
    id: "staging",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-3",
    d: "M384,254.7c0,0.4,0,0.8,0,1.3c0,16.8-3.2,32.8-9.1,47.5L493,352c12.6-30.9,19-63.6,19-97.3V254L384,254.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-1",
    d: "M323.1,147l68.8-110.2C363.5,18.9,332.5,7,299.6,1.3l-22,128.5C294,132.6,309.4,138.5,323.1,147z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-2",
    d: "M377.3,215.2l122.2-39.8c-10.3-31.8-26.4-60.9-48-86.6L353,172.5C363.7,184.9,372,199.3,377.3,215.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-8",
    d: "M161.8,169.3L66,82.3c-22.4,24.9-39.5,53.5-50.8,84.9l120.9,43.9C141.9,195.6,150.7,181.4,161.8,169.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-9",
    d: "M238.5,129.2L220.7,0c-33.1,4.6-64.5,15.5-93.4,32.4l65.2,112.5C206.4,136.9,221.9,131.5,238.5,129.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-5",
    d: "M256,384c-9.3,0-18.4-1-27.2-2.9l-26.7,125.2c17.7,3.8,35.5,5.9,54.1,5.7c14.8,0,29.8-1.3,44.4-3.9L278.5,382C271.2,383.3,263.7,384,256,384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-4",
    d: "M316,369.1l59.5,113.2c29.4-15.6,55.2-36.6,76.6-62.2l-97.7-82.3C343.9,350.5,330.8,361.2,316,369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-7",
    d: "M128,256c0-2,0.1-4,0.1-6l-128-4.6c-0.1,3.1-0.2,6.2-0.2,9.4c0,30.3,5.2,60.1,15.5,88.4l119.9-44.1C130.6,285.6,128,271.1,128,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-staging-tick-6",
    d: "M154.5,334L53.9,412.7c20.5,26.4,45.5,48.3,74.3,65l63.7-110.9C177.4,358.4,164.7,347.2,154.5,334z"
  }))), _symbol351 || (_symbol351 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-half",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M418.1,510.1c-4.1,0-8.2-1.1-11.9-3.3l-150.3-90.2l-146.2,86.2c-8.3,4.9-18.8,4.1-26.3-2s-10.4-16.2-7.3-25.4l55.5-162.9l-121-96.2C3,210.2,0,199.9,3.3,190.6s12-15.5,21.8-15.5h150.1l59.2-158.2c3.4-9,12-15,21.6-15s18.2,6,21.6,15l59.2,158.2H487c9.8,0,18.6,6.2,21.8,15.5c3.2,9.3,0.3,19.6-7.4,25.7l-120.8,96.1l58.3,163.9c1.7,3.2,2.6,6.8,2.6,10.7c0,12.7-10.3,23.1-23.1,23.1C418.2,510.1,418.1,510.1,418.1,510.1L418.1,510.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M418.1,510.1c-4.1,0-8.2-1.1-11.9-3.3l-150.3-90.2l-146.2,86.2c-8.3,4.9-18.8,4.1-26.3-2s-10.4-16.2-7.3-25.4l55.5-162.9l-121-96.2C3,210.2,0,199.9,3.3,190.6s12-15.5,21.8-15.5h150.1l59.2-158.2c3.4-9,12-15,21.6-15s18.2,6,21.6,15l59.2,158.2H487c9.8,0,18.6,6.2,21.8,15.5c3.2,9.3,0.3,19.6-7.4,25.7l-120.8,96.1l58.3,163.9c1.7,3.2,2.6,6.8,2.6,10.7c0,12.7-10.3,23.1-23.1,23.1C418.2,510.1,418.1,510.1,418.1,510.1L418.1,510.1z M256,366.6c4.1,0,8.2,1.1,11.9,3.3L374.7,434l-43.3-121.7c-3.3-9.3-0.3-19.7,7.4-25.8l82-65.2h-100c-9.6,0-18.3-6-21.6-15L256,90.9C256,90.9,251.9,366.6,256,366.6L256,366.6z"
  }))), _symbol352 || (_symbol352 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-o",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M508.753 190.647c-3.247-9.265-11.983-15.493-21.802-15.493h-150.106l-59.203-158.208c-3.378-9.027-12.010-14.992-21.644-14.992s-18.264 5.965-21.617 14.992l-59.203 158.208h-150.131c-9.819 0-18.555 6.202-21.802 15.493-3.247 9.265-0.264 19.558 7.417 25.682l120.966 96.234-55.534 162.88c-3.114 9.132-0.212 19.268 7.285 25.365 7.47 6.097 17.975 6.889 26.316 1.979l146.173-86.204 150.317 90.163c3.668 2.217 7.786 3.299 11.877 3.299 0.026 0 0.079 0 0.132 0 12.722-0.422 23.2-10.32 23.2-23.095 0-3.853-0.924-7.496-2.613-10.69l-58.252-163.83 120.807-96.103c7.68-6.097 10.663-16.417 7.417-25.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M418.1,510.1c-4.1,0-8.2-1.1-11.9-3.3l-150.3-90.2l-146.2,86.2c-8.3,4.9-18.8,4.1-26.3-2s-10.4-16.2-7.3-25.4l55.5-162.9l-121-96.2C3,210.2,0,199.9,3.3,190.6s12-15.5,21.8-15.5h150.1l59.2-158.2c3.4-9,12-15,21.6-15s18.2,6,21.6,15l59.2,158.2H487c9.8,0,18.6,6.2,21.8,15.5c3.2,9.3,0.3,19.6-7.4,25.7l-120.8,96.1l58.3,163.9c1.7,3.2,2.6,6.8,2.6,10.7c0,12.7-10.3,23.1-23.1,23.1C418.2,510.1,418.1,510.1,418.1,510.1L418.1,510.1z M256,366.6c4.1,0,8.2,1.1,11.9,3.3L374.7,434l-43.3-121.7c-3.3-9.3-0.3-19.7,7.4-25.8l82-65.2h-100c-9.6,0-18.3-6-21.6-15L256,90.9l-43.2,115.4c-3.4,9-12,15-21.6,15h-100l82,65.2c7.6,6.1,10.6,16.3,7.5,25.5L140,431.3l104.3-61.5C247.9,367.7,251.9,366.6,256,366.6L256,366.6z"
  }))), _symbol353 || (_symbol353 = /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    d: "M508.753 190.647c-3.247-9.265-11.983-15.493-21.802-15.493h-150.106l-59.203-158.208c-3.378-9.027-12.010-14.992-21.644-14.992s-18.264 5.965-21.617 14.992l-59.203 158.208h-150.131c-9.819 0-18.555 6.202-21.802 15.493-3.247 9.265-0.264 19.558 7.417 25.682l120.966 96.234-55.534 162.88c-3.114 9.132-0.212 19.268 7.285 25.365 7.47 6.097 17.975 6.889 26.316 1.979l146.173-86.204 150.317 90.163c3.668 2.217 7.786 3.299 11.877 3.299 0.026 0 0.079 0 0.132 0 12.722-0.422 23.2-10.32 23.2-23.095 0-3.853-0.924-7.496-2.613-10.69l-58.252-163.83 120.807-96.103c7.68-6.097 10.663-16.417 7.417-25.682z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M418.1,510.1c-4.1,0-8.2-1.1-11.9-3.3l-150.3-90.2l-146.2,86.2c-8.3,4.9-18.8,4.1-26.3-2s-10.4-16.2-7.3-25.4l55.5-162.9l-121-96.2C3,210.2,0,199.9,3.3,190.6s12-15.5,21.8-15.5h150.1l59.2-158.2c3.4-9,12-15,21.6-15s18.2,6,21.6,15l59.2,158.2H487c9.8,0,18.6,6.2,21.8,15.5c3.2,9.3,0.3,19.6-7.4,25.7l-120.8,96.1l58.3,163.9c1.7,3.2,2.6,6.8,2.6,10.7c0,12.7-10.3,23.1-23.1,23.1C418.2,510.1,418.1,510.1,418.1,510.1L418.1,510.1z M256,366.6c4.1,0,8.2,1.1,11.9,3.3L374.7,434l-43.3-121.7c-3.3-9.3-0.3-19.7,7.4-25.8l82-65.2h-100c-9.6,0-18.3-6-21.6-15L256,90.9l-43.2,115.4c-3.4,9-12,15-21.6,15h-100l82,65.2c7.6,6.1,10.6,16.3,7.5,25.5L140,431.3l104.3-61.5C247.9,367.7,251.9,366.6,256,366.6L256,366.6z"
  }))), _symbol354 || (_symbol354 = /*#__PURE__*/React.createElement("symbol", {
    id: "sticky",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M401.4,246.4c-27.2,27.2-45.4,10.5-51.2,5.9l-25.7,25.7c13.1,67.7-42.2,110.1-42.2,110.1c-12.5,12.5-32.8,12.5-45.3,0L195.7,347l-66.5,54L111.4,383l53-67.3l-40.6-40.6c-12.5-12.5-12.5-32.8,0-45.3c0,0,41.8-55.1,110.1-42.2l25.7-25.7c-2.1-2.1-23.6-21.7,6.4-51.8c20.7-20.7,39.6-15.1,50-4.7l90.5,90.5C412,202.6,427.7,220.1,401.4,246.4z"
  }))), _symbol355 || (_symbol355 = /*#__PURE__*/React.createElement("symbol", {
    id: "strikethrough",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M511.999 224h-174.81c-10.057-3.474-20.699-6.363-32.11-8.521l-68.462-13.129c-17.957-3.73-31.342-10.533-40.119-20.48-8.741-9.911-13.129-21.577-13.129-34.962 0-8.338 1.865-16.165 5.522-23.552 3.73-7.387 8.887-13.97 15.579-19.749 6.656-5.815 14.738-10.423 24.21-13.861 9.435-3.511 19.931-5.193 31.451-5.193 15.653 0 28.928 2.304 39.717 6.949 10.862 4.571 19.749 10.386 26.624 17.298 6.912 6.949 12.142 14.446 15.579 22.491s5.851 15.616 7.241 22.491l85.76-26.331c-2.743-13.824-7.973-28.233-15.579-43.301-7.607-14.994-18.286-28.709-32.146-41.216-13.824-12.471-31.232-22.711-52.224-30.793-20.955-8.082-46.153-12.142-75.63-12.142-23.077 0-44.946 3.95-65.719 11.776-20.699 7.899-38.949 18.725-54.638 32.585-15.653 13.861-27.977 30.098-36.974 48.823s-13.495 38.912-13.495 60.599c0 26.843 6.254 50.139 18.213 70.18h-106.862v64h192.913c7.79 2.487 15.799 4.754 24.357 6.473l68.424 13.861c19.419 3.657 34.158 10.715 44.288 21.102 10.13 10.423 15.177 22.784 15.177 37.083 0 17.518-6.802 31.963-20.37 43.301-13.605 11.337-33.317 16.969-59.136 16.969-17.518 0-32.731-2.523-45.641-7.607-12.873-5.083-23.735-11.886-32.475-20.48-8.777-8.521-15.579-18.322-20.407-29.44s-7.717-22.601-8.594-34.633l-88.502 23.515c1.792 17.591 6.912 35.474 15.177 53.723 8.265 18.213 20.37 34.743 36.279 49.518 15.909 14.811 35.621 26.953 59.136 36.352 23.515 9.545 51.602 14.299 84.333 14.299 28.599 0 53.797-4.389 75.666-13.129 21.906-8.777 40.338-20.187 55.296-34.267 15.031-14.080 26.405-30.281 34.267-48.53 7.826-18.213 11.776-36.827 11.776-55.771 0-17.079-3.035-33.499-8.997-49.152-3.109-8.119-6.985-15.799-11.557-23.113h90.587v-64.037z"
  }))), _symbol356 || (_symbol356 = /*#__PURE__*/React.createElement("symbol", {
    id: "subscript",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-subscript-number",
    d: "M297.7,288.3c-3.2-83,147.2-86.2,147.2-6.4c0,36.97-74.4,92.6-74.4,92.6H448V416H300.8v-38.3c0,0,80-70.2,83.2-73.4c34.93-36.18-34.04-56.08-38.4-16l0,0L297.7,288.3L297.7,288.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-subscript-letter",
    d: "M168.08,275.2L118.4,352H64l73.6-112L64,128h57.6l46.39,76.8L214.4,128h54.4l-70.4,112L272,352h-57.6L168.08,275.2z"
  }))), _symbol357 || (_symbol357 = /*#__PURE__*/React.createElement("symbol", {
    id: "suitcase",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M419.1,96L419.1,96L384,96V64c0-35.3-28.7-64-64-64H192c-35.3,0-64,28.7-64,64v32H92.9C41.6,96,0,137.6,0,188.9v230.2C0,470.4,41.6,512,92.9,512h326.2c51.3,0,92.9-41.6,92.9-92.9V188.9C512,137.6,470.4,96,419.1,96z M320,96H192V64h128V96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M419.1,96H384V64c0-35.3-28.7-64-64-64H192c-35.3,0-64,28.7-64,64v32H92.9C41.6,96,0,137.6,0,188.9v230.2C0,470.4,41.6,512,92.9,512h326.2c51.3,0,92.9-41.6,92.9-92.9V188.9C512,137.6,470.4,96,419.1,96L419.1,96z M192,64h128v32H192V64z M448,419.1c0,15.9-13,28.9-28.9,28.9H92.9C77,448,64,435,64,419.1V188.9C64,173,77,160,92.9,160h326.2c15.9,0,28.9,13,28.9,28.9V419.1z"
  }))), _symbol358 || (_symbol358 = /*#__PURE__*/React.createElement("symbol", {
    id: "sun",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-body sun-core-bg",
    fill: "none",
    cx: 256,
    cy: 256,
    r: 128
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-core-border",
    d: "M256,128c-70.7,0-128,57.3-128,128s57.3,128,128,128s128-57.3,128-128S326.7,128,256,128z M301.3,301.3C289.2,313.3,273.1,320,256,320s-33.2-6.7-45.3-18.7C198.7,289.2,192,273.1,192,256s6.7-33.2,18.7-45.3c12.1-12.1,28.2-18.7,45.3-18.7s33.2,6.7,45.3,18.7S320,238.9,320,256S313.3,289.2,301.3,301.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-3",
    d: "M480,224h-32c-17.7,0-32,14.3-32,32l0,0c0,17.7,14.3,32,32,32h32c17.7,0,32-14.3,32-32l0,0C512,238.3,497.7,224,480,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-7",
    d: "M96,256L96,256c0-17.7-14.3-32-32-32H32c-17.7,0-32,14.3-32,32l0,0c0,17.7,14.3,32,32,32h32C81.7,288,96,273.7,96,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-5",
    d: "M256,416L256,416c-17.7,0-32,14.3-32,32v32c0,17.7,14.3,32,32,32l0,0c17.7,0,32-14.3,32-32v-32C288,430.3,273.7,416,256,416z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-1",
    d: "M256,96L256,96c17.7,0,32-14.3,32-32V32c0-17.7-14.3-32-32-32l0,0c-17.7,0-32,14.3-32,32v32C224,81.7,238.3,96,256,96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-4",
    d: "M414.4,369.1c-12.5-12.5-32.8-12.5-45.3,0l0,0c-12.5,12.5-12.5,32.8,0,45.3l22.6,22.6c12.5,12.5,32.8,12.5,45.3,0l0,0c12.5-12.5,12.5-32.8,0-45.3L414.4,369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-8",
    d: "M97.6,142.9c12.5,12.5,32.8,12.5,45.3,0l0,0c12.5-12.5,12.5-32.8,0-45.3L120.2,75C107.7,62.5,87.5,62.5,75,75l0,0c-12.5,12.5-12.5,32.8,0,45.3L97.6,142.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-6",
    d: "M142.9,369.1c-12.5-12.5-32.8-12.5-45.3,0L75,391.8c-12.5,12.5-12.5,32.8,0,45.3l0,0c12.5,12.5,32.8,12.5,45.3,0l22.6-22.6C155.4,401.9,155.4,381.6,142.9,369.1L142.9,369.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline sun-ray-2",
    d: "M369.1,142.9c12.5,12.5,32.8,12.5,45.3,0l22.6-22.6c12.5-12.5,12.5-32.8,0-45.3l0,0c-12.5-12.5-32.8-12.5-45.3,0l-22.6,22.6C356.6,110.1,356.6,130.4,369.1,142.9L369.1,142.9z"
  }))), _symbol359 || (_symbol359 = /*#__PURE__*/React.createElement("symbol", {
    id: "superscript",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-superscript-letter",
    d: "M168.08,275.2L118.4,352H64l73.6-112L64,128h57.6l46.39,76.8L214.4,128h54.4l-70.4,112L272,352h-57.6L168.08,275.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-superscript-number",
    d: "M297.7,64.3c-3.2-83,147.2-86.2,147.2-6.4c0,36.97-74.4,92.6-74.4,92.6H448V192H300.8v-38.3c0,0,80-70.2,83.2-73.4c34.93-36.18-34.04-56.08-38.4-16l0,0L297.7,64.3L297.7,64.3z"
  }))), _symbol360 || (_symbol360 = /*#__PURE__*/React.createElement("symbol", {
    id: "table",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M455.1,0H56.9C25.5,0,0,25.5,0,56.9v398.2C0,486.5,25.5,512,56.9,512h398.2c31.4,0,56.9-25.5,56.9-56.9V56.9C512,25.5,486.5,0,455.1,0z M224,448H64V288h160V448z M224,224H64V64h160V224z M448,448H288V288h160V448z M448,224H288V64h160V224z"
  }))), _symbol361 || (_symbol361 = /*#__PURE__*/React.createElement("symbol", {
    id: "table2",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64C32,0,0,32,0,64v384c0,32,32,64,64,64h384c32,0,64-32,64-64V64C512,32,480,0,448,0z M160,448H64v-96h96V448z M160,288H64v-64h96V288z M160,160H64V64h96V160z M288,448h-64v-96h64V448z M288,288h-64v-64h64V288z M288,160h-64V64h64V160z M448,448h-96v-96h96V448z M448,288h-96v-64h96V288z M448,160h-96V64h96V160z"
  }))), _symbol362 || (_symbol362 = /*#__PURE__*/React.createElement("symbol", {
    id: "tablet-landscape",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,96v320c0,35.2,28.8,64,64,64h384c35.2,0,64-28.8,64-64V96c0-35.2-28.8-64-64-64H64C28.8,32,0,60.8,0,96z M448,288c-41.6,0-41.6-64,0-64C492.8,224,489.6,288,448,288z M384,96v320H64V96H384z"
  }))), _symbol363 || (_symbol363 = /*#__PURE__*/React.createElement("symbol", {
    id: "tablet-portrait",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M416,0H96C60.8,0,32,28.8,32,64v384c0,35.2,28.8,64,64,64h320c35.2,0,64-28.8,64-64V64C480,28.8,451.2,0,416,0z M224,448c0-41.6,64-41.6,64,0C288,492.8,224,489.6,224,448z M416,384H96V64h320V384z"
  }))), _symbol364 || (_symbol364 = /*#__PURE__*/React.createElement("symbol", {
    id: "tabs",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64C31.75,0,0,31.25,0,64c0,127.89,0,384,0,384c0,32.19,32.19,64,64,64h384c32,0,64-31.88,64-64V64C512,32,480.25,0,448,0z M256,64h64v32h-64V64z M448,448H64V64h128v96h256V448z M448,96h-64V64h64V96z M160,288h192c17.67,0,32-14.33,32-32v0c0-17.67-14.33-32-32-32H160c-17.67,0-32,14.33-32,32v0C128,273.67,142.33,288,160,288z M160,384h192c17.67,0,32-14.33,32-32v0c0-17.67-14.33-32-32-32H160c-17.67,0-32,14.33-32,32v0C128,369.67,142.33,384,160,384z"
  }))), _symbol365 || (_symbol365 = /*#__PURE__*/React.createElement("symbol", {
    id: "tag",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M512,94.9l0-1c-1.5-49.8-37-89.3-84.5-93.8L426,0H281.9C239,0,210.9,18.6,198,29.7l-0.9,0.8L25.5,202.2C8.9,218.8-0.1,241.2,0,265.2c0.1,23.9,9.3,46.1,25.8,62.6l158.4,158.4c16.6,16.6,38.9,25.8,62.7,25.8c23.8,0,46.1-9.1,62.6-25.7l167.3-167.4l0.8-0.9c13.2-15.4,35.3-47.9,34.4-92.6L512,94.9z M364,191c-11.6,11.6-31.7,11.6-43.3,0c-11.9-11.9-11.9-31.4,0-43.3c5.8-5.8,13.5-9,21.7-9c8.2,0,15.9,3.2,21.7,9c5.8,5.8,9,13.5,9,21.7C373,177.5,369.8,185.2,364,191z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-tag-border",
    d: "M512,94.9l0-1c-1.5-49.8-37-89.3-84.5-93.8L426,0H281.9C239,0,210.9,18.6,198,29.7l-0.9,0.8L25.5,202.2C8.9,218.8-0.1,241.2,0,265.2c0.1,23.9,9.3,46.1,25.8,62.6l158.4,158.4c16.6,16.6,38.9,25.8,62.7,25.8c23.8,0,46.1-9.1,62.6-25.7l167.3-167.4l0.8-0.9c13.2-15.4,35.3-47.9,34.4-92.6L512,94.9z M448,226.4c0.5,22.9-10.9,40.2-18.2,49L264.2,441.1c-4.5,4.5-10.6,6.9-17.4,6.9c-6.8,0-12.9-2.4-17.4-7L71,282.6c-9.3-9.3-9.4-26-0.3-35.1L240.6,77.5c6.5-5.4,19.9-13.5,41.2-13.5h140.8c14.4,2,24.7,14.7,25.3,31.4l0,130.2L448,226.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-tag-hole-border",
    d: "M294.6,121.6c-26.3,26.3-26.3,69.2,0,95.5c12.8,12.8,29.7,19.8,47.8,19.8c18.1,0,35-7,47.8-19.8c12.8-12.8,19.8-29.7,19.8-47.8s-7-35-19.8-47.8C364.6,96.1,320.1,96,294.6,121.6z M364,191c-11.6,11.6-31.7,11.6-43.3,0c-11.9-11.9-11.9-31.4,0-43.3c5.8-5.8,13.5-9,21.7-9s15.9,3.2,21.7,9s9,13.5,9,21.7C373,177.5,369.8,185.2,364,191z"
  }))), _symbol366 || (_symbol366 = /*#__PURE__*/React.createElement("symbol", {
    id: "tap-ahead",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M140.89,95.88l329.42,329.35c29.9,29.67-15.32,74.88-44.99,45.21L95.9,140.88c-0.03-0.03-0.02,179-0.02,179c0,41.96-64,41.9-64,0v-256c0-17.59,14.42-32,32-32h256c42.01,0,41.97,64,0,64H140.89z"
  }))), _symbol367 || (_symbol367 = /*#__PURE__*/React.createElement("symbol", {
    id: "test",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M459.32,411.64C397.14,291.34,336.37,223.97,336.05,160V64c0,0,12.19,0.03,16,0c41.27-0.35,44.48-62.37,0-64h-192c-43.83,2.47-41.63,62.35,0,64h16v96c0.58,64.07-66.82,140.17-123.27,251.64C39.35,438.17,46.7,507.41,127.66,512h256.78C455.57,509.38,475.43,442.81,459.32,411.64z M380.95,448H130.38c-8.96,0-20.58-10.03-13.44-25.28L144,368.01c80.9,0,110.73-64.09,176.44-64.05c0,0,69.89,113.49,72.34,116.84C403.23,435.11,393.12,448,380.95,448z"
  }))), _symbol368 || (_symbol368 = /*#__PURE__*/React.createElement("symbol", {
    id: "text-color",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-text-color-line",
    d: "M400.01,512H111.5c-63.75,0-62.9-96.04,0-96.04h288.52C463.14,415.96,464.84,512,400.01,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-text-color-a",
    d: "M411.44,327.09L293.88,56.72c-14.96-32.69-59.96-33.17-75.39-0.19L99.4,326.63c-15.55,40.37,41.32,62.93,59,25.06l13.53-31.77H338.9l13.42,31.93C369.76,390.34,427.41,366.22,411.44,327.09z M199.2,255.9l56.79-133.32L312,255.9H199.2z"
  }))), _symbol369 || (_symbol369 = /*#__PURE__*/React.createElement("symbol", {
    id: "text-editor",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-text-editor-t-uppercase",
    d: "M226.6,98.6c0,28.8,0,57.6,0,86.5s0,25.9,0,54.8v31.7c0,28.8,0,57.6,0,86.5c0,17.3,0,34.6,0,51.9c0,20.2,14.4,34.6,34.6,37.5l34.6,2.9V479H91.1v-28.8l34.6-2.9c20.2-2.9,34.6-17.3,34.6-37.5c0-17.3,0-34.6,0-51.9c0-28.8,0-57.6,0-86.5v-31.7c0-28.8,0-25.9,0-54.8s0-57.6,0-86.5h-72c-20.2,0-34.6,14.4-37.5,31.7L42.2,185H1.8L7.6,72.6c0-2.9,2.9-8.6,8.6-8.6h354.5c2.9,0,8.6,2.9,8.6,8.6l5.8,112.4h-40.3l-8.6-54.8c-5.8-17.3-23.1-31.7-40.3-31.7H226.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-text-editor-t-lower-case",
    d: "M416.8,245.5c0,17.3,0,34.6,0,51.9c0,17.3,0,17.3,0,34.6v20.2c0,17.3,0,34.6,0,51.9c0,11.5,0,20.2,0,31.7c0,11.5,8.6,20.2,20.2,23.1l17.3,2.9V479H336.1v-17.3l17.3-2.9c11.5,0,20.2-11.5,20.2-23.1c0-11.5,0-20.2,0-31.7c0-17.3,0-34.6,0-51.9V332c0-17.3,0-17.3,0-34.6s0-34.6,0-51.9H339c-11.5,0-20.2,8.6-23.1,17.3l-5.8,31.7h-25.9l2.9-66.3c0-2.9,2.9-5.8,5.8-5.8h207.5c2.9,0,5.8,2.9,5.8,5.8l2.9,66.3h-25.9l-11.5-28.8c-2.9-11.5-11.5-17.3-23.1-17.3h-31.7C416.8,248.4,416.8,245.5,416.8,245.5z"
  }))), _symbol370 || (_symbol370 = /*#__PURE__*/React.createElement("symbol", {
    id: "text-l",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M296.7,313.6h-83l-20.4,68H148l82.4-251.2h50.8l82.5,251.2h-46.1L296.7,313.6z M286.2,278.7L255.3,165l-30.5,113.7H286.2z"
  }))), _symbol371 || (_symbol371 = /*#__PURE__*/React.createElement("symbol", {
    id: "text",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M445.4,435.3c-24.9-59.8-135-324-159.7-383.4C280.9,40.2,269.4,32,256,32s-24.9,8.2-29.6,19.9C201.6,111.3,91.5,375.5,66.6,435.3c-1.7,3.9-2.6,8.2-2.6,12.7c0,17.7,14.3,32,32,32c13.4,0,24.9-8.2,29.6-19.9c6.2-14.8,17.6-42.2,31.7-76.1h197.3c14.1,33.8,25.5,61.3,31.7,76.1c4.8,11.7,16.2,19.9,29.6,19.9c17.7,0,32-14.3,32-32C448,443.5,447.1,439.2,445.4,435.3z M184,320c24.4-58.5,51.3-123.2,72-172.8c20.7,49.6,47.6,114.2,72,172.8H184z"
  }))), _symbol372 || (_symbol372 = /*#__PURE__*/React.createElement("symbol", {
    id: "textbox",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-textbox-bg",
    d: "M448,64H64C28.7,64,0,92.7,0,128v256c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V128C512,92.7,483.3,64,448,64z M232.2,375.6l-19.6-68h-84.5l-19.6,68H63.2L145,124.5h52.2L279,375.6H232.2z M448,375.6H320v-32h128 V375.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline lx-textbox-bg",
    points: "170.3,159.1 138.5,272.7 202.6,272.7 "
  }))), _symbol373 || (_symbol373 = /*#__PURE__*/React.createElement("symbol", {
    id: "theme",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-body",
    fill: "none",
    x: 64,
    y: 64,
    width: 384,
    height: 384
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-theme-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64 C512,28.7,483.3,0,448,0z M64,64h384v384H64V64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-theme-lines",
    d: "M209,352h-98c-8.3,0-15,6.4-15,14.2v35.6c0,7.9,6.7,14.2,15,14.2h98c8.3,0,15-6.4,15-14.2v-35.6 C224,358.4,217.3,352,209,352z M305.8,352h-35.6c-7.9,0-14.2,6.4-14.2,14.2v35.6c0,7.9,6.4,14.2,14.2,14.2h35.6 c7.9,0,14.2-6.4,14.2-14.2v-35.6C320,358.4,313.6,352,305.8,352z M401.8,352h-35.6c-7.9,0-14.2,6.4-14.2,14.2v35.6 c0,7.9,6.4,14.2,14.2,14.2h35.6c7.9,0,14.2-6.4,14.2-14.2v-35.6C416,358.4,409.6,352,401.8,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-theme-letters",
    d: "M231.7,309.7c2.2,6.1,8.4,10.3,15.4,10.3h2.3c11,0,18.9-10.1,15.4-19.8L204.6,132 c-3.3-9.2-12.6-15.5-23-15.5h-1.4c-10.5,0-19.7,6.3-23,15.5L96.8,300.2c-3.5,9.8,4.3,19.8,15.4,19.8h2.3c7,0,13.1-4.1,15.4-10.3 l14.5-40.6h72.8L231.7,309.7z M155.2,235.2l25.5-67.8l25.5,67.8H155.2z M405.3,192h-11.8c-5.3,0-9.6,4.3-9.6,9.6 c-9.6-6.4-19.3-9.6-32.1-9.6c-83.5,0-86.7,128,0,128c12.8,0,22.5-3.2,32.1-9.6c0,5.3,4.3,9.6,9.6,9.6h11.8c5.9,0,10.7-4.8,10.7-10.7 V202.7C416,196.8,411.2,192,405.3,192z M352.1,288c-41.1,0-44.5-64,0-64C395.2,224,394,288,352.1,288z"
  }))), _symbol374 || (_symbol374 = /*#__PURE__*/React.createElement("symbol", {
    id: "third-party",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline third-party-dots",
    d: "M480.1,194.6v-69.1c47.8-14.6,41.5-93.5-16-93.5c-57.1,0-63.6,78.9-16,93.5v69.2c-15,4.8-24.8,16.1-29.1,29.4H221.4c-5.7-17.6-20.9-32-45.4-32c-62.9,0-64.7,96,0,96c25.1,0,40.1-14.4,45.6-32h197c4.1,13.4,14,24.7,29.4,29.5v101.2c-46.4,14.9-42.6,93.4,16,93.4c58.7,0,62.8-78.6,16-93.4V285.5C522.9,272.4,522.1,207.9,480.1,194.6z M464,224c21.2,0,20.7,32,0,32C442.5,256,443.2,224,464,224z M464,64c21.2,0,20.7,32,0,32C442.5,96,443.2,64,464,64z M176,256c-21.6,0-20.8-32,0-32C197.2,224,196.7,256,176,256z M464,448c-21.6,0-20.8-32,0-32C485.2,416,484.8,448,464,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline third-party-border",
    d: "M284.9,320v92.9H67.1V99.1h217.8V160H352V99.1C352,62.1,322,32,284.9,32H67.1C30.1,32,0,62.1,0,99.1v313.8C0,449.9,30.1,480,67.1,480h217.8c37.1,0,67.1-30.1,67.1-67.1V320H284.9z"
  }))), _symbol375 || (_symbol375 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-down-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-thumbs-down-full-cuff",
    d: "M512,288.1V31.7c0-42.7-64-42.7-64,0v256.4C448.1,331.7,512,330,512,288.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-thumbs-down-full-thumb",
    d: "M0,277.2C-0.1,355.7,63.9,352,63.9,352l159.2,0.2c-60.8,100-54.7,132.2-20.5,151.2c71.5,39.7,111.5-70.3,171.4-183.2h42.1V-0.3H200.2C143.8-0.3,64,59.5,64,127.9V164C5.6,183.5-0.2,225.2,0,277.2z"
  }))), _symbol376 || (_symbol376 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-down",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-down-thumb-border",
    d: "M0.2,277.1c-0.1,78.4,63.9,74.7,63.9,74.7l108.2,0.2c-46.4,106.6-3.1,143.1,21.7,153.7c91.5,38.9,134.4-110.3,180-185.7h42.1V0H200.3C143.9,0,64.2,59.7,64.2,128v36C5.8,183.5,0,225.1,0.2,277.1z M128,224v-96c0-37.4,58.5-64,73.3-64h150.8v192h-17c-25.5,44.1-97.7,209-116.9,190.8c-10.1-9.6,2.9-61.6,57.8-158.8l-211.3-0.1C60.2,216.4,70.6,223.9,128,224z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-down-cuff",
    d: "M512,288V32c0-42.6-64-42.6-64,0v256C448.1,331.5,512,329.8,512,288z"
  }))), _symbol377 || (_symbol377 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-up-arrow",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-up-arrow-cuff",
    d: "M64,319.8v-160c0-44.8-64-41.6-64,0v160C0,361.4,64,361.4,64,319.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-up-arrow-hand",
    d: "M384,127.8H272c0,0,16-35.2,16-76.8c3.2-48-64-86.4-112,3.2c-19.2,32-48,73.6-48,73.6H96v224c0,0,128,0,131.2,0c115.2,0,124.8-54.4,124.8-96c0,0,64,0,64-64v-32C416,137.4,403.2,127.8,384,127.8z M352,223.8h-32v32c0,57.6-54.4,64-92.8,64H128v-160h16l57.6-89.6C230.4,12.6,256,35,256,57.4c0,38.4-32,102.4-32,102.4h160v32C384,214.2,358.4,223.8,352,223.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-up-arrow-uptrend",
    d: "M153.6,511.8l67.2-54.4l44.8,44.8c12.8,12.8,32,12.8,44.8,0l140.8-140.8l19.2,19.2c9.6,9.6,25.6,3.2,25.6-9.6l16-96c0-12.8-9.6-19.2-22.4-19.2l-96,16c-12.8,0-19.2,16-9.6,25.6l19.2,19.2L284.8,435l-41.6-41.6c-12.8-12.8-28.8-12.8-41.6-3.2L48,511.8H153.6z"
  }))), _symbol378 || (_symbol378 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-up-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-thumbs-up-full-cuff",
    d: "M0,224.8V481c0,41.6,64,41.6,64,0V224.8C64,179.9,0,183.1,0,224.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-thumbs-up-full-thumb",
    d: "M512,233.2c0-76.9-64-73.7-64-73.7H288C348.8,60.2,342.4,28.2,307.2,9c-70.4-41.6-108.8,70.5-169.6,182.5H96v320.2h214.4C368,511.8,448,451,448,383.7v-35.2C505.6,329.3,512,287.7,512,233.2z"
  }))), _symbol379 || (_symbol379 = /*#__PURE__*/React.createElement("symbol", {
    id: "thumbs-up",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-up-thumb-border",
    d: "M511.9,234.9c0.1-78.4-63.9-74.7-63.9-74.7L339.8,160c46.4-106.6,3.1-143.1-21.7-153.7c-91.5-38.9-134.4,110.3-180,185.7H96v320h215.8c56.4,0,136.1-59.7,136.1-128v-36C506.3,328.5,512.1,286.9,511.9,234.9z M384.1,288v96c0,37.4-58.5,64-73.3,64H160V256h17c25.5-44.1,97.7-209,116.9-190.8c10.1,9.6-2.9,61.6-57.8,158.8l211.3,0.1C451.9,295.6,441.5,288.1,384.1,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline thumbs-up-cuff",
    d: "M0.1,224v256c0,42.6,64,42.6,64,0V224C64,180.5,0.1,182.2,0.1,224z"
  }))), _symbol380 || (_symbol380 = /*#__PURE__*/React.createElement("symbol", {
    id: "time",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M437,75C388.7,26.6,324.4,0,256,0S123.3,26.6,75,75C26.6,123.3,0,187.6,0,256s26.6,132.7,75,181c48.4,48.4,112.6,75,181,75s132.7-26.6,181-75c48.4-48.4,75-112.6,75-181S485.4,123.3,437,75z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-time-border",
    d: "M437,75C388.7,26.6,324.4,0,256,0S123.3,26.6,75,75C26.6,123.3,0,187.6,0,256s26.6,132.7,75,181c48.4,48.4,112.6,75,181,75s132.7-26.6,181-75c48.4-48.4,75-112.6,75-181S485.4,123.3,437,75z M256,448c-105.9,0-192-86.1-192-192S150.1,64,256,64s192,86.1,192,192S361.9,448,256,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-time-hands",
    d: "M180.7,347.3c3.1,3.1,7.2,4.7,11.3,4.7s8.2-1.6,11.3-4.7l48-48c6.3,3,13.3,4.7,20.7,4.7c26.5,0,48-21.5,48-48c0-20.9-13.4-38.7-32-45.3V112c0-8.8-7.2-16-16-16s-16,7.2-16,16v98.7c-18.6,6.6-32,24.4-32,45.3c0,7.4,1.7,14.4,4.7,20.7l-48,48C174.4,330.9,174.4,341.1,180.7,347.3z"
  }))), _symbol381 || (_symbol381 = /*#__PURE__*/React.createElement("symbol", {
    id: "times-circle-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M0,256.7c8,343,502.7,337.6,512,0C502.7-83.6,10.7-87.6,0,256.7z M374.4,329.4c29,29.1-16.4,74.4-45.2,45.4l-73.3-73.6l-73.3,73.6c-29.4,29.6-74.1-16.5-45.2-45.4l73.3-73.6l-73.2-73.5c-28.4-28.5,15.2-75.6,45.2-45.4l73.2,73.5l73.2-73.5c28.4-28.5,75.3,15.3,45.2,45.4l-73.2,73.5L374.4,329.4z"
  }))), _symbol382 || (_symbol382 = /*#__PURE__*/React.createElement("symbol", {
    id: "times-circle",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline times-circle-border",
    d: "M256,0C114.8,0,0,114.8,0,256s114.8,256,256,256s256-114.8,256-256S397.2,0,256,0z M403,403c-19.1,19.1-41.4,34.2-66.2,44.7C311.2,458.5,284,464,256,464s-55.2-5.5-80.8-16.3c-24.8-10.5-47-25.5-66.2-44.7s-34.2-41.4-44.7-66.2C53.5,311.2,48,284,48,256s5.5-55.2,16.3-80.8c10.5-24.8,25.5-47,44.7-66.2s41.4-34.2,66.2-44.7C200.8,53.5,228,48,256,48s55.2,5.5,80.8,16.3c24.8,10.5,47,25.5,66.2,44.7s34.2,41.4,44.7,66.2C458.5,200.8,464,228,464,256s-5.5,55.2-16.3,80.8C437.2,361.6,422.1,383.8,403,403L403,403z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline times-circle-x",
    d: "M301.5,255.5l67.9-67.9c12.5-12.5,12.5-32.8,0-45.3l0,0c-12.5-12.5-32.8-12.5-45.3,0l-67.9,67.9l-67.9-67.9c-12.5-12.5-32.8-12.5-45.3,0l0,0c-12.5,12.5-12.5,32.8,0,45.3l67.9,67.9l-67.9,67.9c-12.5,12.5-12.5,32.8,0,45.3l0,0c12.5,12.5,32.8,12.5,45.3,0l67.9-67.9l68.9,68.9c12.5,12.5,32.8,12.5,45.3,0l0,0c12.5-12.5,12.5-32.8,0-45.3L301.5,255.5L301.5,255.5z"
  }))), _symbol383 || (_symbol383 = /*#__PURE__*/React.createElement("symbol", {
    id: "times-small",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M300.2,256l102.9-102.9c29.5-29.5-14.7-73.7-44.2-44.2L256,211.8L153.1,108.9c-29.5-29.5-73.7,14.7-44.2,44.2L211.8,256 L108.9,358.9c-29.5,29.5,14.7,73.7,44.2,44.2L256,300.2l102.9,102.9c29.5,29.5,73.7-14.7,44.2-44.2L300.2,256z"
  }))), _symbol384 || (_symbol384 = /*#__PURE__*/React.createElement("symbol", {
    id: "times",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M300.4,256L467,89.4c29.6-29.6-14.8-74.1-44.4-44.4L256,211.6L89.4,45C59.8,15.3,15.3,59.8,45,89.4L211.6,256L45,422.6 c-29.7,29.7,14.7,74.1,44.4,44.4L256,300.4L422.6,467c29.7,29.7,74.1-14.7,44.4-44.4L300.4,256z"
  }))), _symbol385 || (_symbol385 = /*#__PURE__*/React.createElement("symbol", {
    id: "transform",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-transform-center",
    d: "M352,96H160V0H96v352c0,35.3,28.7,64,64,64h192v96h64V160C416,124.7,387.3,96,352,96z M160,352V160h192v192H160z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-transform-right",
    x: 448,
    y: 352,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-transform-left",
    y: 96,
    width: 64,
    height: 64
  }))), _symbol386 || (_symbol386 = /*#__PURE__*/React.createElement("symbol", {
    id: "trash",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-trash-body-border",
    d: "M64.4,440.7c0,39.3,31.9,71.3,71.3,71.3h240.6c39.3,0,71.3-31.9,71.3-71.3v-312H64.4V440.7z M128.2,192.6h255.5v231.7c0,13.1-10.7,23.8-23.8,23.8H152c-13.1,0-23.8-10.7-23.8-23.8V192.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline lx-trash-lid",
    points: "351.8,32.9 351.8,0 160.2,0 160.2,32.9 64.4,32.9 64.4,96.1 447.6,96.1 447.6,32.9 "
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-trash-line-2",
    x: 287.9,
    y: 223.6,
    width: 63.9,
    height: 191.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline lx-trash-line-1",
    x: 160.2,
    y: 223.6,
    width: 63.9,
    height: 191.6
  }))), _symbol387 || (_symbol387 = /*#__PURE__*/React.createElement("symbol", {
    id: "truck",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M510.4,270.5c3.1-14.3,1.3-24-3.2-36.1L452.6,98.9c-7-17.4-30.2-35.6-52.5-36.1h-48c-0.7-15.7-12.2-31-33.3-31H30.3C9.4,31.8-0.4,48.5,0.2,64.8H0V349c0,22.8,16.1,34.9,32.1,35.3c0,0.1,0,0.3,0,0.4c0,114.3,158.6,127.7,187.5,31.7h104.3c29.6,93.2,187.2,86,187.2-31.7c0-20.2-5.1-36.9-13.1-50.8L510.4,270.5z M351.9,126.9h43l26,64.7h-68.9V126.9z M96.2,384.4c0-43.1,64.1-43.4,64.1,0C160.3,428,96.2,426.6,96.2,384.4z M440.7,291.6c-46.2-11.6-100.6,8.7-116.8,60.6H219.3c-21.1-68-107.3-81.7-155.1-41.3V95.9h224.4v94.8c0,35.6,28.9,64.5,64.5,64.5l95.2,0l-0.7,2.9 M382.7,384.4c0-43.1,64.1-43.4,64.1,0C446.9,428,382.7,426.6,382.7,384.4z"
  }))), _symbol388 || (_symbol388 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M512.015 97.213c-18.842 8.368-39.089 14.015-60.332 16.531 21.68-12.991 38.358-33.589 46.2-58.108-20.306 12.026-42.776 20.774-66.71 25.485-19.164-20.423-46.462-33.179-76.688-33.179-58.020 0-105.039 47.048-105.039 105.039 0 8.222 0.936 16.238 2.721 23.934-87.308-4.389-164.698-46.2-216.516-109.749-9.041 15.508-14.22 33.559-14.22 52.812 0 36.457 18.55 68.612 46.727 87.425-17.234-0.556-33.414-5.267-47.575-13.137 0 0.439 0 0.877 0 1.317 0 50.91 36.222 93.336 84.266 102.99-8.807 2.399-18.082 3.687-27.679 3.687-6.759 0-13.343-0.673-19.779-1.901 13.371 41.723 52.169 72.123 98.135 72.942-35.959 28.176-81.252 44.971-130.465 44.971-8.486 0-16.853-0.498-25.046-1.464 46.493 29.815 101.704 47.195 161.041 47.195 193.226 0 298.879-160.075 298.879-298.879 0-4.565-0.117-9.070-0.293-13.576 20.481-14.776 38.3-33.267 52.374-54.334v0z"
  }))), _symbol389 || (_symbol389 = /*#__PURE__*/React.createElement("symbol", {
    id: "underline",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M128,448h256v32H128V448z M384,256V64h-64v192c0,85.6-128,85.6-128,0V64h-64c0,64,0,127.9,0,192C128,426.7,384,426.7,384,256z"
  }))), _symbol390 || (_symbol390 = /*#__PURE__*/React.createElement("symbol", {
    id: "undo",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M73.4,137.4l96-96c12.5-12.5,32.8-12.5,45.3,0s12.5,32.8,0,45.3l-41.2,41.2H288c88.2,0,160,71.8,160,160s-71.8,160-160,160c-17.7,0-32-14.3-32-32s14.3-32,32-32c52.9,0,96-43.1,96-96s-43.1-96-96-96H173l41.4,41.4c12.5,12.5,12.5,32.8,0,45.3c-6.2,6.2-14.4,9.4-22.6,9.4c-8.2,0-16.4-3.1-22.6-9.4l-95.8-96C60.9,170.1,60.9,149.9,73.4,137.4z"
  }))), _symbol391 || (_symbol391 = /*#__PURE__*/React.createElement("symbol", {
    id: "unlock",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M364.8,223.9H192v-96.1c0-84,128-84.7,128,0v31.5h32v-31.5c0-127.4-192-128.1-192,0v96.1h-19.2c-28.2,0-44.8,23-44.8,51.2v153.7c0,28.2,16.6,51.2,44.8,51.2h224c28.2,0,51.2-23,51.2-51.2V275.1C416,246.9,393,223.9,364.8,223.9z M288,416h-64v-96.1h64V416z"
  }))), _symbol392 || (_symbol392 = /*#__PURE__*/React.createElement("symbol", {
    id: "unpin",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline unpin-tack",
    points: "0,512 140,295.5 217.6,372.9 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline unpin-body",
    d: "M414.8,458.6l-362-362C12,55,69-4,115,36.4l362,362C519,445,462,502,414.8,458.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline unpin-head",
    d: "M501.9,140.7l-129.2-129c-35.4-32-76.7,8.8-58.1,41.9L247,87l180,174l31.6-63.2C494.5,216.7,529.9,173.3,501.9,140.7z"
  }))), _symbol393 || (_symbol393 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload-multiple",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline upload-multiple-arrow-up",
    d: "M278.9,9.9c-14.9-13.5-32.6-12.8-45.8,0l-71.5,71.5c-28.8,26.6,10.8,77.1,45.8,45.8l16.7-16.7v113.6c0,42.3,64,42,64,0V110.5l16.7,16.7c28,29.1,76.5-13.6,45.8-45.8L278.9,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline upload-multiple-bracket",
    d: "M383.9,256.1v64H128.1v-64c0-43-64-41.7-64,0V384h383.7V256.1C447.9,214.1,383.9,213.8,383.9,256.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "lexicon-icon-outline upload-multiple-line",
    x: 64,
    y: 448,
    width: 384,
    height: 64
  }))), _symbol394 || (_symbol394 = /*#__PURE__*/React.createElement("symbol", {
    id: "upload",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline upload-arrow-up",
    d: "M278.9,9.5C272.8,3.4,264.6,0,256,0c-8.6,0-16.8,3.4-22.9,9.5l-71.6,71.6c-12.7,12.7-12.7,33.2,0,45.8c6.3,6.3,14.6,9.5,22.9,9.5s16.6-3.2,22.9-9.5l16.7-16.7V352c0,17.7,14.3,32,32,32c17.7,0,32-14.3,32-32V110.2l16.7,16.7c12.7,12.7,33.2,12.7,45.8,0c12.7-12.7,12.7-33.2,0-45.8L278.9,9.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline upload-bracket",
    d: "M416,352c-17.7,0-32,14.3-32,32v64H128v-64c0-17.7-14.3-32-32-32s-32,14.3-32,32v128h384V384C448,366.3,433.7,352,416,352z"
  }))), _symbol395 || (_symbol395 = /*#__PURE__*/React.createElement("symbol", {
    id: "urgent",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.6,0,0,114.6,0,256s114.6,256,256,256s256-114.6,256-256S397.4,0,256,0z M287.9,399.7c15.1-6.9,33.4-17.8,52.5-34C365.8,407.8,306.1,435,287.9,399.7z M223.5,383.5c-37.1-26.1-4.1-45.4-50.9-90.5c-16.9-16.2-70.6-60.6-30.6-127.6c-21.1-19.9,1.4-45.8,23.6-23.6c66.5-38.9,111.1,13.9,127.5,30.5c48.8,49.6,65.3,13.1,91.5,49.9C376,303.9,290.2,377.6,223.5,383.5z"
  }))), _symbol396 || (_symbol396 = /*#__PURE__*/React.createElement("symbol", {
    id: "user-plus",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline user-plus-plus-sign",
    points: "512,156.9 448,156.9 448,92.9 416,92.9 416,156.9 352,156.9 352,188.9 416,188.9 416,252.9 448,252.9 448,188.9 512,188.9 "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "lexicon-icon-outline user-plus-head",
    cx: 192,
    cy: 127.3,
    rx: 96,
    ry: 95.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline user-plus-body",
    d: "M384,396.8c0,111-384,111-384,0C0,200.6,384,202.6,384,396.8z"
  }))), _symbol397 || (_symbol397 = /*#__PURE__*/React.createElement("symbol", {
    id: "user",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline user-head",
    cx: 256,
    cy: 126.1,
    r: 96
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline user-body",
    d: "M448,398.1c0,112-384,112-384,0C64,200.1,448,202.1,448,398.1z"
  }))), _symbol398 || (_symbol398 = /*#__PURE__*/React.createElement("symbol", {
    id: "users",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline users-icon-body-2",
    d: "M510.3,428.8c0,111-380.6,111-380.6,0C129.7,232.6,510.3,234.6,510.3,428.8z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline users-icon-head-2",
    cx: 320,
    cy: 159.3,
    r: 95.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline users-icon-body-1",
    d: "M204.8,219.1C29,195-84,399,81,433.8c1.6-93.7,72.8-150.7,159.9-171.7C225.9,250.6,213.6,236,204.8,219.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline users-icon-head-1",
    d: "M268.7,39.4C205-39,96.8,11,96.8,95.3c0,52.6,42.6,95.2,95.2,95.2c0.6,0,1.2-0.2,1.8-0.2C175,121,219,59,268.7,39.4z"
  }))), _symbol399 || (_symbol399 = /*#__PURE__*/React.createElement("symbol", {
    id: "vertical-scroll",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M333.1,365.1c-8.9,0-17.9,3.4-24.7,10.2L288,395.8V116.2l20.4,20.4c13.6,13.6,35.7,13.6,49.3,0c13.6-13.6,13.6-35.7,0-49.3l-77.1-77.1C274.1,3.7,265.3,0,256,0c-9.3,0-18.1,3.7-24.7,10.2l-77.1,77.1c-13.6,13.6-13.6,35.7,0,49.3c6.8,6.8,15.7,10.2,24.7,10.2c8.9,0,17.9-3.4,24.7-10.2l20.4-20.4v279.5l-20.4-20.4c-13.6-13.6-35.7-13.6-49.3,0c-13.6,13.6-13.6,35.7,0,49.3l77.1,77.1c0.8,0.8,1.7,1.6,2.5,2.3c5.7,5.5,13.5,8.9,22.1,8.9c8.6,0,16.4-3.4,22.1-8.9c0.9-0.7,1.7-1.5,2.5-2.3l77.1-77.1c13.6-13.6,13.6-35.7,0-49.3C351,368.5,342,365.1,333.1,365.1z"
  }))), _symbol400 || (_symbol400 = /*#__PURE__*/React.createElement("symbol", {
    id: "video",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M192,352V160l160,96L192,352z"
  }))), _symbol401 || (_symbol401 = /*#__PURE__*/React.createElement("symbol", {
    id: "view",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M5.1,273.3c127.1,192,374.7,188.6,501.6-0.1c7-10.4,7-24.5,0.1-34.9C378.6,45.8,132.4,51.3,5.3,238.5C-1.7,248.8-1.8,262.8,5.1,273.3z M63.7,255.8c120.8-137.8,266.3-139.6,384.5,0C330,393.5,183.9,391.7,63.7,255.8z M283.9,164.4c-91.6-26-160.9,74.5-102.8,151.5c57.4,75.2,195.5,24.2,166.5-87.9C301.4,304.3,208.7,209.5,283.9,164.4z"
  }))), _symbol402 || (_symbol402 = /*#__PURE__*/React.createElement("symbol", {
    id: "vocabulary",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-vocabulary-a",
    d: "M145.689,252.6216c15.8076,7.9038,35.0288,1.4971,42.9326-14.3105L195.7771,224h120.4454l7.1555,14.311c5.6074,11.2139,16.9082,17.6968,28.6465,17.6958c4.8086,0,9.6934-1.0884,14.2861-3.3853c15.8076-7.9038,22.2148-27.125,14.3115-42.9326l-96-192C279.2012,6.8481,268.1211,0,256,0c-12.1206,0-23.2012,6.8481-28.6216,17.689l-96,192C123.4746,225.4966,129.8818,244.7178,145.689,252.6216z M256,103.5542L284.2227,160h-56.4456L256,103.5542z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-vocabulary-b",
    d: "M160,352v-64c0-17.6729-14.3271-32-32-32H64H32H0v256h32h32h96c17.6733,0,32-14.3271,32-32v-96C192,366.3271,177.6733,352,160,352z M96,320v32H64v-32H96z M128,448H64v-32h64V448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-vocabulary-c",
    d: "M478.7363,448.0254c-16.3994,0.6455-18.5439,0.4795-20.2666,0.3438C455.8945,448.167,453.3301,448,448,448c-35.29,0-64-28.71-64-64s28.71-64,64-64c15.1777,0,28.1934,1.4736,28.2949,1.4854c17.5674,2.04,33.4443-10.5264,35.4902-28.0801c2.0459-17.5547-10.5264-33.4434-28.0801-35.4902C483.0342,257.8369,467.0527,256,448,256c-70.5791,0-128,57.4209-128,128s57.4209,128,128,128c3.2549,0,4.2285,0.0762,5.4609,0.1729c2.3564,0.1855,4.499,0.3252,8.4287,0.3252c3.9609,0,9.7373-0.1426,19.374-0.5234c17.6592-0.6973,31.4092-15.5791,30.7109-33.2383C511.2773,461.0762,496.3662,447.3018,478.7363,448.0254z"
  }))), _symbol403 || (_symbol403 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning-full",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline",
    d: "M506.3,409.3l-214-353.7c-16.8-30.6-55.8-32.6-72.6,0L5.7,409.3C-8,436.5,5,480,42,480h428C506,480,522.5,436.5,506.3,409.3z M224,392c0-42.5,64-42,64,0C288,433.5,224,434.5,224,392z M288,288c0,42.5-64,40.5-64,0c0-20.4,0-83.6,0-104c0-43,64-43.5,64,0C288,204.4,288,267.6,288,288z"
  }))), _symbol404 || (_symbol404 = /*#__PURE__*/React.createElement("symbol", {
    id: "warning",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline warning-border",
    d: "M496.1,409.7L290.8,54.1c-15.8-26.4-52.5-27.1-69.6,0L15.9,409.7c-13.9,26,1.1,60.2,34.8,60.2h410.6C491.7,469.9,512,438,496.1,409.7z M83.2,407L256,107.6L428.8,407H83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline warning-stem",
    d: "M284,285v-75c0-38-56-37.5-56,0v75C228,322.5,284,322,284,285z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline warning-dot",
    cx: 256,
    cy: 361.9,
    r: 32
  }))), _symbol405 || (_symbol405 = /*#__PURE__*/React.createElement("symbol", {
    id: "web-content",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline web-content-border",
    d: "M0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64c0-35.3-28.7-64-64-64H64C28.7,0,0,28.7,0,64z M448,448H64V64h384V448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline web-content-text-1",
    d: "M144,320h224c22,0,21-32,0-32H144C123,288,123,320,144,320z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline web-content-text-2",
    d: "M144,384h160c22,0,20-32,0-32H144C123,352,122,384,144,384z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "lexicon-icon-outline web-content-circle",
    cx: 320,
    cy: 160,
    r: 64
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "lexicon-icon-outline web-content-triangle",
    points: "128,224 192,96 256,224 "
  }))), _symbol406 || (_symbol406 = /*#__PURE__*/React.createElement("symbol", {
    id: "wiki-page",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M416,0H63.4C28.4,0,0,28.4,0,63.4V448c0,35,28.4,64,63.4,64h380.2c35,0,68.4-29,68.4-64V128V96L416,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-page-border",
    d: "M416,0H63.4C28.4,0,0,28.4,0,63.4V448c0,35,28.4,64,63.4,64h380.2c35,0,68.4-29,68.4-64V128V96L416,0z M448,448H64l0-384h224h32v96v32h32h96V448z M384,128V64l64,64H384z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-page-line-1",
    d: "M96,288c0,17.7,14.3,32,32,32h256c17.7,0,32-14.3,32-32s-14.3-32-32-32H128C110.3,256,96,270.3,96,288z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-page-line-2",
    d: "M288,352H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S305.7,352,288,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-page-w",
    d: "M127,200.6c0.7,1.9,1.8,4.4,3.1,7.7c1.3,3.2,2.8,6,4.5,8.4c1.7,2.4,3.8,4.2,6.4,5.4s5.7,1.9,9.3,1.9c7.2,0,12.2-2,15-6.1c2.9-4.1,5.5-10.2,7.9-18.2l18.5-65.2l19.1,65.2c1.6,5.2,3.1,9.5,4.5,12.7s3.5,6,6.4,8.3c2.9,2.2,6.9,3.4,11.9,3.4c4.9,0,8.7-1,11.6-3.2s4.9-4.5,6.2-7.2c1.3-2.7,3.1-7,5.5-13l27.3-78.5c2.5-6.2,3.8-10.8,3.8-13.8c0-3.3-1.5-6.2-4.4-8.7c-2.9-2.5-6.4-3.7-10.4-3.7c-4,0-7,0.8-9.2,2.4c-2.1,1.6-3.6,3.5-4.5,5.6c-0.9,2.1-2.1,5.6-3.5,10.4l-22,73.7l-19.8-69c-2-6.2-3.6-10.5-4.8-13c-1.1-2.5-3.1-4.8-5.9-7c-2.8-2.1-6.7-3.2-11.7-3.2c-4.9,0-8.7,1.1-11.5,3.2s-4.7,4.4-5.7,6.7s-2.6,6.8-4.7,13.2l-19.8,69l-21.8-73.7c-2.2-6.7-4.3-11.5-6.2-14.3c-2-2.8-5.7-4.2-11.2-4.2c-4.2,0-7.7,1.3-10.5,3.8s-4.3,5.4-4.3,8.6c0,2.5,1.3,7.1,4,13.8L127,200.6z"
  }))), _symbol407 || (_symbol407 = /*#__PURE__*/React.createElement("symbol", {
    id: "wiki",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,448H64V64h384V448C448,448,448,448,448,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-line-1",
    d: "M384,256H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h256c17.7,0,32-14.3,32-32S401.7,256,384,256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-line-2",
    d: "M288,352H128c-17.7,0-32,14.3-32,32s14.3,32,32,32h160c17.7,0,32-14.3,32-32S305.7,352,288,352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-wiki-w",
    d: "M191,200.6c0.7,1.9,1.8,4.4,3.1,7.7c1.3,3.2,2.8,6,4.5,8.4c1.7,2.4,3.8,4.2,6.4,5.4s5.7,1.9,9.3,1.9c7.2,0,12.2-2,15-6.1c2.9-4.1,5.5-10.2,7.9-18.2l18.5-65.2l19.1,65.2c1.6,5.2,3.1,9.5,4.5,12.7s3.5,6,6.4,8.3c2.9,2.2,6.9,3.4,11.9,3.4c4.9,0,8.7-1,11.6-3.2s4.9-4.5,6.2-7.2c1.3-2.7,3.1-7,5.5-13l27.3-78.5c2.5-6.2,3.8-10.8,3.8-13.8c0-3.3-1.5-6.2-4.4-8.7c-2.9-2.5-6.4-3.7-10.4-3.7c-4,0-7,0.8-9.2,2.4c-2.1,1.6-3.6,3.5-4.5,5.6c-0.9,2.1-2.1,5.6-3.5,10.4l-22,73.7l-19.8-69c-2-6.2-3.6-10.5-4.8-13c-1.1-2.5-3.1-4.8-5.9-7c-2.8-2.1-6.7-3.2-11.7-3.2c-4.9,0-8.7,1.1-11.5,3.2s-4.7,4.4-5.7,6.7s-2.6,6.8-4.7,13.2l-19.8,69l-21.8-73.7c-2.2-6.7-4.3-11.5-6.2-14.3c-2-2.8-5.7-4.2-11.2-4.2c-4.2,0-7.7,1.3-10.5,3.8s-4.3,5.4-4.3,8.6c0,2.5,1.3,7.1,4,13.8L191,200.6z"
  }))), _symbol408 || (_symbol408 = /*#__PURE__*/React.createElement("symbol", {
    id: "workflow",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-body",
    fill: "none",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-workflow-border",
    d: "M448,0H64C28.7,0,0,28.7,0,64v384c0,35.3,28.7,64,64,64h384c35.3,0,64-28.7,64-64V64C512,28.7,483.3,0,448,0z M448,448H64V64h384V448C448,448,448,448,448,448z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "lexicon-icon-outline lx-workflow-content",
    d: "M352,257.6V208h32l-48-96l-48,96h32v49.6c-31.3,6.4-56,31.1-62.4,62.4H192v-64h64V96H96v160h64v64v32h32h65.6c7.4,36.5,39.7,64,78.4,64c44.2,0,80-35.8,80-80C416,297.3,388.5,265,352,257.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.bb2daba86474307ccdc25a00092f0e91.svg";
export { ForwardRef as ReactComponent };